webpackJsonp([5,4],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	//common module
	__webpack_require__(135);
	__webpack_require__(123);
	__webpack_require__(122);
	__webpack_require__(117);
	
	
	var Vue = __webpack_require__(113),
	    VueRouter = __webpack_require__(154);
	Router = __webpack_require__(159);
	Main = __webpack_require__(148),
	    utils = __webpack_require__(115),
	    commonutils = __webpack_require__(116),
	    Constant = __webpack_require__(157),
	    md5 = __webpack_require__(156),
	    VueI18n = __webpack_require__(160),
	    VueTap = __webpack_require__(155);
	Vue.use(VueRouter);
	Vue.use(VueTap);
	Vue.use(__webpack_require__(153));
	//设置url传递过来的参数
	Vue.http.options.emulateJSON = true;
	Vue.http.headers.common['activeCode'] = Constant.activationCode = commonutils.getPageUrlParam('activeCode');
	Vue.http.headers.common['app'] = Constant.app = commonutils.getPageUrlParam('app');
	Vue.http.headers.common['isWKWebView'] = Constant.isWKWebView = commonutils.getPageUrlParam('isWKWebView');
	Vue.http.headers.common['signUserId'] = Constant.signUserId = commonutils.getPageUrlParam('signUserId');
	Vue.http.headers.common['enterId'] = Constant.enterId = commonutils.getPageUrlParam('enterId');
	Constant.language = commonutils.getPageUrlParam('lang')?commonutils.getPageUrlParam('lang'):'cn';
	
	var router = new VueRouter(
	    {
	      hashbang: true,
	      history: false,
	      initialTransition: 'show',
	      saveScrollPosition: true
	    }
	);
	Router(router);
	window.router = router;
	//添加国际化插件
	Vue.use(VueI18n,{
	    default:Constant.language,
	    data:__webpack_require__(158)
	});
	document.getElementsByTagName('title')[0].innerHTML = Vue.prototype.$translate("register");
	    /**
	 * 提供Android和iOS调用返回功能
	 * @returns {boolean}
	 */
	window.goBack = function(){
	  var curPathName = Constant.curRoute.pathName;
	  var backInfo = utils.getBackPath(curPathName);
	  if(backInfo.parent){
	    router.go({name:backInfo.parent,params:backInfo.params});
	    window.webview &&　window.webview.goBack(false);
	    return false;
	  }
	  window.webview　&& window.webview.goBack(true);
	  return true;
	};
	window.LxStr = utils.LxStr;
	router.start(Main,'#app');

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	var paths = [{
	  name: 'default', parent: ''
	  },
	  {
	    name: 'shoplist', parent: 'default'
	  },
	  {
	    name: 'search', parent: 'default'
	  }];
	module.exports.getBackPath = function(name){
	  var res = {};
	  for(var i=0;i<paths.length;i++){
	    if(name == paths[i].name){
	      res.parent = paths[i].parent;
	      break;
	    }
	  }
	  for(var i=0;i<paths.length;i++){
	    if(res.parent == paths[i].name){
	      res.params = paths[i].params;
	      break;
	    }
	  }
	  return res;
	};
	
	module.exports.setBackPath = function(name,params){
	  for(var i=0;i<paths.length;i++){
	    if(name == paths[i].name){
	      paths[i].params = params;
	      break;
	    }
	  }
	};
	/*
	 /!**
	 * 判断对象是否被修改过
	 * @param newdata
	 * @param olddata
	 * @returns {boolean}
	 *!/
	 module.exports.isDataChange = function(newdata,olddata){
	 for(var key in newdata){
	 if(newdata.hasOwnProperty(key)){
	 if(newdata[key] != olddata[key]){;
	 return true;
	 }
	 }
	 }
	 return false;
	 };*/
	
	var goHome = function () {
	  window.location.href = 'index.html?token=' + Constant.token + '&name=' + encodeURIComponent(Constant.shopInfo.name) + '&id=' + Constant.shopInfo.id;
	};
	module.exports.goHome = goHome;
	/**
	 *判断是否为整数
	 * @param number
	 * @returns {boolean}
	 */
	module.exports.isInteger = function (number) {
	  return Math.floor(number) == number;
	};
	
	/**
	 * 校验密码不能未连续数字或者字母
	 * @param str
	 * @returns {boolean}
	 * @constructor
	 */
	module.exports.LxStr = function(str){
	  var arr = str.split('');
	  var flag = true;
	  for (var i = 1; i < arr.length-1; i++) {
	    var firstIndex = arr[i-1].charCodeAt();
	    var secondIndex = arr[i].charCodeAt();
	    var thirdIndex = arr[i+1].charCodeAt();
	    if(((thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex == 1))
	        ||((thirdIndex - secondIndex == 0)&&(secondIndex - firstIndex == 0))
	        ||((thirdIndex - secondIndex == -1)&&(secondIndex - firstIndex == -1))
	        ||((thirdIndex - secondIndex == 0)&&(secondIndex - firstIndex == 0))){
	      flag =  false;
	    }
	  }
	  return flag;
	}
	


/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	/**
	 * 格式化日期
	 * @param date : 日期值, [Date]或者[long]
	 * @param mode 模式：
	 * 		默认值 0或null,返回格式：yyyy-MM-dd HH:mm:ss
	 * 		1		返回格式：yyyy-MM-dd
	 * 		2		返回格式：HH:mm:ss
	 */
	module.exports.formatDateTime = function (date, mode) {
	    var _type = typeof date;
	    if (_type == "object") {
	        return formatDate0(date);
	    } else if (_type == "number") {
	        return formatDate1(date);
	    }
	
	    function formatDate0(date) {
	        function _ten(i) {
	            return i < 10 ? "0" + i : "" + i;
	        }
	
	        var s1 = date.getFullYear() + "-" + _ten((date.getMonth() + 1)) + "-" + _ten(date.getDate());
	        var s2 = _ten(date.getHours()) + ":" + _ten(date.getMinutes()) + ":" + _ten(date.getSeconds());
	
	        if (mode == 1) {
	            return s1;
	        } else if (mode == 2) {
	            return s2;
	        } else {
	            return s1 + " " + s2;
	        }
	    }
	    function formatDate1(time) {
	        var d = new Date();
	        d.setTime(time);
	        return formatDate0(d);
	    }
	
	};
	
	module.exports.getThisWeekTime = function () {
	    var curDate = new Date();
	    var startDate = new Date();
	    if (curDate.getDay() == 0) {//周日特殊处理
	        startDate.setDate(curDate.getDate() - 6);
	    } else {
	        startDate.setDate(curDate.getDate() - curDate.getDay() + 1);
	    }
	    startDate.setHours(0);
	    startDate.setMinutes(0);
	    startDate.setSeconds(0);
	    return {
	        startTime: this.formatDateTime(startDate, 1),
	        endTime: this.formatDateTime(curDate, 1)
	    };
	};
	module.exports.getThisMonthTime = function () {
	    var curDate = new Date();
	    var startDate = new Date();
	    startDate.setDate(1);
	    startDate.setHours(0);
	    startDate.setMinutes(0);
	    startDate.setSeconds(0);
	    return {
	        startTime: this.formatDateTime(startDate, 1),
	        endTime: this.formatDateTime(curDate, 1)
	    };
	};
	
	module.exports.getPageUrlParam = function (param) {
	    var query = window.location.search;//获取URL地址中？后的所有字符
	    var iLen = param.length;//获取你的参数名称长度
	    var iStart = query.indexOf(param);//获取你该参数名称的其实索引
	    if (iStart == -1)//-1为没有该参数
	        return "";
	    iStart += iLen + 1;
	    var iEnd = query.indexOf("&", iStart);//获取第二个参数的其实索引
	    if (iEnd == -1)//只有一个参数
	        return query.substring(iStart);//获取单个参数的参数值
	    return query.substring(iStart, iEnd);//获取第二个参数的值
	};
	
	/**
	 * 压缩图片
	 * @param source_img_obj 图片
	 * @param quality        压缩率0-1之间
	 * @param output_format  格式
	 * @returns {*}
	 */
	module.exports.compressImg = function (source_img_obj, quality, output_format) {
	    var mime_type = "image/jpeg";
	    if (output_format != undefined && output_format == "png") {
	        mime_type = "image/png";
	    }
	    var cvs = document.createElement('canvas');
	    //naturalWidth真实图片的宽度
	    cvs.width = source_img_obj.naturalWidth / 2;
	    cvs.height = source_img_obj.naturalHeight / 2;
	    cvs.getContext("2d").drawImage(source_img_obj, 0, 0);
	    var newImageData = cvs.toDataURL(mime_type, quality);
	    return newImageData;
	};
	
	module.exports.getLanguageParam = function (lang) {
	    var languageTypes = {
	        cn: "SIMPLIFIED_CHINESE",
	        en: "ENGLISH",
	        tw: "TRADITIONAL_CHINESE"
	    };
	    return lang ? languageTypes[lang] : languageTypes["cn"];
	}
	
	module.exports.getCookie = function (key) {
	  var name = encodeURIComponent(key) + '=';
	  var arr = document.cookie.split(';');
	
	  for (var i = 0; i < arr.length; i++) {
	    var val = arr[i].trim();
	
	    if (val.indexOf(name) === 0) {
	      return decodeURIComponent(val.substring(name.length, val.length));
	    }
	  }
	  return '';
	}
	
	module.exports.setCookie = function (key, value) {
	  var str = encodeURIComponent(key) + '=' + encodeURIComponent(value);
	  document.cookie = str;
	}

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	(function () {
	    var ua = navigator.userAgent,
	        isInWechat = ~ua.indexOf('MicroMessenger'),
	        isAndroid = ~ua.indexOf('Android'),
	        isOldIos = (function () {
	            var match = navigator.userAgent.match(/(\d)_\d like Mac OS/);
	            return match && match[1] <= 7;
	        })(),
	        URL = window.URL || window.webkitURL;
	    /*scripts = document.scripts,
	     src = scripts[scripts.length - 1].src;
	     console.log(src);
	     // 打包 async require path
	     __webpack_public_path__ = src.substr(0, src.lastIndexOf('/') + 1);*/
	    var EXIF, JPEGEncoder, MegaPixImage;
	    if (isOldIos) {
	        MegaPixImage = __webpack_require__(120);
	    }
	    if (isAndroid && isInWechat) { // 安卓微信下压缩有问题
	        JPEGEncoder = __webpack_require__(119);
	    }
	    if (!isAndroid) { // 非安卓需要获取orientation来drawImage，所以要以引入exif
	        EXIF = __webpack_require__(118);
	    }
	    /**
	     * 组件构造器
	     * @param {file} 上传文件
	     * @param {object} options选项
	     *   - maxWidth {number} 最大宽度(如果最大高宽同时存在则根据原图的高宽比例来计算以哪个为准)，默认值1000
	     *   - maxHeight {number} 最大高度，默认值1000
	     *   - quality {number} 质量等级(类似PS保存事的质量等级，并不是压缩比例)，取值范围 0-1，默认值0.6
	     *   - before {function} 压缩前handler
	     *     - param {file} 原始上传文件
	     *     - return {boolean} 是否放弃，返回false放弃压缩
	     *   - done {function} 成功handler
	     *     - param {file} 原始上传文件
	     *     - param {string} 生成的base64图片
	     *   - fail {function} 失败handler
	     *     - param {file} 原始上传文件
	     *   - complate {function} 完成handler
	     *     - param {file} 原始上传文件
	     *   - notSupport {function} 浏览器不支持handler
	     *     - param {file} 原始上传文件
	     */
	    function html5ImgCompress(file, options) {
	        var DEFAULTE = html5ImgCompress.DEFAULTE;
	
	        this.file = file;
	        this.options = {};
	
	        for (var key in DEFAULTE) {
	            this.options[key] = options[key] == null ? DEFAULTE[key] : options[key];
	        }
	
	        this.init();
	    }
	
	    html5ImgCompress.prototype = {
	        init: function () {
	            if (URL && File && document.createElement('canvas').getContext) {
	                this.read(this.file);
	            } else { // 浏览器不支持
	                this.options.notSupport();
	            }
	        },
	        /**
	         * 读取文件，用canvas画出来并用toDataURL来压缩后转成base64
	         * @param {file} 上传文件
	         */
	        read: function (file) {
	            var
	                self = this,
	                img = new Image(),
	                fileURL = URL.createObjectURL(file),
	                size, canvas, ctx, iosImg, quality, encoder, base64, handler, iosRenderOptions;
	
	            if (self.options.before(file) === false) return;
	
	            img.src = fileURL;
	
	            img.onload = function () {
	                handler = function (orientation) {
	                    quality = self.options.quality;
	                    size = self.getSize(img, orientation);
	                    canvas = document.createElement('canvas');
	                    canvas.width = size.width;
	                    canvas.height = size.height;
	                    ctx = canvas.getContext('2d');
	
	                    if (isOldIos) { // iOS6/iOS7
	                        iosImg = new MegaPixImage(img);
	                        iosRenderOptions = {
	                            maxWidth: canvas.width,
	                            maxHeight: canvas.height,
	                            orientation: orientation
	                        };
	                        if (~"68".indexOf(orientation)) { // 90，270度则高宽互换
	                            iosRenderOptions.maxWidth = canvas.height;
	                            iosRenderOptions.maxHeight = canvas.width;
	                        }
	                        iosImg.render(canvas, iosRenderOptions);
	                        base64 = canvas.toDataURL('image/jpeg', quality);
	                        self.handler('done', canvas, img, fileURL, base64, file);
	                    } else { // 其他设备
	                        switch (orientation) { // 根据方向在画布不同的位置画图
	                            case 3:
	                                ctx.rotate(180 * Math.PI / 180);
	                                ctx.drawImage(img, -canvas.width, -canvas.height, canvas.width, canvas.height);
	                                break;
	                            case 6:
	                                ctx.rotate(90 * Math.PI / 180);
	                                ctx.drawImage(img, 0, -canvas.width, canvas.height, canvas.width);
	                                break;
	                            case 8:
	                                ctx.rotate(270 * Math.PI / 180);
	                                ctx.drawImage(img, -canvas.height, 0, canvas.height, canvas.width);
	                                break;
	                            default:
	                                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
	                        }
	
	                        if (isAndroid && isInWechat) { // 安卓微信下压缩有问题
	                            encoder = new JPEGEncoder();
	                            base64 = encoder.encode(ctx.getImageData(0, 0, canvas.width, canvas.height), quality * 100);
	                            self.handler('done', canvas, img, fileURL, base64, file);
	                        } else {
	                            base64 = canvas.toDataURL('image/jpeg', quality);
	                            self.handler('done', canvas, img, fileURL, base64, file);
	                        }
	                    }
	                };
	
	                if (!isAndroid) { // 非安卓需要获取orientation来drawImage，所以要以引入exif
	                    EXIF.getData(img, function () {
	                        handler(EXIF.getTag(this, "Orientation"));
	                    })
	                } else {
	                    handler();
	                }
	            };
	
	            img.onerror = function () {
	                self.handler('fail', canvas, img, fileURL, base64, file);
	            };
	
	        },
	        // 处理句柄
	        handler: function (action, canvas, img, fileURL, base64, file) {
	            // 释放内存
	            canvas = null;
	            URL.revokeObjectURL(fileURL);
	            this.options[action](file, base64,img);
	            this.options['complate'](file);
	            img = null;
	        },
	        /**
	         * 图片最大高宽校正（方向和比例）
	         * @param  {image} 图片
	         * @param  {number} 图片方向 1)正常 3)180度 6)90度 8)270度
	         * @return  {object}
	         *   width: {number} 矫正后的width
	         *   height: {number} 校正后的hieght
	         */
	        getSize: function (img, orientation) {
	            var
	                options = this.options,
	                mW = options.maxWidth,
	                mH = options.maxHeight,
	                w = img.width,
	                h = img.height,
	                scale;
	
	            if (~"68".indexOf(orientation)) { // 90，270度则高宽互换
	                w = img.height;
	                h = img.width;
	            }
	
	            scale = w / h;
	
	            if (mW && mH) {
	                if (scale >= mW / mH) {
	                    if (w > mW) {
	                        h = mW / scale;
	                        w = mW;
	                    }
	                } else {
	                    if (h > mH) {
	                        w = mH * scale;
	                        h = mH;
	                    }
	                }
	            } else if (mW) {
	                if (mW < w) {
	                    h = mW / scale;
	                    w = mW;
	                }
	            } else if (mH) {
	                if (mH < h) {
	                    w = mH * scale;
	                    h = mH;
	                }
	            }
	
	            return {width: w, height: h};
	        }
	    };
	
	    // 默认参数
	    html5ImgCompress.DEFAULTE = {
	        maxWidth: 1000,
	        maxHeight: 1000,
	        quality: 0.6,
	        before: function () {
	        },
	        done: function () {
	        },
	        fail: function () {
	        },
	        complate: function () {
	        },
	        notSupport: function () {
	        }
	    };
	
	    window.html5ImgCompress = html5ImgCompress;
	}());

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function () {
	
	    var debug = false;
	
	    var root = this;
	
	    var EXIF = function (obj) {
	        if (obj instanceof EXIF) return obj;
	        if (!(this instanceof EXIF)) return new EXIF(obj);
	        this.EXIFwrapped = obj;
	    };
	
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = EXIF;
	        }
	        exports.EXIF = EXIF;
	    } else {
	        root.EXIF = EXIF;
	    }
	
	    var ExifTags = EXIF.Tags = {
	
	        // version tags
	        0x9000: "ExifVersion",             // EXIF version
	        0xA000: "FlashpixVersion",         // Flashpix format version
	
	        // colorspace tags
	        0xA001: "ColorSpace",              // Color space information tag
	
	        // image configuration
	        0xA002: "PixelXDimension",         // Valid width of meaningful image
	        0xA003: "PixelYDimension",         // Valid height of meaningful image
	        0x9101: "ComponentsConfiguration", // Information about channels
	        0x9102: "CompressedBitsPerPixel",  // Compressed bits per pixel
	
	        // user information
	        0x927C: "MakerNote",               // Any desired information written by the manufacturer
	        0x9286: "UserComment",             // Comments by user
	
	        // related file
	        0xA004: "RelatedSoundFile",        // Name of related sound file
	
	        // date and time
	        0x9003: "DateTimeOriginal",        // Date and time when the original image was generated
	        0x9004: "DateTimeDigitized",       // Date and time when the image was stored digitally
	        0x9290: "SubsecTime",              // Fractions of seconds for DateTime
	        0x9291: "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
	        0x9292: "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized
	
	        // picture-taking conditions
	        0x829A: "ExposureTime",            // Exposure time (in seconds)
	        0x829D: "FNumber",                 // F number
	        0x8822: "ExposureProgram",         // Exposure program
	        0x8824: "SpectralSensitivity",     // Spectral sensitivity
	        0x8827: "ISOSpeedRatings",         // ISO speed rating
	        0x8828: "OECF",                    // Optoelectric conversion factor
	        0x9201: "ShutterSpeedValue",       // Shutter speed
	        0x9202: "ApertureValue",           // Lens aperture
	        0x9203: "BrightnessValue",         // Value of brightness
	        0x9204: "ExposureBias",            // Exposure bias
	        0x9205: "MaxApertureValue",        // Smallest F number of lens
	        0x9206: "SubjectDistance",         // Distance to subject in meters
	        0x9207: "MeteringMode",            // Metering mode
	        0x9208: "LightSource",             // Kind of light source
	        0x9209: "Flash",                   // Flash status
	        0x9214: "SubjectArea",             // Location and area of main subject
	        0x920A: "FocalLength",             // Focal length of the lens in mm
	        0xA20B: "FlashEnergy",             // Strobe energy in BCPS
	        0xA20C: "SpatialFrequencyResponse",    //
	        0xA20E: "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
	        0xA20F: "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
	        0xA210: "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
	        0xA214: "SubjectLocation",         // Location of subject in image
	        0xA215: "ExposureIndex",           // Exposure index selected on camera
	        0xA217: "SensingMethod",           // Image sensor type
	        0xA300: "FileSource",              // Image source (3 == DSC)
	        0xA301: "SceneType",               // Scene type (1 == directly photographed)
	        0xA302: "CFAPattern",              // Color filter array geometric pattern
	        0xA401: "CustomRendered",          // Special processing
	        0xA402: "ExposureMode",            // Exposure mode
	        0xA403: "WhiteBalance",            // 1 = auto white balance, 2 = manual
	        0xA404: "DigitalZoomRation",       // Digital zoom ratio
	        0xA405: "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
	        0xA406: "SceneCaptureType",        // Type of scene
	        0xA407: "GainControl",             // Degree of overall image gain adjustment
	        0xA408: "Contrast",                // Direction of contrast processing applied by camera
	        0xA409: "Saturation",              // Direction of saturation processing applied by camera
	        0xA40A: "Sharpness",               // Direction of sharpness processing applied by camera
	        0xA40B: "DeviceSettingDescription",    //
	        0xA40C: "SubjectDistanceRange",    // Distance to subject
	
	        // other tags
	        0xA005: "InteroperabilityIFDPointer",
	        0xA420: "ImageUniqueID"            // Identifier assigned uniquely to each image
	    };
	
	    var TiffTags = EXIF.TiffTags = {
	        0x0100: "ImageWidth",
	        0x0101: "ImageHeight",
	        0x8769: "ExifIFDPointer",
	        0x8825: "GPSInfoIFDPointer",
	        0xA005: "InteroperabilityIFDPointer",
	        0x0102: "BitsPerSample",
	        0x0103: "Compression",
	        0x0106: "PhotometricInterpretation",
	        0x0112: "Orientation",
	        0x0115: "SamplesPerPixel",
	        0x011C: "PlanarConfiguration",
	        0x0212: "YCbCrSubSampling",
	        0x0213: "YCbCrPositioning",
	        0x011A: "XResolution",
	        0x011B: "YResolution",
	        0x0128: "ResolutionUnit",
	        0x0111: "StripOffsets",
	        0x0116: "RowsPerStrip",
	        0x0117: "StripByteCounts",
	        0x0201: "JPEGInterchangeFormat",
	        0x0202: "JPEGInterchangeFormatLength",
	        0x012D: "TransferFunction",
	        0x013E: "WhitePoint",
	        0x013F: "PrimaryChromaticities",
	        0x0211: "YCbCrCoefficients",
	        0x0214: "ReferenceBlackWhite",
	        0x0132: "DateTime",
	        0x010E: "ImageDescription",
	        0x010F: "Make",
	        0x0110: "Model",
	        0x0131: "Software",
	        0x013B: "Artist",
	        0x8298: "Copyright"
	    };
	
	    var GPSTags = EXIF.GPSTags = {
	        0x0000: "GPSVersionID",
	        0x0001: "GPSLatitudeRef",
	        0x0002: "GPSLatitude",
	        0x0003: "GPSLongitudeRef",
	        0x0004: "GPSLongitude",
	        0x0005: "GPSAltitudeRef",
	        0x0006: "GPSAltitude",
	        0x0007: "GPSTimeStamp",
	        0x0008: "GPSSatellites",
	        0x0009: "GPSStatus",
	        0x000A: "GPSMeasureMode",
	        0x000B: "GPSDOP",
	        0x000C: "GPSSpeedRef",
	        0x000D: "GPSSpeed",
	        0x000E: "GPSTrackRef",
	        0x000F: "GPSTrack",
	        0x0010: "GPSImgDirectionRef",
	        0x0011: "GPSImgDirection",
	        0x0012: "GPSMapDatum",
	        0x0013: "GPSDestLatitudeRef",
	        0x0014: "GPSDestLatitude",
	        0x0015: "GPSDestLongitudeRef",
	        0x0016: "GPSDestLongitude",
	        0x0017: "GPSDestBearingRef",
	        0x0018: "GPSDestBearing",
	        0x0019: "GPSDestDistanceRef",
	        0x001A: "GPSDestDistance",
	        0x001B: "GPSProcessingMethod",
	        0x001C: "GPSAreaInformation",
	        0x001D: "GPSDateStamp",
	        0x001E: "GPSDifferential"
	    };
	
	    var StringValues = EXIF.StringValues = {
	        ExposureProgram: {
	            0: "Not defined",
	            1: "Manual",
	            2: "Normal program",
	            3: "Aperture priority",
	            4: "Shutter priority",
	            5: "Creative program",
	            6: "Action program",
	            7: "Portrait mode",
	            8: "Landscape mode"
	        },
	        MeteringMode: {
	            0: "Unknown",
	            1: "Average",
	            2: "CenterWeightedAverage",
	            3: "Spot",
	            4: "MultiSpot",
	            5: "Pattern",
	            6: "Partial",
	            255: "Other"
	        },
	        LightSource: {
	            0: "Unknown",
	            1: "Daylight",
	            2: "Fluorescent",
	            3: "Tungsten (incandescent light)",
	            4: "Flash",
	            9: "Fine weather",
	            10: "Cloudy weather",
	            11: "Shade",
	            12: "Daylight fluorescent (D 5700 - 7100K)",
	            13: "Day white fluorescent (N 4600 - 5400K)",
	            14: "Cool white fluorescent (W 3900 - 4500K)",
	            15: "White fluorescent (WW 3200 - 3700K)",
	            17: "Standard light A",
	            18: "Standard light B",
	            19: "Standard light C",
	            20: "D55",
	            21: "D65",
	            22: "D75",
	            23: "D50",
	            24: "ISO studio tungsten",
	            255: "Other"
	        },
	        Flash: {
	            0x0000: "Flash did not fire",
	            0x0001: "Flash fired",
	            0x0005: "Strobe return light not detected",
	            0x0007: "Strobe return light detected",
	            0x0009: "Flash fired, compulsory flash mode",
	            0x000D: "Flash fired, compulsory flash mode, return light not detected",
	            0x000F: "Flash fired, compulsory flash mode, return light detected",
	            0x0010: "Flash did not fire, compulsory flash mode",
	            0x0018: "Flash did not fire, auto mode",
	            0x0019: "Flash fired, auto mode",
	            0x001D: "Flash fired, auto mode, return light not detected",
	            0x001F: "Flash fired, auto mode, return light detected",
	            0x0020: "No flash function",
	            0x0041: "Flash fired, red-eye reduction mode",
	            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
	            0x0047: "Flash fired, red-eye reduction mode, return light detected",
	            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
	            0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
	            0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
	            0x0059: "Flash fired, auto mode, red-eye reduction mode",
	            0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
	            0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
	        },
	        SensingMethod: {
	            1: "Not defined",
	            2: "One-chip color area sensor",
	            3: "Two-chip color area sensor",
	            4: "Three-chip color area sensor",
	            5: "Color sequential area sensor",
	            7: "Trilinear sensor",
	            8: "Color sequential linear sensor"
	        },
	        SceneCaptureType: {
	            0: "Standard",
	            1: "Landscape",
	            2: "Portrait",
	            3: "Night scene"
	        },
	        SceneType: {
	            1: "Directly photographed"
	        },
	        CustomRendered: {
	            0: "Normal process",
	            1: "Custom process"
	        },
	        WhiteBalance: {
	            0: "Auto white balance",
	            1: "Manual white balance"
	        },
	        GainControl: {
	            0: "None",
	            1: "Low gain up",
	            2: "High gain up",
	            3: "Low gain down",
	            4: "High gain down"
	        },
	        Contrast: {
	            0: "Normal",
	            1: "Soft",
	            2: "Hard"
	        },
	        Saturation: {
	            0: "Normal",
	            1: "Low saturation",
	            2: "High saturation"
	        },
	        Sharpness: {
	            0: "Normal",
	            1: "Soft",
	            2: "Hard"
	        },
	        SubjectDistanceRange: {
	            0: "Unknown",
	            1: "Macro",
	            2: "Close view",
	            3: "Distant view"
	        },
	        FileSource: {
	            3: "DSC"
	        },
	
	        Components: {
	            0: "",
	            1: "Y",
	            2: "Cb",
	            3: "Cr",
	            4: "R",
	            5: "G",
	            6: "B"
	        }
	    };
	
	    function addEvent(element, event, handler) {
	        if (element.addEventListener) {
	            element.addEventListener(event, handler, false);
	        } else if (element.attachEvent) {
	            element.attachEvent("on" + event, handler);
	        }
	    }
	
	    function imageHasData(img) {
	        return !!(img.exifdata);
	    }
	
	
	    function base64ToArrayBuffer(base64, contentType) {
	        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
	        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
	        var binary = atob(base64);
	        var len = binary.length;
	        var buffer = new ArrayBuffer(len);
	        var view = new Uint8Array(buffer);
	        for (var i = 0; i < len; i++) {
	            view[i] = binary.charCodeAt(i);
	        }
	        return buffer;
	    }
	
	    function objectURLToBlob(url, callback) {
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.responseType = "blob";
	        http.onload = function (e) {
	            if (this.status == 200 || this.status === 0) {
	                callback(this.response);
	            }
	        };
	        http.send();
	    }
	
	    function getImageData(img, callback) {
	        function handleBinaryFile(binFile) {
	            var data = findEXIFinJPEG(binFile);
	            var iptcdata = findIPTCinJPEG(binFile);
	            img.exifdata = data || {};
	            img.iptcdata = iptcdata || {};
	            if (callback) {
	                callback.call(img);
	            }
	        }
	
	        if (img.src) {
	            if (/^data\:/i.test(img.src)) { // Data URI
	                var arrayBuffer = base64ToArrayBuffer(img.src);
	                handleBinaryFile(arrayBuffer);
	
	            } else if (/^blob\:/i.test(img.src)) { // Object URL
	                var fileReader = new FileReader();
	                fileReader.onload = function (e) {
	                    handleBinaryFile(e.target.result);
	                };
	                objectURLToBlob(img.src, function (blob) {
	                    fileReader.readAsArrayBuffer(blob);
	                });
	            } else {
	                var http = new XMLHttpRequest();
	                http.onload = function () {
	                    if (this.status == 200 || this.status === 0) {
	                        handleBinaryFile(http.response);
	                    } else {
	                        throw "Could not load image";
	                    }
	                    http = null;
	                };
	                http.open("GET", img.src, true);
	                http.responseType = "arraybuffer";
	                http.send(null);
	            }
	        } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	                if (debug) console.log("Got file of length " + e.target.result.byteLength);
	                handleBinaryFile(e.target.result);
	            };
	
	            fileReader.readAsArrayBuffer(img);
	        }
	    }
	
	    function findEXIFinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            marker;
	
	        while (offset < length) {
	            if (dataView.getUint8(offset) != 0xFF) {
	                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
	                return false; // not a valid marker, something is wrong
	            }
	
	            marker = dataView.getUint8(offset + 1);
	            if (debug) console.log(marker);
	
	            // we could implement handling for other markers here,
	            // but we're only looking for 0xFFE1 for EXIF data
	
	            if (marker == 225) {
	                if (debug) console.log("Found 0xFFE1 marker");
	
	                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
	
	                // offset += 2 + file.getShortAt(offset+2, true);
	
	            } else {
	                offset += 2 + dataView.getUint16(offset + 2);
	            }
	
	        }
	
	    }
	
	    function findIPTCinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength;
	
	
	        var isFieldSegmentStart = function (dataView, offset) {
	            return (
	            dataView.getUint8(offset) === 0x38 &&
	            dataView.getUint8(offset + 1) === 0x42 &&
	            dataView.getUint8(offset + 2) === 0x49 &&
	            dataView.getUint8(offset + 3) === 0x4D &&
	            dataView.getUint8(offset + 4) === 0x04 &&
	            dataView.getUint8(offset + 5) === 0x04
	            );
	        };
	
	        while (offset < length) {
	
	            if (isFieldSegmentStart(dataView, offset)) {
	
	                // Get the length of the name header (which is padded to an even number of bytes)
	                var nameHeaderLength = dataView.getUint8(offset + 7);
	                if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
	                // Check for pre photoshop 6 format
	                if (nameHeaderLength === 0) {
	                    // Always 4
	                    nameHeaderLength = 4;
	                }
	
	                var startOffset = offset + 8 + nameHeaderLength;
	                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
	
	                return readIPTCData(file, startOffset, sectionLength);
	
	                break;
	
	            }
	
	
	            // Not the marker, continue searching
	            offset++;
	
	        }
	
	    }
	
	    var IptcFieldMap = {
	        0x78: 'caption',
	        0x6E: 'credit',
	        0x19: 'keywords',
	        0x37: 'dateCreated',
	        0x50: 'byline',
	        0x55: 'bylineTitle',
	        0x7A: 'captionWriter',
	        0x69: 'headline',
	        0x74: 'copyright',
	        0x0F: 'category'
	    };
	
	    function readIPTCData(file, startOffset, sectionLength) {
	        var dataView = new DataView(file);
	        var data = {};
	        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
	        var segmentStartPos = startOffset;
	        while (segmentStartPos < startOffset + sectionLength) {
	            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
	                segmentType = dataView.getUint8(segmentStartPos + 2);
	                if (segmentType in IptcFieldMap) {
	                    dataSize = dataView.getInt16(segmentStartPos + 3);
	                    segmentSize = dataSize + 5;
	                    fieldName = IptcFieldMap[segmentType];
	                    fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
	                    // Check if we already stored a value with this name
	                    if (data.hasOwnProperty(fieldName)) {
	                        // Value already stored with this name, create multivalue field
	                        if (data[fieldName] instanceof Array) {
	                            data[fieldName].push(fieldValue);
	                        }
	                        else {
	                            data[fieldName] = [data[fieldName], fieldValue];
	                        }
	                    }
	                    else {
	                        data[fieldName] = fieldValue;
	                    }
	                }
	
	            }
	            segmentStartPos++;
	        }
	        return data;
	    }
	
	
	    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
	        var entries = file.getUint16(dirStart, !bigEnd),
	            tags = {},
	            entryOffset, tag,
	            i;
	
	        for (i = 0; i < entries; i++) {
	            entryOffset = dirStart + i * 12 + 2;
	            tag = strings[file.getUint16(entryOffset, !bigEnd)];
	            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
	            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
	        }
	        return tags;
	    }
	
	
	    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
	        var type = file.getUint16(entryOffset + 2, !bigEnd),
	            numValues = file.getUint32(entryOffset + 4, !bigEnd),
	            valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart,
	            offset,
	            vals, val, n,
	            numerator, denominator;
	
	        switch (type) {
	            case 1: // byte, 8-bit unsigned int
	            case 7: // undefined, 8-bit byte, value depending on field
	                if (numValues == 1) {
	                    return file.getUint8(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint8(offset + n);
	                    }
	                    return vals;
	                }
	
	            case 2: // ascii, 8-bit byte
	                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                return getStringFromDB(file, offset, numValues - 1);
	
	            case 3: // short, 16 bit int
	                if (numValues == 1) {
	                    return file.getUint16(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 4: // long, 32 bit int
	                if (numValues == 1) {
	                    return file.getUint32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 5:    // rational = two long values, first is numerator, second is denominator
	                if (numValues == 1) {
	                    numerator = file.getUint32(valueOffset, !bigEnd);
	                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
	                    val = Number(numerator / denominator);
	                    val.numerator = numerator;
	                    val.denominator = denominator;
	                    return val;
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
	                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
	                        vals[n] = Number(numerator / denominator);
	                        vals[n].numerator = numerator;
	                        vals[n].denominator = denominator;
	                    }
	                    return vals;
	                }
	
	            case 9: // slong, 32 bit signed int
	                if (numValues == 1) {
	                    return file.getInt32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 10: // signed rational, two slongs, first is numerator, second is denominator
	                if (numValues == 1) {
	                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	        }
	    }
	
	    function getStringFromDB(buffer, start, length) {
	        var outstr = "";
	        for (n = start; n < start + length; n++) {
	            outstr += String.fromCharCode(buffer.getUint8(n));
	        }
	        return outstr;
	    }
	
	    function readEXIFData(file, start) {
	        if (getStringFromDB(file, start, 4) != "Exif") {
	            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
	            return false;
	        }
	
	        var bigEnd,
	            tags, tag,
	            exifData, gpsData,
	            tiffOffset = start + 6;
	
	        // test for TIFF validity and endianness
	        if (file.getUint16(tiffOffset) == 0x4949) {
	            bigEnd = false;
	        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
	            bigEnd = true;
	        } else {
	            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
	            return false;
	        }
	
	        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
	            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
	            return false;
	        }
	
	        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
	
	        if (firstIFDOffset < 0x00000008) {
	            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
	            return false;
	        }
	
	        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
	
	        if (tags.ExifIFDPointer) {
	            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
	            for (tag in exifData) {
	                switch (tag) {
	                    case "LightSource" :
	                    case "Flash" :
	                    case "MeteringMode" :
	                    case "ExposureProgram" :
	                    case "SensingMethod" :
	                    case "SceneCaptureType" :
	                    case "SceneType" :
	                    case "CustomRendered" :
	                    case "WhiteBalance" :
	                    case "GainControl" :
	                    case "Contrast" :
	                    case "Saturation" :
	                    case "Sharpness" :
	                    case "SubjectDistanceRange" :
	                    case "FileSource" :
	                        exifData[tag] = StringValues[tag][exifData[tag]];
	                        break;
	
	                    case "ExifVersion" :
	                    case "FlashpixVersion" :
	                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
	                        break;
	
	                    case "ComponentsConfiguration" :
	                        exifData[tag] =
	                            StringValues.Components[exifData[tag][0]] +
	                            StringValues.Components[exifData[tag][1]] +
	                            StringValues.Components[exifData[tag][2]] +
	                            StringValues.Components[exifData[tag][3]];
	                        break;
	                }
	                tags[tag] = exifData[tag];
	            }
	        }
	
	        if (tags.GPSInfoIFDPointer) {
	            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
	            for (tag in gpsData) {
	                switch (tag) {
	                    case "GPSVersionID" :
	                        gpsData[tag] = gpsData[tag][0] +
	                        "." + gpsData[tag][1] +
	                        "." + gpsData[tag][2] +
	                        "." + gpsData[tag][3];
	                        break;
	                }
	                tags[tag] = gpsData[tag];
	            }
	        }
	
	        return tags;
	    }
	
	    EXIF.getData = function (img, callback) {
	        if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) return false;
	
	        if (!imageHasData(img)) {
	            getImageData(img, callback);
	        } else {
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        return true;
	    };
	
	    EXIF.getTag = function (img, tag) {
	        if (!imageHasData(img)) return;
	        return img.exifdata[tag];
	    };
	
	    EXIF.getAllTags = function (img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.exifdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    };
	
	    EXIF.pretty = function (img) {
	        if (!imageHasData(img)) return "";
	        var a,
	            data = img.exifdata,
	            strPretty = "";
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                if (typeof data[a] == "object") {
	                    if (data[a] instanceof Number) {
	                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
	                    } else {
	                        strPretty += a + " : [" + data[a].length + " values]\r\n";
	                    }
	                } else {
	                    strPretty += a + " : " + data[a] + "\r\n";
	                }
	            }
	        }
	        return strPretty;
	    };
	
	    EXIF.readFromBinaryFile = function (file) {
	        return findEXIFinJPEG(file);
	    };
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return EXIF;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}.call(this));
	


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	
	 Basic GUI blocking jpeg encoder ported to JavaScript and optimized by
	 Andreas Ritter, www.bytestrom.eu, 11/2009.
	
	 Example usage is given at the bottom of this file.
	
	 ---------
	
	 Copyright (c) 2008, Adobe Systems Incorporated
	 All rights reserved.
	
	 Redistribution and use in source and binary forms, with or without
	 modification, are permitted provided that the following conditions are
	 met:
	
	 * Redistributions of source code must retain the above copyright notice,
	 this list of conditions and the following disclaimer.
	
	 * Redistributions in binary form must reproduce the above copyright
	 notice, this list of conditions and the following disclaimer in the
	 documentation and/or other materials provided with the distribution.
	
	 * Neither the name of Adobe Systems Incorporated nor the names of its
	 contributors may be used to endorse or promote products derived from
	 this software without specific prior written permission.
	
	 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
	 IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
	 THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
	 PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR
	 CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	 EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	 PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	function JPEGEncoder(quality) {
	    var self = this;
	    var fround = Math.round;
	    var ffloor = Math.floor;
	    var YTable = new Array(64);
	    var UVTable = new Array(64);
	    var fdtbl_Y = new Array(64);
	    var fdtbl_UV = new Array(64);
	    var YDC_HT;
	    var UVDC_HT;
	    var YAC_HT;
	    var UVAC_HT;
	
	    var bitcode = new Array(65535);
	    var category = new Array(65535);
	    var outputfDCTQuant = new Array(64);
	    var DU = new Array(64);
	    var byteout = [];
	    var bytenew = 0;
	    var bytepos = 7;
	
	    var YDU = new Array(64);
	    var UDU = new Array(64);
	    var VDU = new Array(64);
	    var clt = new Array(256);
	    var RGB_YUV_TABLE = new Array(2048);
	    var currentQuality;
	
	    var ZigZag = [
	        0, 1, 5, 6, 14, 15, 27, 28,
	        2, 4, 7, 13, 16, 26, 29, 42,
	        3, 8, 12, 17, 25, 30, 41, 43,
	        9, 11, 18, 24, 31, 40, 44, 53,
	        10, 19, 23, 32, 39, 45, 52, 54,
	        20, 22, 33, 38, 46, 51, 55, 60,
	        21, 34, 37, 47, 50, 56, 59, 61,
	        35, 36, 48, 49, 57, 58, 62, 63
	    ];
	
	    var std_dc_luminance_nrcodes = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0];
	    var std_dc_luminance_values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	    var std_ac_luminance_nrcodes = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 0x7d];
	    var std_ac_luminance_values = [
	        0x01, 0x02, 0x03, 0x00, 0x04, 0x11, 0x05, 0x12,
	        0x21, 0x31, 0x41, 0x06, 0x13, 0x51, 0x61, 0x07,
	        0x22, 0x71, 0x14, 0x32, 0x81, 0x91, 0xa1, 0x08,
	        0x23, 0x42, 0xb1, 0xc1, 0x15, 0x52, 0xd1, 0xf0,
	        0x24, 0x33, 0x62, 0x72, 0x82, 0x09, 0x0a, 0x16,
	        0x17, 0x18, 0x19, 0x1a, 0x25, 0x26, 0x27, 0x28,
	        0x29, 0x2a, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39,
	        0x3a, 0x43, 0x44, 0x45, 0x46, 0x47, 0x48, 0x49,
	        0x4a, 0x53, 0x54, 0x55, 0x56, 0x57, 0x58, 0x59,
	        0x5a, 0x63, 0x64, 0x65, 0x66, 0x67, 0x68, 0x69,
	        0x6a, 0x73, 0x74, 0x75, 0x76, 0x77, 0x78, 0x79,
	        0x7a, 0x83, 0x84, 0x85, 0x86, 0x87, 0x88, 0x89,
	        0x8a, 0x92, 0x93, 0x94, 0x95, 0x96, 0x97, 0x98,
	        0x99, 0x9a, 0xa2, 0xa3, 0xa4, 0xa5, 0xa6, 0xa7,
	        0xa8, 0xa9, 0xaa, 0xb2, 0xb3, 0xb4, 0xb5, 0xb6,
	        0xb7, 0xb8, 0xb9, 0xba, 0xc2, 0xc3, 0xc4, 0xc5,
	        0xc6, 0xc7, 0xc8, 0xc9, 0xca, 0xd2, 0xd3, 0xd4,
	        0xd5, 0xd6, 0xd7, 0xd8, 0xd9, 0xda, 0xe1, 0xe2,
	        0xe3, 0xe4, 0xe5, 0xe6, 0xe7, 0xe8, 0xe9, 0xea,
	        0xf1, 0xf2, 0xf3, 0xf4, 0xf5, 0xf6, 0xf7, 0xf8,
	        0xf9, 0xfa
	    ];
	
	    var std_dc_chrominance_nrcodes = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0];
	    var std_dc_chrominance_values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	    var std_ac_chrominance_nrcodes = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 0x77];
	    var std_ac_chrominance_values = [
	        0x00, 0x01, 0x02, 0x03, 0x11, 0x04, 0x05, 0x21,
	        0x31, 0x06, 0x12, 0x41, 0x51, 0x07, 0x61, 0x71,
	        0x13, 0x22, 0x32, 0x81, 0x08, 0x14, 0x42, 0x91,
	        0xa1, 0xb1, 0xc1, 0x09, 0x23, 0x33, 0x52, 0xf0,
	        0x15, 0x62, 0x72, 0xd1, 0x0a, 0x16, 0x24, 0x34,
	        0xe1, 0x25, 0xf1, 0x17, 0x18, 0x19, 0x1a, 0x26,
	        0x27, 0x28, 0x29, 0x2a, 0x35, 0x36, 0x37, 0x38,
	        0x39, 0x3a, 0x43, 0x44, 0x45, 0x46, 0x47, 0x48,
	        0x49, 0x4a, 0x53, 0x54, 0x55, 0x56, 0x57, 0x58,
	        0x59, 0x5a, 0x63, 0x64, 0x65, 0x66, 0x67, 0x68,
	        0x69, 0x6a, 0x73, 0x74, 0x75, 0x76, 0x77, 0x78,
	        0x79, 0x7a, 0x82, 0x83, 0x84, 0x85, 0x86, 0x87,
	        0x88, 0x89, 0x8a, 0x92, 0x93, 0x94, 0x95, 0x96,
	        0x97, 0x98, 0x99, 0x9a, 0xa2, 0xa3, 0xa4, 0xa5,
	        0xa6, 0xa7, 0xa8, 0xa9, 0xaa, 0xb2, 0xb3, 0xb4,
	        0xb5, 0xb6, 0xb7, 0xb8, 0xb9, 0xba, 0xc2, 0xc3,
	        0xc4, 0xc5, 0xc6, 0xc7, 0xc8, 0xc9, 0xca, 0xd2,
	        0xd3, 0xd4, 0xd5, 0xd6, 0xd7, 0xd8, 0xd9, 0xda,
	        0xe2, 0xe3, 0xe4, 0xe5, 0xe6, 0xe7, 0xe8, 0xe9,
	        0xea, 0xf2, 0xf3, 0xf4, 0xf5, 0xf6, 0xf7, 0xf8,
	        0xf9, 0xfa
	    ];
	
	    function initQuantTables(sf) {
	        var YQT = [
	            16, 11, 10, 16, 24, 40, 51, 61,
	            12, 12, 14, 19, 26, 58, 60, 55,
	            14, 13, 16, 24, 40, 57, 69, 56,
	            14, 17, 22, 29, 51, 87, 80, 62,
	            18, 22, 37, 56, 68, 109, 103, 77,
	            24, 35, 55, 64, 81, 104, 113, 92,
	            49, 64, 78, 87, 103, 121, 120, 101,
	            72, 92, 95, 98, 112, 100, 103, 99
	        ];
	
	        for (var i = 0; i < 64; i++) {
	            var t = ffloor((YQT[i] * sf + 50) / 100);
	            if (t < 1) {
	                t = 1;
	            } else if (t > 255) {
	                t = 255;
	            }
	            YTable[ZigZag[i]] = t;
	        }
	        var UVQT = [
	            17, 18, 24, 47, 99, 99, 99, 99,
	            18, 21, 26, 66, 99, 99, 99, 99,
	            24, 26, 56, 99, 99, 99, 99, 99,
	            47, 66, 99, 99, 99, 99, 99, 99,
	            99, 99, 99, 99, 99, 99, 99, 99,
	            99, 99, 99, 99, 99, 99, 99, 99,
	            99, 99, 99, 99, 99, 99, 99, 99,
	            99, 99, 99, 99, 99, 99, 99, 99
	        ];
	        for (var j = 0; j < 64; j++) {
	            var u = ffloor((UVQT[j] * sf + 50) / 100);
	            if (u < 1) {
	                u = 1;
	            } else if (u > 255) {
	                u = 255;
	            }
	            UVTable[ZigZag[j]] = u;
	        }
	        var aasf = [
	            1.0, 1.387039845, 1.306562965, 1.175875602,
	            1.0, 0.785694958, 0.541196100, 0.275899379
	        ];
	        var k = 0;
	        for (var row = 0; row < 8; row++) {
	            for (var col = 0; col < 8; col++) {
	                fdtbl_Y[k] = (1.0 / (YTable [ZigZag[k]] * aasf[row] * aasf[col] * 8.0));
	                fdtbl_UV[k] = (1.0 / (UVTable[ZigZag[k]] * aasf[row] * aasf[col] * 8.0));
	                k++;
	            }
	        }
	    }
	
	    function computeHuffmanTbl(nrcodes, std_table) {
	        var codevalue = 0;
	        var pos_in_table = 0;
	        var HT = [];
	        for (var k = 1; k <= 16; k++) {
	            for (var j = 1; j <= nrcodes[k]; j++) {
	                HT[std_table[pos_in_table]] = [];
	                HT[std_table[pos_in_table]][0] = codevalue;
	                HT[std_table[pos_in_table]][1] = k;
	                pos_in_table++;
	                codevalue++;
	            }
	            codevalue *= 2;
	        }
	        return HT;
	    }
	
	    function initHuffmanTbl() {
	        YDC_HT = computeHuffmanTbl(std_dc_luminance_nrcodes, std_dc_luminance_values);
	        UVDC_HT = computeHuffmanTbl(std_dc_chrominance_nrcodes, std_dc_chrominance_values);
	        YAC_HT = computeHuffmanTbl(std_ac_luminance_nrcodes, std_ac_luminance_values);
	        UVAC_HT = computeHuffmanTbl(std_ac_chrominance_nrcodes, std_ac_chrominance_values);
	    }
	
	    function initCategoryNumber() {
	        var nrlower = 1;
	        var nrupper = 2;
	        for (var cat = 1; cat <= 15; cat++) {
	            //Positive numbers
	            for (var nr = nrlower; nr < nrupper; nr++) {
	                category[32767 + nr] = cat;
	                bitcode[32767 + nr] = [];
	                bitcode[32767 + nr][1] = cat;
	                bitcode[32767 + nr][0] = nr;
	            }
	            //Negative numbers
	            for (var nrneg = -(nrupper - 1); nrneg <= -nrlower; nrneg++) {
	                category[32767 + nrneg] = cat;
	                bitcode[32767 + nrneg] = [];
	                bitcode[32767 + nrneg][1] = cat;
	                bitcode[32767 + nrneg][0] = nrupper - 1 + nrneg;
	            }
	            nrlower <<= 1;
	            nrupper <<= 1;
	        }
	    }
	
	    function initRGBYUVTable() {
	        for (var i = 0; i < 256; i++) {
	            RGB_YUV_TABLE[i] = 19595 * i;
	            RGB_YUV_TABLE[(i + 256) >> 0] = 38470 * i;
	            RGB_YUV_TABLE[(i + 512) >> 0] = 7471 * i + 0x8000;
	            RGB_YUV_TABLE[(i + 768) >> 0] = -11059 * i;
	            RGB_YUV_TABLE[(i + 1024) >> 0] = -21709 * i;
	            RGB_YUV_TABLE[(i + 1280) >> 0] = 32768 * i + 0x807FFF;
	            RGB_YUV_TABLE[(i + 1536) >> 0] = -27439 * i;
	            RGB_YUV_TABLE[(i + 1792) >> 0] = -5329 * i;
	        }
	    }
	
	    // IO functions
	    function writeBits(bs) {
	        var value = bs[0];
	        var posval = bs[1] - 1;
	        while (posval >= 0) {
	            if (value & (1 << posval)) {
	                bytenew |= (1 << bytepos);
	            }
	            posval--;
	            bytepos--;
	            if (bytepos < 0) {
	                if (bytenew == 0xFF) {
	                    writeByte(0xFF);
	                    writeByte(0);
	                }
	                else {
	                    writeByte(bytenew);
	                }
	                bytepos = 7;
	                bytenew = 0;
	            }
	        }
	    }
	
	    function writeByte(value) {
	        byteout.push(clt[value]); // write char directly instead of converting later
	    }
	
	    function writeWord(value) {
	        writeByte((value >> 8) & 0xFF);
	        writeByte((value   ) & 0xFF);
	    }
	
	    // DCT & quantization core
	    function fDCTQuant(data, fdtbl) {
	        var d0, d1, d2, d3, d4, d5, d6, d7;
	        /* Pass 1: process rows. */
	        var dataOff = 0;
	        var i;
	        const I8 = 8;
	        const I64 = 64;
	        for (i = 0; i < I8; ++i) {
	            d0 = data[dataOff];
	            d1 = data[dataOff + 1];
	            d2 = data[dataOff + 2];
	            d3 = data[dataOff + 3];
	            d4 = data[dataOff + 4];
	            d5 = data[dataOff + 5];
	            d6 = data[dataOff + 6];
	            d7 = data[dataOff + 7];
	
	            var tmp0 = d0 + d7;
	            var tmp7 = d0 - d7;
	            var tmp1 = d1 + d6;
	            var tmp6 = d1 - d6;
	            var tmp2 = d2 + d5;
	            var tmp5 = d2 - d5;
	            var tmp3 = d3 + d4;
	            var tmp4 = d3 - d4;
	
	            /* Even part */
	            var tmp10 = tmp0 + tmp3;
	            /* phase 2 */
	            var tmp13 = tmp0 - tmp3;
	            var tmp11 = tmp1 + tmp2;
	            var tmp12 = tmp1 - tmp2;
	
	            data[dataOff] = tmp10 + tmp11;
	            /* phase 3 */
	            data[dataOff + 4] = tmp10 - tmp11;
	
	            var z1 = (tmp12 + tmp13) * 0.707106781;
	            /* c4 */
	            data[dataOff + 2] = tmp13 + z1;
	            /* phase 5 */
	            data[dataOff + 6] = tmp13 - z1;
	
	            /* Odd part */
	            tmp10 = tmp4 + tmp5;
	            /* phase 2 */
	            tmp11 = tmp5 + tmp6;
	            tmp12 = tmp6 + tmp7;
	
	            /* The rotator is modified from fig 4-8 to avoid extra negations. */
	            var z5 = (tmp10 - tmp12) * 0.382683433;
	            /* c6 */
	            var z2 = 0.541196100 * tmp10 + z5;
	            /* c2-c6 */
	            var z4 = 1.306562965 * tmp12 + z5;
	            /* c2+c6 */
	            var z3 = tmp11 * 0.707106781;
	            /* c4 */
	
	            var z11 = tmp7 + z3;
	            /* phase 5 */
	            var z13 = tmp7 - z3;
	
	            data[dataOff + 5] = z13 + z2;
	            /* phase 6 */
	            data[dataOff + 3] = z13 - z2;
	            data[dataOff + 1] = z11 + z4;
	            data[dataOff + 7] = z11 - z4;
	
	            dataOff += 8;
	            /* advance pointer to next row */
	        }
	
	        /* Pass 2: process columns. */
	        dataOff = 0;
	        for (i = 0; i < I8; ++i) {
	            d0 = data[dataOff];
	            d1 = data[dataOff + 8];
	            d2 = data[dataOff + 16];
	            d3 = data[dataOff + 24];
	            d4 = data[dataOff + 32];
	            d5 = data[dataOff + 40];
	            d6 = data[dataOff + 48];
	            d7 = data[dataOff + 56];
	
	            var tmp0p2 = d0 + d7;
	            var tmp7p2 = d0 - d7;
	            var tmp1p2 = d1 + d6;
	            var tmp6p2 = d1 - d6;
	            var tmp2p2 = d2 + d5;
	            var tmp5p2 = d2 - d5;
	            var tmp3p2 = d3 + d4;
	            var tmp4p2 = d3 - d4;
	
	            /* Even part */
	            var tmp10p2 = tmp0p2 + tmp3p2;
	            /* phase 2 */
	            var tmp13p2 = tmp0p2 - tmp3p2;
	            var tmp11p2 = tmp1p2 + tmp2p2;
	            var tmp12p2 = tmp1p2 - tmp2p2;
	
	            data[dataOff] = tmp10p2 + tmp11p2;
	            /* phase 3 */
	            data[dataOff + 32] = tmp10p2 - tmp11p2;
	
	            var z1p2 = (tmp12p2 + tmp13p2) * 0.707106781;
	            /* c4 */
	            data[dataOff + 16] = tmp13p2 + z1p2;
	            /* phase 5 */
	            data[dataOff + 48] = tmp13p2 - z1p2;
	
	            /* Odd part */
	            tmp10p2 = tmp4p2 + tmp5p2;
	            /* phase 2 */
	            tmp11p2 = tmp5p2 + tmp6p2;
	            tmp12p2 = tmp6p2 + tmp7p2;
	
	            /* The rotator is modified from fig 4-8 to avoid extra negations. */
	            var z5p2 = (tmp10p2 - tmp12p2) * 0.382683433;
	            /* c6 */
	            var z2p2 = 0.541196100 * tmp10p2 + z5p2;
	            /* c2-c6 */
	            var z4p2 = 1.306562965 * tmp12p2 + z5p2;
	            /* c2+c6 */
	            var z3p2 = tmp11p2 * 0.707106781;
	            /* c4 */
	            var z11p2 = tmp7p2 + z3p2;
	            /* phase 5 */
	            var z13p2 = tmp7p2 - z3p2;
	
	            data[dataOff + 40] = z13p2 + z2p2;
	            /* phase 6 */
	            data[dataOff + 24] = z13p2 - z2p2;
	            data[dataOff + 8] = z11p2 + z4p2;
	            data[dataOff + 56] = z11p2 - z4p2;
	
	            dataOff++;
	            /* advance pointer to next column */
	        }
	
	        // Quantize/descale the coefficients
	        var fDCTQuant;
	        for (i = 0; i < I64; ++i) {
	            // Apply the quantization and scaling factor & Round to nearest integer
	            fDCTQuant = data[i] * fdtbl[i];
	            outputfDCTQuant[i] = (fDCTQuant > 0.0) ? ((fDCTQuant + 0.5) | 0) : ((fDCTQuant - 0.5) | 0);
	            //outputfDCTQuant[i] = fround(fDCTQuant);
	
	        }
	        return outputfDCTQuant;
	    }
	
	    function writeAPP0() {
	        writeWord(0xFFE0); // marker
	        writeWord(16); // length
	        writeByte(0x4A); // J
	        writeByte(0x46); // F
	        writeByte(0x49); // I
	        writeByte(0x46); // F
	        writeByte(0); // = "JFIF",'\0'
	        writeByte(1); // versionhi
	        writeByte(1); // versionlo
	        writeByte(0); // xyunits
	        writeWord(1); // xdensity
	        writeWord(1); // ydensity
	        writeByte(0); // thumbnwidth
	        writeByte(0); // thumbnheight
	    }
	
	    function writeSOF0(width, height) {
	        writeWord(0xFFC0); // marker
	        writeWord(17);   // length, truecolor YUV JPG
	        writeByte(8);    // precision
	        writeWord(height);
	        writeWord(width);
	        writeByte(3);    // nrofcomponents
	        writeByte(1);    // IdY
	        writeByte(0x11); // HVY
	        writeByte(0);    // QTY
	        writeByte(2);    // IdU
	        writeByte(0x11); // HVU
	        writeByte(1);    // QTU
	        writeByte(3);    // IdV
	        writeByte(0x11); // HVV
	        writeByte(1);    // QTV
	    }
	
	    function writeDQT() {
	        writeWord(0xFFDB); // marker
	        writeWord(132);       // length
	        writeByte(0);
	        for (var i = 0; i < 64; i++) {
	            writeByte(YTable[i]);
	        }
	        writeByte(1);
	        for (var j = 0; j < 64; j++) {
	            writeByte(UVTable[j]);
	        }
	    }
	
	    function writeDHT() {
	        writeWord(0xFFC4); // marker
	        writeWord(0x01A2); // length
	
	        writeByte(0); // HTYDCinfo
	        for (var i = 0; i < 16; i++) {
	            writeByte(std_dc_luminance_nrcodes[i + 1]);
	        }
	        for (var j = 0; j <= 11; j++) {
	            writeByte(std_dc_luminance_values[j]);
	        }
	
	        writeByte(0x10); // HTYACinfo
	        for (var k = 0; k < 16; k++) {
	            writeByte(std_ac_luminance_nrcodes[k + 1]);
	        }
	        for (var l = 0; l <= 161; l++) {
	            writeByte(std_ac_luminance_values[l]);
	        }
	
	        writeByte(1); // HTUDCinfo
	        for (var m = 0; m < 16; m++) {
	            writeByte(std_dc_chrominance_nrcodes[m + 1]);
	        }
	        for (var n = 0; n <= 11; n++) {
	            writeByte(std_dc_chrominance_values[n]);
	        }
	
	        writeByte(0x11); // HTUACinfo
	        for (var o = 0; o < 16; o++) {
	            writeByte(std_ac_chrominance_nrcodes[o + 1]);
	        }
	        for (var p = 0; p <= 161; p++) {
	            writeByte(std_ac_chrominance_values[p]);
	        }
	    }
	
	    function writeSOS() {
	        writeWord(0xFFDA); // marker
	        writeWord(12); // length
	        writeByte(3); // nrofcomponents
	        writeByte(1); // IdY
	        writeByte(0); // HTY
	        writeByte(2); // IdU
	        writeByte(0x11); // HTU
	        writeByte(3); // IdV
	        writeByte(0x11); // HTV
	        writeByte(0); // Ss
	        writeByte(0x3f); // Se
	        writeByte(0); // Bf
	    }
	
	    function processDU(CDU, fdtbl, DC, HTDC, HTAC) {
	        var EOB = HTAC[0x00];
	        var M16zeroes = HTAC[0xF0];
	        var pos;
	        const I16 = 16;
	        const I63 = 63;
	        const I64 = 64;
	        var DU_DCT = fDCTQuant(CDU, fdtbl);
	        //ZigZag reorder
	        for (var j = 0; j < I64; ++j) {
	            DU[ZigZag[j]] = DU_DCT[j];
	        }
	        var Diff = DU[0] - DC;
	        DC = DU[0];
	        //Encode DC
	        if (Diff == 0) {
	            writeBits(HTDC[0]); // Diff might be 0
	        } else {
	            pos = 32767 + Diff;
	            writeBits(HTDC[category[pos]]);
	            writeBits(bitcode[pos]);
	        }
	        //Encode ACs
	        var end0pos = 63; // was const... which is crazy
	        for (; (end0pos > 0) && (DU[end0pos] == 0); end0pos--) {
	        }
	        //end0pos = first element in reverse order !=0
	        if (end0pos == 0) {
	            writeBits(EOB);
	            return DC;
	        }
	        var i = 1;
	        var lng;
	        while (i <= end0pos) {
	            var startpos = i;
	            for (; (DU[i] == 0) && (i <= end0pos); ++i) {
	            }
	            var nrzeroes = i - startpos;
	            if (nrzeroes >= I16) {
	                lng = nrzeroes >> 4;
	                for (var nrmarker = 1; nrmarker <= lng; ++nrmarker)
	                    writeBits(M16zeroes);
	                nrzeroes = nrzeroes & 0xF;
	            }
	            pos = 32767 + DU[i];
	            writeBits(HTAC[(nrzeroes << 4) + category[pos]]);
	            writeBits(bitcode[pos]);
	            i++;
	        }
	        if (end0pos != I63) {
	            writeBits(EOB);
	        }
	        return DC;
	    }
	
	    function initCharLookupTable() {
	        var sfcc = String.fromCharCode;
	        for (var i = 0; i < 256; i++) { ///// ACHTUNG // 255
	            clt[i] = sfcc(i);
	        }
	    }
	
	    this.encode = function (image, quality, toRaw) // image data object
	    {
	        var time_start = new Date().getTime();
	
	        if (quality) setQuality(quality);
	
	        // Initialize bit writer
	        byteout = [];
	        bytenew = 0;
	        bytepos = 7;
	
	        // Add JPEG headers
	        writeWord(0xFFD8); // SOI
	        writeAPP0();
	        writeDQT();
	        writeSOF0(image.width, image.height);
	        writeDHT();
	        writeSOS();
	
	        // Encode 8x8 macroblocks
	        var DCY = 0;
	        var DCU = 0;
	        var DCV = 0;
	
	        bytenew = 0;
	        bytepos = 7;
	
	        this.encode.displayName = "_encode_";
	
	        var imageData = image.data;
	        var width = image.width;
	        var height = image.height;
	
	        var quadWidth = width * 4;
	        var tripleWidth = width * 3;
	
	        var x, y = 0;
	        var r, g, b;
	        var start, p, col, row, pos;
	        while (y < height) {
	            x = 0;
	            while (x < quadWidth) {
	                start = quadWidth * y + x;
	                p = start;
	                col = -1;
	                row = 0;
	
	                for (pos = 0; pos < 64; pos++) {
	                    row = pos >> 3;// /8
	                    col = ( pos & 7 ) * 4; // %8
	                    p = start + ( row * quadWidth ) + col;
	
	                    if (y + row >= height) { // padding bottom
	                        p -= (quadWidth * (y + 1 + row - height));
	                    }
	
	                    if (x + col >= quadWidth) { // padding right
	                        p -= ((x + col) - quadWidth + 4)
	                    }
	
	                    r = imageData[p++];
	                    g = imageData[p++];
	                    b = imageData[p++];
	
	                    /* // calculate YUV values dynamically
	                     YDU[pos]=((( 0.29900)*r+( 0.58700)*g+( 0.11400)*b))-128; //-0x80
	                     UDU[pos]=(((-0.16874)*r+(-0.33126)*g+( 0.50000)*b));
	                     VDU[pos]=((( 0.50000)*r+(-0.41869)*g+(-0.08131)*b));
	                     */
	
	                    // use lookup table (slightly faster)
	                    YDU[pos] = ((RGB_YUV_TABLE[r] + RGB_YUV_TABLE[(g + 256) >> 0] + RGB_YUV_TABLE[(b + 512) >> 0]) >> 16) - 128;
	                    UDU[pos] = ((RGB_YUV_TABLE[(r + 768) >> 0] + RGB_YUV_TABLE[(g + 1024) >> 0] + RGB_YUV_TABLE[(b + 1280) >> 0]) >> 16) - 128;
	                    VDU[pos] = ((RGB_YUV_TABLE[(r + 1280) >> 0] + RGB_YUV_TABLE[(g + 1536) >> 0] + RGB_YUV_TABLE[(b + 1792) >> 0]) >> 16) - 128;
	
	                }
	
	                DCY = processDU(YDU, fdtbl_Y, DCY, YDC_HT, YAC_HT);
	                DCU = processDU(UDU, fdtbl_UV, DCU, UVDC_HT, UVAC_HT);
	                DCV = processDU(VDU, fdtbl_UV, DCV, UVDC_HT, UVAC_HT);
	                x += 32;
	            }
	            y += 8;
	        }
	
	        ////////////////////////////////////////////////////////////////
	
	        // Do the bit alignment of the EOI marker
	        if (bytepos >= 0) {
	            var fillbits = [];
	            fillbits[1] = bytepos + 1;
	            fillbits[0] = (1 << (bytepos + 1)) - 1;
	            writeBits(fillbits);
	        }
	
	        writeWord(0xFFD9); //EOI
	
	        if (toRaw) {
	            var len = byteout.length;
	            var data = new Uint8Array(len);
	
	            for (var i = 0; i < len; i++) {
	                data[i] = byteout[i].charCodeAt();
	            }
	
	            //cleanup
	            byteout = [];
	
	            // benchmarking
	            var duration = new Date().getTime() - time_start;
	            console.log('Encoding time: ' + duration + 'ms');
	
	            return data;
	        }
	
	        var jpegDataUri = 'data:image/jpeg;base64,' + btoa(byteout.join(''));
	
	        byteout = [];
	
	        // benchmarking
	        var duration = new Date().getTime() - time_start;
	        console.log('Encoding time: ' + duration + 'ms');
	
	        return jpegDataUri
	    };
	
	    function setQuality(quality) {
	        if (quality <= 0) {
	            quality = 1;
	        }
	        if (quality > 100) {
	            quality = 100;
	        }
	
	        if (currentQuality == quality) return; // don't recalc if unchanged
	
	        var sf = 0;
	        if (quality < 50) {
	            sf = Math.floor(5000 / quality);
	        } else {
	            sf = Math.floor(200 - quality * 2);
	        }
	
	        initQuantTables(sf);
	        currentQuality = quality;
	        console.log('Quality set to: ' + quality + '%');
	    }
	
	    function init() {
	        var time_start = new Date().getTime();
	        if (!quality) quality = 50;
	        // Create tables
	        initCharLookupTable();
	        initHuffmanTbl();
	        initCategoryNumber();
	        initRGBYUVTable();
	
	        setQuality(quality);
	        var duration = new Date().getTime() - time_start;
	        console.log('Initialization ' + duration + 'ms');
	    }
	
	    init();
	
	}
	/* Example usage. Quality is an int in the range [0, 100]
	 function example(quality){
	 // Pass in an existing image from the page
	 var theImg = document.getElementById('testimage');
	 // Use a canvas to extract the raw image data
	 var cvs = document.createElement('canvas');
	 cvs.width = theImg.width;
	 cvs.height = theImg.height;
	 var ctx = cvs.getContext("2d");
	 ctx.drawImage(theImg,0,0);
	 var theImgData = (ctx.getImageData(0, 0, cvs.width, cvs.height));
	 // Encode the image and get a URI back, toRaw is false by default
	 var jpegURI = encoder.encode(theImgData, quality);
	 var img = document.createElement('img');
	 img.src = jpegURI;
	 document.body.appendChild(img);
	 }
	
	 Example usage for getting back raw data and transforming it to a blob.
	 Raw data is useful when trying to send an image over XHR or Websocket,
	 it uses around 30% less bytes then a Base64 encoded string. It can
	 also be useful if you want to save the image to disk using a FileWriter.
	
	 NOTE: The browser you are using must support Blobs
	 function example(quality){
	 // Pass in an existing image from the page
	 var theImg = document.getElementById('testimage');
	 // Use a canvas to extract the raw image data
	 var cvs = document.createElement('canvas');
	 cvs.width = theImg.width;
	 cvs.height = theImg.height;
	 var ctx = cvs.getContext("2d");
	 ctx.drawImage(theImg,0,0);
	 var theImgData = (ctx.getImageData(0, 0, cvs.width, cvs.height));
	 // Encode the image and get a URI back, set toRaw to true
	 var rawData = encoder.encode(theImgData, quality, true);
	
	 blob = new Blob([rawData.buffer], {type: 'image/jpeg'});
	 var jpegURI = URL.createObjectURL(blob);
	
	 var img = document.createElement('img');
	 img.src = jpegURI;
	 document.body.appendChild(img);
	 }*/
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return JPEGEncoder;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Mega pixel image rendering library for iOS6 Safari
	 *
	 * Fixes iOS6 Safari's image file rendering issue for large size image (over mega-pixel),
	 * which causes unexpected subsampling when drawing it in canvas.
	 * By using this library, you can safely render the image with proper stretching.
	 *
	 * Copyright (c) 2012 Shinichi Tomita <shinichi.tomita@gmail.com>
	 * Released under the MIT license
	 */
	(function () {
	
	    /**
	     * Detect subsampling in loaded image.
	     * In iOS, larger images than 2M pixels may be subsampled in rendering.
	     */
	    function detectSubsampling(img) {
	        var iw = img.naturalWidth, ih = img.naturalHeight;
	        if (iw * ih > 1024 * 1024) { // subsampling may happen over megapixel image
	            var canvas = document.createElement('canvas');
	            canvas.width = canvas.height = 1;
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(img, -iw + 1, 0);
	            // subsampled image becomes half smaller in rendering size.
	            // check alpha channel value to confirm image is covering edge pixel or not.
	            // if alpha value is 0 image is not covering, hence subsampled.
	            return ctx.getImageData(0, 0, 1, 1).data[3] === 0;
	        } else {
	            return false;
	        }
	    }
	
	    /**
	     * Detecting vertical squash in loaded image.
	     * Fixes a bug which squash image vertically while drawing into canvas for some images.
	     */
	    function detectVerticalSquash(img, iw, ih) {
	        var canvas = document.createElement('canvas');
	        canvas.width = 1;
	        canvas.height = ih;
	        var ctx = canvas.getContext('2d');
	        ctx.drawImage(img, 0, 0);
	        var data = ctx.getImageData(0, 0, 1, ih).data;
	        // search image edge pixel position in case it is squashed vertically.
	        var sy = 0;
	        var ey = ih;
	        var py = ih;
	        while (py > sy) {
	            var alpha = data[(py - 1) * 4 + 3];
	            if (alpha === 0) {
	                ey = py;
	            } else {
	                sy = py;
	            }
	            py = (ey + sy) >> 1;
	        }
	        var ratio = (py / ih);
	        return (ratio === 0) ? 1 : ratio;
	    }
	
	    /**
	     * Rendering image element (with resizing) and get its data URL
	     */
	    function renderImageToDataURL(img, options, doSquash) {
	        var canvas = document.createElement('canvas');
	        renderImageToCanvas(img, canvas, options, doSquash);
	        return canvas.toDataURL("image/jpeg", options.quality || 0.8);
	    }
	
	    /**
	     * Rendering image element (with resizing) into the canvas element
	     */
	    function renderImageToCanvas(img, canvas, options, doSquash) {
	        var iw = img.naturalWidth, ih = img.naturalHeight;
	        if (!(iw + ih)) return;
	        var width = options.width, height = options.height;
	        var ctx = canvas.getContext('2d');
	        ctx.save();
	        transformCoordinate(canvas, ctx, width, height, options.orientation);
	        var subsampled = detectSubsampling(img);
	        if (subsampled) {
	            iw /= 2;
	            ih /= 2;
	        }
	        var d = 1024; // size of tiling canvas
	        var tmpCanvas = document.createElement('canvas');
	        tmpCanvas.width = tmpCanvas.height = d;
	        var tmpCtx = tmpCanvas.getContext('2d');
	        var vertSquashRatio = doSquash ? detectVerticalSquash(img, iw, ih) : 1;
	        var dw = Math.ceil(d * width / iw);
	        var dh = Math.ceil(d * height / ih / vertSquashRatio);
	        var sy = 0;
	        var dy = 0;
	        while (sy < ih) {
	            var sx = 0;
	            var dx = 0;
	            while (sx < iw) {
	                tmpCtx.clearRect(0, 0, d, d);
	                tmpCtx.drawImage(img, -sx, -sy);
	                ctx.drawImage(tmpCanvas, 0, 0, d, d, dx, dy, dw, dh);
	                sx += d;
	                dx += dw;
	            }
	            sy += d;
	            dy += dh;
	        }
	        ctx.restore();
	        tmpCanvas = tmpCtx = null;
	    }
	
	    /**
	     * Transform canvas coordination according to specified frame size and orientation
	     * Orientation value is from EXIF tag
	     */
	    function transformCoordinate(canvas, ctx, width, height, orientation) {
	        switch (orientation) {
	            case 5:
	            case 6:
	            case 7:
	            case 8:
	                canvas.width = height;
	                canvas.height = width;
	                break;
	            default:
	                canvas.width = width;
	                canvas.height = height;
	        }
	        switch (orientation) {
	            case 2:
	                // horizontal flip
	                ctx.translate(width, 0);
	                ctx.scale(-1, 1);
	                break;
	            case 3:
	                // 180 rotate left
	                ctx.translate(width, height);
	                ctx.rotate(Math.PI);
	                break;
	            case 4:
	                // vertical flip
	                ctx.translate(0, height);
	                ctx.scale(1, -1);
	                break;
	            case 5:
	                // vertical flip + 90 rotate right
	                ctx.rotate(0.5 * Math.PI);
	                ctx.scale(1, -1);
	                break;
	            case 6:
	                // 90 rotate right
	                ctx.rotate(0.5 * Math.PI);
	                ctx.translate(0, -height);
	                break;
	            case 7:
	                // horizontal flip + 90 rotate right
	                ctx.rotate(0.5 * Math.PI);
	                ctx.translate(width, -height);
	                ctx.scale(-1, 1);
	                break;
	            case 8:
	                // 90 rotate left
	                ctx.rotate(-0.5 * Math.PI);
	                ctx.translate(-width, 0);
	                break;
	            default:
	                break;
	        }
	    }
	
	    var URL = window.URL && window.URL.createObjectURL ? window.URL :
	        window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL :
	            null;
	
	    /**
	     * MegaPixImage class
	     */
	    function MegaPixImage(srcImage) {
	        if (window.Blob && srcImage instanceof Blob) {
	            if (!URL) {
	                throw Error("No createObjectURL function found to create blob url");
	            }
	            var img = new Image();
	            img.src = URL.createObjectURL(srcImage);
	            this.blob = srcImage;
	            srcImage = img;
	        }
	        if (!srcImage.naturalWidth && !srcImage.naturalHeight) {
	            var _this = this;
	            srcImage.onload = srcImage.onerror = function () {
	                var listeners = _this.imageLoadListeners;
	                if (listeners) {
	                    _this.imageLoadListeners = null;
	                    for (var i = 0, len = listeners.length; i < len; i++) {
	                        listeners[i]();
	                    }
	                }
	            };
	            this.imageLoadListeners = [];
	        }
	        this.srcImage = srcImage;
	    }
	
	    /**
	     * Rendering megapix image into specified target element
	     */
	    MegaPixImage.prototype.render = function (target, options, callback) {
	        if (this.imageLoadListeners) {
	            var _this = this;
	            this.imageLoadListeners.push(function () {
	                _this.render(target, options, callback);
	            });
	            return;
	        }
	        options = options || {};
	        var imgWidth = this.srcImage.naturalWidth, imgHeight = this.srcImage.naturalHeight,
	            width = options.width, height = options.height,
	            maxWidth = options.maxWidth, maxHeight = options.maxHeight,
	            doSquash = !this.blob || this.blob.type === 'image/jpeg';
	        if (width && !height) {
	            height = (imgHeight * width / imgWidth) << 0;
	        } else if (height && !width) {
	            width = (imgWidth * height / imgHeight) << 0;
	        } else {
	            width = imgWidth;
	            height = imgHeight;
	        }
	        if (maxWidth && width > maxWidth) {
	            width = maxWidth;
	            height = (imgHeight * width / imgWidth) << 0;
	        }
	        if (maxHeight && height > maxHeight) {
	            height = maxHeight;
	            width = (imgWidth * height / imgHeight) << 0;
	        }
	        var opt = {width: width, height: height};
	        for (var k in options) opt[k] = options[k];
	
	        var tagName = target.tagName.toLowerCase();
	        if (tagName === 'img') {
	            target.src = renderImageToDataURL(this.srcImage, opt, doSquash);
	        } else if (tagName === 'canvas') {
	            renderImageToCanvas(this.srcImage, target, opt, doSquash);
	        }
	        if (typeof this.onrender === 'function') {
	            this.onrender(target);
	        }
	        if (callback) {
	            callback();
	        }
	        if (this.blob) {
	            this.blob = null;
	            URL.revokeObjectURL(this.srcImage.src);
	        }
	    };
	
	    /**
	     * Export class to global
	     */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return MegaPixImage;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // for AMD loader
	    } else if (typeof exports === 'object') {
	        module.exports = MegaPixImage; // for CommonJS
	    } else {
	        this.MegaPixImage = MegaPixImage;
	    }
	
	})();


/***/ }),

/***/ 122:
/***/ (function(module, exports) {

	/*!
	 * =====================================================
	 * SUI Mobile - http://m.sui.taobao.org/
	 *
	 * =====================================================
	 */
	;$.smVersion = "0.6.2";+function ($) {
	    "use strict";
	
	    //全局配置
	    var defaults = {
	        autoInit: false, //自动初始化页面
	        showPageLoadingIndicator: true, //push.js加载页面的时候显示一个加载提示
	        router: true, //默认使用router
	        swipePanel: "left", //滑动打开侧栏
	        swipePanelOnlyClose: true  //只允许滑动关闭，不允许滑动打开侧栏
	    };
	
	    $.smConfig = $.extend(defaults, $.config);
	
	}(Zepto);
	
	+ function($) {
	    "use strict";
	
	    //比较一个字符串版本号
	    //a > b === 1
	    //a = b === 0
	    //a < b === -1
	    $.compareVersion = function(a, b) {
	        var as = a.split('.');
	        var bs = b.split('.');
	        if (a === b) return 0;
	
	        for (var i = 0; i < as.length; i++) {
	            var x = parseInt(as[i]);
	            if (!bs[i]) return 1;
	            var y = parseInt(bs[i]);
	            if (x < y) return -1;
	            if (x > y) return 1;
	        }
	        return -1;
	    };
	
	    $.getCurrentPage = function() {
	        return $(".page-current")[0] || $(".page")[0] || document.body;
	    };
	
	}(Zepto);
	
	/* global WebKitCSSMatrix:true */
	
	(function($) {
	    "use strict";
	    ['width', 'height'].forEach(function(dimension) {
	        var  Dimension = dimension.replace(/./, function(m) {
	            return m[0].toUpperCase();
	        });
	        $.fn['outer' + Dimension] = function(margin) {
	            var elem = this;
	            if (elem) {
	                var size = elem[dimension]();
	                var sides = {
	                    'width': ['left', 'right'],
	                    'height': ['top', 'bottom']
	                };
	                sides[dimension].forEach(function(side) {
	                    if (margin) size += parseInt(elem.css('margin-' + side), 10);
	                });
	                return size;
	            } else {
	                return null;
	            }
	        };
	    });
	
	    //support
	    $.support = (function() {
	        var support = {
	            touch: !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch)
	        };
	        return support;
	    })();
	
	    $.touchEvents = {
	        start: $.support.touch ? 'touchstart' : 'mousedown',
	        move: $.support.touch ? 'touchmove' : 'mousemove',
	        end: $.support.touch ? 'touchend' : 'mouseup'
	    };
	
	    $.getTranslate = function (el, axis) {
	        var matrix, curTransform, curStyle, transformMatrix;
	
	        // automatic axis detection
	        if (typeof axis === 'undefined') {
	            axis = 'x';
	        }
	
	        curStyle = window.getComputedStyle(el, null);
	        if (window.WebKitCSSMatrix) {
	            // Some old versions of Webkit choke when 'none' is passed; pass
	            // empty string instead in this case
	            transformMatrix = new WebKitCSSMatrix(curStyle.webkitTransform === 'none' ? '' : curStyle.webkitTransform);
	        }
	        else {
	            transformMatrix = curStyle.MozTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	            matrix = transformMatrix.toString().split(',');
	        }
	
	        if (axis === 'x') {
	            //Latest Chrome and webkits Fix
	            if (window.WebKitCSSMatrix)
	                curTransform = transformMatrix.m41;
	            //Crazy IE10 Matrix
	            else if (matrix.length === 16)
	                curTransform = parseFloat(matrix[12]);
	            //Normal Browsers
	            else
	                curTransform = parseFloat(matrix[4]);
	        }
	        if (axis === 'y') {
	            //Latest Chrome and webkits Fix
	            if (window.WebKitCSSMatrix)
	                curTransform = transformMatrix.m42;
	            //Crazy IE10 Matrix
	            else if (matrix.length === 16)
	                curTransform = parseFloat(matrix[13]);
	            //Normal Browsers
	            else
	                curTransform = parseFloat(matrix[5]);
	        }
	
	        return curTransform || 0;
	    };
	    /* jshint ignore:start */
	    $.requestAnimationFrame = function (callback) {
	        if (requestAnimationFrame) return requestAnimationFrame(callback);
	        else if (webkitRequestAnimationFrame) return webkitRequestAnimationFrame(callback);
	        else if (mozRequestAnimationFrame) return mozRequestAnimationFrame(callback);
	        else {
	            return setTimeout(callback, 1000 / 60);
	        }
	    };
	    $.cancelAnimationFrame = function (id) {
	        if (cancelAnimationFrame) return cancelAnimationFrame(id);
	        else if (webkitCancelAnimationFrame) return webkitCancelAnimationFrame(id);
	        else if (mozCancelAnimationFrame) return mozCancelAnimationFrame(id);
	        else {
	            return clearTimeout(id);
	        }
	    };
	    /* jshint ignore:end */
	
	    $.fn.dataset = function() {
	        var dataset = {},
	            ds = this[0].dataset;
	        for (var key in ds) { // jshint ignore:line
	            var item = (dataset[key] = ds[key]);
	            if (item === 'false') dataset[key] = false;
	            else if (item === 'true') dataset[key] = true;
	            else if (parseFloat(item) === item * 1) dataset[key] = item * 1;
	        }
	        // mixin dataset and __eleData
	        return $.extend({}, dataset, this[0].__eleData);
	    };
	    $.fn.data = function(key, value) {
	        var tmpData = $(this).dataset();
	        if (!key) {
	            return tmpData;
	        }
	        // value may be 0, false, null
	        if (typeof value === 'undefined') {
	            // Get value
	            var dataVal = tmpData[key],
	                __eD = this[0].__eleData;
	
	            //if (dataVal !== undefined) {
	            if (__eD && (key in __eD)) {
	                return __eD[key];
	            } else {
	                return dataVal;
	            }
	
	        } else {
	            // Set value,uniformly set in extra ```__eleData```
	            for (var i = 0; i < this.length; i++) {
	                var el = this[i];
	                // delete multiple data in dataset
	                if (key in tmpData) delete el.dataset[key];
	
	                if (!el.__eleData) el.__eleData = {};
	                el.__eleData[key] = value;
	            }
	            return this;
	        }
	    };
	    function __dealCssEvent(eventNameArr, callback) {
	        var events = eventNameArr,
	            i, dom = this;// jshint ignore:line
	
	        function fireCallBack(e) {
	            /*jshint validthis:true */
	            if (e.target !== this) return;
	            callback.call(this, e);
	            for (i = 0; i < events.length; i++) {
	                dom.off(events[i], fireCallBack);
	            }
	        }
	        if (callback) {
	            for (i = 0; i < events.length; i++) {
	                dom.on(events[i], fireCallBack);
	            }
	        }
	    }
	    $.fn.animationEnd = function(callback) {
	        __dealCssEvent.call(this, ['webkitAnimationEnd', 'animationend'], callback);
	        return this;
	    };
	    $.fn.transitionEnd = function(callback) {
	        __dealCssEvent.call(this, ['webkitTransitionEnd', 'transitionend'], callback);
	        return this;
	    };
	    $.fn.transition = function(duration) {
	        if (typeof duration !== 'string') {
	            duration = duration + 'ms';
	        }
	        for (var i = 0; i < this.length; i++) {
	            var elStyle = this[i].style;
	            elStyle.webkitTransitionDuration = elStyle.MozTransitionDuration = elStyle.transitionDuration = duration;
	        }
	        return this;
	    };
	    $.fn.transform = function(transform) {
	        for (var i = 0; i < this.length; i++) {
	            var elStyle = this[i].style;
	            elStyle.webkitTransform = elStyle.MozTransform = elStyle.transform = transform;
	        }
	        return this;
	    };
	    $.fn.prevAll = function (selector) {
	        var prevEls = [];
	        var el = this[0];
	        if (!el) return $([]);
	        while (el.previousElementSibling) {
	            var prev = el.previousElementSibling;
	            if (selector) {
	                if($(prev).is(selector)) prevEls.push(prev);
	            }
	            else prevEls.push(prev);
	            el = prev;
	        }
	        return $(prevEls);
	    };
	    $.fn.nextAll = function (selector) {
	        var nextEls = [];
	        var el = this[0];
	        if (!el) return $([]);
	        while (el.nextElementSibling) {
	            var next = el.nextElementSibling;
	            if (selector) {
	                if($(next).is(selector)) nextEls.push(next);
	            }
	            else nextEls.push(next);
	            el = next;
	        }
	        return $(nextEls);
	    };
	
	    //重置zepto的show方法，防止有些人引用的版本中 show 方法操作 opacity 属性影响动画执行
	    $.fn.show = function(){
	        var elementDisplay = {};
	        function defaultDisplay(nodeName) {
	            var element, display;
	            if (!elementDisplay[nodeName]) {
	                element = document.createElement(nodeName);
	                document.body.appendChild(element);
	                display = getComputedStyle(element, '').getPropertyValue("display");
	                element.parentNode.removeChild(element);
	                display === "none" && (display = "block");
	                elementDisplay[nodeName] = display;
	            }
	            return elementDisplay[nodeName];
	        }
	
	        return this.each(function(){
	            this.style.display === "none" && (this.style.display = '');
	            if (getComputedStyle(this, '').getPropertyValue("display") === "none");
	            this.style.display = defaultDisplay(this.nodeName);
	        });
	    };
	})(Zepto);
	
	/*===========================
	Device/OS Detection
	===========================*/
	(function ($) {
	    "use strict";
	    var device = {};
	    var ua = navigator.userAgent;
	
	    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	    var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
	
	    device.ios = device.android = device.iphone = device.ipad = device.androidChrome = false;
	
	    // Android
	    if (android) {
	        device.os = 'android';
	        device.osVersion = android[2];
	        device.android = true;
	        device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	    }
	    if (ipad || iphone || ipod) {
	        device.os = 'ios';
	        device.ios = true;
	    }
	    // iOS
	    if (iphone && !ipod) {
	        device.osVersion = iphone[2].replace(/_/g, '.');
	        device.iphone = true;
	    }
	    if (ipad) {
	        device.osVersion = ipad[2].replace(/_/g, '.');
	        device.ipad = true;
	    }
	    if (ipod) {
	        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	        device.iphone = true;
	    }
	    // iOS 8+ changed UA
	    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	        if (device.osVersion.split('.')[0] === '10') {
	            device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	        }
	    }
	
	    // Webview
	    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
	
	    // Minimal UI
	    if (device.os && device.os === 'ios') {
	        var osVersionArr = device.osVersion.split('.');
	        device.minimalUi = !device.webView &&
	            (ipod || iphone) &&
	            (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
	            $('meta[name="viewport"]').length > 0 && $('meta[name="viewport"]').attr('content').indexOf('minimal-ui') >= 0;
	    }
	
	    // Check for status bar and fullscreen app mode
	    var windowWidth = $(window).width();
	    var windowHeight = $(window).height();
	    device.statusBar = false;
	    if (device.webView && (windowWidth * windowHeight === screen.width * screen.height)) {
	        device.statusBar = true;
	    }
	    else {
	        device.statusBar = false;
	    }
	
	    // Classes
	    var classNames = [];
	
	    // Pixel Ratio
	    device.pixelRatio = window.devicePixelRatio || 1;
	    classNames.push('pixel-ratio-' + Math.floor(device.pixelRatio));
	    if (device.pixelRatio >= 2) {
	        classNames.push('retina');
	    }
	
	    // OS classes
	    if (device.os) {
	        classNames.push(device.os, device.os + '-' + device.osVersion.split('.')[0], device.os + '-' + device.osVersion.replace(/\./g, '-'));
	        if (device.os === 'ios') {
	            var major = parseInt(device.osVersion.split('.')[0], 10);
	            for (var i = major - 1; i >= 6; i--) {
	                classNames.push('ios-gt-' + i);
	            }
	        }
	
	    }
	    // Status bar classes
	    if (device.statusBar) {
	        classNames.push('with-statusbar-overlay');
	    }
	    else {
	        $('html').removeClass('with-statusbar-overlay');
	    }
	
	    // Add html classes
	    if (classNames.length > 0) $('html').addClass(classNames.join(' '));
	
	    // keng..
	    device.isWeixin = /MicroMessenger/i.test(ua);
	
	    $.device = device;
	})(Zepto);
	
	(function () {
	    'use strict';
	
	    /**
	     * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	     *
	     * @codingstandard ftlabs-jsv2
	     * @copyright The Financial Times Limited [All Rights Reserved]
	     * @license MIT License (see LICENSE.txt)
	     */
	
	    /*jslint browser:true, node:true, elision:true*/
	    /*global Event, Node*/
	
	
	    /**
	     * Instantiate fast-clicking listeners on the specified layer.
	     *
	     * @constructor
	     * @param {Element} layer The layer to listen on
	     * @param {Object} [options={}] The options to override the defaults
	     */
	    function FastClick(layer, options) {
	        var oldOnClick;
	
	        options = options || {};
	
	        /**
	         * Whether a click is currently being tracked.
	         *
	         * @type boolean
	         */
	        this.trackingClick = false;
	
	
	        /**
	         * Timestamp for when click tracking started.
	         *
	         * @type number
	         */
	        this.trackingClickStart = 0;
	
	
	        /**
	         * The element being tracked for a click.
	         *
	         * @type EventTarget
	         */
	        this.targetElement = null;
	
	
	        /**
	         * X-coordinate of touch start event.
	         *
	         * @type number
	         */
	        this.touchStartX = 0;
	
	
	        /**
	         * Y-coordinate of touch start event.
	         *
	         * @type number
	         */
	        this.touchStartY = 0;
	
	
	        /**
	         * ID of the last touch, retrieved from Touch.identifier.
	         *
	         * @type number
	         */
	        this.lastTouchIdentifier = 0;
	
	
	        /**
	         * Touchmove boundary, beyond which a click will be cancelled.
	         *
	         * @type number
	         */
	        this.touchBoundary = options.touchBoundary || 10;
	
	
	        /**
	         * The FastClick layer.
	         *
	         * @type Element
	         */
	        this.layer = layer;
	
	        /**
	         * The minimum time between tap(touchstart and touchend) events
	         *
	         * @type number
	         */
	        this.tapDelay = options.tapDelay || 200;
	
	        /**
	         * The maximum time for a tap
	         *
	         * @type number
	         */
	        this.tapTimeout = options.tapTimeout || 700;
	
	        if (FastClick.notNeeded(layer)) {
	            return;
	        }
	
	        // Some old versions of Android don't have Function.prototype.bind
	        function bind(method, context) {
	            return function() { return method.apply(context, arguments); };
	        }
	
	
	        var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
	        var context = this;
	        for (var i = 0, l = methods.length; i < l; i++) {
	            context[methods[i]] = bind(context[methods[i]], context);
	        }
	
	        // Set up event handlers as required
	        if (deviceIsAndroid) {
	            layer.addEventListener('mouseover', this.onMouse, true);
	            layer.addEventListener('mousedown', this.onMouse, true);
	            layer.addEventListener('mouseup', this.onMouse, true);
	        }
	
	        layer.addEventListener('click', this.onClick, true);
	        layer.addEventListener('touchstart', this.onTouchStart, false);
	        layer.addEventListener('touchmove', this.onTouchMove, false);
	        layer.addEventListener('touchend', this.onTouchEnd, false);
	        layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
	        // Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
	        // which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
	        // layer when they are cancelled.
	        if (!Event.prototype.stopImmediatePropagation) {
	            layer.removeEventListener = function(type, callback, capture) {
	                var rmv = Node.prototype.removeEventListener;
	                if (type === 'click') {
	                    rmv.call(layer, type, callback.hijacked || callback, capture);
	                } else {
	                    rmv.call(layer, type, callback, capture);
	                }
	            };
	
	            layer.addEventListener = function(type, callback, capture) {
	                var adv = Node.prototype.addEventListener;
	                if (type === 'click') {
	                    adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
	                        if (!event.propagationStopped) {
	                            callback(event);
	                        }
	                    }), capture);
	                } else {
	                    adv.call(layer, type, callback, capture);
	                }
	            };
	        }
	
	        // If a handler is already declared in the element's onclick attribute, it will be fired before
	        // FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
	        // adding it as listener.
	        if (typeof layer.onclick === 'function') {
	
	            // Android browser on at least 3.2 requires a new reference to the function in layer.onclick
	            // - the old one won't work if passed to addEventListener directly.
	            oldOnClick = layer.onclick;
	            layer.addEventListener('click', function(event) {
	                oldOnClick(event);
	            }, false);
	            layer.onclick = null;
	        }
	    }
	
	    /**
	     * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	     *
	     * @type boolean
	     */
	    var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
	
	    /**
	     * Android requires exceptions.
	     *
	     * @type boolean
	     */
	    var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
	
	
	    /**
	     * iOS requires exceptions.
	     *
	     * @type boolean
	     */
	    var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
	
	
	    /**
	     * iOS 4 requires an exception for select elements.
	     *
	     * @type boolean
	     */
	    var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);
	
	
	    /**
	     * iOS 6.0-7.* requires the target element to be manually derived
	     *
	     * @type boolean
	     */
	    var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);
	
	    /**
	     * BlackBerry requires exceptions.
	     *
	     * @type boolean
	     */
	    var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;
	
	    /**
	     * 判断是否组合型label
	     * @type {Boolean}
	     */
	    var isCompositeLabel = false;
	
	    /**
	     * Determine whether a given element requires a native click.
	     *
	     * @param {EventTarget|Element} target Target DOM element
	     * @returns {boolean} Returns true if the element needs a native click
	     */
	    FastClick.prototype.needsClick = function(target) {
	
	        // 修复bug: 如果父元素中有 label
	        // 如果label上有needsclick这个类，则用原生的点击，否则，用模拟点击
	        var parent = target;
	        while(parent && (parent.tagName.toUpperCase() !== "BODY")) {
	            if (parent.tagName.toUpperCase() === "LABEL") {
	                isCompositeLabel = true;
	                if ((/\bneedsclick\b/).test(parent.className)) return true;
	            }
	            parent = parent.parentNode;
	        }
	
	        switch (target.nodeName.toLowerCase()) {
	
	            // Don't send a synthetic click to disabled inputs (issue #62)
	            case 'button':
	            case 'select':
	            case 'textarea':
	                if (target.disabled) {
	                    return true;
	                }
	
	                break;
	            case 'input':
	
	                // File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
	                if ((deviceIsIOS && target.type === 'file') || target.disabled) {
	                    return true;
	                }
	
	                break;
	            case 'label':
	            case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
	            case 'video':
	                return true;
	        }
	
	        return (/\bneedsclick\b/).test(target.className);
	    };
	
	
	    /**
	     * Determine whether a given element requires a call to focus to simulate click into element.
	     *
	     * @param {EventTarget|Element} target Target DOM element
	     * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	     */
	    FastClick.prototype.needsFocus = function(target) {
	        switch (target.nodeName.toLowerCase()) {
	            case 'textarea':
	                return true;
	            case 'select':
	                return !deviceIsAndroid;
	            case 'input':
	                switch (target.type) {
	                    case 'button':
	                    case 'checkbox':
	                    case 'file':
	                    case 'image':
	                    case 'radio':
	                    case 'submit':
	                        return false;
	                }
	
	                // No point in attempting to focus disabled inputs
	                return !target.disabled && !target.readOnly;
	            default:
	                return (/\bneedsfocus\b/).test(target.className);
	        }
	    };
	
	
	    /**
	     * Send a click event to the specified element.
	     *
	     * @param {EventTarget|Element} targetElement
	     * @param {Event} event
	     */
	    FastClick.prototype.sendClick = function(targetElement, event) {
	        var clickEvent, touch;
	
	        // On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
	        if (document.activeElement && document.activeElement !== targetElement) {
	            document.activeElement.blur();
	        }
	
	        touch = event.changedTouches[0];
	
	        // Synthesise a click event, with an extra attribute so it can be tracked
	        clickEvent = document.createEvent('MouseEvents');
	        clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
	        clickEvent.forwardedTouchEvent = true;
	        targetElement.dispatchEvent(clickEvent);
	    };
	
	    FastClick.prototype.determineEventType = function(targetElement) {
	
	        //Issue #159: Android Chrome Select Box does not open with a synthetic click event
	        if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
	            return 'mousedown';
	        }
	
	        return 'click';
	    };
	
	
	    /**
	     * @param {EventTarget|Element} targetElement
	     */
	    FastClick.prototype.focus = function(targetElement) {
	        var length;
	
	        // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
	        var unsupportedType = ['date', 'time', 'month', 'number', 'email'];
	        if (deviceIsIOS && targetElement.setSelectionRange && unsupportedType.indexOf(targetElement.type) === -1) {
	            length = targetElement.value.length;
	            targetElement.setSelectionRange(length, length);
	        } else {
	            targetElement.focus();
	        }
	    };
	
	
	    /**
	     * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	     *
	     * @param {EventTarget|Element} targetElement
	     */
	    FastClick.prototype.updateScrollParent = function(targetElement) {
	        var scrollParent, parentElement;
	
	        scrollParent = targetElement.fastClickScrollParent;
	
	        // Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
	        // target element was moved to another parent.
	        if (!scrollParent || !scrollParent.contains(targetElement)) {
	            parentElement = targetElement;
	            do {
	                if (parentElement.scrollHeight > parentElement.offsetHeight) {
	                    scrollParent = parentElement;
	                    targetElement.fastClickScrollParent = parentElement;
	                    break;
	                }
	
	                parentElement = parentElement.parentElement;
	            } while (parentElement);
	        }
	
	        // Always update the scroll top tracker if possible.
	        if (scrollParent) {
	            scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
	        }
	    };
	
	
	    /**
	     * @param {EventTarget} targetElement
	     * @returns {Element|EventTarget}
	     */
	    FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
	
	        // On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
	        if (eventTarget.nodeType === Node.TEXT_NODE) {
	            return eventTarget.parentNode;
	        }
	
	        return eventTarget;
	    };
	
	
	    /**
	     * On touch start, record the position and scroll offset.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onTouchStart = function(event) {
	        var targetElement, touch, selection;
	
	        // Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
	        if (event.targetTouches.length > 1) {
	            return true;
	        }
	
	        targetElement = this.getTargetElementFromEventTarget(event.target);
	        touch = event.targetTouches[0];
	
	        if (deviceIsIOS) {
	
	            // Only trusted events will deselect text on iOS (issue #49)
	            selection = window.getSelection();
	            if (selection.rangeCount && !selection.isCollapsed) {
	                return true;
	            }
	
	            if (!deviceIsIOS4) {
	
	                // Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
	                // when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
	                // with the same identifier as the touch event that previously triggered the click that triggered the alert.
	                // Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
	                // immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
	                // Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
	                // which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
	                // random integers, it's safe to to continue if the identifier is 0 here.
	                if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
	                    event.preventDefault();
	                    return false;
	                }
	
	                this.lastTouchIdentifier = touch.identifier;
	
	                // If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
	                // 1) the user does a fling scroll on the scrollable layer
	                // 2) the user stops the fling scroll with another tap
	                // then the event.target of the last 'touchend' event will be the element that was under the user's finger
	                // when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
	                // is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
	                this.updateScrollParent(targetElement);
	            }
	        }
	
	        this.trackingClick = true;
	        this.trackingClickStart = event.timeStamp;
	        this.targetElement = targetElement;
	
	        this.touchStartX = touch.pageX;
	        this.touchStartY = touch.pageY;
	
	        // Prevent phantom clicks on fast double-tap (issue #36)
	        if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
	            event.preventDefault();
	        }
	
	        return true;
	    };
	
	
	    /**
	     * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.touchHasMoved = function(event) {
	        var touch = event.changedTouches[0], boundary = this.touchBoundary;
	
	        if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
	            return true;
	        }
	
	        return false;
	    };
	
	
	    /**
	     * Update the last position.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onTouchMove = function(event) {
	        if (!this.trackingClick) {
	            return true;
	        }
	
	        // If the touch has moved, cancel the click tracking
	        if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
	            this.trackingClick = false;
	            this.targetElement = null;
	        }
	
	        return true;
	    };
	
	
	    /**
	     * Attempt to find the labelled control for the given label element.
	     *
	     * @param {EventTarget|HTMLLabelElement} labelElement
	     * @returns {Element|null}
	     */
	    FastClick.prototype.findControl = function(labelElement) {
	
	        // Fast path for newer browsers supporting the HTML5 control attribute
	        if (labelElement.control !== undefined) {
	            return labelElement.control;
	        }
	
	        // All browsers under test that support touch events also support the HTML5 htmlFor attribute
	        if (labelElement.htmlFor) {
	            return document.getElementById(labelElement.htmlFor);
	        }
	
	        // If no for attribute exists, attempt to retrieve the first labellable descendant element
	        // the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
	        return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	    };
	
	
	    /**
	     * On touch end, determine whether to send a click event at once.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onTouchEnd = function(event) {
	        var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
	
	        if (!this.trackingClick) {
	            return true;
	        }
	
	        // Prevent phantom clicks on fast double-tap (issue #36)
	        if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
	            this.cancelNextClick = true;
	            return true;
	        }
	
	        if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
	            return true;
	        }
	        //修复安卓微信下，input type="date" 的bug，经测试date,time,month已没问题
	        var unsupportedType = ['date', 'time', 'month'];
	        if(unsupportedType.indexOf(event.target.type) !== -1){
	            　　　　return false;
	            　　}
	        // Reset to prevent wrong click cancel on input (issue #156).
	        this.cancelNextClick = false;
	
	        this.lastClickTime = event.timeStamp;
	
	        trackingClickStart = this.trackingClickStart;
	        this.trackingClick = false;
	        this.trackingClickStart = 0;
	
	        // On some iOS devices, the targetElement supplied with the event is invalid if the layer
	        // is performing a transition or scroll, and has to be re-detected manually. Note that
	        // for this to function correctly, it must be called *after* the event target is checked!
	        // See issue #57; also filed as rdar://13048589 .
	        if (deviceIsIOSWithBadTarget) {
	            touch = event.changedTouches[0];
	
	            // In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
	            targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
	            targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
	        }
	
	        targetTagName = targetElement.tagName.toLowerCase();
	        if (targetTagName === 'label') {
	            forElement = this.findControl(targetElement);
	            if (forElement) {
	                this.focus(targetElement);
	                if (deviceIsAndroid) {
	                    return false;
	                }
	
	                targetElement = forElement;
	            }
	        } else if (this.needsFocus(targetElement)) {
	
	            // Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
	            // Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
	            if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
	                this.targetElement = null;
	                return false;
	            }
	
	            this.focus(targetElement);
	            this.sendClick(targetElement, event);
	
	            // Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
	            // Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
	            if (!deviceIsIOS || targetTagName !== 'select') {
	                this.targetElement = null;
	                event.preventDefault();
	            }
	
	            return false;
	        }
	
	        if (deviceIsIOS && !deviceIsIOS4) {
	
	            // Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
	            // and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
	            scrollParent = targetElement.fastClickScrollParent;
	            if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
	                return true;
	            }
	        }
	
	        // Prevent the actual click from going though - unless the target node is marked as requiring
	        // real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
	        if (!this.needsClick(targetElement)) {
	            event.preventDefault();
	            this.sendClick(targetElement, event);
	        }
	
	        return false;
	    };
	
	
	    /**
	     * On touch cancel, stop tracking the click.
	     *
	     * @returns {void}
	     */
	    FastClick.prototype.onTouchCancel = function() {
	        this.trackingClick = false;
	        this.targetElement = null;
	    };
	
	
	    /**
	     * Determine mouse events which should be permitted.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onMouse = function(event) {
	
	        // If a target element was never set (because a touch event was never fired) allow the event
	        if (!this.targetElement) {
	            return true;
	        }
	
	        if (event.forwardedTouchEvent) {
	            return true;
	        }
	
	        // Programmatically generated events targeting a specific element should be permitted
	        if (!event.cancelable) {
	            return true;
	        }
	
	        // Derive and check the target element to see whether the mouse event needs to be permitted;
	        // unless explicitly enabled, prevent non-touch click events from triggering actions,
	        // to prevent ghost/doubleclicks.
	        if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
	            // Prevent any user-added listeners declared on FastClick element from being fired.
	            if (event.stopImmediatePropagation) {
	                event.stopImmediatePropagation();
	            } else {
	
	                // Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
	                event.propagationStopped = true;
	            }
	
	            // Cancel the event
	            event.stopPropagation();
	            // 允许组合型label冒泡
	            if (!isCompositeLabel) {
	                event.preventDefault();
	            }
	            // 允许组合型label冒泡
	            return false;
	        }
	
	        // If the mouse event is permitted, return true for the action to go through.
	        return true;
	    };
	
	
	    /**
	     * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	     * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	     * an actual click which should be permitted.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onClick = function(event) {
	        var permitted;
	
	        // It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
	        if (this.trackingClick) {
	            this.targetElement = null;
	            this.trackingClick = false;
	            return true;
	        }
	
	        // Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
	        if (event.target.type === 'submit' && event.detail === 0) {
	            return true;
	        }
	
	        permitted = this.onMouse(event);
	
	        // Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
	        if (!permitted) {
	            this.targetElement = null;
	        }
	
	        // If clicks are permitted, return true for the action to go through.
	        return permitted;
	    };
	
	
	    /**
	     * Remove all FastClick's event listeners.
	     *
	     * @returns {void}
	     */
	    FastClick.prototype.destroy = function() {
	        var layer = this.layer;
	
	        if (deviceIsAndroid) {
	            layer.removeEventListener('mouseover', this.onMouse, true);
	            layer.removeEventListener('mousedown', this.onMouse, true);
	            layer.removeEventListener('mouseup', this.onMouse, true);
	        }
	
	        layer.removeEventListener('click', this.onClick, true);
	        layer.removeEventListener('touchstart', this.onTouchStart, false);
	        layer.removeEventListener('touchmove', this.onTouchMove, false);
	        layer.removeEventListener('touchend', this.onTouchEnd, false);
	        layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	    };
	
	
	    /**
	     * Check whether FastClick is needed.
	     *
	     * @param {Element} layer The layer to listen on
	     */
	    FastClick.notNeeded = function(layer) {
	        var metaViewport;
	        var chromeVersion;
	        var blackberryVersion;
	        var firefoxVersion;
	
	        // Devices that don't support touch don't need FastClick
	        if (typeof window.ontouchstart === 'undefined') {
	            return true;
	        }
	
	        // Chrome version - zero for other browsers
	        chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
	        if (chromeVersion) {
	
	            if (deviceIsAndroid) {
	                metaViewport = document.querySelector('meta[name=viewport]');
	
	                if (metaViewport) {
	                    // Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
	                    if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
	                        return true;
	                    }
	                    // Chrome 32 and above with width=device-width or less don't need FastClick
	                    if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
	                        return true;
	                    }
	                }
	
	                // Chrome desktop doesn't need FastClick (issue #15)
	            } else {
	                return true;
	            }
	        }
	
	        if (deviceIsBlackBerry10) {
	            blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
	
	            // BlackBerry 10.3+ does not require Fastclick library.
	            // https://github.com/ftlabs/fastclick/issues/251
	            if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
	                metaViewport = document.querySelector('meta[name=viewport]');
	
	                if (metaViewport) {
	                    // user-scalable=no eliminates click delay.
	                    if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
	                        return true;
	                    }
	                    // width=device-width (or less than device-width) eliminates click delay.
	                    if (document.documentElement.scrollWidth <= window.outerWidth) {
	                        return true;
	                    }
	                }
	            }
	        }
	
	        // IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
	        if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
	            return true;
	        }
	
	        // Firefox version - zero for other browsers
	        firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
	        if (firefoxVersion >= 27) {
	            // Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896
	
	            metaViewport = document.querySelector('meta[name=viewport]');
	            if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
	                return true;
	            }
	        }
	
	        // IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
	        // http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
	        if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
	            return true;
	        }
	
	        return false;
	    };
	
	
	    /**
	     * Factory method for creating a FastClick object
	     *
	     * @param {Element} layer The layer to listen on
	     * @param {Object} [options={}] The options to override the defaults
	     */
	    FastClick.attach = function(layer, options) {
	        return new FastClick(layer, options);
	    };
	
	    window.FastClick = FastClick;
	}());
	
	/*======================================================
	************   Modals   ************
	======================================================*/
	/*jshint unused: false*/
	+function ($) {
	    "use strict";
	    var _modalTemplateTempDiv = document.createElement('div');
	
	    $.modalStack = [];
	
	    $.modalStackClearQueue = function () {
	        if ($.modalStack.length) {
	            ($.modalStack.shift())();
	        }
	    };
	    $.modal = function (params) {
	        params = params || {};
	        var modalHTML = '';
	        var buttonsHTML = '';
	        if (params.buttons && params.buttons.length > 0) {
	            for (var i = 0; i < params.buttons.length; i++) {
	                buttonsHTML += '<span class="modal-button' + (params.buttons[i].bold ? ' modal-button-bold' : '') + '">' + params.buttons[i].text + '</span>';
	            }
	        }
	        var extraClass = params.extraClass || '';
	        var titleHTML = params.title ? '<div class="modal-title">' + params.title + '</div>' : '';
	        var textHTML = params.text ? '<div class="modal-text">' + params.text + '</div>' : '';
	        var afterTextHTML = params.afterText ? params.afterText : '';
	        var noButtons = !params.buttons || params.buttons.length === 0 ? 'modal-no-buttons' : '';
	        var verticalButtons = params.verticalButtons ? 'modal-buttons-vertical' : '';
	        modalHTML = '<div class="modal ' + extraClass + ' ' + noButtons + '"><div class="modal-inner">' + (titleHTML + textHTML + afterTextHTML) + '</div><div class="modal-buttons ' + verticalButtons + '">' + buttonsHTML + '</div></div>';
	
	        _modalTemplateTempDiv.innerHTML = modalHTML;
	
	        var modal = $(_modalTemplateTempDiv).children();
	
	        $(defaults.modalContainer).append(modal[0]);
	
	        // Add events on buttons
	        modal.find('.modal-button').each(function (index, el) {
	            $(el).on('click', function (e) {
	                if (params.buttons[index].close !== false) $.closeModal(modal);
	                if (params.buttons[index].onClick) params.buttons[index].onClick(modal, e);
	                if (params.onClick) params.onClick(modal, index);
	            });
	        });
	        $.openModal(modal);
	        return modal[0];
	    };
	    $.alert = function (text, title, callbackOk) {
	        if (typeof title === 'function') {
	            callbackOk = arguments[1];
	            title = undefined;
	        }
	        return $.modal({
	            text: text || '',
	            title: typeof title === 'undefined' ? defaults.modalTitle : title,
	            buttons: [ {text: defaults.modalButtonOk, bold: true, onClick: callbackOk} ]
	        });
	    };
	    $.confirm = function (text, title, callbackOk, callbackCancel) {
	        if (typeof title === 'function') {
	            callbackCancel = arguments[2];
	            callbackOk = arguments[1];
	            title = undefined;
	        }
	        return $.modal({
	            text: text || '',
	            title: typeof title === 'undefined' ? defaults.modalTitle : title,
	            buttons: [
	                {text: defaults.modalButtonCancel, onClick: callbackCancel},
	                {text: defaults.modalButtonOk, bold: true, onClick: callbackOk}
	            ]
	        });
	    };
	    $.prompt = function (text, title, callbackOk, callbackCancel) {
	        if (typeof title === 'function') {
	            callbackCancel = arguments[2];
	            callbackOk = arguments[1];
	            title = undefined;
	        }
	        return $.modal({
	            text: text || '',
	            title: typeof title === 'undefined' ? defaults.modalTitle : title,
	            afterText: '<input type="text" class="modal-text-input">',
	            buttons: [
	                {
	                    text: defaults.modalButtonCancel
	                },
	                {
	                    text: defaults.modalButtonOk,
	                    bold: true
	                }
	            ],
	            onClick: function (modal, index) {
	                if (index === 0 && callbackCancel) callbackCancel($(modal).find('.modal-text-input').val());
	                if (index === 1 && callbackOk) callbackOk($(modal).find('.modal-text-input').val());
	            }
	        });
	    };
	    $.modalLogin = function (text, title, callbackOk, callbackCancel) {
	        if (typeof title === 'function') {
	            callbackCancel = arguments[2];
	            callbackOk = arguments[1];
	            title = undefined;
	        }
	        return $.modal({
	            text: text || '',
	            title: typeof title === 'undefined' ? defaults.modalTitle : title,
	            afterText: '<input type="text" name="modal-username" placeholder="' + defaults.modalUsernamePlaceholder + '" class="modal-text-input modal-text-input-double"><input type="password" name="modal-password" placeholder="' + defaults.modalPasswordPlaceholder + '" class="modal-text-input modal-text-input-double">',
	            buttons: [
	                {
	                    text: defaults.modalButtonCancel
	                },
	                {
	                    text: defaults.modalButtonOk,
	                    bold: true
	                }
	            ],
	            onClick: function (modal, index) {
	                var username = $(modal).find('.modal-text-input[name="modal-username"]').val();
	                var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
	                if (index === 0 && callbackCancel) callbackCancel(username, password);
	                if (index === 1 && callbackOk) callbackOk(username, password);
	            }
	        });
	    };
	    $.modalPassword = function (text, title, callbackOk, callbackCancel) {
	        if (typeof title === 'function') {
	            callbackCancel = arguments[2];
	            callbackOk = arguments[1];
	            title = undefined;
	        }
	        return $.modal({
	            text: text || '',
	            title: typeof title === 'undefined' ? defaults.modalTitle : title,
	            afterText: '<input type="password" name="modal-password" placeholder="' + defaults.modalPasswordPlaceholder + '" class="modal-text-input">',
	            buttons: [
	                {
	                    text: defaults.modalButtonCancel
	                },
	                {
	                    text: defaults.modalButtonOk,
	                    bold: true
	                }
	            ],
	            onClick: function (modal, index) {
	                var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
	                if (index === 0 && callbackCancel) callbackCancel(password);
	                if (index === 1 && callbackOk) callbackOk(password);
	            }
	        });
	    };
	    $.showPreloader = function (title) {
	        $.hidePreloader();
	        $.showPreloader.preloaderModal = $.modal({
	            title: title || defaults.modalPreloaderTitle,
	            text: '<div class="preloader"></div>'
	        });
	
	        return $.showPreloader.preloaderModal;
	    };
	    $.hidePreloader = function () {
	        $.showPreloader.preloaderModal && $.closeModal($.showPreloader.preloaderModal);
	    };
	    $.showIndicator = function () {
	        if ($('.preloader-indicator-modal')[0]) return;
	        $(defaults.modalContainer).append('<div class="preloader-indicator-overlay"></div><div class="preloader-indicator-modal"><span class="preloader preloader-white"></span></div>');
	    };
	    $.hideIndicator = function () {
	        $('.preloader-indicator-overlay, .preloader-indicator-modal').remove();
	    };
	    // Action Sheet
	    $.actions = function (params) {
	        var modal, groupSelector, buttonSelector;
	        params = params || [];
	
	        if (params.length > 0 && !$.isArray(params[0])) {
	            params = [params];
	        }
	        var modalHTML;
	        var buttonsHTML = '';
	        for (var i = 0; i < params.length; i++) {
	            for (var j = 0; j < params[i].length; j++) {
	                if (j === 0) buttonsHTML += '<div class="actions-modal-group">';
	                var button = params[i][j];
	                var buttonClass = button.label ? 'actions-modal-label' : 'actions-modal-button';
	                if (button.bold) buttonClass += ' actions-modal-button-bold';
	                if (button.color) buttonClass += ' color-' + button.color;
	                if (button.bg) buttonClass += ' bg-' + button.bg;
	                if (button.disabled) buttonClass += ' disabled';
	                buttonsHTML += '<span class="' + buttonClass + '">' + button.text + '</span>';
	                if (j === params[i].length - 1) buttonsHTML += '</div>';
	            }
	        }
	        modalHTML = '<div class="actions-modal">' + buttonsHTML + '</div>';
	        _modalTemplateTempDiv.innerHTML = modalHTML;
	        modal = $(_modalTemplateTempDiv).children();
	        $(defaults.modalContainer).append(modal[0]);
	        groupSelector = '.actions-modal-group';
	        buttonSelector = '.actions-modal-button';
	
	        var groups = modal.find(groupSelector);
	        groups.each(function (index, el) {
	            var groupIndex = index;
	            $(el).children().each(function (index, el) {
	                var buttonIndex = index;
	                var buttonParams = params[groupIndex][buttonIndex];
	                var clickTarget;
	                if ($(el).is(buttonSelector)) clickTarget = $(el);
	                // if (toPopover && $(el).find(buttonSelector).length > 0) clickTarget = $(el).find(buttonSelector);
	
	                if (clickTarget) {
	                    clickTarget.on('click', function (e) {
	                        if (buttonParams.close !== false) $.closeModal(modal);
	                        if (buttonParams.onClick) buttonParams.onClick(modal, e);
	                    });
	                }
	            });
	        });
	        $.openModal(modal);
	        return modal[0];
	    };
	    $.popup = function (modal, removeOnClose) {
	        if (typeof removeOnClose === 'undefined') removeOnClose = true;
	        if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	            var _modal = document.createElement('div');
	            _modal.innerHTML = modal.trim();
	            if (_modal.childNodes.length > 0) {
	                modal = _modal.childNodes[0];
	                if (removeOnClose) modal.classList.add('remove-on-close');
	                $(defaults.modalContainer).append(modal);
	            }
	            else return false; //nothing found
	        }
	        modal = $(modal);
	        if (modal.length === 0) return false;
	        modal.show();
	        modal.find(".content").scroller("refresh");
	        if (modal.find('.' + defaults.viewClass).length > 0) {
	            $.sizeNavbars(modal.find('.' + defaults.viewClass)[0]);
	        }
	        $.openModal(modal);
	
	        return modal[0];
	    };
	    $.pickerModal = function (pickerModal, removeOnClose) {
	        if (typeof removeOnClose === 'undefined') removeOnClose = true;
	        if (typeof pickerModal === 'string' && pickerModal.indexOf('<') >= 0) {
	            pickerModal = $(pickerModal);
	            if (pickerModal.length > 0) {
	                if (removeOnClose) pickerModal.addClass('remove-on-close');
	                $(defaults.modalContainer).append(pickerModal[0]);
	            }
	            else return false; //nothing found
	        }
	        pickerModal = $(pickerModal);
	        if (pickerModal.length === 0) return false;
	        pickerModal.show();
	        $.openModal(pickerModal);
	        return pickerModal[0];
	    };
	    $.loginScreen = function (modal) {
	        if (!modal) modal = '.login-screen';
	        modal = $(modal);
	        if (modal.length === 0) return false;
	        modal.show();
	        if (modal.find('.' + defaults.viewClass).length > 0) {
	            $.sizeNavbars(modal.find('.' + defaults.viewClass)[0]);
	        }
	        $.openModal(modal);
	        return modal[0];
	    };
	    //显示一个消息，会在2秒钟后自动消失
	    $.toast = function(msg, duration, extraclass) {
	        var $toast = $('<div class="modal toast ' + (extraclass || '') + '">' + msg + '</div>').appendTo(document.body);
	        $.openModal($toast, function(){
	            setTimeout(function() {
	                $.closeModal($toast);
	            }, duration || 2000);
	        });
	    };
	    $.openModal = function (modal, cb) {
	        modal = $(modal);
	        var isModal = modal.hasClass('modal'),
	            isNotToast = !modal.hasClass('toast');
	        if ($('.modal.modal-in:not(.modal-out)').length && defaults.modalStack && isModal && isNotToast) {
	            $.modalStack.push(function () {
	                $.openModal(modal, cb);
	            });
	            return;
	        }
	        var isPopup = modal.hasClass('popup');
	        var isLoginScreen = modal.hasClass('login-screen');
	        var isPickerModal = modal.hasClass('picker-modal');
	        var isToast = modal.hasClass('toast');
	        if (isModal) {
	            modal.show();
	            modal.css({
	                marginTop: - Math.round(modal.outerHeight() / 2) + 'px'
	            });
	        }
	        if (isToast) {
	            modal.css({
	                marginLeft: - Math.round(modal.outerWidth() / 2 / 1.185) + 'px' //1.185 是初始化时候的放大效果
	            });
	        }
	
	        var overlay;
	        if (!isLoginScreen && !isPickerModal && !isToast) {
	            if ($('.modal-overlay').length === 0 && !isPopup) {
	                $(defaults.modalContainer).append('<div class="modal-overlay"></div>');
	            }
	            if ($('.popup-overlay').length === 0 && isPopup) {
	                $(defaults.modalContainer).append('<div class="popup-overlay"></div>');
	            }
	            overlay = isPopup ? $('.popup-overlay') : $('.modal-overlay');
	        }
	
	        //Make sure that styles are applied, trigger relayout;
	        var clientLeft = modal[0].clientLeft;
	
	        // Trugger open event
	        modal.trigger('open');
	
	        // Picker modal body class
	        if (isPickerModal) {
	            $(defaults.modalContainer).addClass('with-picker-modal');
	        }
	
	        // Classes for transition in
	        if (!isLoginScreen && !isPickerModal && !isToast) overlay.addClass('modal-overlay-visible');
	        modal.removeClass('modal-out').addClass('modal-in').transitionEnd(function (e) {
	            if (modal.hasClass('modal-out')) modal.trigger('closed');
	            else modal.trigger('opened');
	        });
	        // excute callback
	        if (typeof cb === 'function') {
	          cb.call(this);
	        }
	        return true;
	    };
	    $.closeModal = function (modal) {
	        modal = $(modal || '.modal-in');
	        if (typeof modal !== 'undefined' && modal.length === 0) {
	            return;
	        }
	        var isModal = modal.hasClass('modal'),
	            isPopup = modal.hasClass('popup'),
	            isToast = modal.hasClass('toast'),
	            isLoginScreen = modal.hasClass('login-screen'),
	            isPickerModal = modal.hasClass('picker-modal'),
	            removeOnClose = modal.hasClass('remove-on-close'),
	            overlay = isPopup ? $('.popup-overlay') : $('.modal-overlay');
	        if (isPopup){
	            if (modal.length === $('.popup.modal-in').length) {
	                overlay.removeClass('modal-overlay-visible');
	            }
	        }
	        else if (!(isPickerModal || isToast)) {
	            overlay.removeClass('modal-overlay-visible');
	        }
	
	        modal.trigger('close');
	
	        // Picker modal body class
	        if (isPickerModal) {
	            $(defaults.modalContainer).removeClass('with-picker-modal');
	            $(defaults.modalContainer).addClass('picker-modal-closing');
	        }
	
	        modal.removeClass('modal-in').addClass('modal-out').transitionEnd(function (e) {
	            if (modal.hasClass('modal-out')) modal.trigger('closed');
	            else {
	                modal.trigger('opened');
	                return;
	            }
	
	            if (isPickerModal) {
	                $(defaults.modalContainer).removeClass('picker-modal-closing');
	            }
	            if (isPopup || isLoginScreen || isPickerModal) {
	                modal.removeClass('modal-out').hide();
	                if (removeOnClose && modal.length > 0) {
	                    modal.remove();
	                }
	            }
	            else {
	                modal.remove();
	            }
	        });
	        if (isModal &&  defaults.modalStack ) {
	            $.modalStackClearQueue();
	        }
	
	        return true;
	    };
	    function handleClicks(e) {
	        /*jshint validthis:true */
	        var clicked = $(this);
	        var url = clicked.attr('href');
	
	
	        //Collect Clicked data- attributes
	        var clickedData = clicked.dataset();
	
	        // Popup
	        var popup;
	        if (clicked.hasClass('open-popup')) {
	            if (clickedData.popup) {
	                popup = clickedData.popup;
	            }
	            else popup = '.popup';
	            $.popup(popup);
	        }
	        if (clicked.hasClass('close-popup')) {
	            if (clickedData.popup) {
	                popup = clickedData.popup;
	            }
	            else popup = '.popup.modal-in';
	            $.closeModal(popup);
	        }
	
	        // Close Modal
	        if (clicked.hasClass('modal-overlay')) {
	            if ($('.modal.modal-in').length > 0 && defaults.modalCloseByOutside)
	                $.closeModal('.modal.modal-in');
	            if ($('.actions-modal.modal-in').length > 0 && defaults.actionsCloseByOutside)
	                $.closeModal('.actions-modal.modal-in');
	
	        }
	        if (clicked.hasClass('popup-overlay')) {
	            if ($('.popup.modal-in').length > 0 && defaults.popupCloseByOutside)
	                $.closeModal('.popup.modal-in');
	        }
	
	
	
	
	    }
	    $(document).on('click', ' .modal-overlay, .popup-overlay, .close-popup, .open-popup, .close-picker', handleClicks);
	    var defaults =  $.modal.prototype.defaults  = {
	        modalStack: true,
	        modalButtonOk: '确定',
	        modalButtonCancel: '取消',
	        modalPreloaderTitle: '加载中',
	        modalContainer : document.body
	    };
	}(Zepto);
	
	/*======================================================
	************   Calendar   ************
	======================================================*/
	/*jshint unused: false*/
	+function ($) {
	    "use strict";
	    var rtl = false;
	    var Calendar = function (params) {
	        var p = this;
	        var defaults = {
	            monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月' , '九月' , '十月', '十一月', '十二月'],
	            monthNamesShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月' , '九月' , '十月', '十一月', '十二月'],
	            dayNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
	            dayNamesShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
	            firstDay: 1, // First day of the week, Monday
	            weekendDays: [0, 6], // Sunday and Saturday
	            multiple: false,
	            canselected: false,//已经选择的日期能否再次选择
	            dateFormat: 'yyyy-mm-dd',
	            direction: 'horizontal', // or 'vertical'
	            minDate: null,
	            maxDate: null,
	            touchMove: true,
	            animate: true,
	            closeOnSelect: true,
	            monthPicker: true,
	            monthPickerTemplate:
	                '<div class="picker-calendar-month-picker">' +
	                '<a href="javascript:;" class="link icon-only picker-calendar-prev-month"><i class="icon icon-prev"></i></a>' +
	                '<div class="current-month-value"></div>' +
	                '<a href="javascript:;" class="link icon-only picker-calendar-next-month"><i class="icon icon-next"></i></a>' +
	                '</div>',
	            yearPicker: true,
	            yearPickerTemplate:
	                '<div class="picker-calendar-year-picker">' +
	                '<a href="javascript:;" class="link icon-only picker-calendar-prev-year"><i class="icon icon-prev"></i></a>' +
	                '<span class="current-year-value"></span>' +
	                '<a href="javascript:;" class="link icon-only picker-calendar-next-year"><i class="icon icon-next"></i></a>' +
	                '</div>',
	            weekHeader: true,
	            // Common settings
	            scrollToInput: true,
	            inputReadOnly: true,
	            toolbar: true,
	            toolbarCloseText: 'Done',
	            toolbarTemplate:
	                '<div class="toolbar">' +
	                '<div class="toolbar-inner">' +
	                '{{monthPicker}}' +
	                '{{yearPicker}}' +
	                // '<a href="javascript:;" class="link close-picker">{{closeText}}</a>' +
	                '</div>' +
	                '</div>',
	            /* Callbacks
	               onMonthAdd
	               onChange
	               onOpen
	               onClose
	               onDayClick
	               onMonthYearChangeStart
	               onMonthYearChangeEnd
	               */
	        };
	        params = params || {};
	        for (var def in defaults) {
	            if (typeof params[def] === 'undefined') {
	                params[def] = defaults[def];
	            }
	        }
	        p.params = params;
	        p.initialized = false;
	
	        // Inline flag
	        p.inline = p.params.container ? true : false;
	
	        // Is horizontal
	        p.isH = p.params.direction === 'horizontal';
	
	        // RTL inverter
	        var inverter = p.isH ? (rtl ? -1 : 1) : 1;
	
	        // Animating flag
	        p.animating = false;
	
	        // Format date
	        function formatDate(date) {
	            date = new Date(date);
	            var year = date.getFullYear();
	            var month = date.getMonth();
	            var month1 = month + 1;
	            var day = date.getDate();
	            var weekDay = date.getDay();
	            return p.params.dateFormat
	                .replace(/yyyy/g, year)
	                .replace(/yy/g, (year + '').substring(2))
	                .replace(/mm/g, month1 < 10 ? '0' + month1 : month1)
	                .replace(/m/g, month1)
	                .replace(/MM/g, p.params.monthNames[month])
	                .replace(/M/g, p.params.monthNamesShort[month])
	                .replace(/dd/g, day < 10 ? '0' + day : day)
	                .replace(/d/g, day)
	                .replace(/DD/g, p.params.dayNames[weekDay])
	                .replace(/D/g, p.params.dayNamesShort[weekDay]);
	        }
	
	
	        // Value
	        p.addValue = function (value) {
	            if (p.params.multiple) {
	                if (!p.value) p.value = [];
	                var inValuesIndex;
	                for (var i = 0; i < p.value.length; i++) {
	                    if (new Date(value).getTime() === new Date(p.value[i]).getTime()) {
	                        inValuesIndex = i;
	                    }
	                }
	                if (typeof inValuesIndex === 'undefined') {
	                    p.value.push(value);
	                }
	                else {
	                    p.value.splice(inValuesIndex, 1);
	                }
	                p.updateValue();
	            }
	            else {
	                p.value = [value];
	                p.updateValue();
	            }
	        };
	        p.setValue = function (arrValues) {
	            p.value = arrValues;
	            p.updateValue();
	        };
	        p.updateValue = function () {
	            if(p.wrapper) {
	                var oo = p.wrapper.find('.picker-calendar-day-selected');
	                if (oo) {
	                    oo.removeClass('picker-calendar-day-selected');
	                }
	            }
	            var i, inputValue;
	            for (i = 0; i < p.value.length; i++) {
	                var valueDate = new Date(p.value[i]);
	                if(p.wrapper) {
	                    p.wrapper.find('.picker-calendar-day[data-date="' + valueDate.getFullYear() + '-' + valueDate.getMonth() + '-' + valueDate.getDate() + '"]').addClass('picker-calendar-day-selected');
	                }
	            }
	            if (p.params.onChange) {
	                p.params.onChange(p, p.value, p.value.map(formatDate));
	            }
	            if (p.input && p.input.length > 0) {
	                if (p.params.formatValue) inputValue = p.params.formatValue(p, p.value);
	                else {
	                    inputValue = [];
	                    for (i = 0; i < p.value.length; i++) {
	                        inputValue.push(formatDate(p.value[i]));
	                    }
	                    inputValue = inputValue.join(', ');
	                }
	                $(p.input).val(inputValue);
	                $(p.input).trigger('change');
	            }
	        };
	
	        // Columns Handlers
	        p.initCalendarEvents = function () {
	            var col;
	            var allowItemClick = true;
	            var isTouched, isMoved, touchStartX, touchStartY, touchCurrentX, touchCurrentY, touchStartTime, touchEndTime, startTranslate, currentTranslate, wrapperWidth, wrapperHeight, percentage, touchesDiff, isScrolling;
	            function handleTouchStart (e) {
	                if (isMoved || isTouched) return;
	                // e.preventDefault();
	                isTouched = true;
	                touchStartX = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                touchStartTime = (new Date()).getTime();
	                percentage = 0;
	                allowItemClick = true;
	                isScrolling = undefined;
	                startTranslate = currentTranslate = p.monthsTranslate;
	            }
	            function handleTouchMove (e) {
	                if (!isTouched) return;
	
	                touchCurrentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(touchCurrentY - touchStartY) > Math.abs(touchCurrentX - touchStartX));
	                }
	                if (p.isH && isScrolling) {
	                    isTouched = false;
	                    return;
	                }
	                e.preventDefault();
	                if (p.animating) {
	                    isTouched = false;
	                    return;
	                }
	                allowItemClick = false;
	                if (!isMoved) {
	                    // First move
	                    isMoved = true;
	                    wrapperWidth = p.wrapper[0].offsetWidth;
	                    wrapperHeight = p.wrapper[0].offsetHeight;
	                    p.wrapper.transition(0);
	                }
	                e.preventDefault();
	
	                touchesDiff = p.isH ? touchCurrentX - touchStartX : touchCurrentY - touchStartY;
	                percentage = touchesDiff/(p.isH ? wrapperWidth : wrapperHeight);
	                currentTranslate = (p.monthsTranslate * inverter + percentage) * 100;
	
	                // Transform wrapper
	                p.wrapper.transform('translate3d(' + (p.isH ? currentTranslate : 0) + '%, ' + (p.isH ? 0 : currentTranslate) + '%, 0)');
	
	            }
	            function handleTouchEnd (e) {
	                if (!isTouched || !isMoved) {
	                    isTouched = isMoved = false;
	                    return;
	                }
	                isTouched = isMoved = false;
	
	                touchEndTime = new Date().getTime();
	                if (touchEndTime - touchStartTime < 300) {
	                    if (Math.abs(touchesDiff) < 10) {
	                        p.resetMonth();
	                    }
	                    else if (touchesDiff >= 10) {
	                        if (rtl) p.nextMonth();
	                        else p.prevMonth();
	                    }
	                    else {
	                        if (rtl) p.prevMonth();
	                        else p.nextMonth();
	                    }
	                }
	                else {
	                    if (percentage <= -0.5) {
	                        if (rtl) p.prevMonth();
	                        else p.nextMonth();
	                    }
	                    else if (percentage >= 0.5) {
	                        if (rtl) p.nextMonth();
	                        else p.prevMonth();
	                    }
	                    else {
	                        p.resetMonth();
	                    }
	                }
	
	                // Allow click
	                setTimeout(function () {
	                    allowItemClick = true;
	                }, 100);
	            }
	
	            function handleDayClick(e) {
	                if (!allowItemClick) return;
	                var day = $(e.target).parents('.picker-calendar-day');
	                if (day.length === 0 && $(e.target).hasClass('picker-calendar-day')) {
	                    day = $(e.target);
	                }
	                if (day.length === 0) return;
	                if (!p.params.canselected && day.hasClass('picker-calendar-day-selected') && !p.params.multiple) return;
	                if (day.hasClass('picker-calendar-day-disabled')) return;
	                if (day.hasClass('picker-calendar-day-next')) p.nextMonth();
	                if (day.hasClass('picker-calendar-day-prev')) p.prevMonth();
	                var dateYear = day.attr('data-year');
	                var dateMonth = day.attr('data-month');
	                var dateDay = day.attr('data-day');
	                if (p.params.onDayClick) {
	                    p.params.onDayClick(p, day[0], dateYear, dateMonth, dateDay);
	                }
	                p.addValue(new Date(dateYear, dateMonth, dateDay).getTime());
	                if (p.params.closeOnSelect) p.close();
	            }
	
	            p.container.find('.picker-calendar-prev-month').on('click', p.prevMonth);
	            p.container.find('.picker-calendar-next-month').on('click', p.nextMonth);
	            p.container.find('.picker-calendar-prev-year').on('click', p.prevYear);
	            p.container.find('.picker-calendar-next-year').on('click', p.nextYear);
	            p.wrapper.on('click', handleDayClick);
	            if (p.params.touchMove) {
	                p.wrapper.on($.touchEvents.start, handleTouchStart);
	                p.wrapper.on($.touchEvents.move, handleTouchMove);
	                p.wrapper.on($.touchEvents.end, handleTouchEnd);
	            }
	
	            p.container[0].f7DestroyCalendarEvents = function () {
	                p.container.find('.picker-calendar-prev-month').off('click', p.prevMonth);
	                p.container.find('.picker-calendar-next-month').off('click', p.nextMonth);
	                p.container.find('.picker-calendar-prev-year').off('click', p.prevYear);
	                p.container.find('.picker-calendar-next-year').off('click', p.nextYear);
	                p.wrapper.off('click', handleDayClick);
	                if (p.params.touchMove) {
	                    p.wrapper.off($.touchEvents.start, handleTouchStart);
	                    p.wrapper.off($.touchEvents.move, handleTouchMove);
	                    p.wrapper.off($.touchEvents.end, handleTouchEnd);
	                }
	            };
	
	
	        };
	        p.destroyCalendarEvents = function (colContainer) {
	            if ('f7DestroyCalendarEvents' in p.container[0]) p.container[0].f7DestroyCalendarEvents();
	        };
	
	        // Calendar Methods
	        p.daysInMonth = function (date) {
	            var d = new Date(date);
	            return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
	        };
	        p.monthHTML = function (date, offset) {
	            date = new Date(date);
	            var year = date.getFullYear(),
	                month = date.getMonth(),
	                day = date.getDate();
	            if (offset === 'next') {
	                if (month === 11) date = new Date(year + 1, 0);
	                else date = new Date(year, month + 1, 1);
	            }
	            if (offset === 'prev') {
	                if (month === 0) date = new Date(year - 1, 11);
	                else date = new Date(year, month - 1, 1);
	            }
	            if (offset === 'next' || offset === 'prev') {
	                month = date.getMonth();
	                year = date.getFullYear();
	            }
	            var daysInPrevMonth = p.daysInMonth(new Date(date.getFullYear(), date.getMonth()).getTime() - 10 * 24 * 60 * 60 * 1000),
	                daysInMonth = p.daysInMonth(date),
	                firstDayOfMonthIndex = new Date(date.getFullYear(), date.getMonth()).getDay();
	            if (firstDayOfMonthIndex === 0) firstDayOfMonthIndex = 7;
	
	            var dayDate, currentValues = [], i, j,
	                rows = 6, cols = 7,
	                monthHTML = '',
	                dayIndex = 0 + (p.params.firstDay - 1),
	                today = new Date().setHours(0,0,0,0),
	                minDate = p.params.minDate ? new Date(p.params.minDate).getTime() : null,
	                maxDate = p.params.maxDate ? new Date(p.params.maxDate).getTime() : null;
	
	            if (p.value && p.value.length) {
	                for (i = 0; i < p.value.length; i++) {
	                    currentValues.push(new Date(p.value[i]).setHours(0,0,0,0));
	                }
	            }
	
	            for (i = 1; i <= rows; i++) {
	                var rowHTML = '';
	                var row = i;
	                for (j = 1; j <= cols; j++) {
	                    var col = j;
	                    dayIndex ++;
	                    var dayNumber = dayIndex - firstDayOfMonthIndex;
	                    var addClass = '';
	                    if (dayNumber < 0) {
	                        dayNumber = daysInPrevMonth + dayNumber + 1;
	                        addClass += ' picker-calendar-day-prev';
	                        dayDate = new Date(month - 1 < 0 ? year - 1 : year, month - 1 < 0 ? 11 : month - 1, dayNumber).getTime();
	                    }
	                    else {
	                        dayNumber = dayNumber + 1;
	                        if (dayNumber > daysInMonth) {
	                            dayNumber = dayNumber - daysInMonth;
	                            addClass += ' picker-calendar-day-next';
	                            dayDate = new Date(month + 1 > 11 ? year + 1 : year, month + 1 > 11 ? 0 : month + 1, dayNumber).getTime();
	                        }
	                        else {
	                            dayDate = new Date(year, month, dayNumber).getTime();
	                        }
	                    }
	                    // Today
	                    if (dayDate === today) addClass += ' picker-calendar-day-today';
	                    // Selected
	                    if (currentValues.indexOf(dayDate) >= 0) addClass += ' picker-calendar-day-selected';
	                    // Weekend
	                    if (p.params.weekendDays.indexOf(col - 1) >= 0) {
	                        addClass += ' picker-calendar-day-weekend';
	                    }
	                    // Disabled
	                    if ((minDate && dayDate < minDate) || (maxDate && dayDate > maxDate)) {
	                        addClass += ' picker-calendar-day-disabled';
	                    }
	
	                    dayDate = new Date(dayDate);
	                    var dayYear = dayDate.getFullYear();
	                    var dayMonth = dayDate.getMonth();
	                    rowHTML += '<div data-year="' + dayYear + '" data-month="' + dayMonth + '" data-day="' + dayNumber + '" class="picker-calendar-day' + (addClass) + '" data-date="' + (dayYear + '-' + dayMonth + '-' + dayNumber) + '"><span>'+dayNumber+'</span></div>';
	                }
	                monthHTML += '<div class="picker-calendar-row">' + rowHTML + '</div>';
	            }
	            monthHTML = '<div class="picker-calendar-month" data-year="' + year + '" data-month="' + month + '">' + monthHTML + '</div>';
	            return monthHTML;
	        };
	        p.animating = false;
	        p.updateCurrentMonthYear = function (dir) {
	            if (typeof dir === 'undefined') {
	                p.currentMonth = parseInt(p.months.eq(1).attr('data-month'), 10);
	                p.currentYear = parseInt(p.months.eq(1).attr('data-year'), 10);
	            }
	            else {
	                p.currentMonth = parseInt(p.months.eq(dir === 'next' ? (p.months.length - 1) : 0).attr('data-month'), 10);
	                p.currentYear = parseInt(p.months.eq(dir === 'next' ? (p.months.length - 1) : 0).attr('data-year'), 10);
	            }
	            p.container.find('.current-month-value').text(p.params.monthNames[p.currentMonth]);
	            p.container.find('.current-year-value').text(p.currentYear);
	
	        };
	        p.onMonthChangeStart = function (dir) {
	            p.updateCurrentMonthYear(dir);
	            p.months.removeClass('picker-calendar-month-current picker-calendar-month-prev picker-calendar-month-next');
	            var currentIndex = dir === 'next' ? p.months.length - 1 : 0;
	
	            p.months.eq(currentIndex).addClass('picker-calendar-month-current');
	            p.months.eq(dir === 'next' ? currentIndex - 1 : currentIndex + 1).addClass(dir === 'next' ? 'picker-calendar-month-prev' : 'picker-calendar-month-next');
	
	            if (p.params.onMonthYearChangeStart) {
	                p.params.onMonthYearChangeStart(p, p.currentYear, p.currentMonth);
	            }
	        };
	        p.onMonthChangeEnd = function (dir, rebuildBoth) {
	            p.animating = false;
	            var nextMonthHTML, prevMonthHTML, newMonthHTML;
	            p.wrapper.find('.picker-calendar-month:not(.picker-calendar-month-prev):not(.picker-calendar-month-current):not(.picker-calendar-month-next)').remove();
	
	            if (typeof dir === 'undefined') {
	                dir = 'next';
	                rebuildBoth = true;
	            }
	            if (!rebuildBoth) {
	                newMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), dir);
	            }
	            else {
	                p.wrapper.find('.picker-calendar-month-next, .picker-calendar-month-prev').remove();
	                prevMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), 'prev');
	                nextMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), 'next');
	            }
	            if (dir === 'next' || rebuildBoth) {
	                p.wrapper.append(newMonthHTML || nextMonthHTML);
	            }
	            if (dir === 'prev' || rebuildBoth) {
	                p.wrapper.prepend(newMonthHTML || prevMonthHTML);
	            }
	            p.months = p.wrapper.find('.picker-calendar-month');
	            p.setMonthsTranslate(p.monthsTranslate);
	            if (p.params.onMonthAdd) {
	                p.params.onMonthAdd(p, dir === 'next' ? p.months.eq(p.months.length - 1)[0] : p.months.eq(0)[0]);
	            }
	            if (p.params.onMonthYearChangeEnd) {
	                p.params.onMonthYearChangeEnd(p, p.currentYear, p.currentMonth);
	            }
	        };
	        p.setMonthsTranslate = function (translate) {
	            translate = translate || p.monthsTranslate || 0;
	            if (typeof p.monthsTranslate === 'undefined') p.monthsTranslate = translate;
	            p.months.removeClass('picker-calendar-month-current picker-calendar-month-prev picker-calendar-month-next');
	            var prevMonthTranslate = -(translate + 1) * 100 * inverter;
	            var currentMonthTranslate = -translate * 100 * inverter;
	            var nextMonthTranslate = -(translate - 1) * 100 * inverter;
	            p.months.eq(0).transform('translate3d(' + (p.isH ? prevMonthTranslate : 0) + '%, ' + (p.isH ? 0 : prevMonthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	            p.months.eq(1).transform('translate3d(' + (p.isH ? currentMonthTranslate : 0) + '%, ' + (p.isH ? 0 : currentMonthTranslate) + '%, 0)').addClass('picker-calendar-month-current');
	            p.months.eq(2).transform('translate3d(' + (p.isH ? nextMonthTranslate : 0) + '%, ' + (p.isH ? 0 : nextMonthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	        };
	        p.nextMonth = function (transition) {
	            if (typeof transition === 'undefined' || typeof transition === 'object') {
	                transition = '';
	                if (!p.params.animate) transition = 0;
	            }
	            var nextMonth = parseInt(p.months.eq(p.months.length - 1).attr('data-month'), 10);
	            var nextYear = parseInt(p.months.eq(p.months.length - 1).attr('data-year'), 10);
	            var nextDate = new Date(nextYear, nextMonth);
	            var nextDateTime = nextDate.getTime();
	            var transitionEndCallback = p.animating ? false : true;
	            if (p.params.maxDate) {
	                if (nextDateTime > new Date(p.params.maxDate).getTime()) {
	                    return p.resetMonth();
	                }
	            }
	            p.monthsTranslate --;
	            if (nextMonth === p.currentMonth) {
	                var nextMonthTranslate = -(p.monthsTranslate) * 100 * inverter;
	                var nextMonthHTML = $(p.monthHTML(nextDateTime, 'next')).transform('translate3d(' + (p.isH ? nextMonthTranslate : 0) + '%, ' + (p.isH ? 0 : nextMonthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	                p.wrapper.append(nextMonthHTML[0]);
	                p.months = p.wrapper.find('.picker-calendar-month');
	                if (p.params.onMonthAdd) {
	                    p.params.onMonthAdd(p, p.months.eq(p.months.length - 1)[0]);
	                }
	            }
	            p.animating = true;
	            p.onMonthChangeStart('next');
	            var translate = (p.monthsTranslate * 100) * inverter;
	
	            p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	            if (transitionEndCallback) {
	                p.wrapper.transitionEnd(function () {
	                    p.onMonthChangeEnd('next');
	                });
	            }
	            if (!p.params.animate) {
	                p.onMonthChangeEnd('next');
	            }
	        };
	        p.prevMonth = function (transition) {
	            if (typeof transition === 'undefined' || typeof transition === 'object') {
	                transition = '';
	                if (!p.params.animate) transition = 0;
	            }
	            var prevMonth = parseInt(p.months.eq(0).attr('data-month'), 10);
	            var prevYear = parseInt(p.months.eq(0).attr('data-year'), 10);
	            var prevDate = new Date(prevYear, prevMonth + 1, -1);
	            var prevDateTime = prevDate.getTime();
	            var transitionEndCallback = p.animating ? false : true;
	            if (p.params.minDate) {
	                if (prevDateTime < new Date(p.params.minDate).getTime()) {
	                    return p.resetMonth();
	                }
	            }
	            p.monthsTranslate ++;
	            if (prevMonth === p.currentMonth) {
	                var prevMonthTranslate = -(p.monthsTranslate) * 100 * inverter;
	                var prevMonthHTML = $(p.monthHTML(prevDateTime, 'prev')).transform('translate3d(' + (p.isH ? prevMonthTranslate : 0) + '%, ' + (p.isH ? 0 : prevMonthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	                p.wrapper.prepend(prevMonthHTML[0]);
	                p.months = p.wrapper.find('.picker-calendar-month');
	                if (p.params.onMonthAdd) {
	                    p.params.onMonthAdd(p, p.months.eq(0)[0]);
	                }
	            }
	            p.animating = true;
	            p.onMonthChangeStart('prev');
	            var translate = (p.monthsTranslate * 100) * inverter;
	            p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	            if (transitionEndCallback) {
	                p.wrapper.transitionEnd(function () {
	                    p.onMonthChangeEnd('prev');
	                });
	            }
	            if (!p.params.animate) {
	                p.onMonthChangeEnd('prev');
	            }
	        };
	        p.resetMonth = function (transition) {
	            if (typeof transition === 'undefined') transition = '';
	            var translate = (p.monthsTranslate * 100) * inverter;
	            p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	        };
	        p.setYearMonth = function (year, month, transition) {
	            if (typeof year === 'undefined') year = p.currentYear;
	            if (typeof month === 'undefined') month = p.currentMonth;
	            if (typeof transition === 'undefined' || typeof transition === 'object') {
	                transition = '';
	                if (!p.params.animate) transition = 0;
	            }
	            var targetDate;
	            if (year < p.currentYear) {
	                targetDate = new Date(year, month + 1, -1).getTime();
	            }
	            else {
	                targetDate = new Date(year, month).getTime();
	            }
	            if (p.params.maxDate && targetDate > new Date(p.params.maxDate).getTime()) {
	                return false;
	            }
	            if (p.params.minDate && targetDate < new Date(p.params.minDate).getTime()) {
	                return false;
	            }
	            var currentDate = new Date(p.currentYear, p.currentMonth).getTime();
	            var dir = targetDate > currentDate ? 'next' : 'prev';
	            var newMonthHTML = p.monthHTML(new Date(year, month));
	            p.monthsTranslate = p.monthsTranslate || 0;
	            var prevTranslate = p.monthsTranslate;
	            var monthTranslate, wrapperTranslate;
	            var transitionEndCallback = p.animating ? false : true;
	            if (targetDate > currentDate) {
	                // To next
	                p.monthsTranslate --;
	                if (!p.animating) p.months.eq(p.months.length - 1).remove();
	                p.wrapper.append(newMonthHTML);
	                p.months = p.wrapper.find('.picker-calendar-month');
	                monthTranslate = -(prevTranslate - 1) * 100 * inverter;
	                p.months.eq(p.months.length - 1).transform('translate3d(' + (p.isH ? monthTranslate : 0) + '%, ' + (p.isH ? 0 : monthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	            }
	            else {
	                // To prev
	                p.monthsTranslate ++;
	                if (!p.animating) p.months.eq(0).remove();
	                p.wrapper.prepend(newMonthHTML);
	                p.months = p.wrapper.find('.picker-calendar-month');
	                monthTranslate = -(prevTranslate + 1) * 100 * inverter;
	                p.months.eq(0).transform('translate3d(' + (p.isH ? monthTranslate : 0) + '%, ' + (p.isH ? 0 : monthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	            }
	            if (p.params.onMonthAdd) {
	                p.params.onMonthAdd(p, dir === 'next' ? p.months.eq(p.months.length - 1)[0] : p.months.eq(0)[0]);
	            }
	            p.animating = true;
	            p.onMonthChangeStart(dir);
	            wrapperTranslate = (p.monthsTranslate * 100) * inverter;
	            p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? wrapperTranslate : 0) + '%, ' + (p.isH ? 0 : wrapperTranslate) + '%, 0)');
	            if (transitionEndCallback) {
	                p.wrapper.transitionEnd(function () {
	                    p.onMonthChangeEnd(dir, true);
	                });
	            }
	            if (!p.params.animate) {
	                p.onMonthChangeEnd(dir);
	            }
	        };
	        p.nextYear = function () {
	            p.setYearMonth(p.currentYear + 1);
	        };
	        p.prevYear = function () {
	            p.setYearMonth(p.currentYear - 1);
	        };
	
	
	        // HTML Layout
	        p.layout = function () {
	            var pickerHTML = '';
	            var pickerClass = '';
	            var i;
	
	            var layoutDate = p.value && p.value.length ? p.value[0] : new Date().setHours(0,0,0,0);
	            var prevMonthHTML = p.monthHTML(layoutDate, 'prev');
	            var currentMonthHTML = p.monthHTML(layoutDate);
	            var nextMonthHTML = p.monthHTML(layoutDate, 'next');
	            var monthsHTML = '<div class="picker-calendar-months"><div class="picker-calendar-months-wrapper">' + (prevMonthHTML + currentMonthHTML + nextMonthHTML) + '</div></div>';
	            // Week days header
	            var weekHeaderHTML = '';
	            if (p.params.weekHeader) {
	                for (i = 0; i < 7; i++) {
	                    var weekDayIndex = (i + p.params.firstDay > 6) ? (i - 7 + p.params.firstDay) : (i + p.params.firstDay);
	                    var dayName = p.params.dayNamesShort[weekDayIndex];
	                    weekHeaderHTML += '<div class="picker-calendar-week-day ' + ((p.params.weekendDays.indexOf(weekDayIndex) >= 0) ? 'picker-calendar-week-day-weekend' : '') + '"> ' + dayName + '</div>';
	
	                }
	                weekHeaderHTML = '<div class="picker-calendar-week-days">' + weekHeaderHTML + '</div>';
	            }
	            pickerClass = 'picker-modal picker-calendar ' + (p.params.cssClass || '');
	            var toolbarHTML = p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '';
	            if (p.params.toolbar) {
	                toolbarHTML = p.params.toolbarTemplate
	                    .replace(/{{closeText}}/g, p.params.toolbarCloseText)
	                    .replace(/{{monthPicker}}/g, (p.params.monthPicker ? p.params.monthPickerTemplate : ''))
	                    .replace(/{{yearPicker}}/g, (p.params.yearPicker ? p.params.yearPickerTemplate : ''));
	            }
	
	            pickerHTML =
	                '<div class="' + (pickerClass) + '">' +
	                toolbarHTML +
	                '<div class="picker-modal-inner">' +
	                weekHeaderHTML +
	                monthsHTML +
	                '</div>' +
	                '</div>';
	
	
	            p.pickerHTML = pickerHTML;
	        };
	
	        // Input Events
	        function openOnInput(e) {
	            e.preventDefault();
	            // 安卓微信webviewreadonly的input依然弹出软键盘问题修复
	            if ($.device.isWeixin && $.device.android && p.params.inputReadOnly) {
	                /*jshint validthis:true */
	                this.focus();
	                this.blur();
	            }
	            if (p.opened) return;
	            p.open();
	            if (p.params.scrollToInput) {
	                var pageContent = p.input.parents('.content');
	                if (pageContent.length === 0) return;
	
	                var paddingTop = parseInt(pageContent.css('padding-top'), 10),
	                    paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
	                    pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(),
	                    pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(),
	                    newPaddingBottom;
	
	                var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
	                if (inputTop > pageHeight) {
	                    var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                    if (scrollTop + pageHeight > pageScrollHeight) {
	                        newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                        if (pageHeight === pageScrollHeight) {
	                            newPaddingBottom = p.container.height();
	                        }
	                        pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
	                    }
	                    pageContent.scrollTop(scrollTop, 300);
	                }
	            }
	        }
	        function closeOnHTMLClick(e) {
	            if (p.input && p.input.length > 0) {
	                if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0) p.close();
	            }
	            else {
	                if ($(e.target).parents('.picker-modal').length === 0) p.close();
	            }
	        }
	
	        if (p.params.input) {
	            p.input = $(p.params.input);
	            if (p.input.length > 0) {
	                if (p.params.inputReadOnly) p.input.prop('readOnly', true);
	                if (!p.inline) {
	                    p.input.on('click', openOnInput);
	                }
	            }
	
	        }
	
	        if (!p.inline) $('html').on('click', closeOnHTMLClick);
	
	        // Open
	        function onPickerClose() {
	            p.opened = false;
	            if (p.input && p.input.length > 0) p.input.parents('.content').css({'padding-bottom': ''});
	            if (p.params.onClose) p.params.onClose(p);
	
	            // Destroy events
	            p.destroyCalendarEvents();
	        }
	
	        p.opened = false;
	        p.open = function () {
	            var updateValue = false;
	            if (!p.opened) {
	                // Set date value
	                if (!p.value) {
	                    if (p.params.value) {
	                        p.value = p.params.value;
	                        updateValue = true;
	                    }
	                }
	
	                // Layout
	                p.layout();
	
	                // Append
	                if (p.inline) {
	                    p.container = $(p.pickerHTML);
	                    p.container.addClass('picker-modal-inline');
	                    $(p.params.container).append(p.container);
	                }
	                else {
	                    p.container = $($.pickerModal(p.pickerHTML));
	                    $(p.container)
	                        .on('close', function () {
	                            onPickerClose();
	                        });
	                }
	
	                // Store calendar instance
	                p.container[0].f7Calendar = p;
	                p.wrapper = p.container.find('.picker-calendar-months-wrapper');
	
	                // Months
	                p.months = p.wrapper.find('.picker-calendar-month');
	
	                // Update current month and year
	                p.updateCurrentMonthYear();
	
	                // Set initial translate
	                p.monthsTranslate = 0;
	                p.setMonthsTranslate();
	
	                // Init events
	                p.initCalendarEvents();
	
	                // Update input value
	                if (updateValue) p.updateValue();
	
	            }
	
	            // Set flag
	            p.opened = true;
	            p.initialized = true;
	            if (p.params.onMonthAdd) {
	                p.months.each(function () {
	                    p.params.onMonthAdd(p, this);
	                });
	            }
	            if (p.params.onOpen) p.params.onOpen(p);
	        };
	
	        // Close
	        p.close = function () {
	            if (!p.opened || p.inline) return;
	            $.closeModal(p.container);
	
	        };
	
	        // Destroy
	        p.destroy = function () {
	            p.close();
	            if (p.params.input && p.input.length > 0) {
	                p.input.off('click', openOnInput);
	            }
	            $('html').off('click', closeOnHTMLClick);
	        };
	
	        if (p.inline) {
	            p.open();
	        }
	        if(p.params.ready) p.params.ready(p);
	    };
	
	    $.fn.calendar = function (params) {
	        return this.each(function() {
	            var $this = $(this);
	            if(!$this[0]) return;
	            var p = {};
	            if($this[0].tagName.toUpperCase() === "INPUT") {
	                p.input = $this;
	            } else {
	                p.container = $this;
	            }
	            var calendar = $this.data("calendar");
	            if(!calendar) {
	                calendar = new Calendar($.extend(p, params));
	                $this.data("calendar", calendar);
	            }
	            //new Calendar($.extend(p, params));
	        });
	    };
	
	    $.initCalendar = function(content) {
	        var $content = content ? $(content) : $(document.body);
	        $content.find("[data-toggle='date']").each(function() {
	            $(this).calendar();
	        });
	    };
	}(Zepto);
	
	/*======================================================
	************   Picker   ************
	======================================================*/
	/* jshint unused:false */
	/* jshint multistr:true */
	+ function($) {
	    "use strict";
	    var Picker = function (params) {
	        var p = this;
	        var defaults = {
	            updateValuesOnMomentum: false,
	            updateValuesOnTouchmove: true,
	            rotateEffect: false,
	            momentumRatio: 7,
	            freeMode: false,
	            // Common settings
	            scrollToInput: true,
	            inputReadOnly: true,
	            toolbar: true,
	            toolbarCloseText: '确定',
	            toolbarTemplate: '<header class="bar bar-nav">\
	                <button class="button button-link pull-right close-picker"></button>\
	                <h1 class="title"></h1>\
	                </header>',
	        };
	        params = params || {};
	        for (var def in defaults) {
	            if (typeof params[def] === 'undefined') {
	                params[def] = defaults[def];
	            }
	        }
	        params.toolbarTemplate = '<header class="bar bar-nav">\
	                <button class="button button-link pull-right close-picker">'+params.toolbarCloseText+'</button>\
	                <h1 class="title"></h1>\
	                </header>'
	        p.params = params;
	        p.cols = [];
	        p.initialized = false;
	
	        // Inline flag
	        p.inline = p.params.container ? true : false;
	
	        // 3D Transforms origin bug, only on safari
	        var originBug = $.device.ios || (navigator.userAgent.toLowerCase().indexOf('safari') >= 0 && navigator.userAgent.toLowerCase().indexOf('chrome') < 0) && !$.device.android;
	
	        // Value
	        p.setValue = function (arrValues, transition) {
	            var valueIndex = 0;
	            for (var i = 0; i < p.cols.length; i++) {
	                if (p.cols[i] && !p.cols[i].divider) {
	                    p.cols[i].setValue(arrValues[valueIndex], transition);
	                    valueIndex++;
	                }
	            }
	        };
	        p.updateValue = function () {
	            var newValue = [];
	            var newDisplayValue = [];
	            for (var i = 0; i < p.cols.length; i++) {
	                if (!p.cols[i].divider) {
	                    newValue.push(p.cols[i].value);
	                    newDisplayValue.push(p.cols[i].displayValue);
	                }
	            }
	            if (newValue.indexOf(undefined) >= 0) {
	                return;
	            }
	            p.value = newValue;
	            p.displayValue = newDisplayValue;
	            if (p.params.onChange) {
	                p.params.onChange(p, p.value, p.displayValue);
	            }
	            if (p.input && p.input.length > 0) {
	                $(p.input).val(p.params.formatValue ? p.params.formatValue(p, p.value, p.displayValue) : p.value.join(' '));
	                $(p.input).trigger('change');
	            }
	        };
	
	        // Columns Handlers
	        p.initPickerCol = function (colElement, updateItems) {
	            var colContainer = $(colElement);
	            var colIndex = colContainer.index();
	            var col = p.cols[colIndex];
	            if (col.divider) return;
	            col.container = colContainer;
	            col.wrapper = col.container.find('.picker-items-col-wrapper');
	            col.items = col.wrapper.find('.picker-item');
	
	            var i, j;
	            var wrapperHeight, itemHeight, itemsHeight, minTranslate, maxTranslate;
	            col.replaceValues = function (values, displayValues) {
	                col.destroyEvents();
	                col.values = values;
	                col.displayValues = displayValues;
	                var newItemsHTML = p.columnHTML(col, true);
	                col.wrapper.html(newItemsHTML);
	                col.items = col.wrapper.find('.picker-item');
	                col.calcSize();
	                col.setValue(col.values[0], 0, true);
	                col.initEvents();
	            };
	            col.calcSize = function () {
	                if (p.params.rotateEffect) {
	                    col.container.removeClass('picker-items-col-absolute');
	                    if (!col.width) col.container.css({width:''});
	                }
	                var colWidth, colHeight;
	                colWidth = 0;
	                colHeight = col.container[0].offsetHeight;
	                wrapperHeight = col.wrapper[0].offsetHeight;
	                itemHeight = col.items[0].offsetHeight;
	                itemsHeight = itemHeight * col.items.length;
	                minTranslate = colHeight / 2 - itemsHeight + itemHeight / 2;
	                maxTranslate = colHeight / 2 - itemHeight / 2;
	                if (col.width) {
	                    colWidth = col.width;
	                    if (parseInt(colWidth, 10) === colWidth) colWidth = colWidth + 'px';
	                    col.container.css({width: colWidth});
	                }
	                if (p.params.rotateEffect) {
	                    if (!col.width) {
	                        col.items.each(function () {
	                            var item = $(this);
	                            item.css({width:'auto'});
	                            colWidth = Math.max(colWidth, item[0].offsetWidth);
	                            item.css({width:''});
	                        });
	                        col.container.css({width: (colWidth + 2) + 'px'});
	                    }
	                    col.container.addClass('picker-items-col-absolute');
	                }
	            };
	            col.calcSize();
	
	            col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)').transition(0);
	
	
	            var activeIndex = 0;
	            var animationFrameId;
	
	            // Set Value Function
	            col.setValue = function (newValue, transition, valueCallbacks) {
	                if (typeof transition === 'undefined') transition = '';
	                var newActiveIndex = col.wrapper.find('.picker-item[data-picker-value="' + newValue + '"]').index();
	                if(typeof newActiveIndex === 'undefined' || newActiveIndex === -1) {
	                    return;
	                }
	                var newTranslate = -newActiveIndex * itemHeight + maxTranslate;
	                // Update wrapper
	                col.wrapper.transition(transition);
	                col.wrapper.transform('translate3d(0,' + (newTranslate) + 'px,0)');
	
	                // Watch items
	                if (p.params.updateValuesOnMomentum && col.activeIndex && col.activeIndex !== newActiveIndex ) {
	                    $.cancelAnimationFrame(animationFrameId);
	                    col.wrapper.transitionEnd(function(){
	                        $.cancelAnimationFrame(animationFrameId);
	                    });
	                    updateDuringScroll();
	                }
	
	                // Update items
	                col.updateItems(newActiveIndex, newTranslate, transition, valueCallbacks);
	            };
	
	            col.updateItems = function (activeIndex, translate, transition, valueCallbacks) {
	                if (typeof translate === 'undefined') {
	                    translate = $.getTranslate(col.wrapper[0], 'y');
	                }
	                if(typeof activeIndex === 'undefined') activeIndex = -Math.round((translate - maxTranslate)/itemHeight);
	                if (activeIndex < 0) activeIndex = 0;
	                if (activeIndex >= col.items.length) activeIndex = col.items.length - 1;
	                var previousActiveIndex = col.activeIndex;
	                col.activeIndex = activeIndex;
	                /*
	                   col.wrapper.find('.picker-selected, .picker-after-selected, .picker-before-selected').removeClass('picker-selected picker-after-selected picker-before-selected');
	
	                   col.items.transition(transition);
	                   var selectedItem = col.items.eq(activeIndex).addClass('picker-selected').transform('');
	                   var prevItems = selectedItem.prevAll().addClass('picker-before-selected');
	                   var nextItems = selectedItem.nextAll().addClass('picker-after-selected');
	                   */
	                //去掉 .picker-after-selected, .picker-before-selected 以提高性能
	                col.wrapper.find('.picker-selected').removeClass('picker-selected');
	                if (p.params.rotateEffect) {
	                    col.items.transition(transition);
	                }
	                var selectedItem = col.items.eq(activeIndex).addClass('picker-selected').transform('');
	
	                if (valueCallbacks || typeof valueCallbacks === 'undefined') {
	                    // Update values
	                    col.value = selectedItem.attr('data-picker-value');
	                    col.displayValue = col.displayValues ? col.displayValues[activeIndex] : col.value;
	                    // On change callback
	                    if (previousActiveIndex !== activeIndex) {
	                        if (col.onChange) {
	                            col.onChange(p, col.value, col.displayValue);
	                        }
	                        p.updateValue();
	                    }
	                }
	
	                // Set 3D rotate effect
	                if (!p.params.rotateEffect) {
	                    return;
	                }
	                var percentage = (translate - (Math.floor((translate - maxTranslate)/itemHeight) * itemHeight + maxTranslate)) / itemHeight;
	
	                col.items.each(function () {
	                    var item = $(this);
	                    var itemOffsetTop = item.index() * itemHeight;
	                    var translateOffset = maxTranslate - translate;
	                    var itemOffset = itemOffsetTop - translateOffset;
	                    var percentage = itemOffset / itemHeight;
	
	                    var itemsFit = Math.ceil(col.height / itemHeight / 2) + 1;
	
	                    var angle = (-18*percentage);
	                    if (angle > 180) angle = 180;
	                    if (angle < -180) angle = -180;
	                    // Far class
	                    if (Math.abs(percentage) > itemsFit) item.addClass('picker-item-far');
	                    else item.removeClass('picker-item-far');
	                    // Set transform
	                    item.transform('translate3d(0, ' + (-translate + maxTranslate) + 'px, ' + (originBug ? -110 : 0) + 'px) rotateX(' + angle + 'deg)');
	                });
	            };
	
	            function updateDuringScroll() {
	                animationFrameId = $.requestAnimationFrame(function () {
	                    col.updateItems(undefined, undefined, 0);
	                    updateDuringScroll();
	                });
	            }
	
	            // Update items on init
	            if (updateItems) col.updateItems(0, maxTranslate, 0);
	
	            var allowItemClick = true;
	            var isTouched, isMoved, touchStartY, touchCurrentY, touchStartTime, touchEndTime, startTranslate, returnTo, currentTranslate, prevTranslate, velocityTranslate, velocityTime;
	            function handleTouchStart (e) {
	                if (isMoved || isTouched) return;
	                e.preventDefault();
	                isTouched = true;
	                touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                touchStartTime = (new Date()).getTime();
	
	                allowItemClick = true;
	                startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
	            }
	            function handleTouchMove (e) {
	                if (!isTouched) return;
	                e.preventDefault();
	                allowItemClick = false;
	                touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (!isMoved) {
	                    // First move
	                    $.cancelAnimationFrame(animationFrameId);
	                    isMoved = true;
	                    startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
	                    col.wrapper.transition(0);
	                }
	                e.preventDefault();
	
	                var diff = touchCurrentY - touchStartY;
	                currentTranslate = startTranslate + diff;
	                returnTo = undefined;
	
	                // Normalize translate
	                if (currentTranslate < minTranslate) {
	                    currentTranslate = minTranslate - Math.pow(minTranslate - currentTranslate, 0.8);
	                    returnTo = 'min';
	                }
	                if (currentTranslate > maxTranslate) {
	                    currentTranslate = maxTranslate + Math.pow(currentTranslate - maxTranslate, 0.8);
	                    returnTo = 'max';
	                }
	                // Transform wrapper
	                col.wrapper.transform('translate3d(0,' + currentTranslate + 'px,0)');
	
	                // Update items
	                col.updateItems(undefined, currentTranslate, 0, p.params.updateValuesOnTouchmove);
	
	                // Calc velocity
	                velocityTranslate = currentTranslate - prevTranslate || currentTranslate;
	                velocityTime = (new Date()).getTime();
	                prevTranslate = currentTranslate;
	            }
	            function handleTouchEnd (e) {
	                if (!isTouched || !isMoved) {
	                    isTouched = isMoved = false;
	                    return;
	                }
	                isTouched = isMoved = false;
	                col.wrapper.transition('');
	                if (returnTo) {
	                    if (returnTo === 'min') {
	                        col.wrapper.transform('translate3d(0,' + minTranslate + 'px,0)');
	                    }
	                    else col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)');
	                }
	                touchEndTime = new Date().getTime();
	                var velocity, newTranslate;
	                if (touchEndTime - touchStartTime > 300) {
	                    newTranslate = currentTranslate;
	                }
	                else {
	                    velocity = Math.abs(velocityTranslate / (touchEndTime - velocityTime));
	                    newTranslate = currentTranslate + velocityTranslate * p.params.momentumRatio;
	                }
	
	                newTranslate = Math.max(Math.min(newTranslate, maxTranslate), minTranslate);
	
	                // Active Index
	                var activeIndex = -Math.floor((newTranslate - maxTranslate)/itemHeight);
	
	                // Normalize translate
	                if (!p.params.freeMode) newTranslate = -activeIndex * itemHeight + maxTranslate;
	
	                // Transform wrapper
	                col.wrapper.transform('translate3d(0,' + (parseInt(newTranslate,10)) + 'px,0)');
	
	                // Update items
	                col.updateItems(activeIndex, newTranslate, '', true);
	
	                // Watch items
	                if (p.params.updateValuesOnMomentum) {
	                    updateDuringScroll();
	                    col.wrapper.transitionEnd(function(){
	                        $.cancelAnimationFrame(animationFrameId);
	                    });
	                }
	
	                // Allow click
	                setTimeout(function () {
	                    allowItemClick = true;
	                }, 100);
	            }
	
	            function handleClick(e) {
	                if (!allowItemClick) return;
	                $.cancelAnimationFrame(animationFrameId);
	                /*jshint validthis:true */
	                var value = $(this).attr('data-picker-value');
	                col.setValue(value);
	            }
	
	            col.initEvents = function (detach) {
	                var method = detach ? 'off' : 'on';
	                col.container[method]($.touchEvents.start, handleTouchStart);
	                col.container[method]($.touchEvents.move, handleTouchMove);
	                col.container[method]($.touchEvents.end, handleTouchEnd);
	                col.items[method]('click', handleClick);
	            };
	            col.destroyEvents = function () {
	                col.initEvents(true);
	            };
	
	            col.container[0].f7DestroyPickerCol = function () {
	                col.destroyEvents();
	            };
	
	            col.initEvents();
	
	        };
	        p.destroyPickerCol = function (colContainer) {
	            colContainer = $(colContainer);
	            if ('f7DestroyPickerCol' in colContainer[0]) colContainer[0].f7DestroyPickerCol();
	        };
	        // Resize cols
	        function resizeCols() {
	            if (!p.opened) return;
	            for (var i = 0; i < p.cols.length; i++) {
	                if (!p.cols[i].divider) {
	                    p.cols[i].calcSize();
	                    p.cols[i].setValue(p.cols[i].value, 0, false);
	                }
	            }
	        }
	        $(window).on('resize', resizeCols);
	
	        // HTML Layout
	        p.columnHTML = function (col, onlyItems) {
	            var columnItemsHTML = '';
	            var columnHTML = '';
	            if (col.divider) {
	                columnHTML += '<div class="picker-items-col picker-items-col-divider ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '">' + col.content + '</div>';
	            }
	            else {
	                for (var j = 0; j < col.values.length; j++) {
	                    columnItemsHTML += '<div class="picker-item" data-picker-value="' + col.values[j] + '">' + (col.displayValues ? col.displayValues[j] : col.values[j]) + '</div>';
	                }
	
	                columnHTML += '<div class="picker-items-col ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '"><div class="picker-items-col-wrapper">' + columnItemsHTML + '</div></div>';
	            }
	            return onlyItems ? columnItemsHTML : columnHTML;
	        };
	        p.layout = function () {
	            var pickerHTML = '';
	            var pickerClass = '';
	            var i;
	            p.cols = [];
	            var colsHTML = '';
	            for (i = 0; i < p.params.cols.length; i++) {
	                var col = p.params.cols[i];
	                colsHTML += p.columnHTML(p.params.cols[i]);
	                p.cols.push(col);
	            }
	            pickerClass = 'picker-modal picker-columns ' + (p.params.cssClass || '') + (p.params.rotateEffect ? ' picker-3d' : '');
	            pickerHTML =
	                '<div class="' + (pickerClass) + '">' +
	                (p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '') +
	                '<div class="picker-modal-inner picker-items">' +
	                colsHTML +
	                '<div class="picker-center-highlight"></div>' +
	                '</div>' +
	                '</div>';
	
	            p.pickerHTML = pickerHTML;
	        };
	
	        // Input Events
	        function openOnInput(e) {
	            e.preventDefault();
	            // 安卓微信webviewreadonly的input依然弹出软键盘问题修复
	            if ($.device.isWeixin && $.device.android && p.params.inputReadOnly) {
	                /*jshint validthis:true */
	                this.focus();
	                this.blur();
	            }
	            if (p.opened) return;
	            p.open();
	            if (p.params.scrollToInput) {
	                var pageContent = p.input.parents('.content');
	                if (pageContent.length === 0) return;
	
	                var paddingTop = parseInt(pageContent.css('padding-top'), 10),
	                    paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
	                    pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(),
	                    pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(),
	                    newPaddingBottom;
	                var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
	                if (inputTop > pageHeight) {
	                    var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                    if (scrollTop + pageHeight > pageScrollHeight) {
	                        newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                        if (pageHeight === pageScrollHeight) {
	                            newPaddingBottom = p.container.height();
	                        }
	                        pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
	                    }
	                    pageContent.scrollTop(scrollTop, 300);
	                }
	            }
	        }
	        function closeOnHTMLClick(e) {
	            if (!p.opened) return;
	            if (p.input && p.input.length > 0) {
	                if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0) p.close();
	            }
	            else {
	                if ($(e.target).parents('.picker-modal').length === 0) p.close();
	            }
	        }
	
	        if (p.params.input) {
	            p.input = $(p.params.input);
	            if (p.input.length > 0) {
	                if (p.params.inputReadOnly) p.input.prop('readOnly', true);
	                if (!p.inline) {
	                    p.input.on('click', openOnInput);
	                }
	            }
	        }
	
	        if (!p.inline) $('html').on('click', closeOnHTMLClick);
	
	        // Open
	        function onPickerClose() {
	            p.opened = false;
	            if (p.input && p.input.length > 0) p.input.parents('.content').css({'padding-bottom': ''});
	            if (p.params.onClose) p.params.onClose(p);
	
	            // Destroy events
	            p.container.find('.picker-items-col').each(function () {
	                p.destroyPickerCol(this);
	            });
	        }
	
	        p.opened = false;
	        p.open = function () {
	            if (!p.opened) {
	
	                // Layout
	                p.layout();
	
	                // Append
	                if (p.inline) {
	                    p.container = $(p.pickerHTML);
	                    p.container.addClass('picker-modal-inline');
	                    $(p.params.container).append(p.container);
	                    p.opened = true;
	                }
	                else {
	                    p.container = $($.pickerModal(p.pickerHTML));
	                    $(p.container)
	                        .one('opened', function() {
	                            p.opened = true;
	                        })
	                        .on('close', function () {
	                            onPickerClose();
	                        });
	                }
	
	                // Store picker instance
	                p.container[0].f7Picker = p;
	
	                // Init Events
	                p.container.find('.picker-items-col').each(function () {
	                    var updateItems = true;
	                    if ((!p.initialized && p.params.value) || (p.initialized && p.value)) updateItems = false;
	                    p.initPickerCol(this, updateItems);
	                });
	
	                // Set value
	                if (!p.initialized) {
	                    if (p.params.value) {
	                        p.setValue(p.params.value, 0);
	                    }
	                }
	                else {
	                    if (p.value) p.setValue(p.value, 0);
	                }
	            }
	
	            // Set flag
	            p.initialized = true;
	
	            if (p.params.onOpen) p.params.onOpen(p);
	        };
	
	        // Close
	        p.close = function () {
	            if (!p.opened || p.inline) return;
	            $.closeModal(p.container);
	
	        };
	
	        // Destroy
	        p.destroy = function () {
	            p.close();
	            if (p.params.input && p.input.length > 0) {
	                p.input.off('click', openOnInput);
	            }
	            $('html').off('click', closeOnHTMLClick);
	            $(window).off('resize', resizeCols);
	        };
	
	        if (p.inline) {
	            p.open();
	        }
	        return p;
	    };
	
	    $(document).on("click", ".close-picker", function() {
	        var pickerToClose = $('.picker-modal.modal-in');
	        $.closeModal(pickerToClose);
	    });
	
	    $.fn.picker = function(params) {
	        var args = arguments;
	        return this.each(function() {
	            if(!this) return;
	            var $this = $(this);
	
	            var picker = $this.data("picker");
	            if(!picker) {
	                var p = $.extend({
	                    input: this,
	                    value: $this.val() ? $this.val().split(' ') : ''
	                }, params);
	                picker = new Picker(p);
	                $this.data("picker", picker);
	            }
	            if(typeof params === typeof "a") {
	                picker[params].apply(picker, Array.prototype.slice.call(args, 1));
	            }
	        });
	    };
	}(Zepto);
	
	/* jshint unused:false*/
	
	+ function($) {
	    "use strict";
	
	    var today = new Date();
	
	    var getDays = function(max) {
	        var days = [];
	        for(var i=1; i<= (max||31);i++) {
	            days.push(i < 10 ? "0"+i : i);
	        }
	        return days;
	    };
	
	    var getDaysByMonthAndYear = function(month, year) {
	        var int_d = new Date(year, parseInt(month)+1-1, 1);
	        var d = new Date(int_d - 1);
	        return getDays(d.getDate());
	    };
	
	    var formatNumber = function (n) {
	        return n < 10 ? "0" + n : n;
	    };
	
	    var initMonthes = ('01 02 03 04 05 06 07 08 09 10 11 12').split(' ');
	
	    var initYears = (function () {
	        var arr = [];
	        for (var i = 1950; i <= 2030; i++) { arr.push(i); }
	        return arr;
	    })();
	
	
	    var defaults = {
	
	        rotateEffect: false,  //为了性能
	
	        value: [today.getFullYear(), formatNumber(today.getMonth()+1), formatNumber(today.getDate()), today.getHours(), formatNumber(today.getMinutes())],
	
	        onChange: function (picker, values, displayValues) {
	            var days = getDaysByMonthAndYear(picker.cols[1].value, picker.cols[0].value);
	            var currentValue = picker.cols[2].value;
	            if(currentValue > days.length) currentValue = days.length;
	            picker.cols[2].setValue(currentValue);
	        },
	
	        formatValue: function (p, values, displayValues) {
	            return displayValues[0] + '-' + values[1] + '-' + values[2] + ' ' + values[3] + ':' + values[4];
	        },
	
	        cols: [
	            // Years
	        {
	            values: initYears
	        },
	        // Months
	        {
	            values: initMonthes
	        },
	        // Days
	        {
	            values: getDays()
	        },
	
	        // Space divider
	        {
	            divider: true,
	            content: '  '
	        },
	        // Hours
	        {
	            values: (function () {
	                var arr = [];
	                for (var i = 0; i <= 23; i++) { arr.push(i); }
	                return arr;
	            })(),
	        },
	        // Divider
	        {
	            divider: true,
	            content: ':'
	        },
	        // Minutes
	        {
	            values: (function () {
	                var arr = [];
	                for (var i = 0; i <= 59; i++) { arr.push(i < 10 ? '0' + i : i); }
	                return arr;
	            })(),
	        }
	        ]
	    };
	
	    $.fn.datetimePicker = function(params) {
	        return this.each(function() {
	            if(!this) return;
	            var p = $.extend(defaults, params);
	            $(this).picker(p);
	            if (params.value) $(this).val(p.formatValue(p, p.value, p.value));
	        });
	    };
	
	}(Zepto);
	
	+ function(window) {
	
	    "use strict";
	
	    var rAF = window.requestAnimationFrame ||
	        window.webkitRequestAnimationFrame ||
	        window.mozRequestAnimationFrame ||
	        window.oRequestAnimationFrame ||
	        window.msRequestAnimationFrame ||
	        function(callback) {
	            window.setTimeout(callback, 1000 / 60);
	        };
	    /*var cRAF = window.cancelRequestAnimationFrame ||
	        window.webkitCancelRequestAnimationFrame ||
	        window.mozCancelRequestAnimationFrame ||
	        window.oCancelRequestAnimationFrame ||
	        window.msCancelRequestAnimationFrame;*/
	
	    var utils = (function() {
	        var me = {};
	
	        var _elementStyle = document.createElement('div').style;
	        var _vendor = (function() {
	            var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
	                transform,
	                i = 0,
	                l = vendors.length;
	
	            for (; i < l; i++) {
	                transform = vendors[i] + 'ransform';
	                if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
	            }
	
	            return false;
	        })();
	
	        function _prefixStyle(style) {
	            if (_vendor === false) return false;
	            if (_vendor === '') return style;
	            return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
	        }
	
	        me.getTime = Date.now || function getTime() {
	            return new Date().getTime();
	        };
	
	        me.extend = function(target, obj) {
	            for (var i in obj) {  // jshint ignore:line
	                    target[i] = obj[i];
	            }
	        };
	
	        me.addEvent = function(el, type, fn, capture) {
	            el.addEventListener(type, fn, !!capture);
	        };
	
	        me.removeEvent = function(el, type, fn, capture) {
	            el.removeEventListener(type, fn, !!capture);
	        };
	
	        me.prefixPointerEvent = function(pointerEvent) {
	            return window.MSPointerEvent ?
	                'MSPointer' + pointerEvent.charAt(9).toUpperCase() + pointerEvent.substr(10) :
	                pointerEvent;
	        };
	
	        me.momentum = function(current, start, time, lowerMargin, wrapperSize, deceleration, self) {
	            var distance = current - start,
	                speed = Math.abs(distance) / time,
	                destination,
	                duration;
	
	            // var absDistance = Math.abs(distance);
	            speed = speed / 2; //slowdown
	            speed = speed > 1.5 ? 1.5 : speed; //set max speed to 1
	            deceleration = deceleration === undefined ? 0.0006 : deceleration;
	
	            destination = current + (speed * speed) / (2 * deceleration) * (distance < 0 ? -1 : 1);
	            duration = speed / deceleration;
	
	            if (destination < lowerMargin) {
	                destination = wrapperSize ? lowerMargin - (wrapperSize / 2.5 * (speed / 8)) : lowerMargin;
	                distance = Math.abs(destination - current);
	                duration = distance / speed;
	            } else if (destination > 0) {
	                destination = wrapperSize ? wrapperSize / 2.5 * (speed / 8) : 0;
	                distance = Math.abs(current) + destination;
	                duration = distance / speed;
	            }
	
	            //simple trigger, every 50ms
	            var t = +new Date();
	            var l = t;
	
	            function eventTrigger() {
	                if (+new Date() - l > 50) {
	                    self._execEvent('scroll');
	                    l = +new Date();
	                }
	                if (+new Date() - t < duration) {
	                    rAF(eventTrigger);
	                }
	            }
	            rAF(eventTrigger);
	
	            return {
	                destination: Math.round(destination),
	                duration: duration
	            };
	        };
	
	        var _transform = _prefixStyle('transform');
	
	        me.extend(me, {
	            hasTransform: _transform !== false,
	            hasPerspective: _prefixStyle('perspective') in _elementStyle,
	            hasTouch: 'ontouchstart' in window,
	            hasPointer: window.PointerEvent || window.MSPointerEvent, // IE10 is prefixed
	            hasTransition: _prefixStyle('transition') in _elementStyle
	        });
	
	        // This should find all Android browsers lower than build 535.19 (both stock browser and webview)
	        me.isBadAndroid = /Android /.test(window.navigator.appVersion) && !(/Chrome\/\d/.test(window.navigator.appVersion)) && false; //this will cause many android device scroll flash; so set it to false!
	
	        me.extend(me.style = {}, {
	            transform: _transform,
	            transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
	            transitionDuration: _prefixStyle('transitionDuration'),
	            transitionDelay: _prefixStyle('transitionDelay'),
	            transformOrigin: _prefixStyle('transformOrigin')
	        });
	
	        me.hasClass = function(e, c) {
	            var re = new RegExp('(^|\\s)' + c + '(\\s|$)');
	            return re.test(e.className);
	        };
	
	        me.addClass = function(e, c) {
	            if (me.hasClass(e, c)) {
	                return;
	            }
	
	            var newclass = e.className.split(' ');
	            newclass.push(c);
	            e.className = newclass.join(' ');
	        };
	
	        me.removeClass = function(e, c) {
	            if (!me.hasClass(e, c)) {
	                return;
	            }
	
	            var re = new RegExp('(^|\\s)' + c + '(\\s|$)', 'g');
	            e.className = e.className.replace(re, ' ');
	        };
	
	        me.offset = function(el) {
	            var left = -el.offsetLeft,
	                top = -el.offsetTop;
	
	            // jshint -W084
	            while (el = el.offsetParent) {
	                left -= el.offsetLeft;
	                top -= el.offsetTop;
	            }
	            // jshint +W084
	
	            return {
	                left: left,
	                top: top
	            };
	        };
	
	        me.preventDefaultException = function(el, exceptions) {
	            for (var i in exceptions) {
	                if (exceptions[i].test(el[i])) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	
	        me.extend(me.eventType = {}, {
	            touchstart: 1,
	            touchmove: 1,
	            touchend: 1,
	
	            mousedown: 2,
	            mousemove: 2,
	            mouseup: 2,
	
	            pointerdown: 3,
	            pointermove: 3,
	            pointerup: 3,
	
	            MSPointerDown: 3,
	            MSPointerMove: 3,
	            MSPointerUp: 3
	        });
	
	        me.extend(me.ease = {}, {
	            quadratic: {
	                style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
	                fn: function(k) {
	                    return k * (2 - k);
	                }
	            },
	            circular: {
	                style: 'cubic-bezier(0.1, 0.57, 0.1, 1)', // Not properly 'circular' but this looks better, it should be (0.075, 0.82, 0.165, 1)
	                fn: function(k) {
	                    return Math.sqrt(1 - (--k * k));
	                }
	            },
	            back: {
	                style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
	                fn: function(k) {
	                    var b = 4;
	                    return (k = k - 1) * k * ((b + 1) * k + b) + 1;
	                }
	            },
	            bounce: {
	                style: '',
	                fn: function(k) {
	                    if ((k /= 1) < (1 / 2.75)) {
	                        return 7.5625 * k * k;
	                    } else if (k < (2 / 2.75)) {
	                        return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
	                    } else if (k < (2.5 / 2.75)) {
	                        return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
	                    } else {
	                        return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
	                    }
	                }
	            },
	            elastic: {
	                style: '',
	                fn: function(k) {
	                    var f = 0.22,
	                        e = 0.4;
	
	                    if (k === 0) {
	                        return 0;
	                    }
	                    if (k === 1) {
	                        return 1;
	                    }
	
	                    return (e * Math.pow(2, -10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1);
	                }
	            }
	        });
	
	        me.tap = function(e, eventName) {
	            var ev = document.createEvent('Event');
	            ev.initEvent(eventName, true, true);
	            ev.pageX = e.pageX;
	            ev.pageY = e.pageY;
	            e.target.dispatchEvent(ev);
	        };
	
	        me.click = function(e) {
	            var target = e.target,
	                ev;
	
	            if (!(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName)) {
	                ev = document.createEvent('MouseEvents');
	                ev.initMouseEvent('click', true, true, e.view, 1,
	                    target.screenX, target.screenY, target.clientX, target.clientY,
	                    e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
	                    0, null);
	
	                ev._constructed = true;
	                target.dispatchEvent(ev);
	            }
	        };
	
	        return me;
	    })();
	
	    function IScroll(el, options) {
	        this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
	        this.scroller = $(this.wrapper).find('.content-inner')[0]; // jshint ignore:line
	
	
	        this.scrollerStyle = this.scroller&&this.scroller.style; // cache style for better performance
	
	        this.options = {
	
	            resizeScrollbars: true,
	
	            mouseWheelSpeed: 20,
	
	            snapThreshold: 0.334,
	
	            // INSERT POINT: OPTIONS
	
	            startX: 0,
	            startY: 0,
	            scrollY: true,
	            directionLockThreshold: 5,
	            momentum: true,
	
	            bounce: true,
	            bounceTime: 600,
	            bounceEasing: '',
	
	            preventDefault: true,
	            preventDefaultException: {
	                tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/
	            },
	
	            HWCompositing: true,
	            useTransition: true,
	            useTransform: true,
	
	            //other options
	            eventPassthrough: undefined, //if you  want to use native scroll, you can set to: true or horizontal
	        };
	
	        for (var i in options) {
	                this.options[i] = options[i];
	        }
	
	        // Normalize options
	        this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';
	
	        this.options.useTransition = utils.hasTransition && this.options.useTransition;
	        this.options.useTransform = utils.hasTransform && this.options.useTransform;
	
	        this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
	        this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;
	
	        // If you want eventPassthrough I have to lock one of the axes
	        this.options.scrollY = this.options.eventPassthrough === 'vertical' ? false : this.options.scrollY;
	        this.options.scrollX = this.options.eventPassthrough === 'horizontal' ? false : this.options.scrollX;
	
	        // With eventPassthrough we also need lockDirection mechanism
	        this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
	        this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;
	
	        this.options.bounceEasing = typeof this.options.bounceEasing === 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;
	
	        this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;
	
	        if (this.options.tap === true) {
	            this.options.tap = 'tap';
	        }
	
	        if (this.options.shrinkScrollbars === 'scale') {
	            this.options.useTransition = false;
	        }
	
	        this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;
	
	        if (this.options.probeType === 3) {
	            this.options.useTransition = false;
	        }
	
	        // INSERT POINT: NORMALIZATION
	
	        // Some defaults
	        this.x = 0;
	        this.y = 0;
	        this.directionX = 0;
	        this.directionY = 0;
	        this._events = {};
	
	        // INSERT POINT: DEFAULTS
	
	        this._init();
	        this.refresh();
	
	        this.scrollTo(this.options.startX, this.options.startY);
	        this.enable();
	    }
	
	    IScroll.prototype = {
	        version: '5.1.3',
	
	        _init: function() {
	            this._initEvents();
	
	            if (this.options.scrollbars || this.options.indicators) {
	                this._initIndicators();
	            }
	
	            if (this.options.mouseWheel) {
	                this._initWheel();
	            }
	
	            if (this.options.snap) {
	                this._initSnap();
	            }
	
	            if (this.options.keyBindings) {
	                this._initKeys();
	            }
	
	            // INSERT POINT: _init
	
	        },
	
	        destroy: function() {
	            this._initEvents(true);
	
	            this._execEvent('destroy');
	        },
	
	        _transitionEnd: function(e) {
	            if (e.target !== this.scroller || !this.isInTransition) {
	                return;
	            }
	
	            this._transitionTime();
	            if (!this.resetPosition(this.options.bounceTime)) {
	                this.isInTransition = false;
	                this._execEvent('scrollEnd');
	            }
	        },
	
	        _start: function(e) {
	            // React to left mouse button only
	            if (utils.eventType[e.type] !== 1) {
	                if (e.button !== 0) {
	                    return;
	                }
	            }
	
	            if (!this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated)) {
	                return;
	            }
	
	            if (this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
	                e.preventDefault();
	            }
	
	            var point = e.touches ? e.touches[0] : e,
	                pos;
	
	            this.initiated = utils.eventType[e.type];
	            this.moved = false;
	            this.distX = 0;
	            this.distY = 0;
	            this.directionX = 0;
	            this.directionY = 0;
	            this.directionLocked = 0;
	
	            this._transitionTime();
	
	            this.startTime = utils.getTime();
	
	            if (this.options.useTransition && this.isInTransition) {
	                this.isInTransition = false;
	                pos = this.getComputedPosition();
	                this._translate(Math.round(pos.x), Math.round(pos.y));
	                this._execEvent('scrollEnd');
	            } else if (!this.options.useTransition && this.isAnimating) {
	                this.isAnimating = false;
	                this._execEvent('scrollEnd');
	            }
	
	            this.startX = this.x;
	            this.startY = this.y;
	            this.absStartX = this.x;
	            this.absStartY = this.y;
	            this.pointX = point.pageX;
	            this.pointY = point.pageY;
	
	            this._execEvent('beforeScrollStart');
	        },
	
	        _move: function(e) {
	            if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
	                return;
	            }
	
	            if (this.options.preventDefault) { // increases performance on Android? TODO: check!
	                e.preventDefault();
	            }
	
	            var point = e.touches ? e.touches[0] : e,
	                deltaX = point.pageX - this.pointX,
	                deltaY = point.pageY - this.pointY,
	                timestamp = utils.getTime(),
	                newX, newY,
	                absDistX, absDistY;
	
	            this.pointX = point.pageX;
	            this.pointY = point.pageY;
	
	            this.distX += deltaX;
	            this.distY += deltaY;
	            absDistX = Math.abs(this.distX);
	            absDistY = Math.abs(this.distY);
	
	            // We need to move at least 10 pixels for the scrolling to initiate
	            if (timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10)) {
	                return;
	            }
	
	            // If you are scrolling in one direction lock the other
	            if (!this.directionLocked && !this.options.freeScroll) {
	                if (absDistX > absDistY + this.options.directionLockThreshold) {
	                    this.directionLocked = 'h'; // lock horizontally
	                } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
	                    this.directionLocked = 'v'; // lock vertically
	                } else {
	                    this.directionLocked = 'n'; // no lock
	                }
	            }
	
	            if (this.directionLocked === 'h') {
	                if (this.options.eventPassthrough === 'vertical') {
	                    e.preventDefault();
	                } else if (this.options.eventPassthrough === 'horizontal') {
	                    this.initiated = false;
	                    return;
	                }
	
	                deltaY = 0;
	            } else if (this.directionLocked === 'v') {
	                if (this.options.eventPassthrough === 'horizontal') {
	                    e.preventDefault();
	                } else if (this.options.eventPassthrough === 'vertical') {
	                    this.initiated = false;
	                    return;
	                }
	
	                deltaX = 0;
	            }
	
	            deltaX = this.hasHorizontalScroll ? deltaX : 0;
	            deltaY = this.hasVerticalScroll ? deltaY : 0;
	
	            newX = this.x + deltaX;
	            newY = this.y + deltaY;
	
	            // Slow down if outside of the boundaries
	            if (newX > 0 || newX < this.maxScrollX) {
	                newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
	            }
	            if (newY > 0 || newY < this.maxScrollY) {
	                newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
	            }
	
	            this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
	            this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;
	
	            if (!this.moved) {
	                this._execEvent('scrollStart');
	            }
	
	            this.moved = true;
	
	            this._translate(newX, newY);
	
	            /* REPLACE START: _move */
	            if (timestamp - this.startTime > 300) {
	                this.startTime = timestamp;
	                this.startX = this.x;
	                this.startY = this.y;
	
	                if (this.options.probeType === 1) {
	                    this._execEvent('scroll');
	                }
	            }
	
	            if (this.options.probeType > 1) {
	                this._execEvent('scroll');
	            }
	            /* REPLACE END: _move */
	
	        },
	
	        _end: function(e) {
	            if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
	                return;
	            }
	
	            if (this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
	                e.preventDefault();
	            }
	
	            var /*point = e.changedTouches ? e.changedTouches[0] : e,*/
	                momentumX,
	                momentumY,
	                duration = utils.getTime() - this.startTime,
	                newX = Math.round(this.x),
	                newY = Math.round(this.y),
	                distanceX = Math.abs(newX - this.startX),
	                distanceY = Math.abs(newY - this.startY),
	                time = 0,
	                easing = '';
	
	            this.isInTransition = 0;
	            this.initiated = 0;
	            this.endTime = utils.getTime();
	
	            // reset if we are outside of the boundaries
	            if (this.resetPosition(this.options.bounceTime)) {
	                return;
	            }
	
	            this.scrollTo(newX, newY); // ensures that the last position is rounded
	
	            // we scrolled less than 10 pixels
	            if (!this.moved) {
	                if (this.options.tap) {
	                    utils.tap(e, this.options.tap);
	                }
	
	                if (this.options.click) {
	                    utils.click(e);
	                }
	
	                this._execEvent('scrollCancel');
	                return;
	            }
	
	            if (this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100) {
	                this._execEvent('flick');
	                return;
	            }
	
	            // start momentum animation if needed
	            if (this.options.momentum && duration < 300) {
	                momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration, this) : {
	                    destination: newX,
	                    duration: 0
	                };
	                momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration, this) : {
	                    destination: newY,
	                    duration: 0
	                };
	                newX = momentumX.destination;
	                newY = momentumY.destination;
	                time = Math.max(momentumX.duration, momentumY.duration);
	                this.isInTransition = 1;
	            }
	
	
	            if (this.options.snap) {
	                var snap = this._nearestSnap(newX, newY);
	                this.currentPage = snap;
	                time = this.options.snapSpeed || Math.max(
	                    Math.max(
	                        Math.min(Math.abs(newX - snap.x), 1000),
	                        Math.min(Math.abs(newY - snap.y), 1000)
	                    ), 300);
	                newX = snap.x;
	                newY = snap.y;
	
	                this.directionX = 0;
	                this.directionY = 0;
	                easing = this.options.bounceEasing;
	            }
	
	            // INSERT POINT: _end
	
	            if (newX !== this.x || newY !== this.y) {
	                // change easing function when scroller goes out of the boundaries
	                if (newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY) {
	                    easing = utils.ease.quadratic;
	                }
	
	                this.scrollTo(newX, newY, time, easing);
	                return;
	            }
	
	            this._execEvent('scrollEnd');
	        },
	
	        _resize: function() {
	            var that = this;
	
	            clearTimeout(this.resizeTimeout);
	
	            this.resizeTimeout = setTimeout(function() {
	                that.refresh();
	            }, this.options.resizePolling);
	        },
	
	        resetPosition: function(time) {
	            var x = this.x,
	                y = this.y;
	
	            time = time || 0;
	
	            if (!this.hasHorizontalScroll || this.x > 0) {
	                x = 0;
	            } else if (this.x < this.maxScrollX) {
	                x = this.maxScrollX;
	            }
	
	            if (!this.hasVerticalScroll || this.y > 0) {
	                y = 0;
	            } else if (this.y < this.maxScrollY) {
	                y = this.maxScrollY;
	            }
	
	            if (x === this.x && y === this.y) {
	                return false;
	            }
	
	            if (this.options.ptr && this.y > 44 && this.startY * -1 < $(window).height() && !this.ptrLock) {// jshint ignore:line
	                // not trigger ptr when user want to scroll to top
	                y = this.options.ptrOffset || 44;
	                this._execEvent('ptr');
	                // 防止返回的过程中再次触发了 ptr ，导致被定位到 44px（因为可能done事件触发很快，在返回到44px以前就触发done
	                this.ptrLock = true;
	                var self = this;
	                setTimeout(function() {
	                    self.ptrLock = false;
	                }, 500);
	            }
	
	            this.scrollTo(x, y, time, this.options.bounceEasing);
	
	            return true;
	        },
	
	        disable: function() {
	            this.enabled = false;
	        },
	
	        enable: function() {
	            this.enabled = true;
	        },
	
	        refresh: function() {
	            // var rf = this.wrapper.offsetHeight; // Force reflow
	
	            this.wrapperWidth = this.wrapper.clientWidth;
	            this.wrapperHeight = this.wrapper.clientHeight;
	
	            /* REPLACE START: refresh */
	
	            this.scrollerWidth = this.scroller.offsetWidth;
	            this.scrollerHeight = this.scroller.offsetHeight;
	
	            this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
	            this.maxScrollY = this.wrapperHeight - this.scrollerHeight;
	
	            /* REPLACE END: refresh */
	
	            this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0;
	            this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0;
	
	            if (!this.hasHorizontalScroll) {
	                this.maxScrollX = 0;
	                this.scrollerWidth = this.wrapperWidth;
	            }
	
	            if (!this.hasVerticalScroll) {
	                this.maxScrollY = 0;
	                this.scrollerHeight = this.wrapperHeight;
	            }
	
	            this.endTime = 0;
	            this.directionX = 0;
	            this.directionY = 0;
	
	            this.wrapperOffset = utils.offset(this.wrapper);
	
	            this._execEvent('refresh');
	
	            this.resetPosition();
	
	            // INSERT POINT: _refresh
	
	        },
	
	        on: function(type, fn) {
	            if (!this._events[type]) {
	                this._events[type] = [];
	            }
	
	            this._events[type].push(fn);
	        },
	
	        off: function(type, fn) {
	            if (!this._events[type]) {
	                return;
	            }
	
	            var index = this._events[type].indexOf(fn);
	
	            if (index > -1) {
	                this._events[type].splice(index, 1);
	            }
	        },
	
	        _execEvent: function(type) {
	            if (!this._events[type]) {
	                return;
	            }
	
	            var i = 0,
	                l = this._events[type].length;
	
	            if (!l) {
	                return;
	            }
	
	            for (; i < l; i++) {
	                this._events[type][i].apply(this, [].slice.call(arguments, 1));
	            }
	        },
	
	        scrollBy: function(x, y, time, easing) {
	            x = this.x + x;
	            y = this.y + y;
	            time = time || 0;
	
	            this.scrollTo(x, y, time, easing);
	        },
	
	        scrollTo: function(x, y, time, easing) {
	            easing = easing || utils.ease.circular;
	
	            this.isInTransition = this.options.useTransition && time > 0;
	
	            if (!time || (this.options.useTransition && easing.style)) {
	                this._transitionTimingFunction(easing.style);
	                this._transitionTime(time);
	                this._translate(x, y);
	            } else {
	                this._animate(x, y, time, easing.fn);
	            }
	        },
	
	        scrollToElement: function(el, time, offsetX, offsetY, easing) {
	            el = el.nodeType ? el : this.scroller.querySelector(el);
	
	            if (!el) {
	                return;
	            }
	
	            var pos = utils.offset(el);
	
	            pos.left -= this.wrapperOffset.left;
	            pos.top -= this.wrapperOffset.top;
	
	            // if offsetX/Y are true we center the element to the screen
	            if (offsetX === true) {
	                offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
	            }
	            if (offsetY === true) {
	                offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
	            }
	
	            pos.left -= offsetX || 0;
	            pos.top -= offsetY || 0;
	
	            pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
	            pos.top = pos.top > 0 ? 0 : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;
	
	            time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x - pos.left), Math.abs(this.y - pos.top)) : time;
	
	            this.scrollTo(pos.left, pos.top, time, easing);
	        },
	
	        _transitionTime: function(time) {
	            time = time || 0;
	
	            this.scrollerStyle[utils.style.transitionDuration] = time + 'ms';
	
	            if (!time && utils.isBadAndroid) {
	                this.scrollerStyle[utils.style.transitionDuration] = '0.001s';
	            }
	
	
	            if (this.indicators) {
	                for (var i = this.indicators.length; i--;) {
	                    this.indicators[i].transitionTime(time);
	                }
	            }
	
	
	            // INSERT POINT: _transitionTime
	
	        },
	
	        _transitionTimingFunction: function(easing) {
	            this.scrollerStyle[utils.style.transitionTimingFunction] = easing;
	
	
	            if (this.indicators) {
	                for (var i = this.indicators.length; i--;) {
	                    this.indicators[i].transitionTimingFunction(easing);
	                }
	            }
	
	
	            // INSERT POINT: _transitionTimingFunction
	
	        },
	
	        _translate: function(x, y) {
	            if (this.options.useTransform) {
	
	                /* REPLACE START: _translate */
	
	                this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
	
	                /* REPLACE END: _translate */
	
	            } else {
	                x = Math.round(x);
	                y = Math.round(y);
	                this.scrollerStyle.left = x + 'px';
	                this.scrollerStyle.top = y + 'px';
	            }
	
	            this.x = x;
	            this.y = y;
	
	
	            if (this.indicators) {
	                for (var i = this.indicators.length; i--;) {
	                    this.indicators[i].updatePosition();
	                }
	            }
	
	
	            // INSERT POINT: _translate
	
	        },
	
	        _initEvents: function(remove) {
	            var eventType = remove ? utils.removeEvent : utils.addEvent,
	                target = this.options.bindToWrapper ? this.wrapper : window;
	
	            eventType(window, 'orientationchange', this);
	            eventType(window, 'resize', this);
	
	            if (this.options.click) {
	                eventType(this.wrapper, 'click', this, true);
	            }
	
	            if (!this.options.disableMouse) {
	                eventType(this.wrapper, 'mousedown', this);
	                eventType(target, 'mousemove', this);
	                eventType(target, 'mousecancel', this);
	                eventType(target, 'mouseup', this);
	            }
	
	            if (utils.hasPointer && !this.options.disablePointer) {
	                eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
	                eventType(target, utils.prefixPointerEvent('pointermove'), this);
	                eventType(target, utils.prefixPointerEvent('pointercancel'), this);
	                eventType(target, utils.prefixPointerEvent('pointerup'), this);
	            }
	
	            if (utils.hasTouch && !this.options.disableTouch) {
	                eventType(this.wrapper, 'touchstart', this);
	                eventType(target, 'touchmove', this);
	                eventType(target, 'touchcancel', this);
	                eventType(target, 'touchend', this);
	            }
	
	            eventType(this.scroller, 'transitionend', this);
	            eventType(this.scroller, 'webkitTransitionEnd', this);
	            eventType(this.scroller, 'oTransitionEnd', this);
	            eventType(this.scroller, 'MSTransitionEnd', this);
	        },
	
	        getComputedPosition: function() {
	            var matrix = window.getComputedStyle(this.scroller, null),
	                x, y;
	
	            if (this.options.useTransform) {
	                matrix = matrix[utils.style.transform].split(')')[0].split(', ');
	                x = +(matrix[12] || matrix[4]);
	                y = +(matrix[13] || matrix[5]);
	            } else {
	                x = +matrix.left.replace(/[^-\d.]/g, '');
	                y = +matrix.top.replace(/[^-\d.]/g, '');
	            }
	
	            return {
	                x: x,
	                y: y
	            };
	        },
	
	        _initIndicators: function() {
	            var interactive = this.options.interactiveScrollbars,
	                customStyle = typeof this.options.scrollbars !== 'string',
	                indicators = [],
	                indicator;
	
	            var that = this;
	
	            this.indicators = [];
	
	            if (this.options.scrollbars) {
	                // Vertical scrollbar
	                if (this.options.scrollY) {
	                    indicator = {
	                        el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
	                        interactive: interactive,
	                        defaultScrollbars: true,
	                        customStyle: customStyle,
	                        resize: this.options.resizeScrollbars,
	                        shrink: this.options.shrinkScrollbars,
	                        fade: this.options.fadeScrollbars,
	                        listenX: false
	                    };
	
	                    this.wrapper.appendChild(indicator.el);
	                    indicators.push(indicator);
	                }
	
	                // Horizontal scrollbar
	                if (this.options.scrollX) {
	                    indicator = {
	                        el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
	                        interactive: interactive,
	                        defaultScrollbars: true,
	                        customStyle: customStyle,
	                        resize: this.options.resizeScrollbars,
	                        shrink: this.options.shrinkScrollbars,
	                        fade: this.options.fadeScrollbars,
	                        listenY: false
	                    };
	
	                    this.wrapper.appendChild(indicator.el);
	                    indicators.push(indicator);
	                }
	            }
	
	            if (this.options.indicators) {
	                // TODO: check concat compatibility
	                indicators = indicators.concat(this.options.indicators);
	            }
	
	            for (var i = indicators.length; i--;) {
	                this.indicators.push(new Indicator(this, indicators[i]));
	            }
	
	            // TODO: check if we can use array.map (wide compatibility and performance issues)
	            function _indicatorsMap(fn) {
	                for (var i = that.indicators.length; i--;) {
	                    fn.call(that.indicators[i]);
	                }
	            }
	
	            if (this.options.fadeScrollbars) {
	                this.on('scrollEnd', function() {
	                    _indicatorsMap(function() {
	                        this.fade();
	                    });
	                });
	
	                this.on('scrollCancel', function() {
	                    _indicatorsMap(function() {
	                        this.fade();
	                    });
	                });
	
	                this.on('scrollStart', function() {
	                    _indicatorsMap(function() {
	                        this.fade(1);
	                    });
	                });
	
	                this.on('beforeScrollStart', function() {
	                    _indicatorsMap(function() {
	                        this.fade(1, true);
	                    });
	                });
	            }
	
	
	            this.on('refresh', function() {
	                _indicatorsMap(function() {
	                    this.refresh();
	                });
	            });
	
	            this.on('destroy', function() {
	                _indicatorsMap(function() {
	                    this.destroy();
	                });
	
	                delete this.indicators;
	            });
	        },
	
	        _initWheel: function() {
	            utils.addEvent(this.wrapper, 'wheel', this);
	            utils.addEvent(this.wrapper, 'mousewheel', this);
	            utils.addEvent(this.wrapper, 'DOMMouseScroll', this);
	
	            this.on('destroy', function() {
	                utils.removeEvent(this.wrapper, 'wheel', this);
	                utils.removeEvent(this.wrapper, 'mousewheel', this);
	                utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
	            });
	        },
	
	        _wheel: function(e) {
	            if (!this.enabled) {
	                return;
	            }
	
	            e.preventDefault();
	            e.stopPropagation();
	
	            var wheelDeltaX, wheelDeltaY,
	                newX, newY,
	                that = this;
	
	            if (this.wheelTimeout === undefined) {
	                that._execEvent('scrollStart');
	            }
	
	            // Execute the scrollEnd event after 400ms the wheel stopped scrolling
	            clearTimeout(this.wheelTimeout);
	            this.wheelTimeout = setTimeout(function() {
	                that._execEvent('scrollEnd');
	                that.wheelTimeout = undefined;
	            }, 400);
	
	            if ('deltaX' in e) {
	                if (e.deltaMode === 1) {
	                    wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
	                    wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
	                } else {
	                    wheelDeltaX = -e.deltaX;
	                    wheelDeltaY = -e.deltaY;
	                }
	            } else if ('wheelDeltaX' in e) {
	                wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
	                wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
	            } else if ('wheelDelta' in e) {
	                wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
	            } else if ('detail' in e) {
	                wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
	            } else {
	                return;
	            }
	
	            wheelDeltaX *= this.options.invertWheelDirection;
	            wheelDeltaY *= this.options.invertWheelDirection;
	
	            if (!this.hasVerticalScroll) {
	                wheelDeltaX = wheelDeltaY;
	                wheelDeltaY = 0;
	            }
	
	            if (this.options.snap) {
	                newX = this.currentPage.pageX;
	                newY = this.currentPage.pageY;
	
	                if (wheelDeltaX > 0) {
	                    newX--;
	                } else if (wheelDeltaX < 0) {
	                    newX++;
	                }
	
	                if (wheelDeltaY > 0) {
	                    newY--;
	                } else if (wheelDeltaY < 0) {
	                    newY++;
	                }
	
	                this.goToPage(newX, newY);
	
	                return;
	            }
	
	            newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
	            newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);
	
	            if (newX > 0) {
	                newX = 0;
	            } else if (newX < this.maxScrollX) {
	                newX = this.maxScrollX;
	            }
	
	            if (newY > 0) {
	                newY = 0;
	            } else if (newY < this.maxScrollY) {
	                newY = this.maxScrollY;
	            }
	
	            this.scrollTo(newX, newY, 0);
	
	            this._execEvent('scroll');
	
	            // INSERT POINT: _wheel
	        },
	
	        _initSnap: function() {
	            this.currentPage = {};
	
	            if (typeof this.options.snap === 'string') {
	                this.options.snap = this.scroller.querySelectorAll(this.options.snap);
	            }
	
	            this.on('refresh', function() {
	                var i = 0,
	                    l,
	                    m = 0,
	                    n,
	                    cx, cy,
	                    x = 0,
	                    y,
	                    stepX = this.options.snapStepX || this.wrapperWidth,
	                    stepY = this.options.snapStepY || this.wrapperHeight,
	                    el;
	
	                this.pages = [];
	
	                if (!this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight) {
	                    return;
	                }
	
	                if (this.options.snap === true) {
	                    cx = Math.round(stepX / 2);
	                    cy = Math.round(stepY / 2);
	
	                    while (x > -this.scrollerWidth) {
	                        this.pages[i] = [];
	                        l = 0;
	                        y = 0;
	
	                        while (y > -this.scrollerHeight) {
	                            this.pages[i][l] = {
	                                x: Math.max(x, this.maxScrollX),
	                                y: Math.max(y, this.maxScrollY),
	                                width: stepX,
	                                height: stepY,
	                                cx: x - cx,
	                                cy: y - cy
	                            };
	
	                            y -= stepY;
	                            l++;
	                        }
	
	                        x -= stepX;
	                        i++;
	                    }
	                } else {
	                    el = this.options.snap;
	                    l = el.length;
	                    n = -1;
	
	                    for (; i < l; i++) {
	                        if (i === 0 || el[i].offsetLeft <= el[i - 1].offsetLeft) {
	                            m = 0;
	                            n++;
	                        }
	
	                        if (!this.pages[m]) {
	                            this.pages[m] = [];
	                        }
	
	                        x = Math.max(-el[i].offsetLeft, this.maxScrollX);
	                        y = Math.max(-el[i].offsetTop, this.maxScrollY);
	                        cx = x - Math.round(el[i].offsetWidth / 2);
	                        cy = y - Math.round(el[i].offsetHeight / 2);
	
	                        this.pages[m][n] = {
	                            x: x,
	                            y: y,
	                            width: el[i].offsetWidth,
	                            height: el[i].offsetHeight,
	                            cx: cx,
	                            cy: cy
	                        };
	
	                        if (x > this.maxScrollX) {
	                            m++;
	                        }
	                    }
	                }
	
	                this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);
	
	                // Update snap threshold if needed
	                if (this.options.snapThreshold % 1 === 0) {
	                    this.snapThresholdX = this.options.snapThreshold;
	                    this.snapThresholdY = this.options.snapThreshold;
	                } else {
	                    this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
	                    this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
	                }
	            });
	
	            this.on('flick', function() {
	                var time = this.options.snapSpeed || Math.max(
	                    Math.max(
	                        Math.min(Math.abs(this.x - this.startX), 1000),
	                        Math.min(Math.abs(this.y - this.startY), 1000)
	                    ), 300);
	
	                this.goToPage(
	                    this.currentPage.pageX + this.directionX,
	                    this.currentPage.pageY + this.directionY,
	                    time
	                );
	            });
	        },
	
	        _nearestSnap: function(x, y) {
	            if (!this.pages.length) {
	                return {
	                    x: 0,
	                    y: 0,
	                    pageX: 0,
	                    pageY: 0
	                };
	            }
	
	            var i = 0,
	                l = this.pages.length,
	                m = 0;
	
	            // Check if we exceeded the snap threshold
	            if (Math.abs(x - this.absStartX) < this.snapThresholdX &&
	                Math.abs(y - this.absStartY) < this.snapThresholdY) {
	                return this.currentPage;
	            }
	
	            if (x > 0) {
	                x = 0;
	            } else if (x < this.maxScrollX) {
	                x = this.maxScrollX;
	            }
	
	            if (y > 0) {
	                y = 0;
	            } else if (y < this.maxScrollY) {
	                y = this.maxScrollY;
	            }
	
	            for (; i < l; i++) {
	                if (x >= this.pages[i][0].cx) {
	                    x = this.pages[i][0].x;
	                    break;
	                }
	            }
	
	            l = this.pages[i].length;
	
	            for (; m < l; m++) {
	                if (y >= this.pages[0][m].cy) {
	                    y = this.pages[0][m].y;
	                    break;
	                }
	            }
	
	            if (i === this.currentPage.pageX) {
	                i += this.directionX;
	
	                if (i < 0) {
	                    i = 0;
	                } else if (i >= this.pages.length) {
	                    i = this.pages.length - 1;
	                }
	
	                x = this.pages[i][0].x;
	            }
	
	            if (m === this.currentPage.pageY) {
	                m += this.directionY;
	
	                if (m < 0) {
	                    m = 0;
	                } else if (m >= this.pages[0].length) {
	                    m = this.pages[0].length - 1;
	                }
	
	                y = this.pages[0][m].y;
	            }
	
	            return {
	                x: x,
	                y: y,
	                pageX: i,
	                pageY: m
	            };
	        },
	
	        goToPage: function(x, y, time, easing) {
	            easing = easing || this.options.bounceEasing;
	
	            if (x >= this.pages.length) {
	                x = this.pages.length - 1;
	            } else if (x < 0) {
	                x = 0;
	            }
	
	            if (y >= this.pages[x].length) {
	                y = this.pages[x].length - 1;
	            } else if (y < 0) {
	                y = 0;
	            }
	
	            var posX = this.pages[x][y].x,
	                posY = this.pages[x][y].y;
	
	            time = time === undefined ? this.options.snapSpeed || Math.max(
	                Math.max(
	                    Math.min(Math.abs(posX - this.x), 1000),
	                    Math.min(Math.abs(posY - this.y), 1000)
	                ), 300) : time;
	
	            this.currentPage = {
	                x: posX,
	                y: posY,
	                pageX: x,
	                pageY: y
	            };
	
	            this.scrollTo(posX, posY, time, easing);
	        },
	
	        next: function(time, easing) {
	            var x = this.currentPage.pageX,
	                y = this.currentPage.pageY;
	
	            x++;
	
	            if (x >= this.pages.length && this.hasVerticalScroll) {
	                x = 0;
	                y++;
	            }
	
	            this.goToPage(x, y, time, easing);
	        },
	
	        prev: function(time, easing) {
	            var x = this.currentPage.pageX,
	                y = this.currentPage.pageY;
	
	            x--;
	
	            if (x < 0 && this.hasVerticalScroll) {
	                x = 0;
	                y--;
	            }
	
	            this.goToPage(x, y, time, easing);
	        },
	
	        _initKeys: function() {
	            // default key bindings
	            var keys = {
	                pageUp: 33,
	                pageDown: 34,
	                end: 35,
	                home: 36,
	                left: 37,
	                up: 38,
	                right: 39,
	                down: 40
	            };
	            var i;
	
	            // if you give me characters I give you keycode
	            if (typeof this.options.keyBindings === 'object') {
	                for (i in this.options.keyBindings) {
	                    if (typeof this.options.keyBindings[i] === 'string') {
	                        this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
	                    }
	                }
	            } else {
	                this.options.keyBindings = {};
	            }
	
	            for (i in keys) { // jshint ignore:line
	                    this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
	            }
	
	            utils.addEvent(window, 'keydown', this);
	
	            this.on('destroy', function() {
	                utils.removeEvent(window, 'keydown', this);
	            });
	        },
	
	        _key: function(e) {
	            if (!this.enabled) {
	                return;
	            }
	
	            var snap = this.options.snap, // we are using this alot, better to cache it
	                newX = snap ? this.currentPage.pageX : this.x,
	                newY = snap ? this.currentPage.pageY : this.y,
	                now = utils.getTime(),
	                prevTime = this.keyTime || 0,
	                acceleration = 0.250,
	                pos;
	
	            if (this.options.useTransition && this.isInTransition) {
	                pos = this.getComputedPosition();
	
	                this._translate(Math.round(pos.x), Math.round(pos.y));
	                this.isInTransition = false;
	            }
	
	            this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;
	
	            switch (e.keyCode) {
	                case this.options.keyBindings.pageUp:
	                    if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
	                        newX += snap ? 1 : this.wrapperWidth;
	                    } else {
	                        newY += snap ? 1 : this.wrapperHeight;
	                    }
	                    break;
	                case this.options.keyBindings.pageDown:
	                    if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
	                        newX -= snap ? 1 : this.wrapperWidth;
	                    } else {
	                        newY -= snap ? 1 : this.wrapperHeight;
	                    }
	                    break;
	                case this.options.keyBindings.end:
	                    newX = snap ? this.pages.length - 1 : this.maxScrollX;
	                    newY = snap ? this.pages[0].length - 1 : this.maxScrollY;
	                    break;
	                case this.options.keyBindings.home:
	                    newX = 0;
	                    newY = 0;
	                    break;
	                case this.options.keyBindings.left:
	                    newX += snap ? -1 : 5 + this.keyAcceleration >> 0; // jshint ignore:line
	                    break;
	                case this.options.keyBindings.up:
	                    newY += snap ? 1 : 5 + this.keyAcceleration >> 0; // jshint ignore:line
	                    break;
	                case this.options.keyBindings.right:
	                    newX -= snap ? -1 : 5 + this.keyAcceleration >> 0; // jshint ignore:line
	                    break;
	                case this.options.keyBindings.down:
	                    newY -= snap ? 1 : 5 + this.keyAcceleration >> 0; // jshint ignore:line
	                    break;
	                default:
	                    return;
	            }
	
	            if (snap) {
	                this.goToPage(newX, newY);
	                return;
	            }
	
	            if (newX > 0) {
	                newX = 0;
	                this.keyAcceleration = 0;
	            } else if (newX < this.maxScrollX) {
	                newX = this.maxScrollX;
	                this.keyAcceleration = 0;
	            }
	
	            if (newY > 0) {
	                newY = 0;
	                this.keyAcceleration = 0;
	            } else if (newY < this.maxScrollY) {
	                newY = this.maxScrollY;
	                this.keyAcceleration = 0;
	            }
	
	            this.scrollTo(newX, newY, 0);
	
	            this.keyTime = now;
	        },
	
	        _animate: function(destX, destY, duration, easingFn) {
	            var that = this,
	                startX = this.x,
	                startY = this.y,
	                startTime = utils.getTime(),
	                destTime = startTime + duration;
	
	            function step() {
	                var now = utils.getTime(),
	                    newX, newY,
	                    easing;
	
	                if (now >= destTime) {
	                    that.isAnimating = false;
	                    that._translate(destX, destY);
	
	                    if (!that.resetPosition(that.options.bounceTime)) {
	                        that._execEvent('scrollEnd');
	                    }
	
	                    return;
	                }
	
	                now = (now - startTime) / duration;
	                easing = easingFn(now);
	                newX = (destX - startX) * easing + startX;
	                newY = (destY - startY) * easing + startY;
	                that._translate(newX, newY);
	
	                if (that.isAnimating) {
	                    rAF(step);
	                }
	
	                if (that.options.probeType === 3) {
	                    that._execEvent('scroll');
	                }
	            }
	
	            this.isAnimating = true;
	            step();
	        },
	
	        handleEvent: function(e) {
	            switch (e.type) {
	                case 'touchstart':
	                case 'pointerdown':
	                case 'MSPointerDown':
	                case 'mousedown':
	                    this._start(e);
	                    break;
	                case 'touchmove':
	                case 'pointermove':
	                case 'MSPointerMove':
	                case 'mousemove':
	                    this._move(e);
	                    break;
	                case 'touchend':
	                case 'pointerup':
	                case 'MSPointerUp':
	                case 'mouseup':
	                case 'touchcancel':
	                case 'pointercancel':
	                case 'MSPointerCancel':
	                case 'mousecancel':
	                    this._end(e);
	                    break;
	                case 'orientationchange':
	                case 'resize':
	                    this._resize();
	                    break;
	                case 'transitionend':
	                case 'webkitTransitionEnd':
	                case 'oTransitionEnd':
	                case 'MSTransitionEnd':
	                    this._transitionEnd(e);
	                    break;
	                case 'wheel':
	                case 'DOMMouseScroll':
	                case 'mousewheel':
	                    this._wheel(e);
	                    break;
	                case 'keydown':
	                    this._key(e);
	                    break;
	                case 'click':
	                    if (!e._constructed) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                    }
	                    break;
	            }
	        }
	    };
	
	    function createDefaultScrollbar(direction, interactive, type) {
	        var scrollbar = document.createElement('div'),
	            indicator = document.createElement('div');
	
	        if (type === true) {
	            scrollbar.style.cssText = 'position:absolute;z-index:9999';
	            indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
	        }
	
	        indicator.className = 'iScrollIndicator';
	
	        if (direction === 'h') {
	            if (type === true) {
	                scrollbar.style.cssText += ';height:5px;left:2px;right:2px;bottom:0';
	                indicator.style.height = '100%';
	            }
	            scrollbar.className = 'iScrollHorizontalScrollbar';
	        } else {
	            if (type === true) {
	                scrollbar.style.cssText += ';width:5px;bottom:2px;top:2px;right:1px';
	                indicator.style.width = '100%';
	            }
	            scrollbar.className = 'iScrollVerticalScrollbar';
	        }
	
	        scrollbar.style.cssText += ';overflow:hidden';
	
	        if (!interactive) {
	            scrollbar.style.pointerEvents = 'none';
	        }
	
	        scrollbar.appendChild(indicator);
	
	        return scrollbar;
	    }
	
	    function Indicator(scroller, options) {
	        this.wrapper = typeof options.el === 'string' ? document.querySelector(options.el) : options.el;
	        this.wrapperStyle = this.wrapper.style;
	        this.indicator = this.wrapper.children[0];
	        this.indicatorStyle = this.indicator.style;
	        this.scroller = scroller;
	
	        this.options = {
	            listenX: true,
	            listenY: true,
	            interactive: false,
	            resize: true,
	            defaultScrollbars: false,
	            shrink: false,
	            fade: false,
	            speedRatioX: 0,
	            speedRatioY: 0
	        };
	
	        for (var i in options) { // jshint ignore:line
	                this.options[i] = options[i];
	
	        }
	
	        this.sizeRatioX = 1;
	        this.sizeRatioY = 1;
	        this.maxPosX = 0;
	        this.maxPosY = 0;
	
	        if (this.options.interactive) {
	            if (!this.options.disableTouch) {
	                utils.addEvent(this.indicator, 'touchstart', this);
	                utils.addEvent(window, 'touchend', this);
	            }
	            if (!this.options.disablePointer) {
	                utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
	                utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
	            }
	            if (!this.options.disableMouse) {
	                utils.addEvent(this.indicator, 'mousedown', this);
	                utils.addEvent(window, 'mouseup', this);
	            }
	        }
	
	        if (this.options.fade) {
	            this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
	            this.wrapperStyle[utils.style.transitionDuration] = utils.isBadAndroid ? '0.001s' : '0ms';
	            this.wrapperStyle.opacity = '0';
	        }
	    }
	
	    Indicator.prototype = {
	        handleEvent: function(e) {
	            switch (e.type) {
	                case 'touchstart':
	                case 'pointerdown':
	                case 'MSPointerDown':
	                case 'mousedown':
	                    this._start(e);
	                    break;
	                case 'touchmove':
	                case 'pointermove':
	                case 'MSPointerMove':
	                case 'mousemove':
	                    this._move(e);
	                    break;
	                case 'touchend':
	                case 'pointerup':
	                case 'MSPointerUp':
	                case 'mouseup':
	                case 'touchcancel':
	                case 'pointercancel':
	                case 'MSPointerCancel':
	                case 'mousecancel':
	                    this._end(e);
	                    break;
	            }
	        },
	
	        destroy: function() {
	            if (this.options.interactive) {
	                utils.removeEvent(this.indicator, 'touchstart', this);
	                utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
	                utils.removeEvent(this.indicator, 'mousedown', this);
	
	                utils.removeEvent(window, 'touchmove', this);
	                utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
	                utils.removeEvent(window, 'mousemove', this);
	
	                utils.removeEvent(window, 'touchend', this);
	                utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
	                utils.removeEvent(window, 'mouseup', this);
	            }
	
	            if (this.options.defaultScrollbars) {
	                this.wrapper.parentNode.removeChild(this.wrapper);
	            }
	        },
	
	        _start: function(e) {
	            var point = e.touches ? e.touches[0] : e;
	
	            e.preventDefault();
	            e.stopPropagation();
	
	            this.transitionTime();
	
	            this.initiated = true;
	            this.moved = false;
	            this.lastPointX = point.pageX;
	            this.lastPointY = point.pageY;
	
	            this.startTime = utils.getTime();
	
	            if (!this.options.disableTouch) {
	                utils.addEvent(window, 'touchmove', this);
	            }
	            if (!this.options.disablePointer) {
	                utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
	            }
	            if (!this.options.disableMouse) {
	                utils.addEvent(window, 'mousemove', this);
	            }
	
	            this.scroller._execEvent('beforeScrollStart');
	        },
	
	        _move: function(e) {
	            var point = e.touches ? e.touches[0] : e,
	                deltaX, deltaY,
	                newX, newY,
	                timestamp = utils.getTime();
	
	            if (!this.moved) {
	                this.scroller._execEvent('scrollStart');
	            }
	
	            this.moved = true;
	
	            deltaX = point.pageX - this.lastPointX;
	            this.lastPointX = point.pageX;
	
	            deltaY = point.pageY - this.lastPointY;
	            this.lastPointY = point.pageY;
	
	            newX = this.x + deltaX;
	            newY = this.y + deltaY;
	
	            this._pos(newX, newY);
	
	
	            if (this.scroller.options.probeType === 1 && timestamp - this.startTime > 300) {
	                this.startTime = timestamp;
	                this.scroller._execEvent('scroll');
	            } else if (this.scroller.options.probeType > 1) {
	                this.scroller._execEvent('scroll');
	            }
	
	
	            // INSERT POINT: indicator._move
	
	            e.preventDefault();
	            e.stopPropagation();
	        },
	
	        _end: function(e) {
	            if (!this.initiated) {
	                return;
	            }
	
	            this.initiated = false;
	
	            e.preventDefault();
	            e.stopPropagation();
	
	            utils.removeEvent(window, 'touchmove', this);
	            utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
	            utils.removeEvent(window, 'mousemove', this);
	
	            if (this.scroller.options.snap) {
	                var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);
	
	                var time = this.options.snapSpeed || Math.max(
	                    Math.max(
	                        Math.min(Math.abs(this.scroller.x - snap.x), 1000),
	                        Math.min(Math.abs(this.scroller.y - snap.y), 1000)
	                    ), 300);
	
	                if (this.scroller.x !== snap.x || this.scroller.y !== snap.y) {
	                    this.scroller.directionX = 0;
	                    this.scroller.directionY = 0;
	                    this.scroller.currentPage = snap;
	                    this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
	                }
	            }
	
	            if (this.moved) {
	                this.scroller._execEvent('scrollEnd');
	            }
	        },
	
	        transitionTime: function(time) {
	            time = time || 0;
	            this.indicatorStyle[utils.style.transitionDuration] = time + 'ms';
	
	            if (!time && utils.isBadAndroid) {
	                this.indicatorStyle[utils.style.transitionDuration] = '0.001s';
	            }
	        },
	
	        transitionTimingFunction: function(easing) {
	            this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
	        },
	
	        refresh: function() {
	            this.transitionTime();
	
	            if (this.options.listenX && !this.options.listenY) {
	                this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
	            } else if (this.options.listenY && !this.options.listenX) {
	                this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
	            } else {
	                this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
	            }
	
	            if (this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll) {
	                utils.addClass(this.wrapper, 'iScrollBothScrollbars');
	                utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');
	
	                if (this.options.defaultScrollbars && this.options.customStyle) {
	                    if (this.options.listenX) {
	                        this.wrapper.style.right = '8px';
	                    } else {
	                        this.wrapper.style.bottom = '8px';
	                    }
	                }
	            } else {
	                utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
	                utils.addClass(this.wrapper, 'iScrollLoneScrollbar');
	
	                if (this.options.defaultScrollbars && this.options.customStyle) {
	                    if (this.options.listenX) {
	                        this.wrapper.style.right = '2px';
	                    } else {
	                        this.wrapper.style.bottom = '2px';
	                    }
	                }
	            }
	
	            // var r = this.wrapper.offsetHeight; // force refresh
	
	            if (this.options.listenX) {
	                this.wrapperWidth = this.wrapper.clientWidth;
	                if (this.options.resize) {
	                    this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
	                    this.indicatorStyle.width = this.indicatorWidth + 'px';
	                } else {
	                    this.indicatorWidth = this.indicator.clientWidth;
	                }
	
	                this.maxPosX = this.wrapperWidth - this.indicatorWidth;
	
	                if (this.options.shrink === 'clip') {
	                    this.minBoundaryX = -this.indicatorWidth + 8;
	                    this.maxBoundaryX = this.wrapperWidth - 8;
	                } else {
	                    this.minBoundaryX = 0;
	                    this.maxBoundaryX = this.maxPosX;
	                }
	
	                this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
	            }
	
	            if (this.options.listenY) {
	                this.wrapperHeight = this.wrapper.clientHeight;
	                if (this.options.resize) {
	                    this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
	                    this.indicatorStyle.height = this.indicatorHeight + 'px';
	                } else {
	                    this.indicatorHeight = this.indicator.clientHeight;
	                }
	
	                this.maxPosY = this.wrapperHeight - this.indicatorHeight;
	
	                if (this.options.shrink === 'clip') {
	                    this.minBoundaryY = -this.indicatorHeight + 8;
	                    this.maxBoundaryY = this.wrapperHeight - 8;
	                } else {
	                    this.minBoundaryY = 0;
	                    this.maxBoundaryY = this.maxPosY;
	                }
	
	                this.maxPosY = this.wrapperHeight - this.indicatorHeight;
	                this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
	            }
	
	            this.updatePosition();
	        },
	
	        updatePosition: function() {
	            var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
	                y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;
	
	            if (!this.options.ignoreBoundaries) {
	                if (x < this.minBoundaryX) {
	                    if (this.options.shrink === 'scale') {
	                        this.width = Math.max(this.indicatorWidth + x, 8);
	                        this.indicatorStyle.width = this.width + 'px';
	                    }
	                    x = this.minBoundaryX;
	                } else if (x > this.maxBoundaryX) {
	                    if (this.options.shrink === 'scale') {
	                        this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
	                        this.indicatorStyle.width = this.width + 'px';
	                        x = this.maxPosX + this.indicatorWidth - this.width;
	                    } else {
	                        x = this.maxBoundaryX;
	                    }
	                } else if (this.options.shrink === 'scale' && this.width !== this.indicatorWidth) {
	                    this.width = this.indicatorWidth;
	                    this.indicatorStyle.width = this.width + 'px';
	                }
	
	                if (y < this.minBoundaryY) {
	                    if (this.options.shrink === 'scale') {
	                        this.height = Math.max(this.indicatorHeight + y * 3, 8);
	                        this.indicatorStyle.height = this.height + 'px';
	                    }
	                    y = this.minBoundaryY;
	                } else if (y > this.maxBoundaryY) {
	                    if (this.options.shrink === 'scale') {
	                        this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
	                        this.indicatorStyle.height = this.height + 'px';
	                        y = this.maxPosY + this.indicatorHeight - this.height;
	                    } else {
	                        y = this.maxBoundaryY;
	                    }
	                } else if (this.options.shrink === 'scale' && this.height !== this.indicatorHeight) {
	                    this.height = this.indicatorHeight;
	                    this.indicatorStyle.height = this.height + 'px';
	                }
	            }
	
	            this.x = x;
	            this.y = y;
	
	            if (this.scroller.options.useTransform) {
	                this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
	            } else {
	                this.indicatorStyle.left = x + 'px';
	                this.indicatorStyle.top = y + 'px';
	            }
	        },
	
	        _pos: function(x, y) {
	            if (x < 0) {
	                x = 0;
	            } else if (x > this.maxPosX) {
	                x = this.maxPosX;
	            }
	
	            if (y < 0) {
	                y = 0;
	            } else if (y > this.maxPosY) {
	                y = this.maxPosY;
	            }
	
	            x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
	            y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;
	
	            this.scroller.scrollTo(x, y);
	        },
	
	        fade: function(val, hold) {
	            if (hold && !this.visible) {
	                return;
	            }
	
	            clearTimeout(this.fadeTimeout);
	            this.fadeTimeout = null;
	
	            var time = val ? 250 : 500,
	                delay = val ? 0 : 300;
	
	            val = val ? '1' : '0';
	
	            this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';
	
	            this.fadeTimeout = setTimeout((function(val) {
	                this.wrapperStyle.opacity = val;
	                this.visible = +val;
	            }).bind(this, val), delay);
	        }
	    };
	
	    IScroll.utils = utils;
	
	    window.IScroll = IScroll;
	}(window);
	
	/* ===============================================================================
	************   scroller   ************
	=============================================================================== */
	+ function($) {
	    "use strict";
	    //重置zepto自带的滚动条
	    var _zeptoMethodCache = {
	        "scrollTop": $.fn.scrollTop,
	        "scrollLeft": $.fn.scrollLeft
	    };
	    //重置scrollLeft和scrollRight
	    (function() {
	        $.extend($.fn, {
	            scrollTop: function(top, dur) {
	                if (!this.length) return;
	                var scroller = this.data('scroller');
	                if (scroller && scroller.scroller) { //js滚动
	                    return scroller.scrollTop(top, dur);
	                } else {
	                    return _zeptoMethodCache.scrollTop.apply(this, arguments);
	                }
	            }
	        });
	        $.extend($.fn, {
	            scrollLeft: function(left, dur) {
	                if (!this.length) return;
	                var scroller = this.data('scroller');
	                if (scroller && scroller.scroller) { //js滚动
	                    return scroller.scrollLeft(left, dur);
	                } else {
	                    return _zeptoMethodCache.scrollLeft.apply(this, arguments);
	                }
	            }
	        });
	    })();
	
	
	
	    //自定义的滚动条
	    var Scroller = function(pageContent, _options) {
	        var $pageContent = this.$pageContent = $(pageContent);
	
	        this.options = $.extend({}, this._defaults, _options);
	
	        var type = this.options.type;
	        //auto的type,系统版本的小于4.4.0的安卓设备和系统版本小于6.0.0的ios设备，启用js版的iscoll
	        var useJSScroller = (type === 'js') || (type === 'auto' && ($.device.android && $.compareVersion('4.4.0', $.device.osVersion) > -1) || (type === 'auto' && ($.device.ios && $.compareVersion('6.0.0', $.device.osVersion) > -1)));
	
	        if (useJSScroller) {
	
	            var $pageContentInner = $pageContent.find('.content-inner');
	            //如果滚动内容没有被包裹，自动添加wrap
	            if (!$pageContentInner[0]) {
	                // $pageContent.html('<div class="content-inner">' + $pageContent.html() + '</div>');
	                var children = $pageContent.children();
	                if (children.length < 1) {
	                    $pageContent.children().wrapAll('<div class="content-inner"></div>');
	                } else {
	                    $pageContent.html('<div class="content-inner">' + $pageContent.html() + '</div>');
	                }
	            }
	
	            if ($pageContent.hasClass('pull-to-refresh-content')) {
	                //因为iscroll 当页面高度不足 100% 时无法滑动，所以无法触发下拉动作，这里改动一下高度
	                //区分是否有.bar容器，如有，则content的top:0，无则content的top:-2.2rem,这里取2.2rem的最大值，近60
	                var minHeight = $(window).height() + ($pageContent.prev().hasClass(".bar") ? 1 : 61);
	                $pageContent.find('.content-inner').css('min-height', minHeight + 'px');
	            }
	
	            var ptr = $(pageContent).hasClass('pull-to-refresh-content');
	            //js滚动模式，用transform移动内容区位置，会导致fixed失效，表现类似absolute。因此禁用transform模式
	            var useTransform = $pageContent.find('.fixed-tab').length === 0;
	            var options = {
	                probeType: 1,
	                mouseWheel: true,
	                //解决安卓js模式下，刷新滚动条后绑定的事件不响应，对chrome内核浏览器设置click:true
	                click: $.device.androidChrome,
	                useTransform: useTransform,
	                //js模式下允许滚动条横向滚动，但是需要注意，滚动容易宽度必须大于屏幕宽度滚动才生效
	                scrollX: true
	            };
	            if (ptr) {
	                options.ptr = true;
	                options.ptrOffset = 44;
	            }
	            //如果用js滚动条，用transform计算内容区位置，position：fixed将实效。若有.fixed-tab，强制使用native滚动条；备选方案，略粗暴
	            // if($(pageContent).find('.fixed-tab').length>0){
	            //     $pageContent.addClass('native-scroll');
	            //     return;
	            // }
	            this.scroller = new IScroll(pageContent, options); // jshint ignore:line
	            //和native滚动统一起来
	            this._bindEventToDomWhenJs();
	            $.initPullToRefresh = $._pullToRefreshJSScroll.initPullToRefresh;
	            $.pullToRefreshDone = $._pullToRefreshJSScroll.pullToRefreshDone;
	            $.pullToRefreshTrigger = $._pullToRefreshJSScroll.pullToRefreshTrigger;
	            $.destroyToRefresh = $._pullToRefreshJSScroll.destroyToRefresh;
	            $pageContent.addClass('javascript-scroll');
	            if (!useTransform) {
	                $pageContent.find('.content-inner').css({
	                    width: '100%',
	                    position: 'absolute'
	                });
	            }
	
	            //如果页面本身已经进行了原生滚动，那么把这个滚动换成JS的滚动
	            var nativeScrollTop = this.$pageContent[0].scrollTop;
	            if(nativeScrollTop) {
	                this.$pageContent[0].scrollTop = 0;
	                this.scrollTop(nativeScrollTop);
	            }
	        } else {
	            $pageContent.addClass('native-scroll');
	        }
	    };
	    Scroller.prototype = {
	        _defaults: {
	            type: 'native',
	        },
	        _bindEventToDomWhenJs: function() {
	            //"scrollStart", //the scroll started.
	            //"scroll", //the content is scrolling. Available only in scroll-probe.js edition. See onScroll event.
	            //"scrollEnd", //content stopped scrolling.
	            if (this.scroller) {
	                var self = this;
	                this.scroller.on('scrollStart', function() {
	                    self.$pageContent.trigger('scrollstart');
	                });
	                this.scroller.on('scroll', function() {
	                    self.$pageContent.trigger('scroll');
	                });
	                this.scroller.on('scrollEnd', function() {
	                    self.$pageContent.trigger('scrollend');
	                });
	            } else {
	                //TODO: 实现native的scrollStart和scrollEnd
	            }
	        },
	        scrollTop: function(top, dur) {
	            if (this.scroller) {
	                if (top !== undefined) {
	                    this.scroller.scrollTo(0, -1 * top, dur);
	                } else {
	                    return this.scroller.getComputedPosition().y * -1;
	                }
	            } else {
	                return this.$pageContent.scrollTop(top, dur);
	            }
	            return this;
	        },
	        scrollLeft: function(left, dur) {
	            if (this.scroller) {
	                if (left !== undefined) {
	                    this.scroller.scrollTo(-1 * left, 0);
	                } else {
	                    return this.scroller.getComputedPosition().x * -1;
	                }
	            } else {
	                return this.$pageContent.scrollTop(left, dur);
	            }
	            return this;
	        },
	        on: function(event, callback) {
	            if (this.scroller) {
	                this.scroller.on(event, function() {
	                    callback.call(this.wrapper);
	                });
	            } else {
	                this.$pageContent.on(event, callback);
	            }
	            return this;
	        },
	        off: function(event, callback) {
	            if (this.scroller) {
	                this.scroller.off(event, callback);
	            } else {
	                this.$pageContent.off(event, callback);
	            }
	            return this;
	        },
	        refresh: function() {
	            if (this.scroller) this.scroller.refresh();
	            return this;
	        },
	        scrollHeight: function() {
	            if (this.scroller) {
	                return this.scroller.scrollerHeight;
	            } else {
	                return this.$pageContent[0].scrollHeight;
	            }
	        }
	
	    };
	
	    //Scroller PLUGIN DEFINITION
	    // =======================
	
	    function Plugin(option) {
	        var args = Array.apply(null, arguments);
	        args.shift();
	        var internal_return;
	
	        this.each(function() {
	
	            var $this = $(this);
	
	            var options = $.extend({}, $this.dataset(), typeof option === 'object' && option);
	
	            var data = $this.data('scroller');
	            //如果 scroller 没有被初始化，对scroller 进行初始化r
	            if (!data) {
	                //获取data-api的
	                $this.data('scroller', (data = new Scroller(this, options)));
	
	            }
	            if (typeof option === 'string' && typeof data[option] === 'function') {
	                internal_return = data[option].apply(data, args);
	                if (internal_return !== undefined)
	            return false;
	            }
	
	        });
	
	        if (internal_return !== undefined)
	            return internal_return;
	        else
	            return this;
	
	    }
	
	    var old = $.fn.scroller;
	
	    $.fn.scroller = Plugin;
	    $.fn.scroller.Constructor = Scroller;
	
	
	    // Scroll NO CONFLICT
	    // =================
	
	    $.fn.scroller.noConflict = function() {
	        $.fn.scroller = old;
	        return this;
	    };
	    //添加data-api
	    $(function() {
	        $('[data-toggle="scroller"]').scroller();
	    });
	
	    //统一的接口,带有 .javascript-scroll 的content 进行刷新
	    $.refreshScroller = function(content) {
	        if (content) {
	            $(content).scroller('refresh');
	        } else {
	            $('.javascript-scroll').each(function() {
	                $(this).scroller('refresh');
	            });
	        }
	
	    };
	    //全局初始化方法，会对页面上的 [data-toggle="scroller"]，.content. 进行滚动条初始化
	    $.initScroller = function(option) {
	        this.options = $.extend({}, typeof option === 'object' && option);
	        $('[data-toggle="scroller"],.content').scroller(option);
	    };
	    //获取scroller对象
	    $.getScroller = function(content) {
	        content = $(content);
	        //以前默认只能有一个无限滚动，因此infinitescroll都是加在content上，现在允许里面有多个，因此要判断父元素是否有content
	        content = content.hasClass('content') ? content : content.parents('.content');
	        if (content) {
	            return $(content).data('scroller');
	        } else {
	            return $('.content.javascript-scroll').data('scroller');
	        }
	    };
	    //检测滚动类型,
	    //‘js’: javascript 滚动条
	    //‘native’: 原生滚动条
	    $.detectScrollerType = function(content) {
	        if (content) {
	            if ($(content).data('scroller') && $(content).data('scroller').scroller) {
	                return 'js';
	            } else {
	                return 'native';
	            }
	        }
	    };
	
	}(Zepto);
	
	/* ===============================================================================
	************   Tabs   ************
	=============================================================================== */
	+function ($) {
	    "use strict";
	
	    var showTab = function (tab, tabLink, force) {
	        var newTab = $(tab);
	        if (arguments.length === 2) {
	            if (typeof tabLink === 'boolean') {
	                force = tabLink;
	            }
	        }
	        if (newTab.length === 0) return false;
	        if (newTab.hasClass('active')) {
	            if (force) newTab.trigger('show');
	            return false;
	        }
	        var tabs = newTab.parent('.tabs');
	        if (tabs.length === 0) return false;
	
	        // Animated tabs
	        /*var isAnimatedTabs = tabs.parent().hasClass('tabs-animated-wrap');
	          if (isAnimatedTabs) {
	          tabs.transform('translate3d(' + -newTab.index() * 100 + '%,0,0)');
	          }*/
	
	        // Remove active class from old tabs
	        var oldTab = tabs.children('.tab.active').removeClass('active');
	        // Add active class to new tab
	        newTab.addClass('active');
	        // Trigger 'show' event on new tab
	        newTab.trigger('show');
	
	        // Update navbars in new tab
	        /*if (!isAnimatedTabs && newTab.find('.navbar').length > 0) {
	        // Find tab's view
	        var viewContainer;
	        if (newTab.hasClass(app.params.viewClass)) viewContainer = newTab[0];
	        else viewContainer = newTab.parents('.' + app.params.viewClass)[0];
	        app.sizeNavbars(viewContainer);
	        }*/
	
	        // Find related link for new tab
	        if (tabLink) tabLink = $(tabLink);
	        else {
	            // Search by id
	            if (typeof tab === 'string') tabLink = $('.tab-link[href="' + tab + '"]');
	            else tabLink = $('.tab-link[href="#' + newTab.attr('id') + '"]');
	            // Search by data-tab
	            if (!tabLink || tabLink && tabLink.length === 0) {
	                $('[data-tab]').each(function () {
	                    if (newTab.is($(this).attr('data-tab'))) tabLink = $(this);
	                });
	            }
	        }
	        if (tabLink.length === 0) return;
	
	        // Find related link for old tab
	        var oldTabLink;
	        if (oldTab && oldTab.length > 0) {
	            // Search by id
	            var oldTabId = oldTab.attr('id');
	            if (oldTabId) oldTabLink = $('.tab-link[href="#' + oldTabId + '"]');
	            // Search by data-tab
	            if (!oldTabLink || oldTabLink && oldTabLink.length === 0) {
	                $('[data-tab]').each(function () {
	                    if (oldTab.is($(this).attr('data-tab'))) oldTabLink = $(this);
	                });
	            }
	        }
	
	        // Update links' classes
	        if (tabLink && tabLink.length > 0) tabLink.addClass('active');
	        if (oldTabLink && oldTabLink.length > 0) oldTabLink.removeClass('active');
	        tabLink.trigger('active');
	
	        //app.refreshScroller();
	
	        return true;
	    };
	
	    var old = $.showTab;
	    $.showTab = showTab;
	
	    $.showTab.noConflict = function () {
	        $.showTab = old;
	        return this;
	    };
	    //a标签上的click事件，在iscroll下响应有问题
	    $(document).on("click", ".tab-link", function(e) {
	        e.preventDefault();
	        var clicked = $(this);
	        showTab(clicked.data("tab") || clicked.attr('href'), clicked);
	    });
	
	
	}(Zepto);
	
	/* ===============================================================================
	************   Tabs   ************
	=============================================================================== */
	+function ($) {
	    "use strict";
	    $.initFixedTab = function(){
	        var $fixedTab = $('.fixed-tab');
	        if ($fixedTab.length === 0) return;
	        $('.fixed-tab').fixedTab();//默认{offset: 0}
	    };
	    var FixedTab = function(pageContent, _options) {
	        var $pageContent = this.$pageContent = $(pageContent);
	        var shadow = $pageContent.clone();
	        var fixedTop = $pageContent[0].getBoundingClientRect().top;
	
	        shadow.css('visibility', 'hidden');
	        this.options = $.extend({}, this._defaults, {
	            fixedTop: fixedTop,
	            shadow: shadow,
	            offset: 0
	        }, _options);
	
	        this._bindEvents();
	    };
	
	    FixedTab.prototype = {
	        _defaults: {
	            offset: 0,
	        },
	        _bindEvents: function() {
	            this.$pageContent.parents('.content').on('scroll', this._scrollHandler.bind(this));
	            this.$pageContent.on('active', '.tab-link', this._tabLinkHandler.bind(this));
	        },
	        _tabLinkHandler: function(ev) {
	            var isFixed = $(ev.target).parents('.buttons-fixed').length > 0;
	            var fixedTop = this.options.fixedTop;
	            var offset = this.options.offset;
	            $.refreshScroller();
	            if (!isFixed) return;
	            this.$pageContent.parents('.content').scrollTop(fixedTop - offset);
	        },
	        // 滚动核心代码
	        _scrollHandler: function(ev) {
	            var $scroller = $(ev.target);
	            var $pageContent = this.$pageContent;
	            var shadow = this.options.shadow;
	            var offset = this.options.offset;
	            var fixedTop = this.options.fixedTop;
	            var scrollTop = $scroller.scrollTop();
	            var isFixed = scrollTop >= fixedTop - offset;
	            if (isFixed) {
	                shadow.insertAfter($pageContent);
	                $pageContent.addClass('buttons-fixed').css('top', offset);
	            } else {
	                shadow.remove();
	                $pageContent.removeClass('buttons-fixed').css('top', 0);
	            }
	        }
	    };
	
	    //FixedTab PLUGIN DEFINITION
	    // =======================
	
	    function Plugin(option) {
	        var args = Array.apply(null, arguments);
	        args.shift();
	        this.each(function() {
	            var $this = $(this);
	            var options = $.extend({}, $this.dataset(), typeof option === 'object' && option);
	            var data = $this.data('fixedtab');
	            if (!data) {
	                //获取data-api的
	                $this.data('fixedtab', (data = new FixedTab(this, options)));
	            }
	        });
	
	    }
	    $.fn.fixedTab = Plugin;
	    $.fn.fixedTab.Constructor = FixedTab;
	    $(document).on('pageInit',function(){
	        $.initFixedTab();
	    });
	
	
	
	}(Zepto);
	
	+ function($) {
	    "use strict";
	    //这里实在js滚动时使用的下拉刷新代码。
	
	    var refreshTime = 0;
	    var initPullToRefreshJS = function(pageContainer) {
	        var eventsTarget = $(pageContainer);
	        if (!eventsTarget.hasClass('pull-to-refresh-content')) {
	            eventsTarget = eventsTarget.find('.pull-to-refresh-content');
	        }
	        if (!eventsTarget || eventsTarget.length === 0) return;
	
	        var page = eventsTarget.hasClass('content') ? eventsTarget : eventsTarget.parents('.content');
	        var scroller = $.getScroller(page[0]);
	        if(!scroller) return;
	
	
	        var container = eventsTarget;
	
	        function handleScroll() {
	            if (container.hasClass('refreshing')) return;
	            if (scroller.scrollTop() * -1 >= 44) {
	                container.removeClass('pull-down').addClass('pull-up');
	            } else {
	                container.removeClass('pull-up').addClass('pull-down');
	            }
	        }
	
	        function handleRefresh() {
	            if (container.hasClass('refreshing')) return;
	            container.removeClass('pull-down pull-up');
	            container.addClass('refreshing transitioning');
	            container.trigger('refresh');
	            refreshTime = +new Date();
	        }
	        scroller.on('scroll', handleScroll);
	        scroller.scroller.on('ptr', handleRefresh);
	
	        // Detach Events on page remove
	        function destroyPullToRefresh() {
	            scroller.off('scroll', handleScroll);
	            scroller.scroller.off('ptr', handleRefresh);
	        }
	        eventsTarget[0].destroyPullToRefresh = destroyPullToRefresh;
	
	    };
	
	    var pullToRefreshDoneJS = function(container) {
	        container = $(container);
	        if (container.length === 0) container = $('.pull-to-refresh-content.refreshing');
	        if (container.length === 0) return;
	        var interval = (+new Date()) - refreshTime;
	        var timeOut = interval > 1000 ? 0 : 1000 - interval; //long than bounce time
	        var scroller = $.getScroller(container);
	        setTimeout(function() {
	            scroller.refresh();
	            container.removeClass('refreshing');
	            container.transitionEnd(function() {
	                container.removeClass("transitioning");
	            });
	        }, timeOut);
	    };
	    var pullToRefreshTriggerJS = function(container) {
	        container = $(container);
	        if (container.length === 0) container = $('.pull-to-refresh-content');
	        if (container.hasClass('refreshing')) return;
	        container.addClass('refreshing');
	        var scroller = $.getScroller(container);
	        scroller.scrollTop(44 + 1, 200);
	        container.trigger('refresh');
	    };
	
	    var destroyPullToRefreshJS = function(pageContainer) {
	        pageContainer = $(pageContainer);
	        var pullToRefreshContent = pageContainer.hasClass('pull-to-refresh-content') ? pageContainer : pageContainer.find('.pull-to-refresh-content');
	        if (pullToRefreshContent.length === 0) return;
	        if (pullToRefreshContent[0].destroyPullToRefresh) pullToRefreshContent[0].destroyPullToRefresh();
	    };
	
	    $._pullToRefreshJSScroll = {
	        "initPullToRefresh": initPullToRefreshJS,
	        "pullToRefreshDone": pullToRefreshDoneJS,
	        "pullToRefreshTrigger": pullToRefreshTriggerJS,
	        "destroyPullToRefresh": destroyPullToRefreshJS,
	    };
	}(Zepto); // jshint ignore:line
	
	+ function($) {
	    'use strict';
	    $.initPullToRefresh = function(pageContainer) {
	        var eventsTarget = $(pageContainer);
	        if (!eventsTarget.hasClass('pull-to-refresh-content')) {
	            eventsTarget = eventsTarget.find('.pull-to-refresh-content');
	        }
	        if (!eventsTarget || eventsTarget.length === 0) return;
	
	        var isTouched, isMoved, touchesStart = {},
	            isScrolling, touchesDiff, touchStartTime, container, refresh = false,
	            useTranslate = false,
	            startTranslate = 0,
	            translate, scrollTop, wasScrolled, triggerDistance, dynamicTriggerDistance;
	
	        container = eventsTarget;
	
	        // Define trigger distance
	        if (container.attr('data-ptr-distance')) {
	            dynamicTriggerDistance = true;
	        } else {
	            triggerDistance = 44;
	        }
	
	        function handleTouchStart(e) {
	            if (isTouched) {
	                if ($.device.android) {
	                    if ('targetTouches' in e && e.targetTouches.length > 1) return;
	                } else return;
	            }
	            isMoved = false;
	            isTouched = true;
	            isScrolling = undefined;
	            wasScrolled = undefined;
	            touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	            touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	            touchStartTime = (new Date()).getTime();
	            /*jshint validthis:true */
	            container = $(this);
	        }
	
	        function handleTouchMove(e) {
	            if (!isTouched) return;
	            var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	            var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	            if (typeof isScrolling === 'undefined') {
	                isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	            }
	            if (!isScrolling) {
	                isTouched = false;
	                return;
	            }
	
	            scrollTop = container[0].scrollTop;
	            if (typeof wasScrolled === 'undefined' && scrollTop !== 0) wasScrolled = true;
	
	            if (!isMoved) {
	                /*jshint validthis:true */
	                container.removeClass('transitioning');
	                if (scrollTop > container[0].offsetHeight) {
	                    isTouched = false;
	                    return;
	                }
	                if (dynamicTriggerDistance) {
	                    triggerDistance = container.attr('data-ptr-distance');
	                    if (triggerDistance.indexOf('%') >= 0) triggerDistance = container[0].offsetHeight * parseInt(triggerDistance, 10) / 100;
	                }
	                startTranslate = container.hasClass('refreshing') ? triggerDistance : 0;
	                if (container[0].scrollHeight === container[0].offsetHeight || !$.device.ios) {
	                    useTranslate = true;
	                } else {
	                    useTranslate = false;
	                }
	                useTranslate = true;
	            }
	            isMoved = true;
	            touchesDiff = pageY - touchesStart.y;
	
	            if (touchesDiff > 0 && scrollTop <= 0 || scrollTop < 0) {
	                // iOS 8 fix
	                if ($.device.ios && parseInt($.device.osVersion.split('.')[0], 10) > 7 && scrollTop === 0 && !wasScrolled) useTranslate = true;
	
	                if (useTranslate) {
	                    e.preventDefault();
	                    translate = (Math.pow(touchesDiff, 0.85) + startTranslate);
	                    container.transform('translate3d(0,' + translate + 'px,0)');
	                } else {}
	                if ((useTranslate && Math.pow(touchesDiff, 0.85) > triggerDistance) || (!useTranslate && touchesDiff >= triggerDistance * 2)) {
	                    refresh = true;
	                    container.addClass('pull-up').removeClass('pull-down');
	                } else {
	                    refresh = false;
	                    container.removeClass('pull-up').addClass('pull-down');
	                }
	            } else {
	
	                container.removeClass('pull-up pull-down');
	                refresh = false;
	
	            }
	        }
	
	        function handleTouchEnd() {
	            if (!isTouched || !isMoved) {
	                isTouched = false;
	                isMoved = false;
	                return;
	            }
	            if (translate) {
	                container.addClass('transitioning');
	                translate = 0;
	            }
	            container.transform('');
	            if (refresh) {
	                //防止二次触发
	                if(container.hasClass('refreshing')) return;
	                container.addClass('refreshing');
	                container.trigger('refresh');
	            } else {
	                container.removeClass('pull-down');
	            }
	            isTouched = false;
	            isMoved = false;
	        }
	
	        // Attach Events
	        eventsTarget.on($.touchEvents.start, handleTouchStart);
	        eventsTarget.on($.touchEvents.move, handleTouchMove);
	        eventsTarget.on($.touchEvents.end, handleTouchEnd);
	
	
	        function destroyPullToRefresh() {
	            eventsTarget.off($.touchEvents.start, handleTouchStart);
	            eventsTarget.off($.touchEvents.move, handleTouchMove);
	            eventsTarget.off($.touchEvents.end, handleTouchEnd);
	        }
	        eventsTarget[0].destroyPullToRefresh = destroyPullToRefresh;
	
	    };
	    $.pullToRefreshDone = function(container) {
	        $(window).scrollTop(0);//解决微信下拉刷新顶部消失的问题
	        container = $(container);
	        if (container.length === 0) container = $('.pull-to-refresh-content.refreshing');
	        container.removeClass('refreshing').addClass('transitioning');
	        container.transitionEnd(function() {
	            container.removeClass('transitioning pull-up pull-down');
	        });
	    };
	    $.pullToRefreshTrigger = function(container) {
	        container = $(container);
	        if (container.length === 0) container = $('.pull-to-refresh-content');
	        if (container.hasClass('refreshing')) return;
	        container.addClass('transitioning refreshing');
	        container.trigger('refresh');
	    };
	
	    $.destroyPullToRefresh = function(pageContainer) {
	        pageContainer = $(pageContainer);
	        var pullToRefreshContent = pageContainer.hasClass('pull-to-refresh-content') ? pageContainer : pageContainer.find('.pull-to-refresh-content');
	        if (pullToRefreshContent.length === 0) return;
	        if (pullToRefreshContent[0].destroyPullToRefresh) pullToRefreshContent[0].destroyPullToRefresh();
	    };
	
	    //这里是否需要写到 scroller 中去？
	/*    $.initPullToRefresh = function(pageContainer) {
	        var $pageContainer = $(pageContainer);
	        $pageContainer.each(function(index, item) {
	            if ($.detectScrollerType(item) === 'js') {
	                $._pullToRefreshJSScroll.initPullToRefresh(item);
	            } else {
	                initPullToRefresh(item);
	            }
	        });
	    };
	
	
	    $.pullToRefreshDone = function(pageContainer) {
	        var $pageContainer = $(pageContainer);
	        $pageContainer.each(function(index, item) {
	            if ($.detectScrollerType(item) === 'js') {
	                $._pullToRefreshJSScroll.pullToRefreshDone(item);
	            } else {
	                pullToRefreshDone(item);
	            }
	        });
	    };
	
	
	    $.pullToRefreshTrigger = function(pageContainer) {
	       var $pageContainer = $(pageContainer);
	        $pageContainer.each(function(index, item) {
	            if ($.detectScrollerType(item) === 'js') {
	                $._pullToRefreshJSScroll.pullToRefreshTrigger(item);
	            } else {
	                pullToRefreshTrigger(item);
	            }
	        });
	    };
	
	    $.destroyPullToRefresh = function(pageContainer) {
	        var $pageContainer = $(pageContainer);
	        $pageContainer.each(function(index, item) {
	            if ($.detectScrollerType(item) === 'js') {
	                $._pullToRefreshJSScroll.destroyPullToRefresh(item);
	            } else {
	                destroyPullToRefresh(item);
	            }
	        });
	    };
	*/
	
	}(Zepto); //jshint ignore:line
	
	+ function($) {
	    'use strict';
	
	    function handleInfiniteScroll() {
	        /*jshint validthis:true */
	        var inf = $(this);
	        var scroller = $.getScroller(inf);
	        var scrollTop = scroller.scrollTop();
	        var scrollHeight = scroller.scrollHeight();
	        var height = inf[0].offsetHeight;
	        var distance = inf[0].getAttribute('data-distance');
	        var virtualListContainer = inf.find('.virtual-list');
	        var virtualList;
	        var onTop = inf.hasClass('infinite-scroll-top');
	        if (!distance) distance = 50;
	        if (typeof distance === 'string' && distance.indexOf('%') >= 0) {
	            distance = parseInt(distance, 10) / 100 * height;
	        }
	        if (distance > height) distance = height;
	        if (onTop) {
	            if (scrollTop < distance) {
	                inf.trigger('infinite');
	            }
	        } else {
	            if (scrollTop + height >= scrollHeight - distance) {
	                if (virtualListContainer.length > 0) {
	                    virtualList = virtualListContainer[0].f7VirtualList;
	                    if (virtualList && !virtualList.reachEnd) return;
	                }
	                inf.trigger('infinite');
	            }
	        }
	
	    }
	    $.attachInfiniteScroll = function(infiniteContent) {
	        $.getScroller(infiniteContent).on('scroll', handleInfiniteScroll);
	    };
	    $.detachInfiniteScroll = function(infiniteContent) {
	        $.getScroller(infiniteContent).off('scroll', handleInfiniteScroll);
	    };
	    $.locScroll = function(infiniteContent){
	        var scroller = $.getScroller(infiniteContent);
	        var scrollTop = scroller.scrollTop();
	        var scrollHeight = scroller.scrollHeight();
	        var height = infiniteContent[0].offsetHeight;
	        var distance = infiniteContent[0].getAttribute('data-distance');
	        var virtualListContainer = infiniteContent.find('.virtual-list');
	        var virtualList;
	        var onTop = infiniteContent.hasClass('infinite-scroll-top');
	        if (!distance) distance = 50;
	        if (typeof distance === 'string' && distance.indexOf('%') >= 0) {
	            distance = parseInt(distance, 10) / 100 * height;
	        }
	        if (distance > height) distance = height;
	        if (onTop) {
	            if (scrollTop < distance) {
	                infiniteContent.trigger('infinite');
	            }
	        } else {
	            if (scrollTop + height >= scrollHeight - distance) {
	                if (virtualListContainer.length > 0) {
	                    virtualList = virtualListContainer[0].f7VirtualList;
	                    if (virtualList && !virtualList.reachEnd) return;
	                }
	                infiniteContent.trigger('infinite');
	            }
	        }
	    };
	
	    $.initInfiniteScroll = function(pageContainer) {
	        pageContainer = $(pageContainer);
	        var infiniteContent = pageContainer.hasClass('infinite-scroll')?pageContainer:pageContainer.find('.infinite-scroll');
	        if (infiniteContent.length === 0) return;
	        $.attachInfiniteScroll(infiniteContent);
	        //如果是顶部无限刷新，要将滚动条初始化于最下端
	        pageContainer.forEach(function(v){
	            if($(v).hasClass('infinite-scroll-top')){
	                var height = v.scrollHeight - v.clientHeight;
	                $(v).scrollTop(height);
	            }
	        });
	        function detachEvents() {
	            $.detachInfiniteScroll(infiniteContent);
	            pageContainer.off('pageBeforeRemove', detachEvents);
	        }
	        pageContainer.on('pageBeforeRemove', detachEvents);
	    };
	}(Zepto);
	
	+function ($) {
	    "use strict";
	    $(function() {
	        $(document).on("focus", ".searchbar input", function(e) {
	            var $input = $(e.target);
	            $input.parents(".searchbar").addClass("searchbar-active");
	        });
	        $(document).on("click", ".searchbar-cancel", function(e) {
	            var $btn = $(e.target);
	            $btn.parents(".searchbar").removeClass("searchbar-active");
	        });
	        $(document).on("blur", ".searchbar input", function(e) {
	            var $input = $(e.target);
	            $input.parents(".searchbar").removeClass("searchbar-active");
	        });
	    });
	}(Zepto);
	
	/*======================================================
	************   Panels   ************
	======================================================*/
	/*jshint unused: false*/
	+function ($) {
	    "use strict";
	    $.allowPanelOpen = true;
	    $.openPanel = function (panel) {
	        if (!$.allowPanelOpen) return false;
	        if(panel === 'left' || panel === 'right') panel = ".panel-" + panel;  //可以传入一个方向
	        panel = panel ? $(panel) : $(".panel").eq(0);
	        var direction = panel.hasClass("panel-right") ? "right" : "left";
	        if (panel.length === 0 || panel.hasClass('active')) return false;
	        $.closePanel(); // Close if some panel is opened
	        $.allowPanelOpen = false;
	        var effect = panel.hasClass('panel-reveal') ? 'reveal' : 'cover';
	        panel.css({display: 'block'}).addClass('active');
	        panel.trigger('open');
	
	        // Trigger reLayout
	        var clientLeft = panel[0].clientLeft;
	
	        // Transition End;
	        var transitionEndTarget = effect === 'reveal' ? $($.getCurrentPage()) : panel;
	        var openedTriggered = false;
	
	        function panelTransitionEnd() {
	            transitionEndTarget.transitionEnd(function (e) {
	                if (e.target === transitionEndTarget[0]) {
	                    if (panel.hasClass('active')) {
	                        panel.trigger('opened');
	                    }
	                    else {
	                        panel.trigger('closed');
	                    }
	            $.allowPanelOpen = true;
	                }
	                else panelTransitionEnd();
	            });
	        }
	        panelTransitionEnd();
	
	        $(document.body).addClass('with-panel-' + direction + '-' + effect);
	        return true;
	    };
	    $.closePanel = function () {
	        var activePanel = $('.panel.active');
	        if (activePanel.length === 0) return false;
	        var effect = activePanel.hasClass('panel-reveal') ? 'reveal' : 'cover';
	        var panelPosition = activePanel.hasClass('panel-left') ? 'left' : 'right';
	        activePanel.removeClass('active');
	        var transitionEndTarget = effect === 'reveal' ? $('.page') : activePanel;
	        activePanel.trigger('close');
	        $.allowPanelOpen = false;
	
	        transitionEndTarget.transitionEnd(function () {
	            if (activePanel.hasClass('active')) return;
	            activePanel.css({display: ''});
	            activePanel.trigger('closed');
	            $('body').removeClass('panel-closing');
	            $.allowPanelOpen = true;
	        });
	
	        $('body').addClass('panel-closing').removeClass('with-panel-' + panelPosition + '-' + effect);
	    };
	
	    $(document).on("click", ".open-panel", function(e) {
	        var panel = $(e.target).data('panel');
	        $.openPanel(panel);
	    });
	    $(document).on("click", ".close-panel, .panel-overlay", function(e) {
	        $.closePanel();
	    });
	    /*======================================================
	     ************   Swipe panels   ************
	     ======================================================*/
	    $.initSwipePanels = function () {
	        var panel, side;
	        var swipePanel = $.smConfig.swipePanel;
	        var swipePanelOnlyClose = $.smConfig.swipePanelOnlyClose;
	        var swipePanelCloseOpposite = true;
	        var swipePanelActiveArea = false;
	        var swipePanelThreshold = 2;
	        var swipePanelNoFollow = false;
	
	        if(!(swipePanel || swipePanelOnlyClose)) return;
	
	        var panelOverlay = $('.panel-overlay');
	        var isTouched, isMoved, isScrolling, touchesStart = {}, touchStartTime, touchesDiff, translate, opened, panelWidth, effect, direction;
	        var views = $('.page');
	
	        function handleTouchStart(e) {
	            if (!$.allowPanelOpen || (!swipePanel && !swipePanelOnlyClose) || isTouched) return;
	            if ($('.modal-in, .photo-browser-in').length > 0) return;
	            if (!(swipePanelCloseOpposite || swipePanelOnlyClose)) {
	                if ($('.panel.active').length > 0 && !panel.hasClass('active')) return;
	            }
	            touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	            touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	            if (swipePanelCloseOpposite || swipePanelOnlyClose) {
	                if ($('.panel.active').length > 0) {
	                    side = $('.panel.active').hasClass('panel-left') ? 'left' : 'right';
	                }
	                else {
	                    if (swipePanelOnlyClose) return;
	                    side = swipePanel;
	                }
	                if (!side) return;
	            }
	            panel = $('.panel.panel-' + side);
	            if(!panel[0]) return;
	            opened = panel.hasClass('active');
	            if (swipePanelActiveArea && !opened) {
	                if (side === 'left') {
	                    if (touchesStart.x > swipePanelActiveArea) return;
	                }
	                if (side === 'right') {
	                    if (touchesStart.x < window.innerWidth - swipePanelActiveArea) return;
	                }
	            }
	            isMoved = false;
	            isTouched = true;
	            isScrolling = undefined;
	
	            touchStartTime = (new Date()).getTime();
	            direction = undefined;
	        }
	        function handleTouchMove(e) {
	            if (!isTouched) return;
	            if(!panel[0]) return;
	            if (e.f7PreventPanelSwipe) return;
	            var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	            var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	            if (typeof isScrolling === 'undefined') {
	                isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	            }
	            if (isScrolling) {
	                isTouched = false;
	                return;
	            }
	            if (!direction) {
	                if (pageX > touchesStart.x) {
	                    direction = 'to-right';
	                }
	                else {
	                    direction = 'to-left';
	                }
	
	                if (
	                        side === 'left' &&
	                        (
	                         direction === 'to-left' && !panel.hasClass('active')
	                        ) ||
	                        side === 'right' &&
	                        (
	                         direction === 'to-right' && !panel.hasClass('active')
	                        )
	                   )
	                {
	                    isTouched = false;
	                    return;
	                }
	            }
	
	            if (swipePanelNoFollow) {
	                var timeDiff = (new Date()).getTime() - touchStartTime;
	                if (timeDiff < 300) {
	                    if (direction === 'to-left') {
	                        if (side === 'right') $.openPanel(side);
	                        if (side === 'left' && panel.hasClass('active')) $.closePanel();
	                    }
	                    if (direction === 'to-right') {
	                        if (side === 'left') $.openPanel(side);
	                        if (side === 'right' && panel.hasClass('active')) $.closePanel();
	                    }
	                }
	                isTouched = false;
	                console.log(3);
	                isMoved = false;
	                return;
	            }
	
	            if (!isMoved) {
	                effect = panel.hasClass('panel-cover') ? 'cover' : 'reveal';
	                if (!opened) {
	                    panel.show();
	                    panelOverlay.show();
	                }
	                panelWidth = panel[0].offsetWidth;
	                panel.transition(0);
	                /*
	                   if (panel.find('.' + app.params.viewClass).length > 0) {
	                   if (app.sizeNavbars) app.sizeNavbars(panel.find('.' + app.params.viewClass)[0]);
	                   }
	                   */
	            }
	
	            isMoved = true;
	
	            e.preventDefault();
	            var threshold = opened ? 0 : -swipePanelThreshold;
	            if (side === 'right') threshold = -threshold;
	
	            touchesDiff = pageX - touchesStart.x + threshold;
	
	            if (side === 'right') {
	                translate = touchesDiff  - (opened ? panelWidth : 0);
	                if (translate > 0) translate = 0;
	                if (translate < -panelWidth) {
	                    translate = -panelWidth;
	                }
	            }
	            else {
	                translate = touchesDiff  + (opened ? panelWidth : 0);
	                if (translate < 0) translate = 0;
	                if (translate > panelWidth) {
	                    translate = panelWidth;
	                }
	            }
	            if (effect === 'reveal') {
	                views.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	                panelOverlay.transform('translate3d(' + translate + 'px,0,0)');
	                //app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
	            }
	            else {
	                panel.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	                //app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
	            }
	        }
	        function handleTouchEnd(e) {
	            if (!isTouched || !isMoved) {
	                isTouched = false;
	                isMoved = false;
	                return;
	            }
	            isTouched = false;
	            isMoved = false;
	            var timeDiff = (new Date()).getTime() - touchStartTime;
	            var action;
	            var edge = (translate === 0 || Math.abs(translate) === panelWidth);
	
	            if (!opened) {
	                if (translate === 0) {
	                    action = 'reset';
	                }
	                else if (
	                        timeDiff < 300 && Math.abs(translate) > 0 ||
	                        timeDiff >= 300 && (Math.abs(translate) >= panelWidth / 2)
	                        ) {
	                            action = 'swap';
	                        }
	                else {
	                    action = 'reset';
	                }
	            }
	            else {
	                if (translate === -panelWidth) {
	                    action = 'reset';
	                }
	                else if (
	                        timeDiff < 300 && Math.abs(translate) >= 0 ||
	                        timeDiff >= 300 && (Math.abs(translate) <= panelWidth / 2)
	                        ) {
	                            if (side === 'left' && translate === panelWidth) action = 'reset';
	                            else action = 'swap';
	                        }
	                else {
	                    action = 'reset';
	                }
	            }
	            if (action === 'swap') {
	                $.allowPanelOpen = true;
	                if (opened) {
	                    $.closePanel();
	                    if (edge) {
	                        panel.css({display: ''});
	                        $('body').removeClass('panel-closing');
	                    }
	                }
	                else {
	                    $.openPanel(side);
	                }
	                if (edge) $.allowPanelOpen = true;
	            }
	            if (action === 'reset') {
	                if (opened) {
	                    $.allowPanelOpen = true;
	                    $.openPanel(side);
	                }
	                else {
	                    $.closePanel();
	                    if (edge) {
	                        $.allowPanelOpen = true;
	                        panel.css({display: ''});
	                    }
	                    else {
	                        var target = effect === 'reveal' ? views : panel;
	                        $('body').addClass('panel-closing');
	                        target.transitionEnd(function () {
	                            $.allowPanelOpen = true;
	                            panel.css({display: ''});
	                            $('body').removeClass('panel-closing');
	                        });
	                    }
	                }
	            }
	            if (effect === 'reveal') {
	                views.transition('');
	                views.transform('');
	            }
	            panel.transition('').transform('');
	            panelOverlay.css({display: ''}).transform('');
	        }
	        $(document).on($.touchEvents.start, handleTouchStart);
	        $(document).on($.touchEvents.move, handleTouchMove);
	        $(document).on($.touchEvents.end, handleTouchEnd);
	    };
	
	    $.initSwipePanels();
	}(Zepto);
	
	/**
	 * 路由
	 *
	 * 路由功能将接管页面的链接点击行为，最后达到动画切换的效果，具体如下：
	 *  1. 链接对应的是另一个页面，那么则尝试 ajax 加载，然后把新页面里的符合约定的结构提取出来，然后做动画切换；如果没法 ajax 或结构不符合，那么则回退为普通的页面跳转
	 *  2. 链接是当前页面的锚点，并且该锚点对应的元素存在且符合路由约定，那么则把该元素做动画切入
	 *  3. 浏览器前进后退（history.forward/history.back）时，也使用动画效果
	 *  4. 如果链接有 back 这个 class，那么则忽略一切，直接调用 history.back() 来后退
	 *
	 * 路由功能默认开启，如果需要关闭路由功能，那么在 zepto 之后，msui 脚本之前设置 $.config.router = false 即可（intro.js 中会 extend 到 $.smConfig 中）。
	 *
	 * 可以设置 $.config.routerFilter 函数来设置当前点击链接是否使用路由功能，实参是 a 链接的 zepto 对象；返回 false 表示不使用 router 功能。
	 *
	 * ajax 载入新的文档时，并不会执行里面的 js。到目前为止，在开启路由功能时，建议的做法是：
	 *  把所有页面的 js 都放到同一个脚本里，js 里面的事件绑定使用委托而不是直接的绑定在元素上（因为动态加载的页面元素还不存在），然后所有页面都引用相同的 js 脚本。非事件类可以通过监控 pageInit 事件，根据里面的 pageId 来做对应区别处理。
	 *
	 * 如果有需要
	 *
	 * 对外暴露的方法
	 *  - load （原 loadPage 效果一致,但后者已标记为待移除）
	 *  - forward
	 *  - back
	 *
	 * 事件
	 * pageLoad* 系列在发生 ajax 加载时才会触发；当是块切换或已缓存的情况下，不会发送这些事件
	 *  - pageLoadCancel: 如果前一个还没加载完,那么取消并发送该事件
	 *  - pageLoadStart: 开始加载
	 *  - pageLodComplete: ajax complete 完成
	 *  - pageLoadError: ajax 发生 error
	 *  - pageAnimationStart: 执行动画切换前，实参是 event，sectionId 和 $section
	 *  - pageAnimationEnd: 执行动画完毕，实参是 event，sectionId 和 $section
	 *  - beforePageRemove: 新 document 载入且动画切换完毕，旧的 document remove 之前在 window 上触发，实参是 event 和 $pageContainer
	 *  - pageRemoved: 新的 document 载入且动画切换完毕，旧的 document remove 之后在 window 上触发
	 *  - beforePageSwitch: page 切换前，在 pageAnimationStart 前，beforePageSwitch 之后会做一些额外的处理才触发 pageAnimationStart
	 *  - pageInitInternal: （经 init.js 处理后，对外是 pageInit）紧跟着动画完成的事件，实参是 event，sectionId 和 $section
	 *
	 * 术语
	 *  - 文档（document），不带 hash 的 url 关联着的应答 html 结构
	 *  - 块（section），一个文档内有指定块标识的元素
	 *
	 * 路由实现约定
	 *  - 每个文档的需要展示的内容必需位于指定的标识（routerConfig.sectionGroupClass）的元素里面，默认是: div.page-group （注意,如果改变这个需要同时改变 less 中的命名）
	 *  - 每个块必需带有指定的块标识（routerConfig.pageClass），默认是 .page
	 *
	 *  即，使用路由功能的每一个文档应当是下面这样的结构（省略 <body> 等）:
	 *      <div class="page-group">
	 *          <div class="page">xxx</div>
	 *          <div class="page">yyy</div>
	 *      </div>
	 *
	 * 另，每一个块都应当有一个唯一的 ID，这样才能通过 #the-id 的形式来切换定位。
	 * 当一个块没有 id 时，如果是第一个的默认的需要展示的块，那么会给其添加一个随机的 id；否则，没有 id 的块将不会被切换展示。
	 *
	 * 通过 history.state/history.pushState 以及用 sessionStorage 来记录当前 state 以及最大的 state id 来辅助前进后退的切换效果，所以在不支持 sessionStorage 的情况下，将不开启路由功能。
	 *
	 * 为了解决 ajax 载入页面导致重复 ID 以及重复 popup 等功能，上面约定了使用路由功能的所有可展示内容都必需位于指定元素内。从而可以在进行文档间切换时可以进行两个文档的整体移动，切换完毕后再把前一个文档的内容从页面之间移除。
	 *
	 * 默认地过滤了部分协议的链接，包括 tel:, javascript:, mailto:，这些链接将不会使用路由功能。如果有更多的自定义控制需求，可以在 $.config.routerFilter 实现
	 *
	 * 注: 以 _ 开头的函数标明用于此处内部使用，可根据需要随时重构变更，不对外确保兼容性。
	 *
	 */
	+function($) {
	    'use strict';
	
	    if (!window.CustomEvent) {
	        window.CustomEvent = function(type, config) {
	            config = config || { bubbles: false, cancelable: false, detail: undefined};
	            var e = document.createEvent('CustomEvent');
	            e.initCustomEvent(type, config.bubbles, config.cancelable, config.detail);
	            return e;
	        };
	
	        window.CustomEvent.prototype = window.Event.prototype;
	    }
	
	    var EVENTS = {
	        pageLoadStart: 'pageLoadStart', // ajax 开始加载新页面前
	        pageLoadCancel: 'pageLoadCancel', // 取消前一个 ajax 加载动作后
	        pageLoadError: 'pageLoadError', // ajax 加载页面失败后
	        pageLoadComplete: 'pageLoadComplete', // ajax 加载页面完成后（不论成功与否）
	        pageAnimationStart: 'pageAnimationStart', // 动画切换 page 前
	        pageAnimationEnd: 'pageAnimationEnd', // 动画切换 page 结束后
	        beforePageRemove: 'beforePageRemove', // 移除旧 document 前（适用于非内联 page 切换）
	        pageRemoved: 'pageRemoved', // 移除旧 document 后（适用于非内联 page 切换）
	        beforePageSwitch: 'beforePageSwitch', // page 切换前，在 pageAnimationStart 前，beforePageSwitch 之后会做一些额外的处理才触发 pageAnimationStart
	        pageInit: 'pageInitInternal' // 目前是定义为一个 page 加载完毕后（实际和 pageAnimationEnd 等同）
	    };
	
	    var Util = {
	        /**
	         * 获取 url 的 fragment（即 hash 中去掉 # 的剩余部分）
	         *
	         * 如果没有则返回空字符串
	         * 如: http://example.com/path/?query=d#123 => 123
	         *
	         * @param {String} url url
	         * @returns {String}
	         */
	        getUrlFragment: function(url) {
	            var hashIndex = url.indexOf('#');
	            return hashIndex === -1 ? '' : url.slice(hashIndex + 1);
	        },
	        /**
	         * 获取一个链接相对于当前页面的绝对地址形式
	         *
	         * 假设当前页面是 http://a.com/b/c
	         * 那么有以下情况:
	         * d => http://a.com/b/d
	         * /e => http://a.com/e
	         * #1 => http://a.com/b/c#1
	         * http://b.com/f => http://b.com/f
	         *
	         * @param {String} url url
	         * @returns {String}
	         */
	        getAbsoluteUrl: function(url) {
	            var link = document.createElement('a');
	            link.setAttribute('href', url);
	            var absoluteUrl = link.href;
	            link = null;
	            return absoluteUrl;
	        },
	        /**
	         * 获取一个 url 的基本部分，即不包括 hash
	         *
	         * @param {String} url url
	         * @returns {String}
	         */
	        getBaseUrl: function(url) {
	            var hashIndex = url.indexOf('#');
	            return hashIndex === -1 ? url.slice(0) : url.slice(0, hashIndex);
	        },
	        /**
	         * 把一个字符串的 url 转为一个可获取其 base 和 fragment 等的对象
	         *
	         * @param {String} url url
	         * @returns {UrlObject}
	         */
	        toUrlObject: function(url) {
	            var fullUrl = this.getAbsoluteUrl(url),
	                baseUrl = this.getBaseUrl(fullUrl),
	                fragment = this.getUrlFragment(url);
	
	            return {
	                base: baseUrl,
	                full: fullUrl,
	                original: url,
	                fragment: fragment
	            };
	        },
	        /**
	         * 判断浏览器是否支持 sessionStorage，支持返回 true，否则返回 false
	         * @returns {Boolean}
	         */
	        supportStorage: function() {
	            var mod = 'sm.router.storage.ability';
	            try {
	                sessionStorage.setItem(mod, mod);
	                sessionStorage.removeItem(mod);
	                return true;
	            } catch(e) {
	                return false;
	            }
	        }
	    };
	
	    var routerConfig = {
	        sectionGroupClass: 'page-group',
	        // 表示是当前 page 的 class
	        curPageClass: 'page-current',
	        // 用来辅助切换时表示 page 是 visible 的,
	        // 之所以不用 curPageClass，是因为 page-current 已被赋予了「当前 page」这一含义而不仅仅是 display: block
	        // 并且，别的地方已经使用了，所以不方便做变更，故新增一个
	        visiblePageClass: 'page-visible',
	        // 表示是 page 的 class，注意，仅是标志 class，而不是所有的 class
	        pageClass: 'page'
	    };
	
	    var DIRECTION = {
	        leftToRight: 'from-left-to-right',
	        rightToLeft: 'from-right-to-left'
	    };
	
	    var theHistory = window.history;
	
	    var Router = function() {
	        this.sessionNames = {
	            currentState: 'sm.router.currentState',
	            maxStateId: 'sm.router.maxStateId'
	        };
	
	        this._init();
	        this.xhr = null;
	        window.addEventListener('popstate', this._onPopState.bind(this));
	    };
	
	    /**
	     * 初始化
	     *
	     * - 把当前文档内容缓存起来
	     * - 查找默认展示的块内容，查找顺序如下
	     *      1. id 是 url 中的 fragment 的元素
	     *      2. 有当前块 class 标识的第一个元素
	     *      3. 第一个块
	     * - 初始页面 state 处理
	     *
	     * @private
	     */
	    Router.prototype._init = function() {
	
	        this.$view = $('body');
	
	        // 用来保存 document 的 map
	        this.cache = {};
	        var $doc = $(document);
	        var currentUrl = location.href;
	        this._saveDocumentIntoCache($doc, currentUrl);
	
	        var curPageId;
	
	        var currentUrlObj = Util.toUrlObject(currentUrl);
	        var $allSection = $doc.find('.' + routerConfig.pageClass);
	        var $visibleSection = $doc.find('.' + routerConfig.curPageClass);
	        var $curVisibleSection = $visibleSection.eq(0);
	        var $hashSection;
	
	        if (currentUrlObj.fragment) {
	            $hashSection = $doc.find('#' + currentUrlObj.fragment);
	        }
	        if ($hashSection && $hashSection.length) {
	            $visibleSection = $hashSection.eq(0);
	        } else if (!$visibleSection.length) {
	            $visibleSection = $allSection.eq(0);
	        }
	        if (!$visibleSection.attr('id')) {
	            $visibleSection.attr('id', this._generateRandomId());
	        }
	
	        if ($curVisibleSection.length &&
	            ($curVisibleSection.attr('id') !== $visibleSection.attr('id'))) {
	            // 在 router 到 inner page 的情况下，刷新（或者直接访问该链接）
	            // 直接切换 class 会有「闪」的现象,或许可以采用 animateSection 来减缓一下
	            $curVisibleSection.removeClass(routerConfig.curPageClass);
	            $visibleSection.addClass(routerConfig.curPageClass);
	        } else {
	            $visibleSection.addClass(routerConfig.curPageClass);
	        }
	        curPageId = $visibleSection.attr('id');
	
	
	        // 新进入一个使用 history.state 相关技术的页面时，如果第一个 state 不 push/replace,
	        // 那么在后退回该页面时，将不触发 popState 事件
	        if (theHistory.state === null) {
	            var curState = {
	                id: this._getNextStateId(),
	                url: Util.toUrlObject(currentUrl),
	                pageId: curPageId
	            };
	
	            theHistory.replaceState(curState, '', currentUrl);
	            this._saveAsCurrentState(curState);
	            this._incMaxStateId();
	        }
	    };
	
	    /**
	     * 切换到 url 指定的块或文档
	     *
	     * 如果 url 指向的是当前页面，那么认为是切换块；
	     * 否则是切换文档
	     *
	     * @param {String} url url
	     * @param {Boolean=} ignoreCache 是否强制请求不使用缓存，对 document 生效，默认是 false
	     */
	    Router.prototype.load = function(url, ignoreCache) {
	        if (ignoreCache === undefined) {
	            ignoreCache = false;
	        }
	
	        if (this._isTheSameDocument(location.href, url)) {
	            this._switchToSection(Util.getUrlFragment(url));
	        } else {
	            this._saveDocumentIntoCache($(document), location.href);
	            this._switchToDocument(url, ignoreCache);
	        }
	    };
	
	    /**
	     * 调用 history.forward()
	     */
	    Router.prototype.forward = function() {
	        theHistory.forward();
	    };
	
	    /**
	     * 调用 history.back()
	     */
	    Router.prototype.back = function() {
	        theHistory.back();
	    };
	
	    //noinspection JSUnusedGlobalSymbols
	    /**
	     * @deprecated
	     */
	    Router.prototype.loadPage = Router.prototype.load;
	
	    /**
	     * 切换显示当前文档另一个块
	     *
	     * 把新块从右边切入展示，同时会把新的块的记录用 history.pushState 来保存起来
	     *
	     * 如果已经是当前显示的块，那么不做任何处理；
	     * 如果没对应的块，那么忽略。
	     *
	     * @param {String} sectionId 待切换显示的块的 id
	     * @private
	     */
	    Router.prototype._switchToSection = function(sectionId) {
	        if (!sectionId) {
	            return;
	        }
	
	        var $curPage = this._getCurrentSection(),
	            $newPage = $('#' + sectionId);
	
	        // 如果已经是当前页，不做任何处理
	        if ($curPage === $newPage) {
	            return;
	        }
	
	        this._animateSection($curPage, $newPage, DIRECTION.rightToLeft);
	        this._pushNewState('#' + sectionId, sectionId);
	    };
	
	    /**
	     * 载入显示一个新的文档
	     *
	     * - 如果有缓存，那么直接利用缓存来切换
	     * - 否则，先把页面加载过来缓存，然后再切换
	     *      - 如果解析失败，那么用 location.href 的方式来跳转
	     *
	     * 注意：不能在这里以及其之后用 location.href 来 **读取** 切换前的页面的 url，
	     *     因为如果是 popState 时的调用，那么此时 location 已经是 pop 出来的 state 的了
	     *
	     * @param {String} url 新的文档的 url
	     * @param {Boolean=} ignoreCache 是否不使用缓存强制加载页面
	     * @param {Boolean=} isPushState 是否需要 pushState
	     * @param {String=} direction 新文档切入的方向
	     * @private
	     */
	    Router.prototype._switchToDocument = function(url, ignoreCache, isPushState, direction) {
	        var baseUrl = Util.toUrlObject(url).base;
	
	        if (ignoreCache) {
	            delete this.cache[baseUrl];
	        }
	
	        var cacheDocument = this.cache[baseUrl];
	        var context = this;
	
	        if (cacheDocument) {
	            this._doSwitchDocument(url, isPushState, direction);
	        } else {
	            this._loadDocument(url, {
	                success: function($doc) {
	                    try {
	                        context._parseDocument(url, $doc);
	                        context._doSwitchDocument(url, isPushState, direction);
	                    } catch (e) {
	                        location.href = url;
	                    }
	                },
	                error: function() {
	                    location.href = url;
	                }
	            });
	        }
	    };
	
	    /**
	     * 利用缓存来做具体的切换文档操作
	     *
	     * - 确定待切入的文档的默认展示 section
	     * - 把新文档 append 到 view 中
	     * - 动画切换文档
	     * - 如果需要 pushState，那么把最新的状态 push 进去并把当前状态更新为该状态
	     *
	     * @param {String} url 待切换的文档的 url
	     * @param {Boolean} isPushState 加载页面后是否需要 pushState，默认是 true
	     * @param {String} direction 动画切换方向，默认是 DIRECTION.rightToLeft
	     * @private
	     */
	    Router.prototype._doSwitchDocument = function(url, isPushState, direction) {
	        if (typeof isPushState === 'undefined') {
	            isPushState = true;
	        }
	
	        var urlObj = Util.toUrlObject(url);
	        var $currentDoc = this.$view.find('.' + routerConfig.sectionGroupClass);
	        var $newDoc = $($('<div></div>').append(this.cache[urlObj.base].$content).html());
	
	        // 确定一个 document 展示 section 的顺序
	        // 1. 与 hash 关联的 element
	        // 2. 默认的标识为 current 的 element
	        // 3. 第一个 section
	        var $allSection = $newDoc.find('.' + routerConfig.pageClass);
	        var $visibleSection = $newDoc.find('.' + routerConfig.curPageClass);
	        var $hashSection;
	
	        if (urlObj.fragment) {
	            $hashSection = $newDoc.find('#' + urlObj.fragment);
	        }
	        if ($hashSection && $hashSection.length) {
	            $visibleSection = $hashSection.eq(0);
	        } else if (!$visibleSection.length) {
	            $visibleSection = $allSection.eq(0);
	        }
	        if (!$visibleSection.attr('id')) {
	            $visibleSection.attr('id', this._generateRandomId());
	        }
	
	        var $currentSection = this._getCurrentSection();
	        $currentSection.trigger(EVENTS.beforePageSwitch, [$currentSection.attr('id'), $currentSection]);
	
	        $allSection.removeClass(routerConfig.curPageClass);
	        $visibleSection.addClass(routerConfig.curPageClass);
	
	        // prepend 而不 append 的目的是避免 append 进去新的 document 在后面，
	        // 其里面的默认展示的(.page-current) 的页面直接就覆盖了原显示的页面（因为都是 absolute）
	        this.$view.prepend($newDoc);
	
	        this._animateDocument($currentDoc, $newDoc, $visibleSection, direction);
	
	        if (isPushState) {
	            this._pushNewState(url, $visibleSection.attr('id'));
	        }
	    };
	
	    /**
	     * 判断两个 url 指向的页面是否是同一个
	     *
	     * 判断方式: 如果两个 url 的 base 形式（不带 hash 的绝对形式）相同，那么认为是同一个页面
	     *
	     * @param {String} url
	     * @param {String} anotherUrl
	     * @returns {Boolean}
	     * @private
	     */
	    Router.prototype._isTheSameDocument = function(url, anotherUrl) {
	        return Util.toUrlObject(url).base === Util.toUrlObject(anotherUrl).base;
	    };
	
	    /**
	     * ajax 加载 url 指定的页面内容
	     *
	     * 加载过程中会发出以下事件
	     *  pageLoadCancel: 如果前一个还没加载完,那么取消并发送该事件
	     *  pageLoadStart: 开始加载
	     *  pageLodComplete: ajax complete 完成
	     *  pageLoadError: ajax 发生 error
	     *
	     *
	     * @param {String} url url
	     * @param {Object=} callback 回调函数配置，可选，可以配置 success\error 和 complete
	     *      所有回调函数的 this 都是 null，各自实参如下：
	     *      success: $doc, status, xhr
	     *      error: xhr, status, err
	     *      complete: xhr, status
	     *
	     * @private
	     */
	    Router.prototype._loadDocument = function(url, callback) {
	        if (this.xhr && this.xhr.readyState < 4) {
	            this.xhr.onreadystatechange = function() {
	            };
	            this.xhr.abort();
	            this.dispatch(EVENTS.pageLoadCancel);
	        }
	
	        this.dispatch(EVENTS.pageLoadStart);
	
	        callback = callback || {};
	        var self = this;
	
	        this.xhr = $.ajax({
	            url: url,
	            success: $.proxy(function(data, status, xhr) {
	                // 给包一层 <html/>，从而可以拿到完整的结构
	                var $doc = $('<html></html>');
	                $doc.append(data);
	                callback.success && callback.success.call(null, $doc, status, xhr);
	            }, this),
	            error: function(xhr, status, err) {
	                callback.error && callback.error.call(null, xhr, status, err);
	                self.dispatch(EVENTS.pageLoadError);
	            },
	            complete: function(xhr, status) {
	                callback.complete && callback.complete.call(null, xhr, status);
	                self.dispatch(EVENTS.pageLoadComplete);
	            }
	        });
	    };
	
	    /**
	     * 对于 ajax 加载进来的页面，把其缓存起来
	     *
	     * @param {String} url url
	     * @param $doc ajax 载入的页面的 jq 对象，可以看做是该页面的 $(document)
	     * @private
	     */
	    Router.prototype._parseDocument = function(url, $doc) {
	        var $innerView = $doc.find('.' + routerConfig.sectionGroupClass);
	
	        if (!$innerView.length) {
	            throw new Error('missing router view mark: ' + routerConfig.sectionGroupClass);
	        }
	
	        this._saveDocumentIntoCache($doc, url);
	    };
	
	    /**
	     * 把一个页面的相关信息保存到 this.cache 中
	     *
	     * 以页面的 baseUrl 为 key,而 value 则是一个 DocumentCache
	     *
	     * @param {*} doc doc
	     * @param {String} url url
	     * @private
	     */
	    Router.prototype._saveDocumentIntoCache = function(doc, url) {
	        var urlAsKey = Util.toUrlObject(url).base;
	        var $doc = $(doc);
	
	        this.cache[urlAsKey] = {
	            $doc: $doc,
	            $content: $doc.find('.' + routerConfig.sectionGroupClass)
	        };
	    };
	
	    /**
	     * 从 sessionStorage 中获取保存下来的「当前状态」
	     *
	     * 如果解析失败，那么认为当前状态是 null
	     *
	     * @returns {State|null}
	     * @private
	     */
	    Router.prototype._getLastState = function() {
	        var currentState = sessionStorage.getItem(this.sessionNames.currentState);
	        try {
	            currentState = JSON.parse(currentState);
	        } catch(e) {
	            currentState = null;
	        }
	
	        return currentState;
	    };
	
	    /**
	     * 把一个状态设为当前状态，保存仅 sessionStorage 中
	     *
	     * @param {State} state
	     * @private
	     */
	    Router.prototype._saveAsCurrentState = function(state) {
	        sessionStorage.setItem(this.sessionNames.currentState, JSON.stringify(state));
	    };
	
	    /**
	     * 获取下一个 state 的 id
	     *
	     * 读取 sessionStorage 里的最后的状态的 id，然后 + 1；如果原没设置，那么返回 1
	     *
	     * @returns {number}
	     * @private
	     */
	    Router.prototype._getNextStateId = function() {
	        var maxStateId = sessionStorage.getItem(this.sessionNames.maxStateId);
	        return maxStateId ? parseInt(maxStateId, 10) + 1 : 1;
	    };
	
	    /**
	     * 把 sessionStorage 里的最后状态的 id 自加 1
	     *
	     * @private
	     */
	    Router.prototype._incMaxStateId = function() {
	        sessionStorage.setItem(this.sessionNames.maxStateId, this._getNextStateId());
	    };
	
	    /**
	     * 从一个文档切换为显示另一个文档
	     *
	     * @param $from 目前显示的文档
	     * @param $to 待切换显示的新文档
	     * @param $visibleSection 新文档中展示的 section 元素
	     * @param direction 新文档切入方向
	     * @private
	     */
	    Router.prototype._animateDocument = function($from, $to, $visibleSection, direction) {
	        var sectionId = $visibleSection.attr('id');
	
	
	        var $visibleSectionInFrom = $from.find('.' + routerConfig.curPageClass);
	        $visibleSectionInFrom.addClass(routerConfig.visiblePageClass).removeClass(routerConfig.curPageClass);
	
	        $visibleSection.trigger(EVENTS.pageAnimationStart, [sectionId, $visibleSection]);
	
	        this._animateElement($from, $to, direction);
	
	        $from.animationEnd(function() {
	            $visibleSectionInFrom.removeClass(routerConfig.visiblePageClass);
	            // 移除 document 前后，发送 beforePageRemove 和 pageRemoved 事件
	            $(window).trigger(EVENTS.beforePageRemove, [$from]);
	            $from.remove();
	            $(window).trigger(EVENTS.pageRemoved);
	        });
	
	        $to.animationEnd(function() {
	            $visibleSection.trigger(EVENTS.pageAnimationEnd, [sectionId, $visibleSection]);
	            // 外层（init.js）中会绑定 pageInitInternal 事件，然后对页面进行初始化
	            $visibleSection.trigger(EVENTS.pageInit, [sectionId, $visibleSection]);
	        });
	    };
	
	    /**
	     * 把当前文档的展示 section 从一个 section 切换到另一个 section
	     *
	     * @param $from
	     * @param $to
	     * @param direction
	     * @private
	     */
	    Router.prototype._animateSection = function($from, $to, direction) {
	        var toId = $to.attr('id');
	        $from.trigger(EVENTS.beforePageSwitch, [$from.attr('id'), $from]);
	
	        $from.removeClass(routerConfig.curPageClass);
	        $to.addClass(routerConfig.curPageClass);
	        $to.trigger(EVENTS.pageAnimationStart, [toId, $to]);
	        this._animateElement($from, $to, direction);
	        $to.animationEnd(function() {
	            $to.trigger(EVENTS.pageAnimationEnd, [toId, $to]);
	            // 外层（init.js）中会绑定 pageInitInternal 事件，然后对页面进行初始化
	            $to.trigger(EVENTS.pageInit, [toId, $to]);
	        });
	    };
	
	    /**
	     * 切换显示两个元素
	     *
	     * 切换是通过更新 class 来实现的，而具体的切换动画则是 class 关联的 css 来实现
	     *
	     * @param $from 当前显示的元素
	     * @param $to 待显示的元素
	     * @param direction 切换的方向
	     * @private
	     */
	    Router.prototype._animateElement = function($from, $to, direction) {
	        // todo: 可考虑如果入参不指定，那么尝试读取 $to 的属性，再没有再使用默认的
	        // 考虑读取点击的链接上指定的方向
	        if (typeof direction === 'undefined') {
	            direction = DIRECTION.rightToLeft;
	        }
	
	        var animPageClasses = [
	            'page-from-center-to-left',
	            'page-from-center-to-right',
	            'page-from-right-to-center',
	            'page-from-left-to-center'].join(' ');
	
	        var classForFrom, classForTo;
	        switch(direction) {
	            case DIRECTION.rightToLeft:
	                classForFrom = 'page-from-center-to-left';
	                classForTo = 'page-from-right-to-center';
	                break;
	            case DIRECTION.leftToRight:
	                classForFrom = 'page-from-center-to-right';
	                classForTo = 'page-from-left-to-center';
	                break;
	            default:
	                classForFrom = 'page-from-center-to-left';
	                classForTo = 'page-from-right-to-center';
	                break;
	        }
	
	        $from.removeClass(animPageClasses).addClass(classForFrom);
	        $to.removeClass(animPageClasses).addClass(classForTo);
	
	        $from.animationEnd(function() {
	            $from.removeClass(animPageClasses);
	        });
	        $to.animationEnd(function() {
	            $to.removeClass(animPageClasses);
	        });
	    };
	
	    /**
	     * 获取当前显示的第一个 section
	     *
	     * @returns {*}
	     * @private
	     */
	    Router.prototype._getCurrentSection = function() {
	        return this.$view.find('.' + routerConfig.curPageClass).eq(0);
	    };
	
	    /**
	     * popState 事件关联着的后退处理
	     *
	     * 判断两个 state 判断是否是属于同一个文档，然后做对应的 section 或文档切换；
	     * 同时在切换后把新 state 设为当前 state
	     *
	     * @param {State} state 新 state
	     * @param {State} fromState 旧 state
	     * @private
	     */
	    Router.prototype._back = function(state, fromState) {
	        if (this._isTheSameDocument(state.url.full, fromState.url.full)) {
	            var $newPage = $('#' + state.pageId);
	            if ($newPage.length) {
	                var $currentPage = this._getCurrentSection();
	                this._animateSection($currentPage, $newPage, DIRECTION.leftToRight);
	                this._saveAsCurrentState(state);
	            } else {
	                location.href = state.url.full;
	            }
	        } else {
	            this._saveDocumentIntoCache($(document), fromState.url.full);
	            this._switchToDocument(state.url.full, false, false, DIRECTION.leftToRight);
	            this._saveAsCurrentState(state);
	        }
	    };
	
	    /**
	     * popState 事件关联着的前进处理,类似于 _back，不同的是切换方向
	     *
	     * @param {State} state 新 state
	     * @param {State} fromState 旧 state
	     * @private
	     */
	    Router.prototype._forward = function(state, fromState) {
	        if (this._isTheSameDocument(state.url.full, fromState.url.full)) {
	            var $newPage = $('#' + state.pageId);
	            if ($newPage.length) {
	                var $currentPage = this._getCurrentSection();
	                this._animateSection($currentPage, $newPage, DIRECTION.rightToLeft);
	                this._saveAsCurrentState(state);
	            } else {
	                location.href = state.url.full;
	            }
	        } else {
	            this._saveDocumentIntoCache($(document), fromState.url.full);
	            this._switchToDocument(state.url.full, false, false, DIRECTION.rightToLeft);
	            this._saveAsCurrentState(state);
	        }
	    };
	
	    /**
	     * popState 事件处理
	     *
	     * 根据 pop 出来的 state 和当前 state 来判断是前进还是后退
	     *
	     * @param event
	     * @private
	     */
	    Router.prototype._onPopState = function(event) {
	        var state = event.state;
	        // if not a valid state, do nothing
	        if (!state || !state.pageId) {
	            return;
	        }
	
	        var lastState = this._getLastState();
	
	        if (!lastState) {
	            console.error && console.error('Missing last state when backward or forward');
	            return;
	        }
	
	        if (state.id === lastState.id) {
	            return;
	        }
	
	        if (state.id < lastState.id) {
	            this._back(state, lastState);
	        } else {
	            this._forward(state, lastState);
	        }
	    };
	
	    /**
	     * 页面进入到一个新状态
	     *
	     * 把新状态 push 进去，设置为当前的状态，然后把 maxState 的 id +1。
	     *
	     * @param {String} url 新状态的 url
	     * @param {String} sectionId 新状态中显示的 section 元素的 id
	     * @private
	     */
	    Router.prototype._pushNewState = function(url, sectionId) {
	        var state = {
	            id: this._getNextStateId(),
	            pageId: sectionId,
	            url: Util.toUrlObject(url)
	        };
	
	        theHistory.pushState(state, '', url);
	        this._saveAsCurrentState(state);
	        this._incMaxStateId();
	    };
	
	    /**
	     * 生成一个随机的 id
	     *
	     * @returns {string}
	     * @private
	     */
	    Router.prototype._generateRandomId = function() {
	        return "page-" + (+new Date());
	    };
	
	    Router.prototype.dispatch = function(event) {
	        var e = new CustomEvent(event, {
	            bubbles: true,
	            cancelable: true
	        });
	
	        //noinspection JSUnresolvedFunction
	        window.dispatchEvent(e);
	    };
	
	    /**
	     * 判断一个链接是否使用 router 来处理
	     *
	     * @param $link
	     * @returns {boolean}
	     */
	    function isInRouterBlackList($link) {
	        var classBlackList = [
	            'external',
	            'tab-link',
	            'open-popup',
	            'close-popup',
	            'open-panel',
	            'close-panel'
	        ];
	
	        for (var i = classBlackList.length -1 ; i >= 0; i--) {
	            if ($link.hasClass(classBlackList[i])) {
	                return true;
	            }
	        }
	
	        var linkEle = $link.get(0);
	        var linkHref = linkEle.getAttribute('href');
	
	        var protoWhiteList = [
	            'http',
	            'https'
	        ];
	
	        //如果非noscheme形式的链接，且协议不是http(s)，那么路由不会处理这类链接
	        if (/^(\w+):/.test(linkHref) && protoWhiteList.indexOf(RegExp.$1) < 0) {
	            return true;
	        }
	
	        //noinspection RedundantIfStatementJS
	        if (linkEle.hasAttribute('external')) {
	            return true;
	        }
	
	        return false;
	    }
	
	    /**
	     * 自定义是否执行路由功能的过滤器
	     *
	     * 可以在外部定义 $.config.routerFilter 函数，实参是点击链接的 Zepto 对象。
	     *
	     * @param $link 当前点击的链接的 Zepto 对象
	     * @returns {boolean} 返回 true 表示执行路由功能，否则不做路由处理
	     */
	    function customClickFilter($link) {
	        var customRouterFilter = $.smConfig.routerFilter;
	        if ($.isFunction(customRouterFilter)) {
	            var filterResult = customRouterFilter($link);
	            if (typeof filterResult === 'boolean') {
	                return filterResult;
	            }
	        }
	
	        return true;
	    }
	
	    $(function() {
	        // 用户可选关闭router功能
	        if (!$.smConfig.router) {
	            return;
	        }
	
	        if (!Util.supportStorage()) {
	            return;
	        }
	
	        var $pages = $('.' + routerConfig.pageClass);
	        if (!$pages.length) {
	            var warnMsg = 'Disable router function because of no .page elements';
	            if (window.console && window.console.warn) {
	                console.warn(warnMsg);
	            }
	            return;
	        }
	
	        var router = $.router = new Router();
	
	        $(document).on('click', 'a', function(e) {
	            var $target = $(e.currentTarget);
	
	            var filterResult = customClickFilter($target);
	            if (!filterResult) {
	                return;
	            }
	
	            if (isInRouterBlackList($target)) {
	                return;
	            }
	
	            e.preventDefault();
	
	            if ($target.hasClass('back')) {
	                router.back();
	            } else {
	                var url = $target.attr('href');
	                if (!url || url === '#') {
	                    return;
	                }
	
	                var ignoreCache = $target.attr('data-no-cache') === 'true';
	
	                router.load(url, ignoreCache);
	            }
	        });
	    });
	}(Zepto);
	
	/**
	 * @typedef {Object} State
	 * @property {Number} id
	 * @property {String} url
	 * @property {String} pageId
	 */
	
	/**
	 * @typedef {Object} UrlObject 字符串 url 转为的对象
	 * @property {String} base url 的基本路径
	 * @property {String} full url 的完整绝对路径
	 * @property {String} origin 转换前的 url
	 * @property {String} fragment url 的 fragment
	 */
	
	/**
	 * @typedef {Object} DocumentCache
	 * @property {*|HTMLElement} $doc 看做是 $(document)
	 * @property {*|HTMLElement} $content $doc 里的 routerConfig.innerViewClass 元素
	 */
	
	/*======================================================
	************   Modals   ************
	======================================================*/
	/*jshint unused: false*/
	+function ($) {
	  "use strict";
	  $.lastPosition =function(options) {
	    if ( !sessionStorage) {
	        return;
	    }
	    // 需要记忆模块的className
	    var needMemoryClass = options.needMemoryClass || [];
	
	    $(window).off('beforePageSwitch').on('beforePageSwitch', function(event,id,arg) {
	      updateMemory(id,arg);
	    });
	    $(window).off('pageAnimationStart').on('pageAnimationStart', function(event,id,arg) {
	      getMemory(id,arg);
	    });
	    //让后退页面回到之前的高度
	    function getMemory(id,arg){
	      needMemoryClass.forEach(function(item, index) {
	          if ($(item).length === 0) {
	              return;
	          }
	          var positionName = id ;
	          // 遍历对应节点设置存储的高度
	          var memoryHeight = sessionStorage.getItem(positionName);
	          arg.find(item).scrollTop(parseInt(memoryHeight));
	
	      });
	    }
	    //记住即将离开的页面的高度
	    function updateMemory(id,arg) {
	        var positionName = id ;
	        // 存储需要记忆模块的高度
	        needMemoryClass.forEach(function(item, index) {
	            if ($(item).length === 0) {
	                return;
	            }
	            sessionStorage.setItem(
	                positionName,
	                arg.find(item).scrollTop()
	            );
	
	        });
	    }
	  };
	}(Zepto);
	
	/*jshint unused: false*/
	+function($) {
	    'use strict';
	
	    var getPage = function() {
	        var $page = $(".page-current");
	        if (!$page[0]) $page = $(".page").addClass('page-current');
	        return $page;
	    };
	
	    //初始化页面中的JS组件
	    $.initPage = function(page) {
	        var $page = getPage();
	        if (!$page[0]) $page = $(document.body);
	        var $content = $page.hasClass('content') ?
	                       $page :
	                       $page.find('.content');
	        $content.scroller();  //注意滚动条一定要最先初始化
	
	        $.initPullToRefresh($content);
	        $.initInfiniteScroll($content);
	        $.initCalendar($content);
	
	        //extend
	        if ($.initSwiper) $.initSwiper($content);
	    };
	
	    if ($.smConfig.showPageLoadingIndicator) {
	        //这里的 以 push 开头的是私有事件，不要用
	        $(window).on('pageLoadStart', function() {
	            $.showIndicator();
	
	        });
	        $(window).on('pageAnimationStart', function() {
	            $.hideIndicator();
	        });
	        $(window).on('pageLoadCancel', function() {
	            $.hideIndicator();
	        });
	        $(window).on('pageLoadComplete', function() {
	            $.hideIndicator();
	        });
	        $(window).on('pageLoadError', function() {
	            $.hideIndicator();
	            $.toast('加载失败');
	        });
	    }
	
	    $(window).on('pageAnimationStart', function(event,id,page) {
	        // 在路由切换页面动画开始前,为了把位于 .page 之外的 popup 等隐藏,此处做些处理
	        $.closeModal();
	        $.closePanel();
	        // 如果 panel 的 effect 是 reveal 时,似乎是 page 的动画或别的样式原因导致了 transitionEnd 时间不会触发
	        // 这里暂且处理一下
	        $('body').removeClass('panel-closing');
	        $.allowPanelOpen = true;
	    });
	
	    $(window).on('pageInit', function() {
	        $.hideIndicator();
	        $.lastPosition({
	            needMemoryClass: [
	                '.content'
	            ]
	        });
	    });
	    // safari 在后退的时候会使用缓存技术，但实现上似乎存在些问题，
	    // 导致路由中绑定的点击事件不会正常如期的运行（log 和 debugger 都没法调试），
	    // 从而后续的跳转等完全乱了套。
	    // 所以，这里检测到是 safari 的 cache 的情况下，做一次 reload
	    // 测试路径(后缀 D 表示是 document，E 表示 external，不使用路由跳转）：
	    // 1. aD -> bDE
	    // 2. back
	    // 3. aD -> bD
	    window.addEventListener('pageshow', function(event) {
	        if (event.persisted) {
	            location.reload();
	        }
	    });
	
	    $.init = function() {
	        var $page = getPage();
	        var id = $page[0].id;
	        $.initPage();
	        $page.trigger('pageInit', [id, $page]);
	    };
	
	    //DOM READY
	    $(function() {
	        //直接绑定
	        FastClick.attach(document.body);
	
	        if ($.smConfig.autoInit) {
	            $.init();
	        }
	
	        $(document).on('pageInitInternal', function(e, id, page) {
	            $.init();
	        });
	    });
	
	}(Zepto);
	
	/**
	 * ScrollFix v0.1
	 * http://www.joelambert.co.uk
	 *
	 * Copyright 2011, Joe Lambert.
	 * Free to use under the MIT license.
	 * http://www.opensource.org/licenses/mit-license.php
	 */
	/* ===============================================================================
	************   ScrollFix   ************
	=============================================================================== */
	
	+ function($) {
	    "use strict";
	    //安卓微信中使用scrollfix会有问题，因此只在ios中使用，安卓机器按照原来的逻辑
	
	    if($.device.ios){
	        var ScrollFix = function(elem) {
	
	            // Variables to track inputs
	            var startY;
	            var startTopScroll;
	
	            elem = elem || document.querySelector(elem);
	
	            // If there is no element, then do nothing
	            if(!elem)
	                return;
	
	            // Handle the start of interactions
	            elem.addEventListener('touchstart', function(event){
	                startY = event.touches[0].pageY;
	                startTopScroll = elem.scrollTop;
	
	                if(startTopScroll <= 0)
	                elem.scrollTop = 1;
	
	            if(startTopScroll + elem.offsetHeight >= elem.scrollHeight)
	                elem.scrollTop = elem.scrollHeight - elem.offsetHeight - 1;
	            }, false);
	        };
	
	        var initScrollFix = function(){
	            var prefix = $('.page-current').length > 0 ? '.page-current ' : '';
	            var scrollable = $(prefix + ".content");
	            new ScrollFix(scrollable[0]);
	        };
	
	        $(document).on($.touchEvents.move, ".page-current .bar",function(){
	            event.preventDefault();
	        });
	        //监听ajax页面跳转
	        $(document).on("pageLoadComplete", function(){
	             initScrollFix();
	        });
	        //监听内联页面跳转
	        $(document).on("pageAnimationEnd", function(){
	             initScrollFix();
	        });
	        initScrollFix();
	    }
	
	}(Zepto);


/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	/* Zepto v1.0-1-ga3cab6c - polyfill zepto detect event ajax form fx - zeptojs.com/license */
	(function(a){String.prototype.trim===a&&(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),Array.prototype.reduce===a&&(Array.prototype.reduce=function(b){if(this===void 0||this===null)throw new TypeError;var c=Object(this),d=c.length>>>0,e=0,f;if(typeof b!="function")throw new TypeError;if(d==0&&arguments.length==1)throw new TypeError;if(arguments.length>=2)f=arguments[1];else do{if(e in c){f=c[e++];break}if(++e>=d)throw new TypeError}while(!0);while(e<d)e in c&&(f=b.call(a,f,c[e],e,c)),e++;return f})})();var Zepto=function(){function E(a){return a==null?String(a):y[z.call(a)]||"object"}function F(a){return E(a)=="function"}function G(a){return a!=null&&a==a.window}function H(a){return a!=null&&a.nodeType==a.DOCUMENT_NODE}function I(a){return E(a)=="object"}function J(a){return I(a)&&!G(a)&&a.__proto__==Object.prototype}function K(a){return a instanceof Array}function L(a){return typeof a.length=="number"}function M(a){return g.call(a,function(a){return a!=null})}function N(a){return a.length>0?c.fn.concat.apply([],a):a}function O(a){return a.replace(/::/g,"/").replace(/([A-Z]+)([A-Z][a-z])/g,"$1_$2").replace(/([a-z\d])([A-Z])/g,"$1_$2").replace(/_/g,"-").toLowerCase()}function P(a){return a in j?j[a]:j[a]=new RegExp("(^|\\s)"+a+"(\\s|$)")}function Q(a,b){return typeof b=="number"&&!l[O(a)]?b+"px":b}function R(a){var b,c;return i[a]||(b=h.createElement(a),h.body.appendChild(b),c=k(b,"").getPropertyValue("display"),b.parentNode.removeChild(b),c=="none"&&(c="block"),i[a]=c),i[a]}function S(a){return"children"in a?f.call(a.children):c.map(a.childNodes,function(a){if(a.nodeType==1)return a})}function T(c,d,e){for(b in d)e&&(J(d[b])||K(d[b]))?(J(d[b])&&!J(c[b])&&(c[b]={}),K(d[b])&&!K(c[b])&&(c[b]=[]),T(c[b],d[b],e)):d[b]!==a&&(c[b]=d[b])}function U(b,d){return d===a?c(b):c(b).filter(d)}function V(a,b,c,d){return F(b)?b.call(a,c,d):b}function W(a,b,c){c==null?a.removeAttribute(b):a.setAttribute(b,c)}function X(b,c){var d=b.className,e=d&&d.baseVal!==a;if(c===a)return e?d.baseVal:d;e?d.baseVal=c:b.className=c}function Y(a){var b;try{return a?a=="true"||(a=="false"?!1:a=="null"?null:isNaN(b=Number(a))?/^[\[\{]/.test(a)?c.parseJSON(a):a:b):a}catch(d){return a}}function Z(a,b){b(a);for(var c in a.childNodes)Z(a.childNodes[c],b)}var a,b,c,d,e=[],f=e.slice,g=e.filter,h=window.document,i={},j={},k=h.defaultView.getComputedStyle,l={"column-count":1,columns:1,"font-weight":1,"line-height":1,opacity:1,"z-index":1,zoom:1},m=/^\s*<(\w+|!)[^>]*>/,n=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,o=/^(?:body|html)$/i,p=["val","css","html","text","data","width","height","offset"],q=["after","prepend","before","append"],r=h.createElement("table"),s=h.createElement("tr"),t={tr:h.createElement("tbody"),tbody:r,thead:r,tfoot:r,td:s,th:s,"*":h.createElement("div")},u=/complete|loaded|interactive/,v=/^\.([\w-]+)$/,w=/^#([\w-]*)$/,x=/^[\w-]+$/,y={},z=y.toString,A={},B,C,D=h.createElement("div");return A.matches=function(a,b){if(!a||a.nodeType!==1)return!1;var c=a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.matchesSelector;if(c)return c.call(a,b);var d,e=a.parentNode,f=!e;return f&&(e=D).appendChild(a),d=~A.qsa(e,b).indexOf(a),f&&D.removeChild(a),d},B=function(a){return a.replace(/-+(.)?/g,function(a,b){return b?b.toUpperCase():""})},C=function(a){return g.call(a,function(b,c){return a.indexOf(b)==c})},A.fragment=function(b,d,e){b.replace&&(b=b.replace(n,"<$1></$2>")),d===a&&(d=m.test(b)&&RegExp.$1),d in t||(d="*");var g,h,i=t[d];return i.innerHTML=""+b,h=c.each(f.call(i.childNodes),function(){i.removeChild(this)}),J(e)&&(g=c(h),c.each(e,function(a,b){p.indexOf(a)>-1?g[a](b):g.attr(a,b)})),h},A.Z=function(a,b){return a=a||[],a.__proto__=c.fn,a.selector=b||"",a},A.isZ=function(a){return a instanceof A.Z},A.init=function(b,d){if(!b)return A.Z();if(F(b))return c(h).ready(b);if(A.isZ(b))return b;var e;if(K(b))e=M(b);else if(I(b))e=[J(b)?c.extend({},b):b],b=null;else if(m.test(b))e=A.fragment(b.trim(),RegExp.$1,d),b=null;else{if(d!==a)return c(d).find(b);e=A.qsa(h,b)}return A.Z(e,b)},c=function(a,b){return A.init(a,b)},c.extend=function(a){var b,c=f.call(arguments,1);return typeof a=="boolean"&&(b=a,a=c.shift()),c.forEach(function(c){T(a,c,b)}),a},A.qsa=function(a,b){var c;return H(a)&&w.test(b)?(c=a.getElementById(RegExp.$1))?[c]:[]:a.nodeType!==1&&a.nodeType!==9?[]:f.call(v.test(b)?a.getElementsByClassName(RegExp.$1):x.test(b)?a.getElementsByTagName(b):a.querySelectorAll(b))},c.contains=function(a,b){return a!==b&&a.contains(b)},c.type=E,c.isFunction=F,c.isWindow=G,c.isArray=K,c.isPlainObject=J,c.isEmptyObject=function(a){var b;for(b in a)return!1;return!0},c.inArray=function(a,b,c){return e.indexOf.call(b,a,c)},c.camelCase=B,c.trim=function(a){return a.trim()},c.uuid=0,c.support={},c.expr={},c.map=function(a,b){var c,d=[],e,f;if(L(a))for(e=0;e<a.length;e++)c=b(a[e],e),c!=null&&d.push(c);else for(f in a)c=b(a[f],f),c!=null&&d.push(c);return N(d)},c.each=function(a,b){var c,d;if(L(a)){for(c=0;c<a.length;c++)if(b.call(a[c],c,a[c])===!1)return a}else for(d in a)if(b.call(a[d],d,a[d])===!1)return a;return a},c.grep=function(a,b){return g.call(a,b)},window.JSON&&(c.parseJSON=JSON.parse),c.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){y["[object "+b+"]"]=b.toLowerCase()}),c.fn={forEach:e.forEach,reduce:e.reduce,push:e.push,sort:e.sort,indexOf:e.indexOf,concat:e.concat,map:function(a){return c(c.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return c(f.apply(this,arguments))},ready:function(a){return u.test(h.readyState)?a(c):h.addEventListener("DOMContentLoaded",function(){a(c)},!1),this},get:function(b){return b===a?f.call(this):this[b>=0?b:b+this.length]},toArray:function(){return this.get()},size:function(){return this.length},remove:function(){return this.each(function(){this.parentNode!=null&&this.parentNode.removeChild(this)})},each:function(a){return e.every.call(this,function(b,c){return a.call(b,c,b)!==!1}),this},filter:function(a){return F(a)?this.not(this.not(a)):c(g.call(this,function(b){return A.matches(b,a)}))},add:function(a,b){return c(C(this.concat(c(a,b))))},is:function(a){return this.length>0&&A.matches(this[0],a)},not:function(b){var d=[];if(F(b)&&b.call!==a)this.each(function(a){b.call(this,a)||d.push(this)});else{var e=typeof b=="string"?this.filter(b):L(b)&&F(b.item)?f.call(b):c(b);this.forEach(function(a){e.indexOf(a)<0&&d.push(a)})}return c(d)},has:function(a){return this.filter(function(){return I(a)?c.contains(this,a):c(this).find(a).size()})},eq:function(a){return a===-1?this.slice(a):this.slice(a,+a+1)},first:function(){var a=this[0];return a&&!I(a)?a:c(a)},last:function(){var a=this[this.length-1];return a&&!I(a)?a:c(a)},find:function(a){var b,d=this;return typeof a=="object"?b=c(a).filter(function(){var a=this;return e.some.call(d,function(b){return c.contains(b,a)})}):this.length==1?b=c(A.qsa(this[0],a)):b=this.map(function(){return A.qsa(this,a)}),b},closest:function(a,b){var d=this[0],e=!1;typeof a=="object"&&(e=c(a));while(d&&!(e?e.indexOf(d)>=0:A.matches(d,a)))d=d!==b&&!H(d)&&d.parentNode;return c(d)},parents:function(a){var b=[],d=this;while(d.length>0)d=c.map(d,function(a){if((a=a.parentNode)&&!H(a)&&b.indexOf(a)<0)return b.push(a),a});return U(b,a)},parent:function(a){return U(C(this.pluck("parentNode")),a)},children:function(a){return U(this.map(function(){return S(this)}),a)},contents:function(){return this.map(function(){return f.call(this.childNodes)})},siblings:function(a){return U(this.map(function(a,b){return g.call(S(b.parentNode),function(a){return a!==b})}),a)},empty:function(){return this.each(function(){this.innerHTML=""})},pluck:function(a){return c.map(this,function(b){return b[a]})},show:function(){return this.each(function(){this.style.display=="none"&&(this.style.display=null),k(this,"").getPropertyValue("display")=="none"&&(this.style.display=R(this.nodeName))})},replaceWith:function(a){return this.before(a).remove()},wrap:function(a){var b=F(a);if(this[0]&&!b)var d=c(a).get(0),e=d.parentNode||this.length>1;return this.each(function(f){c(this).wrapAll(b?a.call(this,f):e?d.cloneNode(!0):d)})},wrapAll:function(a){if(this[0]){c(this[0]).before(a=c(a));var b;while((b=a.children()).length)a=b.first();c(a).append(this)}return this},wrapInner:function(a){var b=F(a);return this.each(function(d){var e=c(this),f=e.contents(),g=b?a.call(this,d):a;f.length?f.wrapAll(g):e.append(g)})},unwrap:function(){return this.parent().each(function(){c(this).replaceWith(c(this).children())}),this},clone:function(){return this.map(function(){return this.cloneNode(!0)})},hide:function(){return this.css("display","none")},toggle:function(b){return this.each(function(){var d=c(this);(b===a?d.css("display")=="none":b)?d.show():d.hide()})},prev:function(a){return c(this.pluck("previousElementSibling")).filter(a||"*")},next:function(a){return c(this.pluck("nextElementSibling")).filter(a||"*")},html:function(b){return b===a?this.length>0?this[0].innerHTML:null:this.each(function(a){var d=this.innerHTML;c(this).empty().append(V(this,b,a,d))})},text:function(b){return b===a?this.length>0?this[0].textContent:null:this.each(function(){this.textContent=b})},attr:function(c,d){var e;return typeof c=="string"&&d===a?this.length==0||this[0].nodeType!==1?a:c=="value"&&this[0].nodeName=="INPUT"?this.val():!(e=this[0].getAttribute(c))&&c in this[0]?this[0][c]:e:this.each(function(a){if(this.nodeType!==1)return;if(I(c))for(b in c)W(this,b,c[b]);else W(this,c,V(this,d,a,this.getAttribute(c)))})},removeAttr:function(a){return this.each(function(){this.nodeType===1&&W(this,a)})},prop:function(b,c){return c===a?this[0]&&this[0][b]:this.each(function(a){this[b]=V(this,c,a,this[b])})},data:function(b,c){var d=this.attr("data-"+O(b),c);return d!==null?Y(d):a},val:function(b){return b===a?this[0]&&(this[0].multiple?c(this[0]).find("option").filter(function(a){return this.selected}).pluck("value"):this[0].value):this.each(function(a){this.value=V(this,b,a,this.value)})},offset:function(a){if(a)return this.each(function(b){var d=c(this),e=V(this,a,b,d.offset()),f=d.offsetParent().offset(),g={top:e.top-f.top,left:e.left-f.left};d.css("position")=="static"&&(g.position="relative"),d.css(g)});if(this.length==0)return null;var b=this[0].getBoundingClientRect();return{left:b.left+window.pageXOffset,top:b.top+window.pageYOffset,width:Math.round(b.width),height:Math.round(b.height)}},css:function(a,c){if(arguments.length<2&&typeof a=="string")return this[0]&&(this[0].style[B(a)]||k(this[0],"").getPropertyValue(a));var d="";if(E(a)=="string")!c&&c!==0?this.each(function(){this.style.removeProperty(O(a))}):d=O(a)+":"+Q(a,c);else for(b in a)!a[b]&&a[b]!==0?this.each(function(){this.style.removeProperty(O(b))}):d+=O(b)+":"+Q(b,a[b])+";";return this.each(function(){this.style.cssText+=";"+d})},index:function(a){return a?this.indexOf(c(a)[0]):this.parent().children().indexOf(this[0])},hasClass:function(a){return e.some.call(this,function(a){return this.test(X(a))},P(a))},addClass:function(a){return this.each(function(b){d=[];var e=X(this),f=V(this,a,b,e);f.split(/\s+/g).forEach(function(a){c(this).hasClass(a)||d.push(a)},this),d.length&&X(this,e+(e?" ":"")+d.join(" "))})},removeClass:function(b){return this.each(function(c){if(b===a)return X(this,"");d=X(this),V(this,b,c,d).split(/\s+/g).forEach(function(a){d=d.replace(P(a)," ")}),X(this,d.trim())})},toggleClass:function(b,d){return this.each(function(e){var f=c(this),g=V(this,b,e,X(this));g.split(/\s+/g).forEach(function(b){(d===a?!f.hasClass(b):d)?f.addClass(b):f.removeClass(b)})})},scrollTop:function(){if(!this.length)return;return"scrollTop"in this[0]?this[0].scrollTop:this[0].scrollY},position:function(){if(!this.length)return;var a=this[0],b=this.offsetParent(),d=this.offset(),e=o.test(b[0].nodeName)?{top:0,left:0}:b.offset();return d.top-=parseFloat(c(a).css("margin-top"))||0,d.left-=parseFloat(c(a).css("margin-left"))||0,e.top+=parseFloat(c(b[0]).css("border-top-width"))||0,e.left+=parseFloat(c(b[0]).css("border-left-width"))||0,{top:d.top-e.top,left:d.left-e.left}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||h.body;while(a&&!o.test(a.nodeName)&&c(a).css("position")=="static")a=a.offsetParent;return a})}},c.fn.detach=c.fn.remove,["width","height"].forEach(function(b){c.fn[b]=function(d){var e,f=this[0],g=b.replace(/./,function(a){return a[0].toUpperCase()});return d===a?G(f)?f["inner"+g]:H(f)?f.documentElement["offset"+g]:(e=this.offset())&&e[b]:this.each(function(a){f=c(this),f.css(b,V(this,d,a,f[b]()))})}}),q.forEach(function(a,b){var d=b%2;c.fn[a]=function(){var a,e=c.map(arguments,function(b){return a=E(b),a=="object"||a=="array"||b==null?b:A.fragment(b)}),f,g=this.length>1;return e.length<1?this:this.each(function(a,h){f=d?h:h.parentNode,h=b==0?h.nextSibling:b==1?h.firstChild:b==2?h:null,e.forEach(function(a){if(g)a=a.cloneNode(!0);else if(!f)return c(a).remove();Z(f.insertBefore(a,h),function(a){a.nodeName!=null&&a.nodeName.toUpperCase()==="SCRIPT"&&(!a.type||a.type==="text/javascript")&&!a.src&&window.eval.call(window,a.innerHTML)})})})},c.fn[d?a+"To":"insert"+(b?"Before":"After")]=function(b){return c(b)[a](this),this}}),A.Z.prototype=c.fn,A.uniq=C,A.deserializeValue=Y,c.zepto=A,c}();window.Zepto=Zepto,"$"in window||(window.$=Zepto),function(a){function b(a){var b=this.os={},c=this.browser={},d=a.match(/WebKit\/([\d.]+)/),e=a.match(/(Android)\s+([\d.]+)/),f=a.match(/(iPad).*OS\s([\d_]+)/),g=!f&&a.match(/(iPhone\sOS)\s([\d_]+)/),h=a.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),i=h&&a.match(/TouchPad/),j=a.match(/Kindle\/([\d.]+)/),k=a.match(/Silk\/([\d._]+)/),l=a.match(/(BlackBerry).*Version\/([\d.]+)/),m=a.match(/(BB10).*Version\/([\d.]+)/),n=a.match(/(RIM\sTablet\sOS)\s([\d.]+)/),o=a.match(/PlayBook/),p=a.match(/Chrome\/([\d.]+)/)||a.match(/CriOS\/([\d.]+)/),q=a.match(/Firefox\/([\d.]+)/);if(c.webkit=!!d)c.version=d[1];e&&(b.android=!0,b.version=e[2]),g&&(b.ios=b.iphone=!0,b.version=g[2].replace(/_/g,".")),f&&(b.ios=b.ipad=!0,b.version=f[2].replace(/_/g,".")),h&&(b.webos=!0,b.version=h[2]),i&&(b.touchpad=!0),l&&(b.blackberry=!0,b.version=l[2]),m&&(b.bb10=!0,b.version=m[2]),n&&(b.rimtabletos=!0,b.version=n[2]),o&&(c.playbook=!0),j&&(b.kindle=!0,b.version=j[1]),k&&(c.silk=!0,c.version=k[1]),!k&&b.android&&a.match(/Kindle Fire/)&&(c.silk=!0),p&&(c.chrome=!0,c.version=p[1]),q&&(c.firefox=!0,c.version=q[1]),b.tablet=!!(f||o||e&&!a.match(/Mobile/)||q&&a.match(/Tablet/)),b.phone=!b.tablet&&!!(e||g||h||l||m||p&&a.match(/Android/)||p&&a.match(/CriOS\/([\d.]+)/)||q&&a.match(/Mobile/))}b.call(a,navigator.userAgent),a.__detect=b}(Zepto),function(a){function g(a){return a._zid||(a._zid=d++)}function h(a,b,d,e){b=i(b);if(b.ns)var f=j(b.ns);return(c[g(a)]||[]).filter(function(a){return a&&(!b.e||a.e==b.e)&&(!b.ns||f.test(a.ns))&&(!d||g(a.fn)===g(d))&&(!e||a.sel==e)})}function i(a){var b=(""+a).split(".");return{e:b[0],ns:b.slice(1).sort().join(" ")}}function j(a){return new RegExp("(?:^| )"+a.replace(" "," .* ?")+"(?: |$)")}function k(b,c,d){a.type(b)!="string"?a.each(b,d):b.split(/\s/).forEach(function(a){d(a,c)})}function l(a,b){return a.del&&(a.e=="focus"||a.e=="blur")||!!b}function m(a){return f[a]||a}function n(b,d,e,h,j,n){var o=g(b),p=c[o]||(c[o]=[]);k(d,e,function(c,d){var e=i(c);e.fn=d,e.sel=h,e.e in f&&(d=function(b){var c=b.relatedTarget;if(!c||c!==this&&!a.contains(this,c))return e.fn.apply(this,arguments)}),e.del=j&&j(d,c);var g=e.del||d;e.proxy=function(a){var c=g.apply(b,[a].concat(a.data));return c===!1&&(a.preventDefault(),a.stopPropagation()),c},e.i=p.length,p.push(e),b.addEventListener(m(e.e),e.proxy,l(e,n))})}function o(a,b,d,e,f){var i=g(a);k(b||"",d,function(b,d){h(a,b,d,e).forEach(function(b){delete c[i][b.i],a.removeEventListener(m(b.e),b.proxy,l(b,f))})})}function t(b){var c,d={originalEvent:b};for(c in b)!r.test(c)&&b[c]!==undefined&&(d[c]=b[c]);return a.each(s,function(a,c){d[a]=function(){return this[c]=p,b[a].apply(b,arguments)},d[c]=q}),d}function u(a){if(!("defaultPrevented"in a)){a.defaultPrevented=!1;var b=a.preventDefault;a.preventDefault=function(){this.defaultPrevented=!0,b.call(this)}}}var b=a.zepto.qsa,c={},d=1,e={},f={mouseenter:"mouseover",mouseleave:"mouseout"};e.click=e.mousedown=e.mouseup=e.mousemove="MouseEvents",a.event={add:n,remove:o},a.proxy=function(b,c){if(a.isFunction(b)){var d=function(){return b.apply(c,arguments)};return d._zid=g(b),d}if(typeof c=="string")return a.proxy(b[c],b);throw new TypeError("expected function")},a.fn.bind=function(a,b){return this.each(function(){n(this,a,b)})},a.fn.unbind=function(a,b){return this.each(function(){o(this,a,b)})},a.fn.one=function(a,b){return this.each(function(c,d){n(this,a,b,null,function(a,b){return function(){var c=a.apply(d,arguments);return o(d,b,a),c}})})};var p=function(){return!0},q=function(){return!1},r=/^([A-Z]|layer[XY]$)/,s={preventDefault:"isDefaultPrevented",stopImmediatePropagation:"isImmediatePropagationStopped",stopPropagation:"isPropagationStopped"};a.fn.delegate=function(b,c,d){return this.each(function(e,f){n(f,c,d,b,function(c){return function(d){var e,g=a(d.target).closest(b,f).get(0);if(g)return e=a.extend(t(d),{currentTarget:g,liveFired:f}),c.apply(g,[e].concat([].slice.call(arguments,1)))}})})},a.fn.undelegate=function(a,b,c){return this.each(function(){o(this,b,c,a)})},a.fn.live=function(b,c){return a(document.body).delegate(this.selector,b,c),this},a.fn.die=function(b,c){return a(document.body).undelegate(this.selector,b,c),this},a.fn.on=function(b,c,d){return!c||a.isFunction(c)?this.bind(b,c||d):this.delegate(c,b,d)},a.fn.off=function(b,c,d){return!c||a.isFunction(c)?this.unbind(b,c||d):this.undelegate(c,b,d)},a.fn.trigger=function(b,c){if(typeof b=="string"||a.isPlainObject(b))b=a.Event(b);return u(b),b.data=c,this.each(function(){"dispatchEvent"in this&&this.dispatchEvent(b)})},a.fn.triggerHandler=function(b,c){var d,e;return this.each(function(f,g){d=t(typeof b=="string"?a.Event(b):b),d.data=c,d.target=g,a.each(h(g,b.type||b),function(a,b){e=b.proxy(d);if(d.isImmediatePropagationStopped())return!1})}),e},"focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error".split(" ").forEach(function(b){a.fn[b]=function(a){return a?this.bind(b,a):this.trigger(b)}}),["focus","blur"].forEach(function(b){a.fn[b]=function(a){return a?this.bind(b,a):this.each(function(){try{this[b]()}catch(a){}}),this}}),a.Event=function(a,b){typeof a!="string"&&(b=a,a=b.type);var c=document.createEvent(e[a]||"Events"),d=!0;if(b)for(var f in b)f=="bubbles"?d=!!b[f]:c[f]=b[f];return c.initEvent(a,d,!0,null,null,null,null,null,null,null,null,null,null,null,null),c.isDefaultPrevented=function(){return this.defaultPrevented},c}}(Zepto),function($){function triggerAndReturn(a,b,c){var d=$.Event(b);return $(a).trigger(d,c),!d.defaultPrevented}function triggerGlobal(a,b,c,d){if(a.global)return triggerAndReturn(b||document,c,d)}function ajaxStart(a){a.global&&$.active++===0&&triggerGlobal(a,null,"ajaxStart")}function ajaxStop(a){a.global&&!--$.active&&triggerGlobal(a,null,"ajaxStop")}function ajaxBeforeSend(a,b){var c=b.context;if(b.beforeSend.call(c,a,b)===!1||triggerGlobal(b,c,"ajaxBeforeSend",[a,b])===!1)return!1;triggerGlobal(b,c,"ajaxSend",[a,b])}function ajaxSuccess(a,b,c){var d=c.context,e="success";c.success.call(d,a,e,b),triggerGlobal(c,d,"ajaxSuccess",[b,c,a]),ajaxComplete(e,b,c)}function ajaxError(a,b,c,d){var e=d.context;d.error.call(e,c,b,a),triggerGlobal(d,e,"ajaxError",[c,d,a]),ajaxComplete(b,c,d)}function ajaxComplete(a,b,c){var d=c.context;c.complete.call(d,b,a),triggerGlobal(c,d,"ajaxComplete",[b,c]),ajaxStop(c)}function empty(){}function mimeToDataType(a){return a&&(a=a.split(";",2)[0]),a&&(a==htmlType?"html":a==jsonType?"json":scriptTypeRE.test(a)?"script":xmlTypeRE.test(a)&&"xml")||"text"}function appendQuery(a,b){return(a+"&"+b).replace(/[&?]{1,2}/,"?")}function serializeData(a){a.processData&&a.data&&$.type(a.data)!="string"&&(a.data=$.param(a.data,a.traditional)),a.data&&(!a.type||a.type.toUpperCase()=="GET")&&(a.url=appendQuery(a.url,a.data))}function parseArguments(a,b,c,d){var e=!$.isFunction(b);return{url:a,data:e?b:undefined,success:e?$.isFunction(c)?c:undefined:b,dataType:e?d||c:c}}function serialize(a,b,c,d){var e,f=$.isArray(b);$.each(b,function(b,g){e=$.type(g),d&&(b=c?d:d+"["+(f?"":b)+"]"),!d&&f?a.add(g.name,g.value):e=="array"||!c&&e=="object"?serialize(a,g,c,b):a.add(b,g)})}var jsonpID=0,document=window.document,key,name,rscript=/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,scriptTypeRE=/^(?:text|application)\/javascript/i,xmlTypeRE=/^(?:text|application)\/xml/i,jsonType="application/json",htmlType="text/html",blankRE=/^\s*$/;$.active=0,$.ajaxJSONP=function(a){if("type"in a){var b="jsonp"+ ++jsonpID,c=document.createElement("script"),d=function(){clearTimeout(g),$(c).remove(),delete window[b]},e=function(c){d();if(!c||c=="timeout")window[b]=empty;ajaxError(null,c||"abort",f,a)},f={abort:e},g;return ajaxBeforeSend(f,a)===!1?(e("abort"),!1):(window[b]=function(b){d(),ajaxSuccess(b,f,a)},c.onerror=function(){e("error")},c.src=a.url.replace(/=\?/,"="+b),$("head").append(c),a.timeout>0&&(g=setTimeout(function(){e("timeout")},a.timeout)),f)}return $.ajax(a)},$.ajaxSettings={type:"GET",beforeSend:empty,success:empty,error:empty,complete:empty,context:null,global:!0,xhr:function(){return new window.XMLHttpRequest},accepts:{script:"text/javascript, application/javascript",json:jsonType,xml:"application/xml, text/xml",html:htmlType,text:"text/plain"},crossDomain:!1,timeout:0,processData:!0,cache:!0},$.ajax=function(options){var settings=$.extend({},options||{});for(key in $.ajaxSettings)settings[key]===undefined&&(settings[key]=$.ajaxSettings[key]);ajaxStart(settings),settings.crossDomain||(settings.crossDomain=/^([\w-]+:)?\/\/([^\/]+)/.test(settings.url)&&RegExp.$2!=window.location.host),settings.url||(settings.url=window.location.toString()),serializeData(settings),settings.cache===!1&&(settings.url=appendQuery(settings.url,"_="+Date.now()));var dataType=settings.dataType,hasPlaceholder=/=\?/.test(settings.url);if(dataType=="jsonp"||hasPlaceholder)return hasPlaceholder||(settings.url=appendQuery(settings.url,"callback=?")),$.ajaxJSONP(settings);var mime=settings.accepts[dataType],baseHeaders={},protocol=/^([\w-]+:)\/\//.test(settings.url)?RegExp.$1:window.location.protocol,xhr=settings.xhr(),abortTimeout;settings.crossDomain||(baseHeaders["X-Requested-With"]="XMLHttpRequest"),mime&&(baseHeaders.Accept=mime,mime.indexOf(",")>-1&&(mime=mime.split(",",2)[0]),xhr.overrideMimeType&&xhr.overrideMimeType(mime));if(settings.contentType||settings.contentType!==!1&&settings.data&&settings.type.toUpperCase()!="GET")baseHeaders["Content-Type"]=settings.contentType||"application/x-www-form-urlencoded";settings.headers=$.extend(baseHeaders,settings.headers||{}),xhr.onreadystatechange=function(){if(xhr.readyState==4){xhr.onreadystatechange=empty,clearTimeout(abortTimeout);var result,error=!1;if(xhr.status>=200&&xhr.status<300||xhr.status==304||xhr.status==0&&protocol=="file:"){dataType=dataType||mimeToDataType(xhr.getResponseHeader("content-type")),result=xhr.responseText;try{dataType=="script"?(1,eval)(result):dataType=="xml"?result=xhr.responseXML:dataType=="json"&&(result=blankRE.test(result)?null:$.parseJSON(result))}catch(e){error=e}error?ajaxError(error,"parsererror",xhr,settings):ajaxSuccess(result,xhr,settings)}else ajaxError(null,xhr.status?"error":"abort",xhr,settings)}};var async="async"in settings?settings.async:!0;xhr.open(settings.type,settings.url,async);for(name in settings.headers)xhr.setRequestHeader(name,settings.headers[name]);return ajaxBeforeSend(xhr,settings)===!1?(xhr.abort(),!1):(settings.timeout>0&&(abortTimeout=setTimeout(function(){xhr.onreadystatechange=empty,xhr.abort(),ajaxError(null,"timeout",xhr,settings)},settings.timeout)),xhr.send(settings.data?settings.data:null),xhr)},$.get=function(a,b,c,d){return $.ajax(parseArguments.apply(null,arguments))},$.post=function(a,b,c,d){var e=parseArguments.apply(null,arguments);return e.type="POST",$.ajax(e)},$.getJSON=function(a,b,c){var d=parseArguments.apply(null,arguments);return d.dataType="json",$.ajax(d)},$.fn.load=function(a,b,c){if(!this.length)return this;var d=this,e=a.split(/\s/),f,g=parseArguments(a,b,c),h=g.success;return e.length>1&&(g.url=e[0],f=e[1]),g.success=function(a){d.html(f?$("<div>").html(a.replace(rscript,"")).find(f):a),h&&h.apply(d,arguments)},$.ajax(g),this};var escape=encodeURIComponent;$.param=function(a,b){var c=[];return c.add=function(a,b){this.push(escape(a)+"="+escape(b))},serialize(c,a,b),c.join("&").replace(/%20/g,"+")}}(Zepto),function(a){a.fn.serializeArray=function(){var b=[],c;return a(Array.prototype.slice.call(this.get(0).elements)).each(function(){c=a(this);var d=c.attr("type");this.nodeName.toLowerCase()!="fieldset"&&!this.disabled&&d!="submit"&&d!="reset"&&d!="button"&&(d!="radio"&&d!="checkbox"||this.checked)&&b.push({name:c.attr("name"),value:c.val()})}),b},a.fn.serialize=function(){var a=[];return this.serializeArray().forEach(function(b){a.push(encodeURIComponent(b.name)+"="+encodeURIComponent(b.value))}),a.join("&")},a.fn.submit=function(b){if(b)this.bind("submit",b);else if(this.length){var c=a.Event("submit");this.eq(0).trigger(c),c.defaultPrevented||this.get(0).submit()}return this}}(Zepto),function(a,b){function s(a){return t(a.replace(/([a-z])([A-Z])/,"$1-$2"))}function t(a){return a.toLowerCase()}function u(a){return d?d+a:t(a)}var c="",d,e,f,g={Webkit:"webkit",Moz:"",O:"o",ms:"MS"},h=window.document,i=h.createElement("div"),j=/^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i,k,l,m,n,o,p,q,r={};a.each(g,function(a,e){if(i.style[a+"TransitionProperty"]!==b)return c="-"+t(a)+"-",d=e,!1}),k=c+"transform",r[l=c+"transition-property"]=r[m=c+"transition-duration"]=r[n=c+"transition-timing-function"]=r[o=c+"animation-name"]=r[p=c+"animation-duration"]=r[q=c+"animation-timing-function"]="",a.fx={off:d===b&&i.style.transitionProperty===b,speeds:{_default:400,fast:200,slow:600},cssPrefix:c,transitionEnd:u("TransitionEnd"),animationEnd:u("AnimationEnd")},a.fn.animate=function(b,c,d,e){return a.isPlainObject(c)&&(d=c.easing,e=c.complete,c=c.duration),c&&(c=(typeof c=="number"?c:a.fx.speeds[c]||a.fx.speeds._default)/1e3),this.anim(b,c,d,e)},a.fn.anim=function(c,d,e,f){var g,h={},i,t="",u=this,v,w=a.fx.transitionEnd;d===b&&(d=.4),a.fx.off&&(d=0);if(typeof c=="string")h[o]=c,h[p]=d+"s",h[q]=e||"linear",w=a.fx.animationEnd;else{i=[];for(g in c)j.test(g)?t+=g+"("+c[g]+") ":(h[g]=c[g],i.push(s(g)));t&&(h[k]=t,i.push(k)),d>0&&typeof c=="object"&&(h[l]=i.join(", "),h[m]=d+"s",h[n]=e||"linear")}return v=function(b){if(typeof b!="undefined"){if(b.target!==b.currentTarget)return;a(b.target).unbind(w,v)}a(this).css(r),f&&f.call(this)},d>0&&this.bind(w,v),this.size()&&this.get(0).clientLeft,this.css(h),d<=0&&setTimeout(function(){u.each(function(){v.call(this)})},0),this},i=null}(Zepto)

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	"use strict";

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	module.exports = " <div class=pages> <router-view keep-alive></router-view> </div> ";

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(136)
	__vue_script__ = __webpack_require__(124)
	__vue_template__ = __webpack_require__(143)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 153:
/***/ (function(module, exports) {

	/*!
	 * vue-resource v0.7.4
	 * https://github.com/vuejs/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	/**
	 * Utility functions.
	 */
	
	var util = {};
	var config = {};
	var array = [];
	var console = window.console;
	function Util (Vue) {
	    util = Vue.util;
	    config = Vue.config;
	}
	
	var isArray = Array.isArray;
	
	function warn(msg) {
	    if (console && util.warn && (!config.silent || config.debug)) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (console) {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return util.nextTick(cb, ctx);
	}
	
	function trim(str) {
	    return str.replace(/^\s*|\s*$/g, '');
	}
	
	function toLower(str) {
	    return str ? str.toLowerCase() : '';
	}
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({ $vm: obj, $options: opts }), fn, { $options: opts });
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (typeof obj.length == 'number') {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	function extend(target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (arg) {
	        _merge(target, arg);
	    });
	
	    return target;
	}
	
	function merge(target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (arg) {
	        _merge(target, arg, true);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	function root (options, next) {
	
	    var url = next(options);
	
	    if (isString(options.root) && !url.match(/^(https?:)?\//)) {
	        url = options.root + '/' + url;
	    }
	
	    return url;
	}
	
	function query (options, next) {
	
	    var urlParams = Object.keys(Url.options.params),
	        query = {},
	        url = next(options);
	
	    each(options.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	}
	
	function legacy (options, next) {
	
	    var variables = [],
	        url = next(options);
	
	    url = url.replace(/(\/?):([a-z]\w*)/gi, function (match, slash, name) {
	
	        warn('The `:' + name + '` parameter syntax has been deprecated. Use the `{' + name + '}` syntax instead.');
	
	        if (options.params[name]) {
	            variables.push(name);
	            return slash + encodeUriSegment(options.params[name]);
	        }
	
	        return '';
	    });
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	function encodeUriSegment(value) {
	
	    return encodeUriQuery(value, true).replace(/%26/gi, '&').replace(/%3D/gi, '=').replace(/%2B/gi, '+');
	}
	
	function encodeUriQuery(value, spaces) {
	
	    return encodeURIComponent(value).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, spaces ? '%20' : '+');
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url),
	        expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'],
	        variables = [];
	
	    return {
	        vars: variables,
	        expand: function expand(context) {
	            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null,
	                        values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key],
	        result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	function template (options) {
	
	    var variables = [],
	        url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	
	var ie = document.documentMode;
	var el = document.createElement('a');
	
	function Url(url, params) {
	
	    var self = this || {},
	        options = url,
	        transform;
	
	    if (isString(url)) {
	        options = { url: url, params: params };
	    }
	
	    options = merge({}, Url.options, self.$options, options);
	
	    Url.transforms.forEach(function (handler) {
	        transform = factory(handler, transform, self.$vm);
	    });
	
	    return transform(options);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transforms = [template, legacy, query, root];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [],
	        escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    if (ie) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options) {
	        return handler.call(vm, options, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj),
	        plain = isPlainObject(obj),
	        hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	
	function Promise$2(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$2.reject = function (r) {
	    return new Promise$2(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$2.resolve = function (x) {
	    return new Promise$2(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$2.all = function all(iterable) {
	    return new Promise$2(function (resolve, reject) {
	        var count = 0,
	            result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$2.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$2.race = function race(iterable) {
	    return new Promise$2(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$2.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p$1 = Promise$2.prototype;
	
	p$1.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p$1.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p$1.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p$1.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$2(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p$1.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	var PromiseObj = window.Promise || Promise$2;
	
	function Promise$1(executor, context) {
	
	    if (executor instanceof PromiseObj) {
	        this.promise = executor;
	    } else {
	        this.promise = new PromiseObj(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	Promise$1.all = function (iterable, context) {
	    return new Promise$1(PromiseObj.all(iterable), context);
	};
	
	Promise$1.resolve = function (value, context) {
	    return new Promise$1(PromiseObj.resolve(value), context);
	};
	
	Promise$1.reject = function (reason, context) {
	    return new Promise$1(PromiseObj.reject(reason), context);
	};
	
	Promise$1.race = function (iterable, context) {
	    return new Promise$1(PromiseObj.race(iterable), context);
	};
	
	var p = Promise$1.prototype;
	
	p.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    this.promise = this.promise.then(fulfilled, rejected);
	
	    return this;
	};
	
	p.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    this.promise = this.promise.catch(rejected);
	
	    return this;
	};
	
	p.finally = function (callback) {
	
	    return this.then(function (value) {
	        callback.call(this);
	        return value;
	    }, function (reason) {
	        callback.call(this);
	        return PromiseObj.reject(reason);
	    });
	};
	
	p.success = function (callback) {
	
	    warn('The `success` method has been deprecated. Use the `then` method instead.');
	
	    return this.then(function (response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    });
	};
	
	p.error = function (callback) {
	
	    warn('The `error` method has been deprecated. Use the `catch` method instead.');
	
	    return this.catch(function (response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    });
	};
	
	p.always = function (callback) {
	
	    warn('The `always` method has been deprecated. Use the `finally` method instead.');
	
	    var cb = function cb(response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    };
	
	    return this.then(cb, cb);
	};
	
	function xdrClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var xdr = new XDomainRequest(),
	            response = { request: request },
	            handler;
	
	        request.cancel = function () {
	            xdr.abort();
	        };
	
	        xdr.open(request.method, Url(request), true);
	
	        handler = function handler(event) {
	
	            response.data = xdr.responseText;
	            response.status = xdr.status;
	            response.statusText = xdr.statusText || '';
	
	            resolve(response);
	        };
	
	        xdr.timeout = 0;
	        xdr.onload = handler;
	        xdr.onabort = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = function () {};
	        xdr.onprogress = function () {};
	
	        xdr.send(request.data);
	    });
	}
	
	var originUrl = Url.parse(location.href);
	var supportCors = 'withCredentials' in new XMLHttpRequest();
	
	var exports$1 = {
	    request: function request(_request) {
	
	        if (_request.crossOrigin === null) {
	            _request.crossOrigin = crossOrigin(_request);
	        }
	
	        if (_request.crossOrigin) {
	
	            if (!supportCors) {
	                _request.client = xdrClient;
	            }
	
	            _request.emulateHTTP = false;
	        }
	
	        return _request;
	    }
	};
	
	function crossOrigin(request) {
	
	    var requestUrl = Url.parse(Url(request));
	
	    return requestUrl.protocol !== originUrl.protocol || requestUrl.host !== originUrl.host;
	}
	
	var exports$2 = {
	    request: function request(_request) {
	
	        if (_request.emulateJSON && isPlainObject(_request.data)) {
	            _request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	            _request.data = Url.params(_request.data);
	        }
	
	        if (isObject(_request.data) && /FormData/i.test(_request.data.toString())) {
	            delete _request.headers['Content-Type'];
	        }
	
	        if (isPlainObject(_request.data)) {
	            _request.data = JSON.stringify(_request.data);
	        }
	
	        return _request;
	    },
	    response: function response(_response) {
	
	        try {
	            _response.data = JSON.parse(_response.data);
	        } catch (e) {}
	
	        return _response;
	    }
	};
	
	function jsonpClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var callback = '_jsonp' + Math.random().toString(36).substr(2),
	            response = { request: request, data: null },
	            handler,
	            script;
	
	        request.params[request.jsonp] = callback;
	        request.cancel = function () {
	            handler({ type: 'cancel' });
	        };
	
	        script = document.createElement('script');
	        script.src = Url(request);
	        script.type = 'text/javascript';
	        script.async = true;
	
	        window[callback] = function (data) {
	            response.data = data;
	        };
	
	        handler = function handler(event) {
	
	            if (event.type === 'load' && response.data !== null) {
	                response.status = 200;
	            } else if (event.type === 'error') {
	                response.status = 404;
	            } else {
	                response.status = 0;
	            }
	
	            resolve(response);
	
	            delete window[callback];
	            document.body.removeChild(script);
	        };
	
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	}
	
	var exports$3 = {
	    request: function request(_request) {
	
	        if (_request.method == 'JSONP') {
	            _request.client = jsonpClient;
	        }
	
	        return _request;
	    }
	};
	
	var exports$4 = {
	    request: function request(_request) {
	
	        if (isFunction(_request.beforeSend)) {
	            _request.beforeSend.call(this, _request);
	        }
	
	        return _request;
	    }
	};
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	var exports$5 = {
	    request: function request(_request) {
	
	        if (_request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(_request.method)) {
	            _request.headers['X-HTTP-Method-Override'] = _request.method;
	            _request.method = 'POST';
	        }
	
	        return _request;
	    }
	};
	
	var exports$6 = {
	    request: function request(_request) {
	
	        _request.method = _request.method.toUpperCase();
	        _request.headers = extend({}, Http.headers.common, !_request.crossOrigin ? Http.headers.custom : {}, Http.headers[_request.method.toLowerCase()], _request.headers);
	
	        if (isPlainObject(_request.data) && /^(GET|JSONP)$/i.test(_request.method)) {
	            extend(_request.params, _request.data);
	            delete _request.data;
	        }
	
	        return _request;
	    }
	};
	
	/**
	 * Timeout Interceptor.
	 */
	
	var exports$7 = function exports() {
	
	    var timeout;
	
	    return {
	        request: function request(_request) {
	
	            if (_request.timeout) {
	                timeout = setTimeout(function () {
	                    _request.cancel();
	                }, _request.timeout);
	            }
	
	            return _request;
	        },
	        response: function response(_response) {
	
	            clearTimeout(timeout);
	
	            return _response;
	        }
	    };
	};
	
	function interceptor (handler, vm) {
	
	    return function (client) {
	
	        if (isFunction(handler)) {
	            handler = handler.call(vm, Promise$1);
	        }
	
	        return function (request) {
	
	            if (isFunction(handler.request)) {
	                request = handler.request.call(vm, request);
	            }
	
	            return when(request, function (request) {
	                return when(client(request), function (response) {
	
	                    if (isFunction(handler.response)) {
	                        response = handler.response.call(vm, response);
	                    }
	
	                    return response;
	                });
	            });
	        };
	    };
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = Promise$1.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function xhrClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var xhr = new XMLHttpRequest(),
	            response = { request: request },
	            handler;
	
	        request.cancel = function () {
	            xhr.abort();
	        };
	
	        xhr.open(request.method, Url(request), true);
	
	        handler = function handler(event) {
	
	            response.data = 'response' in xhr ? xhr.response : xhr.responseText;
	            response.status = xhr.status === 1223 ? 204 : xhr.status; // IE9 status bug
	            response.statusText = trim(xhr.statusText || '');
	            response.headers = xhr.getAllResponseHeaders();
	
	            resolve(response);
	        };
	
	        xhr.timeout = 0;
	        xhr.onload = handler;
	        xhr.onabort = handler;
	        xhr.onerror = handler;
	        xhr.ontimeout = function () {};
	        xhr.onprogress = function () {};
	
	        if (isPlainObject(request.xhr)) {
	            extend(xhr, request.xhr);
	        }
	
	        if (isPlainObject(request.upload)) {
	            extend(xhr.upload, request.upload);
	        }
	
	        each(request.headers || {}, function (value, header) {
	            xhr.setRequestHeader(header, value);
	        });
	
	        xhr.send(request.data);
	    });
	}
	
	function Client (request) {
	
	    var response = (request.client || xhrClient)(request);
	
	    return Promise$1.resolve(response).then(function (response) {
	
	        if (response.headers) {
	
	            var headers = parseHeaders(response.headers);
	
	            response.headers = function (name) {
	
	                if (name) {
	                    return headers[toLower(name)];
	                }
	
	                return headers;
	            };
	        }
	
	        response.ok = response.status >= 200 && response.status < 300;
	
	        return response;
	    });
	}
	
	function parseHeaders(str) {
	
	    var headers = {},
	        value,
	        name,
	        i;
	
	    if (isString(str)) {
	        each(str.split('\n'), function (row) {
	
	            i = row.indexOf(':');
	            name = trim(toLower(row.slice(0, i)));
	            value = trim(row.slice(i + 1));
	
	            if (headers[name]) {
	
	                if (isArray(headers[name])) {
	                    headers[name].push(value);
	                } else {
	                    headers[name] = [headers[name], value];
	                }
	            } else {
	
	                headers[name] = value;
	            }
	        });
	    }
	
	    return headers;
	}
	
	/**
	 * Service for sending network requests.
	 */
	
	var jsonType = { 'Content-Type': 'application/json' };
	
	function Http(url, options) {
	
	    var self = this || {},
	        client = Client,
	        request,
	        promise;
	
	    Http.interceptors.forEach(function (handler) {
	        client = interceptor(handler, self.$vm)(client);
	    });
	
	    options = isObject(url) ? url : extend({ url: url }, options);
	    request = merge({}, Http.options, self.$options, options);
	    promise = client(request).bind(self.$vm).then(function (response) {
	
	        return response.ok ? response : Promise$1.reject(response);
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return Promise$1.reject(response);
	    });
	
	    if (request.success) {
	        promise.success(request.success);
	    }
	
	    if (request.error) {
	        promise.error(request.error);
	    }
	
	    return promise;
	}
	
	Http.options = {
	    method: 'get',
	    data: '',
	    params: {},
	    headers: {},
	    xhr: null,
	    upload: null,
	    jsonp: 'callback',
	    beforeSend: null,
	    crossOrigin: null,
	    emulateHTTP: false,
	    emulateJSON: false,
	    timeout: 0
	};
	
	Http.headers = {
	    put: jsonType,
	    post: jsonType,
	    patch: jsonType,
	    delete: jsonType,
	    common: { 'Accept': 'application/json, text/plain, */*' },
	    custom: { 'X-Requested-With': 'XMLHttpRequest' }
	};
	
	Http.interceptors = [exports$4, exports$7, exports$3, exports$5, exports$2, exports$6, exports$1];
	
	['get', 'put', 'post', 'patch', 'delete', 'jsonp'].forEach(function (method) {
	
	    Http[method] = function (url, data, success, options) {
	
	        if (isFunction(data)) {
	            options = success;
	            success = data;
	            data = undefined;
	        }
	
	        if (isObject(success)) {
	            options = success;
	            success = undefined;
	        }
	
	        return this(url, extend({ method: method, data: data, success: success }, options));
	    };
	});
	
	function Resource(url, params, actions, options) {
	
	    var self = this || {},
	        resource = {};
	
	    actions = extend({}, Resource.actions, actions);
	
	    each(actions, function (action, name) {
	
	        action = merge({ url: url, params: params || {} }, options, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options = extend({}, action),
	        params = {},
	        data,
	        success,
	        error;
	
	    switch (args.length) {
	
	        case 4:
	
	            error = args[3];
	            success = args[2];
	
	        case 3:
	        case 2:
	
	            if (isFunction(args[1])) {
	
	                if (isFunction(args[0])) {
	
	                    success = args[0];
	                    error = args[1];
	
	                    break;
	                }
	
	                success = args[1];
	                error = args[2];
	            } else {
	
	                params = args[0];
	                data = args[1];
	                success = args[2];
	
	                break;
	            }
	
	        case 1:
	
	            if (isFunction(args[0])) {
	                success = args[0];
	            } else if (/^(POST|PUT|PATCH)$/i.test(options.method)) {
	                data = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 4 arguments [params, data, success, error], got ' + args.length + ' arguments';
	    }
	
	    options.data = data;
	    options.params = extend({}, options.params, params);
	
	    if (success) {
	        options.success = success;
	    }
	
	    if (error) {
	        options.error = error;
	    }
	
	    return options;
	}
	
	Resource.actions = {
	
	    get: { method: 'GET' },
	    save: { method: 'POST' },
	    query: { method: 'GET' },
	    update: { method: 'PUT' },
	    remove: { method: 'DELETE' },
	    delete: { method: 'DELETE' }
	
	};
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = Promise$1;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function get() {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function get() {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function get() {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function get() {
	                var _this = this;
	
	                return function (executor) {
	                    return new Vue.Promise(executor, _this);
	                };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-router v0.7.13
	 * (c) 2016 Evan You
	 * Released under the MIT License.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.VueRouter = factory();
	}(this, function () { 'use strict';
	
	  var babelHelpers = {};
	
	  babelHelpers.classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	  function Target(path, matcher, delegate) {
	    this.path = path;
	    this.matcher = matcher;
	    this.delegate = delegate;
	  }
	
	  Target.prototype = {
	    to: function to(target, callback) {
	      var delegate = this.delegate;
	
	      if (delegate && delegate.willAddRoute) {
	        target = delegate.willAddRoute(this.matcher.target, target);
	      }
	
	      this.matcher.add(this.path, target);
	
	      if (callback) {
	        if (callback.length === 0) {
	          throw new Error("You must have an argument in the function passed to `to`");
	        }
	        this.matcher.addChild(this.path, target, callback, this.delegate);
	      }
	      return this;
	    }
	  };
	
	  function Matcher(target) {
	    this.routes = {};
	    this.children = {};
	    this.target = target;
	  }
	
	  Matcher.prototype = {
	    add: function add(path, handler) {
	      this.routes[path] = handler;
	    },
	
	    addChild: function addChild(path, target, callback, delegate) {
	      var matcher = new Matcher(target);
	      this.children[path] = matcher;
	
	      var match = generateMatch(path, matcher, delegate);
	
	      if (delegate && delegate.contextEntered) {
	        delegate.contextEntered(target, match);
	      }
	
	      callback(match);
	    }
	  };
	
	  function generateMatch(startingPath, matcher, delegate) {
	    return function (path, nestedCallback) {
	      var fullPath = startingPath + path;
	
	      if (nestedCallback) {
	        nestedCallback(generateMatch(fullPath, matcher, delegate));
	      } else {
	        return new Target(startingPath + path, matcher, delegate);
	      }
	    };
	  }
	
	  function addRoute(routeArray, path, handler) {
	    var len = 0;
	    for (var i = 0, l = routeArray.length; i < l; i++) {
	      len += routeArray[i].path.length;
	    }
	
	    path = path.substr(len);
	    var route = { path: path, handler: handler };
	    routeArray.push(route);
	  }
	
	  function eachRoute(baseRoute, matcher, callback, binding) {
	    var routes = matcher.routes;
	
	    for (var path in routes) {
	      if (routes.hasOwnProperty(path)) {
	        var routeArray = baseRoute.slice();
	        addRoute(routeArray, path, routes[path]);
	
	        if (matcher.children[path]) {
	          eachRoute(routeArray, matcher.children[path], callback, binding);
	        } else {
	          callback.call(binding, routeArray);
	        }
	      }
	    }
	  }
	
	  function map (callback, addRouteCallback) {
	    var matcher = new Matcher();
	
	    callback(generateMatch("", matcher, this.delegate));
	
	    eachRoute([], matcher, function (route) {
	      if (addRouteCallback) {
	        addRouteCallback(this, route);
	      } else {
	        this.add(route);
	      }
	    }, this);
	  }
	
	  var specials = ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'];
	
	  var escapeRegex = new RegExp('(\\' + specials.join('|\\') + ')', 'g');
	
	  var noWarning = false;
	  function warn(msg) {
	    if (!noWarning && typeof console !== 'undefined') {
	      console.error('[vue-router] ' + msg);
	    }
	  }
	
	  function tryDecode(uri, asComponent) {
	    try {
	      return asComponent ? decodeURIComponent(uri) : decodeURI(uri);
	    } catch (e) {
	      warn('malformed URI' + (asComponent ? ' component: ' : ': ') + uri);
	    }
	  }
	
	  function isArray(test) {
	    return Object.prototype.toString.call(test) === "[object Array]";
	  }
	
	  // A Segment represents a segment in the original route description.
	  // Each Segment type provides an `eachChar` and `regex` method.
	  //
	  // The `eachChar` method invokes the callback with one or more character
	  // specifications. A character specification consumes one or more input
	  // characters.
	  //
	  // The `regex` method returns a regex fragment for the segment. If the
	  // segment is a dynamic of star segment, the regex fragment also includes
	  // a capture.
	  //
	  // A character specification contains:
	  //
	  // * `validChars`: a String with a list of all valid characters, or
	  // * `invalidChars`: a String with a list of all invalid characters
	  // * `repeat`: true if the character specification can repeat
	
	  function StaticSegment(string) {
	    this.string = string;
	  }
	  StaticSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      var string = this.string,
	          ch;
	
	      for (var i = 0, l = string.length; i < l; i++) {
	        ch = string.charAt(i);
	        callback({ validChars: ch });
	      }
	    },
	
	    regex: function regex() {
	      return this.string.replace(escapeRegex, '\\$1');
	    },
	
	    generate: function generate() {
	      return this.string;
	    }
	  };
	
	  function DynamicSegment(name) {
	    this.name = name;
	  }
	  DynamicSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      callback({ invalidChars: "/", repeat: true });
	    },
	
	    regex: function regex() {
	      return "([^/]+)";
	    },
	
	    generate: function generate(params) {
	      var val = params[this.name];
	      return val == null ? ":" + this.name : val;
	    }
	  };
	
	  function StarSegment(name) {
	    this.name = name;
	  }
	  StarSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      callback({ invalidChars: "", repeat: true });
	    },
	
	    regex: function regex() {
	      return "(.+)";
	    },
	
	    generate: function generate(params) {
	      var val = params[this.name];
	      return val == null ? ":" + this.name : val;
	    }
	  };
	
	  function EpsilonSegment() {}
	  EpsilonSegment.prototype = {
	    eachChar: function eachChar() {},
	    regex: function regex() {
	      return "";
	    },
	    generate: function generate() {
	      return "";
	    }
	  };
	
	  function parse(route, names, specificity) {
	    // normalize route as not starting with a "/". Recognition will
	    // also normalize.
	    if (route.charAt(0) === "/") {
	      route = route.substr(1);
	    }
	
	    var segments = route.split("/"),
	        results = [];
	
	    // A routes has specificity determined by the order that its different segments
	    // appear in. This system mirrors how the magnitude of numbers written as strings
	    // works.
	    // Consider a number written as: "abc". An example would be "200". Any other number written
	    // "xyz" will be smaller than "abc" so long as `a > z`. For instance, "199" is smaller
	    // then "200", even though "y" and "z" (which are both 9) are larger than "0" (the value
	    // of (`b` and `c`). This is because the leading symbol, "2", is larger than the other
	    // leading symbol, "1".
	    // The rule is that symbols to the left carry more weight than symbols to the right
	    // when a number is written out as a string. In the above strings, the leading digit
	    // represents how many 100's are in the number, and it carries more weight than the middle
	    // number which represents how many 10's are in the number.
	    // This system of number magnitude works well for route specificity, too. A route written as
	    // `a/b/c` will be more specific than `x/y/z` as long as `a` is more specific than
	    // `x`, irrespective of the other parts.
	    // Because of this similarity, we assign each type of segment a number value written as a
	    // string. We can find the specificity of compound routes by concatenating these strings
	    // together, from left to right. After we have looped through all of the segments,
	    // we convert the string to a number.
	    specificity.val = '';
	
	    for (var i = 0, l = segments.length; i < l; i++) {
	      var segment = segments[i],
	          match;
	
	      if (match = segment.match(/^:([^\/]+)$/)) {
	        results.push(new DynamicSegment(match[1]));
	        names.push(match[1]);
	        specificity.val += '3';
	      } else if (match = segment.match(/^\*([^\/]+)$/)) {
	        results.push(new StarSegment(match[1]));
	        specificity.val += '2';
	        names.push(match[1]);
	      } else if (segment === "") {
	        results.push(new EpsilonSegment());
	        specificity.val += '1';
	      } else {
	        results.push(new StaticSegment(segment));
	        specificity.val += '4';
	      }
	    }
	
	    specificity.val = +specificity.val;
	
	    return results;
	  }
	
	  // A State has a character specification and (`charSpec`) and a list of possible
	  // subsequent states (`nextStates`).
	  //
	  // If a State is an accepting state, it will also have several additional
	  // properties:
	  //
	  // * `regex`: A regular expression that is used to extract parameters from paths
	  //   that reached this accepting state.
	  // * `handlers`: Information on how to convert the list of captures into calls
	  //   to registered handlers with the specified parameters
	  // * `types`: How many static, dynamic or star segments in this route. Used to
	  //   decide which route to use if multiple registered routes match a path.
	  //
	  // Currently, State is implemented naively by looping over `nextStates` and
	  // comparing a character specification against a character. A more efficient
	  // implementation would use a hash of keys pointing at one or more next states.
	
	  function State(charSpec) {
	    this.charSpec = charSpec;
	    this.nextStates = [];
	  }
	
	  State.prototype = {
	    get: function get(charSpec) {
	      var nextStates = this.nextStates;
	
	      for (var i = 0, l = nextStates.length; i < l; i++) {
	        var child = nextStates[i];
	
	        var isEqual = child.charSpec.validChars === charSpec.validChars;
	        isEqual = isEqual && child.charSpec.invalidChars === charSpec.invalidChars;
	
	        if (isEqual) {
	          return child;
	        }
	      }
	    },
	
	    put: function put(charSpec) {
	      var state;
	
	      // If the character specification already exists in a child of the current
	      // state, just return that state.
	      if (state = this.get(charSpec)) {
	        return state;
	      }
	
	      // Make a new state for the character spec
	      state = new State(charSpec);
	
	      // Insert the new state as a child of the current state
	      this.nextStates.push(state);
	
	      // If this character specification repeats, insert the new state as a child
	      // of itself. Note that this will not trigger an infinite loop because each
	      // transition during recognition consumes a character.
	      if (charSpec.repeat) {
	        state.nextStates.push(state);
	      }
	
	      // Return the new state
	      return state;
	    },
	
	    // Find a list of child states matching the next character
	    match: function match(ch) {
	      // DEBUG "Processing `" + ch + "`:"
	      var nextStates = this.nextStates,
	          child,
	          charSpec,
	          chars;
	
	      // DEBUG "  " + debugState(this)
	      var returned = [];
	
	      for (var i = 0, l = nextStates.length; i < l; i++) {
	        child = nextStates[i];
	
	        charSpec = child.charSpec;
	
	        if (typeof (chars = charSpec.validChars) !== 'undefined') {
	          if (chars.indexOf(ch) !== -1) {
	            returned.push(child);
	          }
	        } else if (typeof (chars = charSpec.invalidChars) !== 'undefined') {
	          if (chars.indexOf(ch) === -1) {
	            returned.push(child);
	          }
	        }
	      }
	
	      return returned;
	    }
	
	    /** IF DEBUG
	    , debug: function() {
	      var charSpec = this.charSpec,
	          debug = "[",
	          chars = charSpec.validChars || charSpec.invalidChars;
	       if (charSpec.invalidChars) { debug += "^"; }
	      debug += chars;
	      debug += "]";
	       if (charSpec.repeat) { debug += "+"; }
	       return debug;
	    }
	    END IF **/
	  };
	
	  /** IF DEBUG
	  function debug(log) {
	    console.log(log);
	  }
	
	  function debugState(state) {
	    return state.nextStates.map(function(n) {
	      if (n.nextStates.length === 0) { return "( " + n.debug() + " [accepting] )"; }
	      return "( " + n.debug() + " <then> " + n.nextStates.map(function(s) { return s.debug() }).join(" or ") + " )";
	    }).join(", ")
	  }
	  END IF **/
	
	  // Sort the routes by specificity
	  function sortSolutions(states) {
	    return states.sort(function (a, b) {
	      return b.specificity.val - a.specificity.val;
	    });
	  }
	
	  function recognizeChar(states, ch) {
	    var nextStates = [];
	
	    for (var i = 0, l = states.length; i < l; i++) {
	      var state = states[i];
	
	      nextStates = nextStates.concat(state.match(ch));
	    }
	
	    return nextStates;
	  }
	
	  var oCreate = Object.create || function (proto) {
	    function F() {}
	    F.prototype = proto;
	    return new F();
	  };
	
	  function RecognizeResults(queryParams) {
	    this.queryParams = queryParams || {};
	  }
	  RecognizeResults.prototype = oCreate({
	    splice: Array.prototype.splice,
	    slice: Array.prototype.slice,
	    push: Array.prototype.push,
	    length: 0,
	    queryParams: null
	  });
	
	  function findHandler(state, path, queryParams) {
	    var handlers = state.handlers,
	        regex = state.regex;
	    var captures = path.match(regex),
	        currentCapture = 1;
	    var result = new RecognizeResults(queryParams);
	
	    for (var i = 0, l = handlers.length; i < l; i++) {
	      var handler = handlers[i],
	          names = handler.names,
	          params = {};
	
	      for (var j = 0, m = names.length; j < m; j++) {
	        params[names[j]] = captures[currentCapture++];
	      }
	
	      result.push({ handler: handler.handler, params: params, isDynamic: !!names.length });
	    }
	
	    return result;
	  }
	
	  function addSegment(currentState, segment) {
	    segment.eachChar(function (ch) {
	      var state;
	
	      currentState = currentState.put(ch);
	    });
	
	    return currentState;
	  }
	
	  function decodeQueryParamPart(part) {
	    // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
	    part = part.replace(/\+/gm, '%20');
	    return tryDecode(part, true);
	  }
	
	  // The main interface
	
	  var RouteRecognizer = function RouteRecognizer() {
	    this.rootState = new State();
	    this.names = {};
	  };
	
	  RouteRecognizer.prototype = {
	    add: function add(routes, options) {
	      var currentState = this.rootState,
	          regex = "^",
	          specificity = {},
	          handlers = [],
	          allSegments = [],
	          name;
	
	      var isEmpty = true;
	
	      for (var i = 0, l = routes.length; i < l; i++) {
	        var route = routes[i],
	            names = [];
	
	        var segments = parse(route.path, names, specificity);
	
	        allSegments = allSegments.concat(segments);
	
	        for (var j = 0, m = segments.length; j < m; j++) {
	          var segment = segments[j];
	
	          if (segment instanceof EpsilonSegment) {
	            continue;
	          }
	
	          isEmpty = false;
	
	          // Add a "/" for the new segment
	          currentState = currentState.put({ validChars: "/" });
	          regex += "/";
	
	          // Add a representation of the segment to the NFA and regex
	          currentState = addSegment(currentState, segment);
	          regex += segment.regex();
	        }
	
	        var handler = { handler: route.handler, names: names };
	        handlers.push(handler);
	      }
	
	      if (isEmpty) {
	        currentState = currentState.put({ validChars: "/" });
	        regex += "/";
	      }
	
	      currentState.handlers = handlers;
	      currentState.regex = new RegExp(regex + "$");
	      currentState.specificity = specificity;
	
	      if (name = options && options.as) {
	        this.names[name] = {
	          segments: allSegments,
	          handlers: handlers
	        };
	      }
	    },
	
	    handlersFor: function handlersFor(name) {
	      var route = this.names[name],
	          result = [];
	      if (!route) {
	        throw new Error("There is no route named " + name);
	      }
	
	      for (var i = 0, l = route.handlers.length; i < l; i++) {
	        result.push(route.handlers[i]);
	      }
	
	      return result;
	    },
	
	    hasRoute: function hasRoute(name) {
	      return !!this.names[name];
	    },
	
	    generate: function generate(name, params) {
	      var route = this.names[name],
	          output = "";
	      if (!route) {
	        throw new Error("There is no route named " + name);
	      }
	
	      var segments = route.segments;
	
	      for (var i = 0, l = segments.length; i < l; i++) {
	        var segment = segments[i];
	
	        if (segment instanceof EpsilonSegment) {
	          continue;
	        }
	
	        output += "/";
	        output += segment.generate(params);
	      }
	
	      if (output.charAt(0) !== '/') {
	        output = '/' + output;
	      }
	
	      if (params && params.queryParams) {
	        output += this.generateQueryString(params.queryParams);
	      }
	
	      return output;
	    },
	
	    generateQueryString: function generateQueryString(params) {
	      var pairs = [];
	      var keys = [];
	      for (var key in params) {
	        if (params.hasOwnProperty(key)) {
	          keys.push(key);
	        }
	      }
	      keys.sort();
	      for (var i = 0, len = keys.length; i < len; i++) {
	        key = keys[i];
	        var value = params[key];
	        if (value == null) {
	          continue;
	        }
	        var pair = encodeURIComponent(key);
	        if (isArray(value)) {
	          for (var j = 0, l = value.length; j < l; j++) {
	            var arrayPair = key + '[]' + '=' + encodeURIComponent(value[j]);
	            pairs.push(arrayPair);
	          }
	        } else {
	          pair += "=" + encodeURIComponent(value);
	          pairs.push(pair);
	        }
	      }
	
	      if (pairs.length === 0) {
	        return '';
	      }
	
	      return "?" + pairs.join("&");
	    },
	
	    parseQueryString: function parseQueryString(queryString) {
	      var pairs = queryString.split("&"),
	          queryParams = {};
	      for (var i = 0; i < pairs.length; i++) {
	        var pair = pairs[i].split('='),
	            key = decodeQueryParamPart(pair[0]),
	            keyLength = key.length,
	            isArray = false,
	            value;
	        if (pair.length === 1) {
	          value = 'true';
	        } else {
	          //Handle arrays
	          if (keyLength > 2 && key.slice(keyLength - 2) === '[]') {
	            isArray = true;
	            key = key.slice(0, keyLength - 2);
	            if (!queryParams[key]) {
	              queryParams[key] = [];
	            }
	          }
	          value = pair[1] ? decodeQueryParamPart(pair[1]) : '';
	        }
	        if (isArray) {
	          queryParams[key].push(value);
	        } else {
	          queryParams[key] = value;
	        }
	      }
	      return queryParams;
	    },
	
	    recognize: function recognize(path, silent) {
	      noWarning = silent;
	      var states = [this.rootState],
	          pathLen,
	          i,
	          l,
	          queryStart,
	          queryParams = {},
	          isSlashDropped = false;
	
	      queryStart = path.indexOf('?');
	      if (queryStart !== -1) {
	        var queryString = path.substr(queryStart + 1, path.length);
	        path = path.substr(0, queryStart);
	        if (queryString) {
	          queryParams = this.parseQueryString(queryString);
	        }
	      }
	
	      path = tryDecode(path);
	      if (!path) return;
	
	      // DEBUG GROUP path
	
	      if (path.charAt(0) !== "/") {
	        path = "/" + path;
	      }
	
	      pathLen = path.length;
	      if (pathLen > 1 && path.charAt(pathLen - 1) === "/") {
	        path = path.substr(0, pathLen - 1);
	        isSlashDropped = true;
	      }
	
	      for (i = 0, l = path.length; i < l; i++) {
	        states = recognizeChar(states, path.charAt(i));
	        if (!states.length) {
	          break;
	        }
	      }
	
	      // END DEBUG GROUP
	
	      var solutions = [];
	      for (i = 0, l = states.length; i < l; i++) {
	        if (states[i].handlers) {
	          solutions.push(states[i]);
	        }
	      }
	
	      states = sortSolutions(solutions);
	
	      var state = solutions[0];
	
	      if (state && state.handlers) {
	        // if a trailing slash was dropped and a star segment is the last segment
	        // specified, put the trailing slash back
	        if (isSlashDropped && state.regex.source.slice(-5) === "(.+)$") {
	          path = path + "/";
	        }
	        return findHandler(state, path, queryParams);
	      }
	    }
	  };
	
	  RouteRecognizer.prototype.map = map;
	
	  var genQuery = RouteRecognizer.prototype.generateQueryString;
	
	  // export default for holding the Vue reference
	  var exports$1 = {};
	  /**
	   * Warn stuff.
	   *
	   * @param {String} msg
	   */
	
	  function warn$1(msg) {
	    /* istanbul ignore next */
	    if (typeof console !== 'undefined') {
	      console.error('[vue-router] ' + msg);
	    }
	  }
	
	  /**
	   * Resolve a relative path.
	   *
	   * @param {String} base
	   * @param {String} relative
	   * @param {Boolean} append
	   * @return {String}
	   */
	
	  function resolvePath(base, relative, append) {
	    var query = base.match(/(\?.*)$/);
	    if (query) {
	      query = query[1];
	      base = base.slice(0, -query.length);
	    }
	    // a query!
	    if (relative.charAt(0) === '?') {
	      return base + relative;
	    }
	    var stack = base.split('/');
	    // remove trailing segment if:
	    // - not appending
	    // - appending to trailing slash (last segment is empty)
	    if (!append || !stack[stack.length - 1]) {
	      stack.pop();
	    }
	    // resolve relative path
	    var segments = relative.replace(/^\//, '').split('/');
	    for (var i = 0; i < segments.length; i++) {
	      var segment = segments[i];
	      if (segment === '.') {
	        continue;
	      } else if (segment === '..') {
	        stack.pop();
	      } else {
	        stack.push(segment);
	      }
	    }
	    // ensure leading slash
	    if (stack[0] !== '') {
	      stack.unshift('');
	    }
	    return stack.join('/');
	  }
	
	  /**
	   * Forgiving check for a promise
	   *
	   * @param {Object} p
	   * @return {Boolean}
	   */
	
	  function isPromise(p) {
	    return p && typeof p.then === 'function';
	  }
	
	  /**
	   * Retrive a route config field from a component instance
	   * OR a component contructor.
	   *
	   * @param {Function|Vue} component
	   * @param {String} name
	   * @return {*}
	   */
	
	  function getRouteConfig(component, name) {
	    var options = component && (component.$options || component.options);
	    return options && options.route && options.route[name];
	  }
	
	  /**
	   * Resolve an async component factory. Have to do a dirty
	   * mock here because of Vue core's internal API depends on
	   * an ID check.
	   *
	   * @param {Object} handler
	   * @param {Function} cb
	   */
	
	  var resolver = undefined;
	
	  function resolveAsyncComponent(handler, cb) {
	    if (!resolver) {
	      resolver = {
	        resolve: exports$1.Vue.prototype._resolveComponent,
	        $options: {
	          components: {
	            _: handler.component
	          }
	        }
	      };
	    } else {
	      resolver.$options.components._ = handler.component;
	    }
	    resolver.resolve('_', function (Component) {
	      handler.component = Component;
	      cb(Component);
	    });
	  }
	
	  /**
	   * Map the dynamic segments in a path to params.
	   *
	   * @param {String} path
	   * @param {Object} params
	   * @param {Object} query
	   */
	
	  function mapParams(path, params, query) {
	    if (params === undefined) params = {};
	
	    path = path.replace(/:([^\/]+)/g, function (_, key) {
	      var val = params[key];
	      /* istanbul ignore if */
	      if (!val) {
	        warn$1('param "' + key + '" not found when generating ' + 'path for "' + path + '" with params ' + JSON.stringify(params));
	      }
	      return val || '';
	    });
	    if (query) {
	      path += genQuery(query);
	    }
	    return path;
	  }
	
	  var hashRE = /#.*$/;
	
	  var HTML5History = (function () {
	    function HTML5History(_ref) {
	      var root = _ref.root;
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, HTML5History);
	
	      if (root && root !== '/') {
	        // make sure there's the starting slash
	        if (root.charAt(0) !== '/') {
	          root = '/' + root;
	        }
	        // remove trailing slash
	        this.root = root.replace(/\/$/, '');
	        this.rootRE = new RegExp('^\\' + this.root);
	      } else {
	        this.root = null;
	      }
	      this.onChange = onChange;
	      // check base tag
	      var baseEl = document.querySelector('base');
	      this.base = baseEl && baseEl.getAttribute('href');
	    }
	
	    HTML5History.prototype.start = function start() {
	      var _this = this;
	
	      this.listener = function (e) {
	        var url = location.pathname + location.search;
	        if (_this.root) {
	          url = url.replace(_this.rootRE, '');
	        }
	        _this.onChange(url, e && e.state, location.hash);
	      };
	      window.addEventListener('popstate', this.listener);
	      this.listener();
	    };
	
	    HTML5History.prototype.stop = function stop() {
	      window.removeEventListener('popstate', this.listener);
	    };
	
	    HTML5History.prototype.go = function go(path, replace, append) {
	      var url = this.formatPath(path, append);
	      if (replace) {
	        history.replaceState({}, '', url);
	      } else {
	        // record scroll position by replacing current state
	        history.replaceState({
	          pos: {
	            x: window.pageXOffset,
	            y: window.pageYOffset
	          }
	        }, '', location.href);
	        // then push new state
	        history.pushState({}, '', url);
	      }
	      var hashMatch = path.match(hashRE);
	      var hash = hashMatch && hashMatch[0];
	      path = url
	      // strip hash so it doesn't mess up params
	      .replace(hashRE, '')
	      // remove root before matching
	      .replace(this.rootRE, '');
	      this.onChange(path, null, hash);
	    };
	
	    HTML5History.prototype.formatPath = function formatPath(path, append) {
	      return path.charAt(0) === '/'
	      // absolute path
	      ? this.root ? this.root + '/' + path.replace(/^\//, '') : path : resolvePath(this.base || location.pathname, path, append);
	    };
	
	    return HTML5History;
	  })();
	
	  var HashHistory = (function () {
	    function HashHistory(_ref) {
	      var hashbang = _ref.hashbang;
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, HashHistory);
	
	      this.hashbang = hashbang;
	      this.onChange = onChange;
	    }
	
	    HashHistory.prototype.start = function start() {
	      var self = this;
	      this.listener = function () {
	        var path = location.hash;
	        var raw = path.replace(/^#!?/, '');
	        // always
	        if (raw.charAt(0) !== '/') {
	          raw = '/' + raw;
	        }
	        var formattedPath = self.formatPath(raw);
	        if (formattedPath !== path) {
	          location.replace(formattedPath);
	          return;
	        }
	        // determine query
	        // note it's possible to have queries in both the actual URL
	        // and the hash fragment itself.
	        var query = location.search && path.indexOf('?') > -1 ? '&' + location.search.slice(1) : location.search;
	        self.onChange(path.replace(/^#!?/, '') + query);
	      };
	      window.addEventListener('hashchange', this.listener);
	      this.listener();
	    };
	
	    HashHistory.prototype.stop = function stop() {
	      window.removeEventListener('hashchange', this.listener);
	    };
	
	    HashHistory.prototype.go = function go(path, replace, append) {
	      path = this.formatPath(path, append);
	      if (replace) {
	        location.replace(path);
	      } else {
	        location.hash = path;
	      }
	    };
	
	    HashHistory.prototype.formatPath = function formatPath(path, append) {
	      var isAbsoloute = path.charAt(0) === '/';
	      var prefix = '#' + (this.hashbang ? '!' : '');
	      return isAbsoloute ? prefix + path : prefix + resolvePath(location.hash.replace(/^#!?/, ''), path, append);
	    };
	
	    return HashHistory;
	  })();
	
	  var AbstractHistory = (function () {
	    function AbstractHistory(_ref) {
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, AbstractHistory);
	
	      this.onChange = onChange;
	      this.currentPath = '/';
	    }
	
	    AbstractHistory.prototype.start = function start() {
	      this.onChange('/');
	    };
	
	    AbstractHistory.prototype.stop = function stop() {
	      // noop
	    };
	
	    AbstractHistory.prototype.go = function go(path, replace, append) {
	      path = this.currentPath = this.formatPath(path, append);
	      this.onChange(path);
	    };
	
	    AbstractHistory.prototype.formatPath = function formatPath(path, append) {
	      return path.charAt(0) === '/' ? path : resolvePath(this.currentPath, path, append);
	    };
	
	    return AbstractHistory;
	  })();
	
	  /**
	   * Determine the reusability of an existing router view.
	   *
	   * @param {Directive} view
	   * @param {Object} handler
	   * @param {Transition} transition
	   */
	
	  function canReuse(view, handler, transition) {
	    var component = view.childVM;
	    if (!component || !handler) {
	      return false;
	    }
	    // important: check view.Component here because it may
	    // have been changed in activate hook
	    if (view.Component !== handler.component) {
	      return false;
	    }
	    var canReuseFn = getRouteConfig(component, 'canReuse');
	    return typeof canReuseFn === 'boolean' ? canReuseFn : canReuseFn ? canReuseFn.call(component, {
	      to: transition.to,
	      from: transition.from
	    }) : true; // defaults to true
	  }
	
	  /**
	   * Check if a component can deactivate.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function canDeactivate(view, transition, next) {
	    var fromComponent = view.childVM;
	    var hook = getRouteConfig(fromComponent, 'canDeactivate');
	    if (!hook) {
	      next();
	    } else {
	      transition.callHook(hook, fromComponent, next, {
	        expectBoolean: true
	      });
	    }
	  }
	
	  /**
	   * Check if a component can activate.
	   *
	   * @param {Object} handler
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function canActivate(handler, transition, next) {
	    resolveAsyncComponent(handler, function (Component) {
	      // have to check due to async-ness
	      if (transition.aborted) {
	        return;
	      }
	      // determine if this component can be activated
	      var hook = getRouteConfig(Component, 'canActivate');
	      if (!hook) {
	        next();
	      } else {
	        transition.callHook(hook, null, next, {
	          expectBoolean: true
	        });
	      }
	    });
	  }
	
	  /**
	   * Call deactivate hooks for existing router-views.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function deactivate(view, transition, next) {
	    var component = view.childVM;
	    var hook = getRouteConfig(component, 'deactivate');
	    if (!hook) {
	      next();
	    } else {
	      transition.callHooks(hook, component, next);
	    }
	  }
	
	  /**
	   * Activate / switch component for a router-view.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Number} depth
	   * @param {Function} [cb]
	   */
	
	  function activate(view, transition, depth, cb, reuse) {
	    var handler = transition.activateQueue[depth];
	    if (!handler) {
	      saveChildView(view);
	      if (view._bound) {
	        view.setComponent(null);
	      }
	      cb && cb();
	      return;
	    }
	
	    var Component = view.Component = handler.component;
	    var activateHook = getRouteConfig(Component, 'activate');
	    var dataHook = getRouteConfig(Component, 'data');
	    var waitForData = getRouteConfig(Component, 'waitForData');
	
	    view.depth = depth;
	    view.activated = false;
	
	    var component = undefined;
	    var loading = !!(dataHook && !waitForData);
	
	    // "reuse" is a flag passed down when the parent view is
	    // either reused via keep-alive or as a child of a kept-alive view.
	    // of course we can only reuse if the current kept-alive instance
	    // is of the correct type.
	    reuse = reuse && view.childVM && view.childVM.constructor === Component;
	
	    if (reuse) {
	      // just reuse
	      component = view.childVM;
	      component.$loadingRouteData = loading;
	    } else {
	      saveChildView(view);
	
	      // unbuild current component. this step also destroys
	      // and removes all nested child views.
	      view.unbuild(true);
	
	      // build the new component. this will also create the
	      // direct child view of the current one. it will register
	      // itself as view.childView.
	      component = view.build({
	        _meta: {
	          $loadingRouteData: loading
	        },
	        created: function created() {
	          this._routerView = view;
	        }
	      });
	
	      // handle keep-alive.
	      // when a kept-alive child vm is restored, we need to
	      // add its cached child views into the router's view list,
	      // and also properly update current view's child view.
	      if (view.keepAlive) {
	        component.$loadingRouteData = loading;
	        var cachedChildView = component._keepAliveRouterView;
	        if (cachedChildView) {
	          view.childView = cachedChildView;
	          component._keepAliveRouterView = null;
	        }
	      }
	    }
	
	    // cleanup the component in case the transition is aborted
	    // before the component is ever inserted.
	    var cleanup = function cleanup() {
	      component.$destroy();
	    };
	
	    // actually insert the component and trigger transition
	    var insert = function insert() {
	      if (reuse) {
	        cb && cb();
	        return;
	      }
	      var router = transition.router;
	      if (router._rendered || router._transitionOnLoad) {
	        view.transition(component);
	      } else {
	        // no transition on first render, manual transition
	        /* istanbul ignore if */
	        if (view.setCurrent) {
	          // 0.12 compat
	          view.setCurrent(component);
	        } else {
	          // 1.0
	          view.childVM = component;
	        }
	        component.$before(view.anchor, null, false);
	      }
	      cb && cb();
	    };
	
	    var afterData = function afterData() {
	      // activate the child view
	      if (view.childView) {
	        activate(view.childView, transition, depth + 1, null, reuse || view.keepAlive);
	      }
	      insert();
	    };
	
	    // called after activation hook is resolved
	    var afterActivate = function afterActivate() {
	      view.activated = true;
	      if (dataHook && waitForData) {
	        // wait until data loaded to insert
	        loadData(component, transition, dataHook, afterData, cleanup);
	      } else {
	        // load data and insert at the same time
	        if (dataHook) {
	          loadData(component, transition, dataHook);
	        }
	        afterData();
	      }
	    };
	
	    if (activateHook) {
	      transition.callHooks(activateHook, component, afterActivate, {
	        cleanup: cleanup,
	        postActivate: true
	      });
	    } else {
	      afterActivate();
	    }
	  }
	
	  /**
	   * Reuse a view, just reload data if necessary.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   */
	
	  function reuse(view, transition) {
	    var component = view.childVM;
	    var dataHook = getRouteConfig(component, 'data');
	    if (dataHook) {
	      loadData(component, transition, dataHook);
	    }
	  }
	
	  /**
	   * Asynchronously load and apply data to component.
	   *
	   * @param {Vue} component
	   * @param {Transition} transition
	   * @param {Function} hook
	   * @param {Function} cb
	   * @param {Function} cleanup
	   */
	
	  function loadData(component, transition, hook, cb, cleanup) {
	    component.$loadingRouteData = true;
	    transition.callHooks(hook, component, function () {
	      component.$loadingRouteData = false;
	      component.$emit('route-data-loaded', component);
	      cb && cb();
	    }, {
	      cleanup: cleanup,
	      postActivate: true,
	      processData: function processData(data) {
	        // handle promise sugar syntax
	        var promises = [];
	        if (isPlainObject(data)) {
	          Object.keys(data).forEach(function (key) {
	            var val = data[key];
	            if (isPromise(val)) {
	              promises.push(val.then(function (resolvedVal) {
	                component.$set(key, resolvedVal);
	              }));
	            } else {
	              component.$set(key, val);
	            }
	          });
	        }
	        if (promises.length) {
	          return promises[0].constructor.all(promises);
	        }
	      }
	    });
	  }
	
	  /**
	   * Save the child view for a kept-alive view so that
	   * we can restore it when it is switched back to.
	   *
	   * @param {Directive} view
	   */
	
	  function saveChildView(view) {
	    if (view.keepAlive && view.childVM && view.childView) {
	      view.childVM._keepAliveRouterView = view.childView;
	    }
	    view.childView = null;
	  }
	
	  /**
	   * Check plain object.
	   *
	   * @param {*} val
	   */
	
	  function isPlainObject(val) {
	    return Object.prototype.toString.call(val) === '[object Object]';
	  }
	
	  /**
	   * A RouteTransition object manages the pipeline of a
	   * router-view switching process. This is also the object
	   * passed into user route hooks.
	   *
	   * @param {Router} router
	   * @param {Route} to
	   * @param {Route} from
	   */
	
	  var RouteTransition = (function () {
	    function RouteTransition(router, to, from) {
	      babelHelpers.classCallCheck(this, RouteTransition);
	
	      this.router = router;
	      this.to = to;
	      this.from = from;
	      this.next = null;
	      this.aborted = false;
	      this.done = false;
	    }
	
	    /**
	     * Abort current transition and return to previous location.
	     */
	
	    RouteTransition.prototype.abort = function abort() {
	      if (!this.aborted) {
	        this.aborted = true;
	        // if the root path throws an error during validation
	        // on initial load, it gets caught in an infinite loop.
	        var abortingOnLoad = !this.from.path && this.to.path === '/';
	        if (!abortingOnLoad) {
	          this.router.replace(this.from.path || '/');
	        }
	      }
	    };
	
	    /**
	     * Abort current transition and redirect to a new location.
	     *
	     * @param {String} path
	     */
	
	    RouteTransition.prototype.redirect = function redirect(path) {
	      if (!this.aborted) {
	        this.aborted = true;
	        if (typeof path === 'string') {
	          path = mapParams(path, this.to.params, this.to.query);
	        } else {
	          path.params = path.params || this.to.params;
	          path.query = path.query || this.to.query;
	        }
	        this.router.replace(path);
	      }
	    };
	
	    /**
	     * A router view transition's pipeline can be described as
	     * follows, assuming we are transitioning from an existing
	     * <router-view> chain [Component A, Component B] to a new
	     * chain [Component A, Component C]:
	     *
	     *  A    A
	     *  | => |
	     *  B    C
	     *
	     * 1. Reusablity phase:
	     *   -> canReuse(A, A)
	     *   -> canReuse(B, C)
	     *   -> determine new queues:
	     *      - deactivation: [B]
	     *      - activation: [C]
	     *
	     * 2. Validation phase:
	     *   -> canDeactivate(B)
	     *   -> canActivate(C)
	     *
	     * 3. Activation phase:
	     *   -> deactivate(B)
	     *   -> activate(C)
	     *
	     * Each of these steps can be asynchronous, and any
	     * step can potentially abort the transition.
	     *
	     * @param {Function} cb
	     */
	
	    RouteTransition.prototype.start = function start(cb) {
	      var transition = this;
	
	      // determine the queue of views to deactivate
	      var deactivateQueue = [];
	      var view = this.router._rootView;
	      while (view) {
	        deactivateQueue.unshift(view);
	        view = view.childView;
	      }
	      var reverseDeactivateQueue = deactivateQueue.slice().reverse();
	
	      // determine the queue of route handlers to activate
	      var activateQueue = this.activateQueue = toArray(this.to.matched).map(function (match) {
	        return match.handler;
	      });
	
	      // 1. Reusability phase
	      var i = undefined,
	          reuseQueue = undefined;
	      for (i = 0; i < reverseDeactivateQueue.length; i++) {
	        if (!canReuse(reverseDeactivateQueue[i], activateQueue[i], transition)) {
	          break;
	        }
	      }
	      if (i > 0) {
	        reuseQueue = reverseDeactivateQueue.slice(0, i);
	        deactivateQueue = reverseDeactivateQueue.slice(i).reverse();
	        activateQueue = activateQueue.slice(i);
	      }
	
	      // 2. Validation phase
	      transition.runQueue(deactivateQueue, canDeactivate, function () {
	        transition.runQueue(activateQueue, canActivate, function () {
	          transition.runQueue(deactivateQueue, deactivate, function () {
	            // 3. Activation phase
	
	            // Update router current route
	            transition.router._onTransitionValidated(transition);
	
	            // trigger reuse for all reused views
	            reuseQueue && reuseQueue.forEach(function (view) {
	              return reuse(view, transition);
	            });
	
	            // the root of the chain that needs to be replaced
	            // is the top-most non-reusable view.
	            if (deactivateQueue.length) {
	              var _view = deactivateQueue[deactivateQueue.length - 1];
	              var depth = reuseQueue ? reuseQueue.length : 0;
	              activate(_view, transition, depth, cb);
	            } else {
	              cb();
	            }
	          });
	        });
	      });
	    };
	
	    /**
	     * Asynchronously and sequentially apply a function to a
	     * queue.
	     *
	     * @param {Array} queue
	     * @param {Function} fn
	     * @param {Function} cb
	     */
	
	    RouteTransition.prototype.runQueue = function runQueue(queue, fn, cb) {
	      var transition = this;
	      step(0);
	      function step(index) {
	        if (index >= queue.length) {
	          cb();
	        } else {
	          fn(queue[index], transition, function () {
	            step(index + 1);
	          });
	        }
	      }
	    };
	
	    /**
	     * Call a user provided route transition hook and handle
	     * the response (e.g. if the user returns a promise).
	     *
	     * If the user neither expects an argument nor returns a
	     * promise, the hook is assumed to be synchronous.
	     *
	     * @param {Function} hook
	     * @param {*} [context]
	     * @param {Function} [cb]
	     * @param {Object} [options]
	     *                 - {Boolean} expectBoolean
	     *                 - {Boolean} postActive
	     *                 - {Function} processData
	     *                 - {Function} cleanup
	     */
	
	    RouteTransition.prototype.callHook = function callHook(hook, context, cb) {
	      var _ref = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      var _ref$expectBoolean = _ref.expectBoolean;
	      var expectBoolean = _ref$expectBoolean === undefined ? false : _ref$expectBoolean;
	      var _ref$postActivate = _ref.postActivate;
	      var postActivate = _ref$postActivate === undefined ? false : _ref$postActivate;
	      var processData = _ref.processData;
	      var cleanup = _ref.cleanup;
	
	      var transition = this;
	      var nextCalled = false;
	
	      // abort the transition
	      var abort = function abort() {
	        cleanup && cleanup();
	        transition.abort();
	      };
	
	      // handle errors
	      var onError = function onError(err) {
	        postActivate ? next() : abort();
	        if (err && !transition.router._suppress) {
	          warn$1('Uncaught error during transition: ');
	          throw err instanceof Error ? err : new Error(err);
	        }
	      };
	
	      // since promise swallows errors, we have to
	      // throw it in the next tick...
	      var onPromiseError = function onPromiseError(err) {
	        try {
	          onError(err);
	        } catch (e) {
	          setTimeout(function () {
	            throw e;
	          }, 0);
	        }
	      };
	
	      // advance the transition to the next step
	      var next = function next() {
	        if (nextCalled) {
	          warn$1('transition.next() should be called only once.');
	          return;
	        }
	        nextCalled = true;
	        if (transition.aborted) {
	          cleanup && cleanup();
	          return;
	        }
	        cb && cb();
	      };
	
	      var nextWithBoolean = function nextWithBoolean(res) {
	        if (typeof res === 'boolean') {
	          res ? next() : abort();
	        } else if (isPromise(res)) {
	          res.then(function (ok) {
	            ok ? next() : abort();
	          }, onPromiseError);
	        } else if (!hook.length) {
	          next();
	        }
	      };
	
	      var nextWithData = function nextWithData(data) {
	        var res = undefined;
	        try {
	          res = processData(data);
	        } catch (err) {
	          return onError(err);
	        }
	        if (isPromise(res)) {
	          res.then(next, onPromiseError);
	        } else {
	          next();
	        }
	      };
	
	      // expose a clone of the transition object, so that each
	      // hook gets a clean copy and prevent the user from
	      // messing with the internals.
	      var exposed = {
	        to: transition.to,
	        from: transition.from,
	        abort: abort,
	        next: processData ? nextWithData : next,
	        redirect: function redirect() {
	          transition.redirect.apply(transition, arguments);
	        }
	      };
	
	      // actually call the hook
	      var res = undefined;
	      try {
	        res = hook.call(context, exposed);
	      } catch (err) {
	        return onError(err);
	      }
	
	      if (expectBoolean) {
	        // boolean hooks
	        nextWithBoolean(res);
	      } else if (isPromise(res)) {
	        // promise
	        if (processData) {
	          res.then(nextWithData, onPromiseError);
	        } else {
	          res.then(next, onPromiseError);
	        }
	      } else if (processData && isPlainOjbect(res)) {
	        // data promise sugar
	        nextWithData(res);
	      } else if (!hook.length) {
	        next();
	      }
	    };
	
	    /**
	     * Call a single hook or an array of async hooks in series.
	     *
	     * @param {Array} hooks
	     * @param {*} context
	     * @param {Function} cb
	     * @param {Object} [options]
	     */
	
	    RouteTransition.prototype.callHooks = function callHooks(hooks, context, cb, options) {
	      var _this = this;
	
	      if (Array.isArray(hooks)) {
	        this.runQueue(hooks, function (hook, _, next) {
	          if (!_this.aborted) {
	            _this.callHook(hook, context, next, options);
	          }
	        }, cb);
	      } else {
	        this.callHook(hooks, context, cb, options);
	      }
	    };
	
	    return RouteTransition;
	  })();
	
	  function isPlainOjbect(val) {
	    return Object.prototype.toString.call(val) === '[object Object]';
	  }
	
	  function toArray(val) {
	    return val ? Array.prototype.slice.call(val) : [];
	  }
	
	  var internalKeysRE = /^(component|subRoutes|fullPath)$/;
	
	  /**
	   * Route Context Object
	   *
	   * @param {String} path
	   * @param {Router} router
	   */
	
	  var Route = function Route(path, router) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, Route);
	
	    var matched = router._recognizer.recognize(path);
	    if (matched) {
	      // copy all custom fields from route configs
	      [].forEach.call(matched, function (match) {
	        for (var key in match.handler) {
	          if (!internalKeysRE.test(key)) {
	            _this[key] = match.handler[key];
	          }
	        }
	      });
	      // set query and params
	      this.query = matched.queryParams;
	      this.params = [].reduce.call(matched, function (prev, cur) {
	        if (cur.params) {
	          for (var key in cur.params) {
	            prev[key] = cur.params[key];
	          }
	        }
	        return prev;
	      }, {});
	    }
	    // expose path and router
	    this.path = path;
	    // for internal use
	    this.matched = matched || router._notFoundHandler;
	    // internal reference to router
	    Object.defineProperty(this, 'router', {
	      enumerable: false,
	      value: router
	    });
	    // Important: freeze self to prevent observation
	    Object.freeze(this);
	  };
	
	  function applyOverride (Vue) {
	    var _Vue$util = Vue.util;
	    var extend = _Vue$util.extend;
	    var isArray = _Vue$util.isArray;
	    var defineReactive = _Vue$util.defineReactive;
	
	    // override Vue's init and destroy process to keep track of router instances
	    var init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      options = options || {};
	      var root = options._parent || options.parent || this;
	      var router = root.$router;
	      var route = root.$route;
	      if (router) {
	        // expose router
	        this.$router = router;
	        router._children.push(this);
	        /* istanbul ignore if */
	        if (this._defineMeta) {
	          // 0.12
	          this._defineMeta('$route', route);
	        } else {
	          // 1.0
	          defineReactive(this, '$route', route);
	        }
	      }
	      init.call(this, options);
	    };
	
	    var destroy = Vue.prototype._destroy;
	    Vue.prototype._destroy = function () {
	      if (!this._isBeingDestroyed && this.$router) {
	        this.$router._children.$remove(this);
	      }
	      destroy.apply(this, arguments);
	    };
	
	    // 1.0 only: enable route mixins
	    var strats = Vue.config.optionMergeStrategies;
	    var hooksToMergeRE = /^(data|activate|deactivate)$/;
	
	    if (strats) {
	      strats.route = function (parentVal, childVal) {
	        if (!childVal) return parentVal;
	        if (!parentVal) return childVal;
	        var ret = {};
	        extend(ret, parentVal);
	        for (var key in childVal) {
	          var a = ret[key];
	          var b = childVal[key];
	          // for data, activate and deactivate, we need to merge them into
	          // arrays similar to lifecycle hooks.
	          if (a && hooksToMergeRE.test(key)) {
	            ret[key] = (isArray(a) ? a : [a]).concat(b);
	          } else {
	            ret[key] = b;
	          }
	        }
	        return ret;
	      };
	    }
	  }
	
	  function View (Vue) {
	
	    var _ = Vue.util;
	    var componentDef =
	    // 0.12
	    Vue.directive('_component') ||
	    // 1.0
	    Vue.internalDirectives.component;
	    // <router-view> extends the internal component directive
	    var viewDef = _.extend({}, componentDef);
	
	    // with some overrides
	    _.extend(viewDef, {
	
	      _isRouterView: true,
	
	      bind: function bind() {
	        var route = this.vm.$route;
	        /* istanbul ignore if */
	        if (!route) {
	          warn$1('<router-view> can only be used inside a ' + 'router-enabled app.');
	          return;
	        }
	        // force dynamic directive so v-component doesn't
	        // attempt to build right now
	        this._isDynamicLiteral = true;
	        // finally, init by delegating to v-component
	        componentDef.bind.call(this);
	
	        // locate the parent view
	        var parentView = undefined;
	        var parent = this.vm;
	        while (parent) {
	          if (parent._routerView) {
	            parentView = parent._routerView;
	            break;
	          }
	          parent = parent.$parent;
	        }
	        if (parentView) {
	          // register self as a child of the parent view,
	          // instead of activating now. This is so that the
	          // child's activate hook is called after the
	          // parent's has resolved.
	          this.parentView = parentView;
	          parentView.childView = this;
	        } else {
	          // this is the root view!
	          var router = route.router;
	          router._rootView = this;
	        }
	
	        // handle late-rendered view
	        // two possibilities:
	        // 1. root view rendered after transition has been
	        //    validated;
	        // 2. child view rendered after parent view has been
	        //    activated.
	        var transition = route.router._currentTransition;
	        if (!parentView && transition.done || parentView && parentView.activated) {
	          var depth = parentView ? parentView.depth + 1 : 0;
	          activate(this, transition, depth);
	        }
	      },
	
	      unbind: function unbind() {
	        if (this.parentView) {
	          this.parentView.childView = null;
	        }
	        componentDef.unbind.call(this);
	      }
	    });
	
	    Vue.elementDirective('router-view', viewDef);
	  }
	
	  var trailingSlashRE = /\/$/;
	  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	  var queryStringRE = /\?.*$/;
	
	  // install v-link, which provides navigation support for
	  // HTML5 history mode
	  function Link (Vue) {
	    var _Vue$util = Vue.util;
	    var _bind = _Vue$util.bind;
	    var isObject = _Vue$util.isObject;
	    var addClass = _Vue$util.addClass;
	    var removeClass = _Vue$util.removeClass;
	
	    var onPriority = Vue.directive('on').priority;
	    var LINK_UPDATE = '__vue-router-link-update__';
	
	    var activeId = 0;
	
	    Vue.directive('link-active', {
	      priority: 9999,
	      bind: function bind() {
	        var _this = this;
	
	        var id = String(activeId++);
	        // collect v-links contained within this element.
	        // we need do this here before the parent-child relationship
	        // gets messed up by terminal directives (if, for, components)
	        var childLinks = this.el.querySelectorAll('[v-link]');
	        for (var i = 0, l = childLinks.length; i < l; i++) {
	          var link = childLinks[i];
	          var existingId = link.getAttribute(LINK_UPDATE);
	          var value = existingId ? existingId + ',' + id : id;
	          // leave a mark on the link element which can be persisted
	          // through fragment clones.
	          link.setAttribute(LINK_UPDATE, value);
	        }
	        this.vm.$on(LINK_UPDATE, this.cb = function (link, path) {
	          if (link.activeIds.indexOf(id) > -1) {
	            link.updateClasses(path, _this.el);
	          }
	        });
	      },
	      unbind: function unbind() {
	        this.vm.$off(LINK_UPDATE, this.cb);
	      }
	    });
	
	    Vue.directive('link', {
	      priority: onPriority - 2,
	
	      bind: function bind() {
	        var vm = this.vm;
	        /* istanbul ignore if */
	        if (!vm.$route) {
	          warn$1('v-link can only be used inside a router-enabled app.');
	          return;
	        }
	        this.router = vm.$route.router;
	        // update things when the route changes
	        this.unwatch = vm.$watch('$route', _bind(this.onRouteUpdate, this));
	        // check v-link-active ids
	        var activeIds = this.el.getAttribute(LINK_UPDATE);
	        if (activeIds) {
	          this.el.removeAttribute(LINK_UPDATE);
	          this.activeIds = activeIds.split(',');
	        }
	        // no need to handle click if link expects to be opened
	        // in a new window/tab.
	        /* istanbul ignore if */
	        if (this.el.tagName === 'A' && this.el.getAttribute('target') === '_blank') {
	          return;
	        }
	        // handle click
	        this.handler = _bind(this.onClick, this);
	        this.el.addEventListener('click', this.handler);
	      },
	
	      update: function update(target) {
	        this.target = target;
	        if (isObject(target)) {
	          this.append = target.append;
	          this.exact = target.exact;
	          this.prevActiveClass = this.activeClass;
	          this.activeClass = target.activeClass;
	        }
	        this.onRouteUpdate(this.vm.$route);
	      },
	
	      onClick: function onClick(e) {
	        // don't redirect with control keys
	        /* istanbul ignore if */
	        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
	        // don't redirect when preventDefault called
	        /* istanbul ignore if */
	        if (e.defaultPrevented) return;
	        // don't redirect on right click
	        /* istanbul ignore if */
	        if (e.button !== 0) return;
	
	        var target = this.target;
	        if (target) {
	          // v-link with expression, just go
	          e.preventDefault();
	          this.router.go(target);
	        } else {
	          // no expression, delegate for an <a> inside
	          var el = e.target;
	          while (el.tagName !== 'A' && el !== this.el) {
	            el = el.parentNode;
	          }
	          if (el.tagName === 'A' && sameOrigin(el)) {
	            e.preventDefault();
	            var path = el.pathname;
	            if (this.router.history.root) {
	              path = path.replace(this.router.history.rootRE, '');
	            }
	            this.router.go({
	              path: path,
	              replace: target && target.replace,
	              append: target && target.append
	            });
	          }
	        }
	      },
	
	      onRouteUpdate: function onRouteUpdate(route) {
	        // router.stringifyPath is dependent on current route
	        // and needs to be called again whenver route changes.
	        var newPath = this.router.stringifyPath(this.target);
	        if (this.path !== newPath) {
	          this.path = newPath;
	          this.updateActiveMatch();
	          this.updateHref();
	        }
	        if (this.activeIds) {
	          this.vm.$emit(LINK_UPDATE, this, route.path);
	        } else {
	          this.updateClasses(route.path, this.el);
	        }
	      },
	
	      updateActiveMatch: function updateActiveMatch() {
	        this.activeRE = this.path && !this.exact ? new RegExp('^' + this.path.replace(/\/$/, '').replace(queryStringRE, '').replace(regexEscapeRE, '\\$&') + '(\\/|$)') : null;
	      },
	
	      updateHref: function updateHref() {
	        if (this.el.tagName !== 'A') {
	          return;
	        }
	        var path = this.path;
	        var router = this.router;
	        var isAbsolute = path.charAt(0) === '/';
	        // do not format non-hash relative paths
	        var href = path && (router.mode === 'hash' || isAbsolute) ? router.history.formatPath(path, this.append) : path;
	        if (href) {
	          this.el.href = href;
	        } else {
	          this.el.removeAttribute('href');
	        }
	      },
	
	      updateClasses: function updateClasses(path, el) {
	        var activeClass = this.activeClass || this.router._linkActiveClass;
	        // clear old class
	        if (this.prevActiveClass && this.prevActiveClass !== activeClass) {
	          toggleClasses(el, this.prevActiveClass, removeClass);
	        }
	        // remove query string before matching
	        var dest = this.path.replace(queryStringRE, '');
	        path = path.replace(queryStringRE, '');
	        // add new class
	        if (this.exact) {
	          if (dest === path ||
	          // also allow additional trailing slash
	          dest.charAt(dest.length - 1) !== '/' && dest === path.replace(trailingSlashRE, '')) {
	            toggleClasses(el, activeClass, addClass);
	          } else {
	            toggleClasses(el, activeClass, removeClass);
	          }
	        } else {
	          if (this.activeRE && this.activeRE.test(path)) {
	            toggleClasses(el, activeClass, addClass);
	          } else {
	            toggleClasses(el, activeClass, removeClass);
	          }
	        }
	      },
	
	      unbind: function unbind() {
	        this.el.removeEventListener('click', this.handler);
	        this.unwatch && this.unwatch();
	      }
	    });
	
	    function sameOrigin(link) {
	      return link.protocol === location.protocol && link.hostname === location.hostname && link.port === location.port;
	    }
	
	    // this function is copied from v-bind:class implementation until
	    // we properly expose it...
	    function toggleClasses(el, key, fn) {
	      key = key.trim();
	      if (key.indexOf(' ') === -1) {
	        fn(el, key);
	        return;
	      }
	      var keys = key.split(/\s+/);
	      for (var i = 0, l = keys.length; i < l; i++) {
	        fn(el, keys[i]);
	      }
	    }
	  }
	
	  var historyBackends = {
	    abstract: AbstractHistory,
	    hash: HashHistory,
	    html5: HTML5History
	  };
	
	  // late bind during install
	  var Vue = undefined;
	
	  /**
	   * Router constructor
	   *
	   * @param {Object} [options]
	   */
	
	  var Router = (function () {
	    function Router() {
	      var _this = this;
	
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var _ref$hashbang = _ref.hashbang;
	      var hashbang = _ref$hashbang === undefined ? true : _ref$hashbang;
	      var _ref$abstract = _ref.abstract;
	      var abstract = _ref$abstract === undefined ? false : _ref$abstract;
	      var _ref$history = _ref.history;
	      var history = _ref$history === undefined ? false : _ref$history;
	      var _ref$saveScrollPosition = _ref.saveScrollPosition;
	      var saveScrollPosition = _ref$saveScrollPosition === undefined ? false : _ref$saveScrollPosition;
	      var _ref$transitionOnLoad = _ref.transitionOnLoad;
	      var transitionOnLoad = _ref$transitionOnLoad === undefined ? false : _ref$transitionOnLoad;
	      var _ref$suppressTransitionError = _ref.suppressTransitionError;
	      var suppressTransitionError = _ref$suppressTransitionError === undefined ? false : _ref$suppressTransitionError;
	      var _ref$root = _ref.root;
	      var root = _ref$root === undefined ? null : _ref$root;
	      var _ref$linkActiveClass = _ref.linkActiveClass;
	      var linkActiveClass = _ref$linkActiveClass === undefined ? 'v-link-active' : _ref$linkActiveClass;
	      babelHelpers.classCallCheck(this, Router);
	
	      /* istanbul ignore if */
	      if (!Router.installed) {
	        throw new Error('Please install the Router with Vue.use() before ' + 'creating an instance.');
	      }
	
	      // Vue instances
	      this.app = null;
	      this._children = [];
	
	      // route recognizer
	      this._recognizer = new RouteRecognizer();
	      this._guardRecognizer = new RouteRecognizer();
	
	      // state
	      this._started = false;
	      this._startCb = null;
	      this._currentRoute = {};
	      this._currentTransition = null;
	      this._previousTransition = null;
	      this._notFoundHandler = null;
	      this._notFoundRedirect = null;
	      this._beforeEachHooks = [];
	      this._afterEachHooks = [];
	
	      // trigger transition on initial render?
	      this._rendered = false;
	      this._transitionOnLoad = transitionOnLoad;
	
	      // history mode
	      this._root = root;
	      this._abstract = abstract;
	      this._hashbang = hashbang;
	
	      // check if HTML5 history is available
	      var hasPushState = typeof window !== 'undefined' && window.history && window.history.pushState;
	      this._history = history && hasPushState;
	      this._historyFallback = history && !hasPushState;
	
	      // create history object
	      var inBrowser = Vue.util.inBrowser;
	      this.mode = !inBrowser || this._abstract ? 'abstract' : this._history ? 'html5' : 'hash';
	
	      var History = historyBackends[this.mode];
	      this.history = new History({
	        root: root,
	        hashbang: this._hashbang,
	        onChange: function onChange(path, state, anchor) {
	          _this._match(path, state, anchor);
	        }
	      });
	
	      // other options
	      this._saveScrollPosition = saveScrollPosition;
	      this._linkActiveClass = linkActiveClass;
	      this._suppress = suppressTransitionError;
	    }
	
	    /**
	     * Allow directly passing components to a route
	     * definition.
	     *
	     * @param {String} path
	     * @param {Object} handler
	     */
	
	    // API ===================================================
	
	    /**
	    * Register a map of top-level paths.
	    *
	    * @param {Object} map
	    */
	
	    Router.prototype.map = function map(_map) {
	      for (var route in _map) {
	        this.on(route, _map[route]);
	      }
	      return this;
	    };
	
	    /**
	     * Register a single root-level path
	     *
	     * @param {String} rootPath
	     * @param {Object} handler
	     *                 - {String} component
	     *                 - {Object} [subRoutes]
	     *                 - {Boolean} [forceRefresh]
	     *                 - {Function} [before]
	     *                 - {Function} [after]
	     */
	
	    Router.prototype.on = function on(rootPath, handler) {
	      if (rootPath === '*') {
	        this._notFound(handler);
	      } else {
	        this._addRoute(rootPath, handler, []);
	      }
	      return this;
	    };
	
	    /**
	     * Set redirects.
	     *
	     * @param {Object} map
	     */
	
	    Router.prototype.redirect = function redirect(map) {
	      for (var path in map) {
	        this._addRedirect(path, map[path]);
	      }
	      return this;
	    };
	
	    /**
	     * Set aliases.
	     *
	     * @param {Object} map
	     */
	
	    Router.prototype.alias = function alias(map) {
	      for (var path in map) {
	        this._addAlias(path, map[path]);
	      }
	      return this;
	    };
	
	    /**
	     * Set global before hook.
	     *
	     * @param {Function} fn
	     */
	
	    Router.prototype.beforeEach = function beforeEach(fn) {
	      this._beforeEachHooks.push(fn);
	      return this;
	    };
	
	    /**
	     * Set global after hook.
	     *
	     * @param {Function} fn
	     */
	
	    Router.prototype.afterEach = function afterEach(fn) {
	      this._afterEachHooks.push(fn);
	      return this;
	    };
	
	    /**
	     * Navigate to a given path.
	     * The path can be an object describing a named path in
	     * the format of { name: '...', params: {}, query: {}}
	     * The path is assumed to be already decoded, and will
	     * be resolved against root (if provided)
	     *
	     * @param {String|Object} path
	     * @param {Boolean} [replace]
	     */
	
	    Router.prototype.go = function go(path) {
	      var replace = false;
	      var append = false;
	      if (Vue.util.isObject(path)) {
	        replace = path.replace;
	        append = path.append;
	      }
	      path = this.stringifyPath(path);
	      if (path) {
	        this.history.go(path, replace, append);
	      }
	    };
	
	    /**
	     * Short hand for replacing current path
	     *
	     * @param {String} path
	     */
	
	    Router.prototype.replace = function replace(path) {
	      if (typeof path === 'string') {
	        path = { path: path };
	      }
	      path.replace = true;
	      this.go(path);
	    };
	
	    /**
	     * Start the router.
	     *
	     * @param {VueConstructor} App
	     * @param {String|Element} container
	     * @param {Function} [cb]
	     */
	
	    Router.prototype.start = function start(App, container, cb) {
	      /* istanbul ignore if */
	      if (this._started) {
	        warn$1('already started.');
	        return;
	      }
	      this._started = true;
	      this._startCb = cb;
	      if (!this.app) {
	        /* istanbul ignore if */
	        if (!App || !container) {
	          throw new Error('Must start vue-router with a component and a ' + 'root container.');
	        }
	        /* istanbul ignore if */
	        if (App instanceof Vue) {
	          throw new Error('Must start vue-router with a component, not a ' + 'Vue instance.');
	        }
	        this._appContainer = container;
	        var Ctor = this._appConstructor = typeof App === 'function' ? App : Vue.extend(App);
	        // give it a name for better debugging
	        Ctor.options.name = Ctor.options.name || 'RouterApp';
	      }
	
	      // handle history fallback in browsers that do not
	      // support HTML5 history API
	      if (this._historyFallback) {
	        var _location = window.location;
	        var _history = new HTML5History({ root: this._root });
	        var path = _history.root ? _location.pathname.replace(_history.rootRE, '') : _location.pathname;
	        if (path && path !== '/') {
	          _location.assign((_history.root || '') + '/' + this.history.formatPath(path) + _location.search);
	          return;
	        }
	      }
	
	      this.history.start();
	    };
	
	    /**
	     * Stop listening to route changes.
	     */
	
	    Router.prototype.stop = function stop() {
	      this.history.stop();
	      this._started = false;
	    };
	
	    /**
	     * Normalize named route object / string paths into
	     * a string.
	     *
	     * @param {Object|String|Number} path
	     * @return {String}
	     */
	
	    Router.prototype.stringifyPath = function stringifyPath(path) {
	      var generatedPath = '';
	      if (path && typeof path === 'object') {
	        if (path.name) {
	          var extend = Vue.util.extend;
	          var currentParams = this._currentTransition && this._currentTransition.to.params;
	          var targetParams = path.params || {};
	          var params = currentParams ? extend(extend({}, currentParams), targetParams) : targetParams;
	          generatedPath = encodeURI(this._recognizer.generate(path.name, params));
	        } else if (path.path) {
	          generatedPath = encodeURI(path.path);
	        }
	        if (path.query) {
	          // note: the generated query string is pre-URL-encoded by the recognizer
	          var query = this._recognizer.generateQueryString(path.query);
	          if (generatedPath.indexOf('?') > -1) {
	            generatedPath += '&' + query.slice(1);
	          } else {
	            generatedPath += query;
	          }
	        }
	      } else {
	        generatedPath = encodeURI(path ? path + '' : '');
	      }
	      return generatedPath;
	    };
	
	    // Internal methods ======================================
	
	    /**
	    * Add a route containing a list of segments to the internal
	    * route recognizer. Will be called recursively to add all
	    * possible sub-routes.
	    *
	    * @param {String} path
	    * @param {Object} handler
	    * @param {Array} segments
	    */
	
	    Router.prototype._addRoute = function _addRoute(path, handler, segments) {
	      guardComponent(path, handler);
	      handler.path = path;
	      handler.fullPath = (segments.reduce(function (path, segment) {
	        return path + segment.path;
	      }, '') + path).replace('//', '/');
	      segments.push({
	        path: path,
	        handler: handler
	      });
	      this._recognizer.add(segments, {
	        as: handler.name
	      });
	      // add sub routes
	      if (handler.subRoutes) {
	        for (var subPath in handler.subRoutes) {
	          // recursively walk all sub routes
	          this._addRoute(subPath, handler.subRoutes[subPath],
	          // pass a copy in recursion to avoid mutating
	          // across branches
	          segments.slice());
	        }
	      }
	    };
	
	    /**
	     * Set the notFound route handler.
	     *
	     * @param {Object} handler
	     */
	
	    Router.prototype._notFound = function _notFound(handler) {
	      guardComponent('*', handler);
	      this._notFoundHandler = [{ handler: handler }];
	    };
	
	    /**
	     * Add a redirect record.
	     *
	     * @param {String} path
	     * @param {String} redirectPath
	     */
	
	    Router.prototype._addRedirect = function _addRedirect(path, redirectPath) {
	      if (path === '*') {
	        this._notFoundRedirect = redirectPath;
	      } else {
	        this._addGuard(path, redirectPath, this.replace);
	      }
	    };
	
	    /**
	     * Add an alias record.
	     *
	     * @param {String} path
	     * @param {String} aliasPath
	     */
	
	    Router.prototype._addAlias = function _addAlias(path, aliasPath) {
	      this._addGuard(path, aliasPath, this._match);
	    };
	
	    /**
	     * Add a path guard.
	     *
	     * @param {String} path
	     * @param {String} mappedPath
	     * @param {Function} handler
	     */
	
	    Router.prototype._addGuard = function _addGuard(path, mappedPath, _handler) {
	      var _this2 = this;
	
	      this._guardRecognizer.add([{
	        path: path,
	        handler: function handler(match, query) {
	          var realPath = mapParams(mappedPath, match.params, query);
	          _handler.call(_this2, realPath);
	        }
	      }]);
	    };
	
	    /**
	     * Check if a path matches any redirect records.
	     *
	     * @param {String} path
	     * @return {Boolean} - if true, will skip normal match.
	     */
	
	    Router.prototype._checkGuard = function _checkGuard(path) {
	      var matched = this._guardRecognizer.recognize(path, true);
	      if (matched) {
	        matched[0].handler(matched[0], matched.queryParams);
	        return true;
	      } else if (this._notFoundRedirect) {
	        matched = this._recognizer.recognize(path);
	        if (!matched) {
	          this.replace(this._notFoundRedirect);
	          return true;
	        }
	      }
	    };
	
	    /**
	     * Match a URL path and set the route context on vm,
	     * triggering view updates.
	     *
	     * @param {String} path
	     * @param {Object} [state]
	     * @param {String} [anchor]
	     */
	
	    Router.prototype._match = function _match(path, state, anchor) {
	      var _this3 = this;
	
	      if (this._checkGuard(path)) {
	        return;
	      }
	
	      var currentRoute = this._currentRoute;
	      var currentTransition = this._currentTransition;
	
	      if (currentTransition) {
	        if (currentTransition.to.path === path) {
	          // do nothing if we have an active transition going to the same path
	          return;
	        } else if (currentRoute.path === path) {
	          // We are going to the same path, but we also have an ongoing but
	          // not-yet-validated transition. Abort that transition and reset to
	          // prev transition.
	          currentTransition.aborted = true;
	          this._currentTransition = this._prevTransition;
	          return;
	        } else {
	          // going to a totally different path. abort ongoing transition.
	          currentTransition.aborted = true;
	        }
	      }
	
	      // construct new route and transition context
	      var route = new Route(path, this);
	      var transition = new RouteTransition(this, route, currentRoute);
	
	      // current transition is updated right now.
	      // however, current route will only be updated after the transition has
	      // been validated.
	      this._prevTransition = currentTransition;
	      this._currentTransition = transition;
	
	      if (!this.app) {
	        (function () {
	          // initial render
	          var router = _this3;
	          _this3.app = new _this3._appConstructor({
	            el: _this3._appContainer,
	            created: function created() {
	              this.$router = router;
	            },
	            _meta: {
	              $route: route
	            }
	          });
	        })();
	      }
	
	      // check global before hook
	      var beforeHooks = this._beforeEachHooks;
	      var startTransition = function startTransition() {
	        transition.start(function () {
	          _this3._postTransition(route, state, anchor);
	        });
	      };
	
	      if (beforeHooks.length) {
	        transition.runQueue(beforeHooks, function (hook, _, next) {
	          if (transition === _this3._currentTransition) {
	            transition.callHook(hook, null, next, {
	              expectBoolean: true
	            });
	          }
	        }, startTransition);
	      } else {
	        startTransition();
	      }
	
	      if (!this._rendered && this._startCb) {
	        this._startCb.call(null);
	      }
	
	      // HACK:
	      // set rendered to true after the transition start, so
	      // that components that are acitvated synchronously know
	      // whether it is the initial render.
	      this._rendered = true;
	    };
	
	    /**
	     * Set current to the new transition.
	     * This is called by the transition object when the
	     * validation of a route has succeeded.
	     *
	     * @param {Transition} transition
	     */
	
	    Router.prototype._onTransitionValidated = function _onTransitionValidated(transition) {
	      // set current route
	      var route = this._currentRoute = transition.to;
	      // update route context for all children
	      if (this.app.$route !== route) {
	        this.app.$route = route;
	        this._children.forEach(function (child) {
	          child.$route = route;
	        });
	      }
	      // call global after hook
	      if (this._afterEachHooks.length) {
	        this._afterEachHooks.forEach(function (hook) {
	          return hook.call(null, {
	            to: transition.to,
	            from: transition.from
	          });
	        });
	      }
	      this._currentTransition.done = true;
	    };
	
	    /**
	     * Handle stuff after the transition.
	     *
	     * @param {Route} route
	     * @param {Object} [state]
	     * @param {String} [anchor]
	     */
	
	    Router.prototype._postTransition = function _postTransition(route, state, anchor) {
	      // handle scroll positions
	      // saved scroll positions take priority
	      // then we check if the path has an anchor
	      var pos = state && state.pos;
	      if (pos && this._saveScrollPosition) {
	        Vue.nextTick(function () {
	          window.scrollTo(pos.x, pos.y);
	        });
	      } else if (anchor) {
	        Vue.nextTick(function () {
	          var el = document.getElementById(anchor.slice(1));
	          if (el) {
	            window.scrollTo(window.scrollX, el.offsetTop);
	          }
	        });
	      }
	    };
	
	    return Router;
	  })();
	
	  function guardComponent(path, handler) {
	    var comp = handler.component;
	    if (Vue.util.isPlainObject(comp)) {
	      comp = handler.component = Vue.extend(comp);
	    }
	    /* istanbul ignore if */
	    if (typeof comp !== 'function') {
	      handler.component = null;
	      warn$1('invalid component for route "' + path + '".');
	    }
	  }
	
	  /* Installation */
	
	  Router.installed = false;
	
	  /**
	   * Installation interface.
	   * Install the necessary directives.
	   */
	
	  Router.install = function (externalVue) {
	    /* istanbul ignore if */
	    if (Router.installed) {
	      warn$1('already installed.');
	      return;
	    }
	    Vue = externalVue;
	    applyOverride(Vue);
	    View(Vue);
	    Link(Vue);
	    exports$1.Vue = Vue;
	    Router.installed = true;
	  };
	
	  // auto install
	  /* istanbul ignore if */
	  if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(Router);
	  }
	
	  return Router;
	
	}));

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	;(function() {
	    var vueTap = {};
	
	    vueTap.install = function(Vue) {
	        Vue.directive('tap', {
	
	            isFn: true,
	            acceptStatement: true,
	            priority: Vue.directive('on').priority,
	
	            bind: function() {
	                var self = this;
	
	                self.handler = function() {};
	                self.tapInfo = {};
	                self.touchstartFn = function(e) {
	                    if(self.modifiers.stopPropagation) e.stopPropagation();
	                    if(self.modifiers.preventDefault) e.preventDefault();
	                    self._touchstart(self, e);
	                };
	                self.touchendFn = function(e) {
	                    self._touchend(self, e);
	                };
	
	                this.el.addEventListener('touchstart', self.touchstartFn);
	
	                this.el.addEventListener('touchend', self.touchendFn);
	            },
	
	            _touchstart: function(obj, event) {
	                var touch = event.touches[0];
	                obj.tapInfo.pageX = touch.pageX;
	                obj.tapInfo.pageY = touch.pageY;
	                obj.tapInfo.touchStartTime = (new Date()).getTime();
	            },
	
	            _touchend: function(obj, event) {
	                var touch = event.changedTouches[0];
	                var interval = (new Date()).getTime() - obj.tapInfo.touchStartTime;
	                var disX = touch.pageX - obj.tapInfo.pageX;
	                var disY = touch.pageY - obj.tapInfo.pageY;
	
	                if (interval < 100 && Math.abs(disX) < 2 && Math.abs(disY) < 2) {
	                    obj.handler(event);
	                }
	            },
	
	            update: function(fn) {
	                if (typeof fn != 'function') return console.error('the tap event handler must be function!');
	
	                this.handler = fn;
	            },
	
	            unbind: function() {
	                this.el.removeEventListener('touchstart', this.touchstartFn);
	                this.el.removeEventListener('touchend', this.touchendFn);
	                this.touchstartFn = this.touchendFn = null;
	                this.handler = this.tapInfo = null;
	            }
	        });
	    };
	
	    if (true) {
	        module.exports = vueTap;
	    } else if (typeof define == 'function' && define.amd) {
	        define([], function() { return vueTap; });
	    } else {
	        window.vueTap = vueTap;
	        Vue.use(vueTap);
	    }
	})();

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

	module.exports.hex_md5 = function(sMessage) {
		function RotateLeft(lValue, iShiftBits) {
			return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
		}
		function AddUnsigned(lX, lY) {
			var lX4, lY4, lX8, lY8, lResult;
			lX8 = (lX & 0x80000000);
			lY8 = (lY & 0x80000000);
			lX4 = (lX & 0x40000000);
			lY4 = (lY & 0x40000000);
			lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
			if (lX4 & lY4)
				return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
			if (lX4 | lY4) {
				if (lResult & 0x40000000)
					return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
				else
					return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
			} else
				return (lResult ^ lX8 ^ lY8);
		}
		function F(x, y, z) {
			return (x & y) | ((~x) & z);
		}
		function G(x, y, z) {
			return (x & z) | (y & (~z));
		}
		function H(x, y, z) {
			return (x ^ y ^ z);
		}
		function I(x, y, z) {
			return (y ^ (x | (~z)));
		}
		function FF(a, b, c, d, x, s, ac) {
			a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
			return AddUnsigned(RotateLeft(a, s), b);
		}
		function GG(a, b, c, d, x, s, ac) {
			a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
			return AddUnsigned(RotateLeft(a, s), b);
		}
		function HH(a, b, c, d, x, s, ac) {
			a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
			return AddUnsigned(RotateLeft(a, s), b);
		}
		function II(a, b, c, d, x, s, ac) {
			a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
			return AddUnsigned(RotateLeft(a, s), b);
		}
		function ConvertToWordArray(sMessage) {
			var lWordCount;
			var lMessageLength = sMessage.length;
			var lNumberOfWords_temp1 = lMessageLength + 8;
			var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
			var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
			var lWordArray = Array(lNumberOfWords - 1);
			var lBytePosition = 0;
			var lByteCount = 0;
			while (lByteCount < lMessageLength) {
				lWordCount = (lByteCount - (lByteCount % 4)) / 4;
				lBytePosition = (lByteCount % 4) * 8;
				lWordArray[lWordCount] = (lWordArray[lWordCount] | (sMessage
						.charCodeAt(lByteCount) << lBytePosition));
				lByteCount++;
			}
			lWordCount = (lByteCount - (lByteCount % 4)) / 4;
			lBytePosition = (lByteCount % 4) * 8;
			lWordArray[lWordCount] = lWordArray[lWordCount]
					| (0x80 << lBytePosition);
			lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
			lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
			return lWordArray;
		}
		function WordToHex(lValue) {
			var WordToHexValue = "", WordToHexValue_temp = "", lByte, lCount;
			for (lCount = 0; lCount <= 3; lCount++) {
				lByte = (lValue >>> (lCount * 8)) & 255;
				WordToHexValue_temp = "0" + lByte.toString(16);
				WordToHexValue = WordToHexValue
						+ WordToHexValue_temp.substr(
								WordToHexValue_temp.length - 2, 2);
			}
			return WordToHexValue;
		}
		var x = Array();
		var k, AA, BB, CC, DD, a, b, c, d;
		var S11 = 7, S12 = 12, S13 = 17, S14 = 22;
		var S21 = 5, S22 = 9, S23 = 14, S24 = 20;
		var S31 = 4, S32 = 11, S33 = 16, S34 = 23;
		var S41 = 6, S42 = 10, S43 = 15, S44 = 21;
		// Steps 1 and 2. Append padding bits and length and convert to words
		x = ConvertToWordArray(sMessage);
		// Step 3. Initialise
		a = 0x67452301;
		b = 0xEFCDAB89;
		c = 0x98BADCFE;
		d = 0x10325476;
		// Step 4. Process the message in 16-word blocks
		for (k = 0; k < x.length; k += 16) {
			AA = a;
			BB = b;
			CC = c;
			DD = d;
			a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
			d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
			c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
			b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
			a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
			d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
			c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
			b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
			a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
			d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
			c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
			b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
			a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
			d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
			c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
			b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
			a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
			d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
			c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
			b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
			a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
			d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
			c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
			b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
			a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
			d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
			c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
			b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
			a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
			d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
			c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
			b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
			a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
			d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
			c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
			b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
			a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
			d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
			c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
			b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
			a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
			d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
			c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
			b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
			a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
			d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
			c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
			b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
			a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
			d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
			c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
			b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
			a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
			d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
			c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
			b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
			a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
			d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
			c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
			b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
			a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
			d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
			c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
			b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
			a = AddUnsigned(a, AA);
			b = AddUnsigned(b, BB);
			c = AddUnsigned(c, CC);
			d = AddUnsigned(d, DD);
		}
		// Step 5. Output the 128 bit digest
		var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);
		return temp.toLowerCase();
	};
	
	
	//////////////////
	// WEBPACK FOOTER
	// ./src/Md5Util2.js
	// module id = 40
	// module chunks = 4

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	/**
	 * Created by jxm on 16-6-6.
	 * 存放全局变量
	 */
	module.exports = {
	  curRoute:{
	    path:'',
	    pathName:'',
	    params:{},
	    backpath:''
	  },
	  activationCode:'',
	  signUserId:null,
	  currentTab:1,
	  app:0,
	  isWKWebView:0,
	  enterId:null,
	  language:''
	};

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	/**
	 * Created by liubin on 17-3-1.
	 * 存放翻译文件
	 */
	module.exports = {
	  cn: {
	    register: '注册',
	    registernewgroup: '注册新企业',
	    addhasgroup: '加入已有企业',
	    username: '用户名',
	    password: '密码',
	    showname: '姓名',
	    email: '邮箱',
	    mobilephone: '手机号码',
	    validatecode: '验证码',
	    getvalidatecode: '获取验证码',
	    wait: '等待',
	    second: '秒',
	    groupname: '企业名称',
	    createenterprise: '创建企业',
	    invationcode: '企业邀请码',
	    next: '下一步',
	    crateenterpriseaccount: '创建企业帐号',
	    inputusername: '请输入用户名',
	    inputpassword: '请输入密码',
	    passwordcannotsoeasy: '哦吆,密码不能这么随便',
	    passwordatleastsix: '密码至少为8位数字和大小写字母组合',
	    passwordmax:'密码最多50位',
	    passordneednumandabc: '密码只能是数字和字母',
	    inputshowname: '请输入姓名',
	    inputmobilephone: '请输入手机号码',
	    inputemail: '请输入邮箱',
	    mobilephonenotvalid: '手机号码不符合格式',
	    emailnotvalid: '邮箱不符合格式',
	    emailregistered: '邮箱已被注册',
	    inputvalidatecode: '请输入验证码',
	    inputenterprisename: '请输入企业名称',
	    creatingwait: '正在创建,请稍候……',
	    infoperfect: '信息不完善',
	    usernamehasexisted: '用户名已存在',
	    mobilephonehasexisted: '手机号码已存在',
	    enterprisenamehasexisted: '企业名已经存在',
	    validatecodeerror: '验证码错误',
	    registerfailed: '啊噢,注册失败!',
	    serverexception: '服务器出现异常',
	    can: '此用户名可以注册',
	    cannot: '此用户名已被注册',
	    validatecodesendsuccess: '验证码发送成功',
	    mobilephonehasregisted: '该手机号码已被注册过',
	    validatecodesendfailed: '验证码发送失败',
	    inputinvationcode: '请输入邀请码',
	    invationcodeerror: '邀请码错误',
	    netspaceopen: '请点击右上角在浏览器中打开',
	    enterprisename: '企业名：',
	    invitationuser: '推荐人：',
	    joingroup: '加入企业',
	    createnewgroup: '创建新企业',
	    beacuse: '由于',
	    passfailed: ',导致审核失败',
	    beacusesome: '由于某些原因,导致审核失败',
	    enterprisecannotnull: '企业不能为空',
	    joingroupingwait: '正在加入企业,请稍候……',
	    congratulations: '恭喜您,加入企业成功!',
	    joingroupfailed: '啊噢,加入企业失败!',
	    uploadcertificate: '请上传企业营业执照',
	    passingwait: '您的企业营业执照正在审核中，请耐心等待',
	    call400: '如需紧急处理，请拨打400-666-3626',
	    reuploadcertificate: '您的企业营业执照审核不通过，请重新上传',
	    call4001: '如有任何疑问，请拨打400-666-3626',
	    certificate: '营业执照',
	    support: '支持',
	    upload: '上传',
	    changeotheraccount: '返回',
	    picnotbigthan5m: '图片大小不能超过5M',
	    uploadcannotmorethan: '上传的图片最多不能超过',
	    zhang: '张',
	    duozhang: '多张:',
	    compressfailed: '压缩失败...',
	    compresscomplete: '压缩完成...',
	    browsernotsupport: '浏览器不支持',
	    deletecertificatesuccess: '删除企业营业执照成功',
	    deletecertificatefailed: '删除企业营业执照失败',
	    nonewpicupload: '没有新的图片需要上传',
	    uploadingwait: '正在上传请稍候……',
	    uploadcertificatesuccess: '上传营业执照成功',
	    uploadcertificatefailed: '上传营业执照失败',
	    notsupport: '暂不支持',
	    c: '图片验证码',
	    imgcodeerror: '请输入4位的图片验证码',
	    inputimgcodeerror: '图片验证码错误',
	    jointip: '注：企业邀请码可以向企业管理员进行索取',
	    jointip2: '谁是我们企业管理员?',
	    calltip: '请直接致电查询',
	    method1: '方法一',
	    method2: '方法二',
	    method2tip:
	      '留下您的手机号码和姓名信息，我们会尽快通知企业管理员与您联系。',
	    submit: '提交',
	    submitsuccess: '提交成功',
	    submitfailed: '提交失败',
	    doing: '正在处理...',
	    newgroup: '新企业',
	    hasgroup: '已有企业',
	    join: '加入',
	    nochina: '用户名不能包含中文',
	    validatecodesendLimit: '今日发送验证码数量超出限制',
	    experience: "体验",
	    prodemo: "产品Demo",
	    weak: '弱',
	    middle: '中',
	    high: '强',
	    pwderrortip:'密码存在连续字母或数字（3位及以上）'
	  },
	  en: {
	    register: 'Resister',
	    registernewgroup: 'Register a new company',
	    addhasgroup: 'Join a company',
	    username: 'User name',
	    password: 'Password',
	    showname: 'Display name',
	    email: 'Email',
	    mobilephone: 'Mobile',
	    validatecode: 'Verification code',
	    getvalidatecode: 'Get',
	    wait: 'Wait',
	    second: 's',
	    groupname: 'Company',
	    createenterprise: 'Add',
	    invationcode: 'Invitation code',
	    next: 'Next',
	    crateenterpriseaccount: 'Add a company account.',
	    inputusername: 'Please input username.',
	    inputpassword: 'Please input password.',
	    passwordcannotsoeasy: 'The password is too simple.',
	    passwordatleastsix: 'Passwords should be at least 8 digits and uppercase and lowercase letters.',
	    passwordmax:'密码最多50位',
	    passordneednumandabc: 'Your passwords must be numbers and/or letters.',
	    inputshowname: 'Please input display name.',
	    inputmobilephone: 'Please input mobile.',
	    inputemail: 'Please input email.',
	    mobilephonenotvalid: 'Wrong mobile format',
	    emailnotvalid: 'Mailbox does not conform to format',
	    emailregistered: '邮箱已被注册',
	    inputvalidatecode: 'Please input verification code.',
	    inputenterprisename: 'Please input company name.',
	    creatingwait: 'Adding, please wait. ',
	    infoperfect: 'Incomplete information',
	    usernamehasexisted: 'Same name exists.',
	    mobilephonehasexisted: 'Same mobile exists.',
	    enterprisenamehasexisted: 'Same company exists.',
	    validatecodeerror: 'Wrong code.',
	    registerfailed: 'Oops, failed to register.',
	    serverexception: 'Server Error',
	    can: 'Username can be registered.',
	    cannot: 'Username has already been taken.',
	    validatecodesendsuccess: 'Verification code has been sent.',
	    mobilephonehasregisted: 'This phone number has been taken.',
	    validatecodesendfailed: 'Failed to send',
	    inputinvationcode: 'Please input invitation code.',
	    invationcodeerror: 'Wrong invitaiton code',
	    netspaceopen:
	      'Please click the top-right corner to open it with a browser.',
	    enterprisename: 'Company name:',
	    invitationuser: 'Who refers:',
	    joingroup: 'Join',
	    createnewgroup: 'Add a new company',
	    beacuse: 'Because',
	    passfailed: ',It hasnot been approved.',
	    beacusesome: 'It hasnot been approved for some reasons.',
	    enterprisecannotnull: 'The company cannot be null.',
	    joingroupingwait: 'Joining, please wait……',
	    congratulations: 'Congratulations, you have joined this company.',
	    joingroupfailed: 'Oops, failed to join this company.',
	    uploadcertificate: 'Please upload the business license.',
	    passingwait: 'Auditing your business license, please wait.',
	    call400: 'For any emergency, please call 400-666-3626.',
	    reuploadcertificate:
	      'Your business license hasnot been approved. Please upload again.',
	    call4001: 'For any question, please call 400-666-3626.',
	    certificate: 'Business license',
	    support: 'Support',
	    upload: 'Upload',
	    changeotheraccount: 'Back',
	    picnotbigthan5m: 'Photos should be less than 5 MB.',
	    uploadcannotmorethan: 'Max. uploaded pictures should be',
	    zhang: 'pc',
	    duozhang: 'pcs:',
	    compressfailed: 'Failed to compress',
	    compresscomplete: 'Compressed',
	    browsernotsupport: 'Your browser is not supported.',
	    deletecertificatesuccess: 'Deleted',
	    deletecertificatefailed: 'Failed to delete',
	    nonewpicupload: 'No photos need uploading.',
	    uploadingwait: 'Uploading, please wait……',
	    uploadcertificatesuccess: 'Uploaded',
	    uploadcertificatefailed: 'Failed to upload',
	    notsupport: 'Not yet supported',
	    imgcode: 'Picture security code',
	    imgcodeerror: 'Please input the security code.',
	    inputimgcodeerror: 'Wrong security code',
	    jointip: 'Tips: You can get the invitation code from your admin.',
	    jointip2: 'Who is the Admin?',
	    calltip: 'Please call the hotline to search.',
	    method1: ' Method 1',
	    method2: 'Method 2',
	    method2tip:
	      'Please leave your name and number. We will inform Admin to get right back to you.',
	    submit: 'Done',
	    submitsuccess: 'Submitted',
	    submitfailed: 'Failed to submit',
	    doing: 'Processing...',
	    newgroup: 'New company',
	    hasgroup: 'Existing company',
	    join: 'Join',
	    nochina: 'Username cannot contain Chinese',
	    validatecodesendLimit: 'The number of captcha sent today has exceeded the limit.',
	    experience: "Experience",
	    prodemo: "Product Demo",
	    weak: 'Weak',
	    middle: 'Medium',
	    high: 'Strong',
	    pwderrortip:'密码存在连续字母或数字（3位及以上）'
	  },
	  tw: {
	    register: '註冊',
	    registernewgroup: '註冊新企業',
	    addhasgroup: '加入已有企業',
	    username: '用戶名',
	    password: '密碼',
	    showname: '姓名',
	    email: '郵箱',
	    mobilephone: '手機號碼',
	    validatecode: '驗證碼',
	    getvalidatecode: '獲取驗證碼',
	    wait: '等待',
	    second: '秒',
	    groupname: '企業名稱',
	    createenterprise: '創建企業',
	    invationcode: '企業邀請碼',
	    next: '下一步',
	    crateenterpriseaccount: '創建企業帳號',
	    inputusername: '請輸入用戶名',
	    inputpassword: '請輸入密碼',
	    passwordcannotsoeasy: '哦吆,密碼不能這麼隨便',
	    passwordatleastsix: '密碼至少为8位数字和大小写字母组合',
	    passwordmax:'密码最多50位',
	    passordneednumandabc: '密碼只能是數字和字母',
	    inputshowname: '請輸入姓名',
	    inputmobilephone: '請輸入手機號碼',
	    inputemail: '请输入邮箱',
	    mobilephonenotvalid: '手機號碼不符合格式',
	    emailnotvalid: '郵箱不符合格式',
	    emailregistered: '邮箱已被注册',
	    inputvalidatecode: '請輸入驗證碼',
	    inputenterprisename: '請輸入企業名稱',
	    creatingwait: '正在創建,請稍候……',
	    infoperfect: '信息不完善',
	    usernamehasexisted: '用戶名已存在',
	    mobilephonehasexisted: '手機號碼已存在',
	    enterprisenamehasexisted: '企業名已經存在',
	    validatecodeerror: '驗證碼錯誤',
	    registerfailed: '啊噢,註冊失敗!',
	    serverexception: '服務器出現異常',
	    can: '此用戶名可以註冊',
	    cannot: '此用戶名已被註冊',
	    validatecodesendsuccess: '驗證碼發送成功',
	    mobilephonehasregisted: '該手機號碼已被註冊過',
	    validatecodesendfailed: '驗證碼發送失敗',
	    inputinvationcode: '請輸入邀請碼',
	    invationcodeerror: '邀請碼錯誤',
	    netspaceopen: '請點擊右上角在瀏覽器中打開',
	    enterprisename: '企業名：',
	    invitationuser: '推薦人：',
	    joingroup: '加入企業',
	    createnewgroup: '創建新企業',
	    beacuse: '由於',
	    passfailed: ',導致審核失敗',
	    beacusesome: '由於某些原因,導致審核失敗',
	    enterprisecannotnull: '企業不能為空',
	    joingroupingwait: '正在加入企業,請稍候……',
	    congratulations: '恭喜您,加入企業成功!',
	    joingroupfailed: '啊噢,加入企業失敗!',
	    uploadcertificate: '請上傳企業營業執照',
	    passingwait: '您的企業營業執照正在審核中，請耐心等待',
	    call400: '如需緊急處理，請撥打400-666-3626',
	    reuploadcertificate: '您的企業營業執照審核不通過，請重新上傳',
	    call4001: '如有任何疑問，請撥打400-666-3626',
	    certificate: '營業執照',
	    support: '支持',
	    upload: '上傳',
	    changeotheraccount: '返回',
	    picnotbigthan5m: '圖片大小不能超過5M',
	    uploadcannotmorethan: '上傳的圖片最多不能超過',
	    zhang: '張',
	    duozhang: '多張:',
	    compressfailed: '壓縮失敗...',
	    compresscomplete: '壓縮完成...',
	    browsernotsupport: '瀏覽器不支持',
	    deletecertificatesuccess: '刪除企業營業執照成功',
	    deletecertificatefailed: '刪除企業營業執照失敗',
	    nonewpicupload: '沒有新的圖片需要上傳',
	    uploadingwait: '正在上傳請稍候……',
	    uploadcertificatesuccess: '上傳營業執照成功',
	    uploadcertificatefailed: '上傳營業執照失敗',
	    notsupport: '暫不支持',
	    imgcode: '圖片驗證碼',
	    imgcodeerror: '請輸入4位的圖片驗證碼',
	    inputimgcodeerror: '圖片驗證碼錯誤',
	    jointip: '注：企業邀請碼可以向企業管理員進行索取',
	    jointip2: '誰是我們企業管理員?',
	    calltip: '請直接致電查詢',
	    method1: '方法一',
	    method2: '方法二',
	    method2tip:
	      '留下您的手機號碼和姓名信息，我們會盡快通知企業管理員與您聯繫。',
	    submit: '提交',
	    submitsuccess: '提交成功',
	    submitfailed: '提交失敗',
	    doing: '正在處理...',
	    newgroup: '新企業',
	    hasgroup: '已有企業',
	    join: '加入',
	    nochina: '用户名不能包含中文',
	    validatecodesendLimit: '今日發送驗證碼數量超出限制',
	    experience: "體驗",
	    prodemo: "產品Demo",
	    weak: '弱',
	    middle: '中',
	    high: '強',
	    pwderrortip:'密码存在连续字母或数字（3位及以上）'
	  }
	};


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * 路由表
	 * @param router
	 */
	module.exports = function(router){
	  var utils = __webpack_require__(115);
	  router.map({
	    '/':{
	      name:'default',
	      component:function(resolve){
	        __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(149)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    },
	    '/step1':{
	        name:'step1',
	        component:function(resolve){
	            __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/join':{
	      name:'step2',
	      component:function(resolve){
	        __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(151)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    },
	    '/next':{
	      name:'step3',
	      component:function(resolve){
	        __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(152)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }
	  });
	  router.beforeEach(function(transition){
	    Constant.curRoute.path = transition.to.path;
	    Constant.curRoute.pathName = transition.to.name;
	    utils.setBackPath(transition.to.name,transition.to.params);
	    transition.next();
	  });
	};


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		var VueI18n = {
			install: function(Vue, options) {
	
	      // 中文简体、中文繁体对应相应的语言，其他语言皆英文
	      switch (navigator.language) {
	        case 'en':
	        case 'en-US':
	          options.default = 'en';
	          break;
	        case 'tw':
	        case 'zh-TW':
	          options.default = 'tw';
	            break;
	        default:
	          break;
	      }
				Vue.prototype.$language = window.localStorage.language = options.default;
	            //window.localStorage.i18nDatas = options.data;
				Vue.directive('i18n', function(args) {
					if (args.value != undefined && options.data[options.default] != undefined) {
						/*if (args.language == undefined) {
							args.language = options.default
						}
						window.localStorage.language = args.language*/
						var val = eval('options.data.' + options.default + '.' + args.value);
						if (args.replace != undefined && args.replace.length > 0) {
							args.replace.forEach(function(v, k) {
								val = val.replace(new RegExp("\\{" + k + "\\}", "g"), v)
							})
						}
						if (val != undefined) {
							if (this.modifiers.placeholder) {
								this.el.setAttribute('placeholder', val)
							}else if(this.modifiers.value){
	                            this.el.setAttribute('value', val)
							} else {
								this.el.innerHTML = val
							}
						} else {
							this.el.innerHTML = ""
						}
					} else {
						this.el.innerHTML = ""
					}
				});
				Vue.prototype.$translate = function(namespace){
	                try {
	                    var value = eval('options.data.' + options.default + '.' + namespace);
	                    if (value != undefined) {
	                    	return value;
	                    }else{
	                    	return "";
						}
	                } catch(e) {
	                    console.warn('No translation found for namespace', namespace, options.default, e);
	                }
				}
			}
		};
		if (true) {
			module.exports = VueI18n;
		} else if (typeof define == "function" && define.amd) {
			define([], function() {
				return VueI18n;
			});
		} else if (window.Vue) {
			window.VueI18n = VueI18n;
			Vue.use(VueI18n);
		}
	})();

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.72ae6e1104ec1f87dc7c.js